// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/ag-grid-community/styles/ag-grid.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%2836, 149, 207, 0.3%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3e%3cpath fill=%27currentColor%27 d=%27M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3e%3cpath fill=%27currentColor%27 d=%27M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3e%3cpath fill=%27currentColor%27 d=%27M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3e%3cpath fill=%27currentColor%27 d=%27M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* bootstrap vars */
/* colors */
/* general functions */
/* fort awesome svg icons for background image values */
/* import bootstrap to set changes */
/*!
 * Bootstrap  v5.3.6 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #2495cf;
  --bs-danger: #fd6060;
  --bs-warning: #f5e252;
  --bs-success: #6ee86e;
  --bs-secondary: #337ab7;
  --bs-dark: #4f5659;
  --bs-preparation: #aab9bf;
  --bs-step: #68d47f;
  --bs-action: #6dc5f2;
  --bs-condition: #ebce6a;
  --bs-white: #ffffff;
  --bs-transparent: transparent;
  --bs-primary-rgb: 36, 149, 207;
  --bs-danger-rgb: 253, 96, 96;
  --bs-warning-rgb: 245, 226, 82;
  --bs-success-rgb: 110, 232, 110;
  --bs-secondary-rgb: 51, 122, 183;
  --bs-dark-rgb: 79, 86, 89;
  --bs-preparation-rgb: 170, 185, 191;
  --bs-step-rgb: 104, 212, 127;
  --bs-action-rgb: 109, 197, 242;
  --bs-condition-rgb: 235, 206, 106;
  --bs-white-rgb: 255, 255, 255;
  --bs-transparent-rgb: 0, 0, 0;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-root-font-size: 13px;
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

:root {
  font-size: var(--bs-root-font-size);
}
@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 0.75rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.375rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.309615rem + 0.71538vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 1.84615rem;
  }
}

h2, .h2 {
  font-size: calc(1.286538rem + 0.438456vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.61538rem;
  }
}

h3, .h3 {
  font-size: calc(1.263462rem + 0.161544vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.38462rem;
  }
}

h4, .h4 {
  font-size: 1.23077rem;
}

h5, .h5 {
  font-size: 1.07692rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 0.75rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -0.75rem;
  margin-bottom: 0.75rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.375rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.1875rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.1875rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.375rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.375rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 0.75rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 0.75rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.125rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.125rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 1.6875rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 1.6875rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 2.53125rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 2.53125rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.1875rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.1875rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.375rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.375rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.125rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.125rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 1.6875rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 1.6875rem;
  }
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 2.53125rem;
  }
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 2.53125rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.1875rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.1875rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.375rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.375rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.125rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.125rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 1.6875rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 1.6875rem;
  }
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 2.53125rem;
  }
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 2.53125rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.1875rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.1875rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.375rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.375rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.125rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.125rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 1.6875rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 1.6875rem;
  }
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 2.53125rem;
  }
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 2.53125rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.1875rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.1875rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.375rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.375rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.125rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.125rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 1.6875rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 1.6875rem;
  }
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 2.53125rem;
  }
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 2.53125rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.1875rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.1875rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.375rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.375rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.125rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.125rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 1.6875rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 1.6875rem;
  }
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 2.53125rem;
  }
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 2.53125rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 0.75rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.col-form-label {
  padding-top: calc(0.2rem + var(--bs-border-width));
  padding-bottom: calc(0.2rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.3rem + var(--bs-border-width));
  padding-bottom: calc(0.3rem + var(--bs-border-width));
  font-size: 1.07692rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.2rem 0.6rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #212529;
  background-color: var(--bs-body-bg);
  border-color: rgba(36, 149, 207, 0.3);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: rgb(238, 241, 242.2);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.2rem 0.6rem;
  margin: -0.2rem -0.6rem;
  margin-inline-end: 0.6rem;
  color: #212529;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.2rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 0.6rem + calc(var(--bs-border-width) * 2));
  padding: 0.3rem 0.8rem;
  font-size: 1.07692rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.3rem 0.8rem;
  margin: -0.3rem -0.8rem;
  margin-inline-end: 0.8rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.4rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 0.6rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.4rem + calc(var(--bs-border-width) * 2));
  padding: 0.2rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.3rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.3rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 0.6rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.2rem 1.8rem 0.2rem 0.6rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.6rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgba(36, 149, 207, 0.3);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.6rem;
  background-image: none;
}
.form-select:disabled {
  background-color: rgb(238, 241, 242.2);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #212529;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  padding-left: 0.8rem;
  font-size: 1.07692rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgba(36, 149, 207, 0.3);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #2495cf;
  border-color: #2495cf;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #2495cf;
  border-color: #2495cf;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #2495cf;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(189.3, 223.2, 240.6);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #2495cf;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(189.3, 223.2, 240.6);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.6rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.6rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.6rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.3rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: 0.3rem;
}
.form-floating > textarea:disabled ~ label::after {
  background-color: rgb(238, 241, 242.2);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.3rem 0.8rem;
  font-size: 1.07692rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.1875rem 0.375rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.4rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1rem) center;
  background-size: calc(0.75em + 0.2rem) calc(0.75em + 0.2rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.4rem);
  background-position: top calc(0.375em + 0.1rem) right calc(0.375em + 0.1rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 3.3rem;
  background-position: right 0.6rem center, center right 1.8rem;
  background-size: 16px 12px, calc(0.75em + 0.2rem) calc(0.75em + 0.2rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.4rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.1875rem 0.375rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.4rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1rem) center;
  background-size: calc(0.75em + 0.2rem) calc(0.75em + 0.2rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.4rem);
  background-position: top calc(0.375em + 0.1rem) right calc(0.375em + 0.1rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 3.3rem;
  background-position: right 0.6rem center, center right 1.8rem;
  background-size: 16px 12px, calc(0.75em + 0.2rem) calc(0.75em + 0.2rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.4rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.6rem;
  --bs-btn-padding-y: 0.2rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #2495cf;
  --bs-btn-border-color: #2495cf;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(30.6, 126.65, 175.95);
  --bs-btn-hover-border-color: rgb(28.8, 119.2, 165.6);
  --bs-btn-focus-shadow-rgb: 69, 165, 214;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(28.8, 119.2, 165.6);
  --bs-btn-active-border-color: rgb(27, 111.75, 155.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2495cf;
  --bs-btn-disabled-border-color: #2495cf;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #fd6060;
  --bs-btn-border-color: #fd6060;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(215.05, 81.6, 81.6);
  --bs-btn-hover-border-color: rgb(202.4, 76.8, 76.8);
  --bs-btn-focus-shadow-rgb: 253, 120, 120;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(202.4, 76.8, 76.8);
  --bs-btn-active-border-color: rgb(189.75, 72, 72);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #fd6060;
  --bs-btn-disabled-border-color: #fd6060;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #f5e252;
  --bs-btn-border-color: #f5e252;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(246.5, 230.35, 107.95);
  --bs-btn-hover-border-color: rgb(246, 228.9, 99.3);
  --bs-btn-focus-shadow-rgb: 208, 192, 70;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(247, 231.8, 116.6);
  --bs-btn-active-border-color: rgb(246, 228.9, 99.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f5e252;
  --bs-btn-disabled-border-color: #f5e252;
}

.btn-success {
  --bs-btn-color: #000;
  --bs-btn-bg: #6ee86e;
  --bs-btn-border-color: #6ee86e;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(131.75, 235.45, 131.75);
  --bs-btn-hover-border-color: rgb(124.5, 234.3, 124.5);
  --bs-btn-focus-shadow-rgb: 94, 197, 94;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(139, 236.6, 139);
  --bs-btn-active-border-color: rgb(124.5, 234.3, 124.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #6ee86e;
  --bs-btn-disabled-border-color: #6ee86e;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #337ab7;
  --bs-btn-border-color: #337ab7;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(43.35, 103.7, 155.55);
  --bs-btn-hover-border-color: rgb(40.8, 97.6, 146.4);
  --bs-btn-focus-shadow-rgb: 82, 142, 194;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(40.8, 97.6, 146.4);
  --bs-btn-active-border-color: rgb(38.25, 91.5, 137.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #337ab7;
  --bs-btn-disabled-border-color: #337ab7;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4f5659;
  --bs-btn-border-color: #4f5659;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(105.4, 111.35, 113.9);
  --bs-btn-hover-border-color: rgb(96.6, 102.9, 105.6);
  --bs-btn-focus-shadow-rgb: 105, 111, 114;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(114.2, 119.8, 122.2);
  --bs-btn-active-border-color: rgb(96.6, 102.9, 105.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4f5659;
  --bs-btn-disabled-border-color: #4f5659;
}

.btn-preparation {
  --bs-btn-color: #000;
  --bs-btn-bg: #aab9bf;
  --bs-btn-border-color: #aab9bf;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(182.75, 195.5, 200.6);
  --bs-btn-hover-border-color: rgb(178.5, 192, 197.4);
  --bs-btn-focus-shadow-rgb: 145, 157, 162;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(187, 199, 203.8);
  --bs-btn-active-border-color: rgb(178.5, 192, 197.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #aab9bf;
  --bs-btn-disabled-border-color: #aab9bf;
}

.btn-step {
  --bs-btn-color: #000;
  --bs-btn-bg: #68d47f;
  --bs-btn-border-color: #68d47f;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(126.65, 218.45, 146.2);
  --bs-btn-hover-border-color: rgb(119.1, 216.3, 139.8);
  --bs-btn-focus-shadow-rgb: 88, 180, 108;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(134.2, 220.6, 152.6);
  --bs-btn-active-border-color: rgb(119.1, 216.3, 139.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #68d47f;
  --bs-btn-disabled-border-color: #68d47f;
}

.btn-action {
  --bs-btn-color: #000;
  --bs-btn-bg: #6dc5f2;
  --bs-btn-border-color: #6dc5f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(130.9, 205.7, 243.95);
  --bs-btn-hover-border-color: rgb(123.6, 202.8, 243.3);
  --bs-btn-focus-shadow-rgb: 93, 167, 206;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(138.2, 208.6, 244.6);
  --bs-btn-active-border-color: rgb(123.6, 202.8, 243.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #6dc5f2;
  --bs-btn-disabled-border-color: #6dc5f2;
}

.btn-condition {
  --bs-btn-color: #000;
  --bs-btn-bg: #ebce6a;
  --bs-btn-border-color: #ebce6a;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(238, 213.35, 128.35);
  --bs-btn-hover-border-color: rgb(237, 210.9, 120.9);
  --bs-btn-focus-shadow-rgb: 200, 175, 90;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(239, 215.8, 135.8);
  --bs-btn-active-border-color: rgb(237, 210.9, 120.9);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ebce6a;
  --bs-btn-disabled-border-color: #ebce6a;
}

.btn-white {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffffff;
  --bs-btn-disabled-border-color: #ffffff;
}

.btn-transparent {
  --bs-btn-color: #fff;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(0, 0, 0, 0.15);
  --bs-btn-hover-border-color: rgba(0, 0, 0, 0.2);
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgba(0, 0, 0, 0.2);
  --bs-btn-active-border-color: rgba(0, 0, 0, 0.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: transparent;
}

.btn-outline-primary {
  --bs-btn-color: #2495cf;
  --bs-btn-border-color: #2495cf;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2495cf;
  --bs-btn-hover-border-color: #2495cf;
  --bs-btn-focus-shadow-rgb: 36, 149, 207;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2495cf;
  --bs-btn-active-border-color: #2495cf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #2495cf;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #2495cf;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #fd6060;
  --bs-btn-border-color: #fd6060;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #fd6060;
  --bs-btn-hover-border-color: #fd6060;
  --bs-btn-focus-shadow-rgb: 253, 96, 96;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #fd6060;
  --bs-btn-active-border-color: #fd6060;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fd6060;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fd6060;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #f5e252;
  --bs-btn-border-color: #f5e252;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f5e252;
  --bs-btn-hover-border-color: #f5e252;
  --bs-btn-focus-shadow-rgb: 245, 226, 82;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f5e252;
  --bs-btn-active-border-color: #f5e252;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f5e252;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f5e252;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #6ee86e;
  --bs-btn-border-color: #6ee86e;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #6ee86e;
  --bs-btn-hover-border-color: #6ee86e;
  --bs-btn-focus-shadow-rgb: 110, 232, 110;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #6ee86e;
  --bs-btn-active-border-color: #6ee86e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6ee86e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6ee86e;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #337ab7;
  --bs-btn-border-color: #337ab7;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #337ab7;
  --bs-btn-hover-border-color: #337ab7;
  --bs-btn-focus-shadow-rgb: 51, 122, 183;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #337ab7;
  --bs-btn-active-border-color: #337ab7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #337ab7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #337ab7;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #4f5659;
  --bs-btn-border-color: #4f5659;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4f5659;
  --bs-btn-hover-border-color: #4f5659;
  --bs-btn-focus-shadow-rgb: 79, 86, 89;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4f5659;
  --bs-btn-active-border-color: #4f5659;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4f5659;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4f5659;
  --bs-gradient: none;
}

.btn-outline-preparation {
  --bs-btn-color: #aab9bf;
  --bs-btn-border-color: #aab9bf;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #aab9bf;
  --bs-btn-hover-border-color: #aab9bf;
  --bs-btn-focus-shadow-rgb: 170, 185, 191;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #aab9bf;
  --bs-btn-active-border-color: #aab9bf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #aab9bf;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #aab9bf;
  --bs-gradient: none;
}

.btn-outline-step {
  --bs-btn-color: #68d47f;
  --bs-btn-border-color: #68d47f;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #68d47f;
  --bs-btn-hover-border-color: #68d47f;
  --bs-btn-focus-shadow-rgb: 104, 212, 127;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #68d47f;
  --bs-btn-active-border-color: #68d47f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #68d47f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #68d47f;
  --bs-gradient: none;
}

.btn-outline-action {
  --bs-btn-color: #6dc5f2;
  --bs-btn-border-color: #6dc5f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #6dc5f2;
  --bs-btn-hover-border-color: #6dc5f2;
  --bs-btn-focus-shadow-rgb: 109, 197, 242;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #6dc5f2;
  --bs-btn-active-border-color: #6dc5f2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6dc5f2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6dc5f2;
  --bs-gradient: none;
}

.btn-outline-condition {
  --bs-btn-color: #ebce6a;
  --bs-btn-border-color: #ebce6a;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ebce6a;
  --bs-btn-hover-border-color: #ebce6a;
  --bs-btn-focus-shadow-rgb: 235, 206, 106;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ebce6a;
  --bs-btn-active-border-color: #ebce6a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ebce6a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ebce6a;
  --bs-gradient: none;
}

.btn-outline-white {
  --bs-btn-color: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffffff;
  --bs-btn-hover-border-color: #ffffff;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffffff;
  --bs-btn-active-border-color: #ffffff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffffff;
  --bs-gradient: none;
}

.btn-outline-transparent {
  --bs-btn-color: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: transparent;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: transparent;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: transparent;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.3rem;
  --bs-btn-padding-x: 0.8rem;
  --bs-btn-font-size: 1.07692rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.375rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #2495cf;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 0.75rem;
  --bs-dropdown-item-padding-y: 0.1875rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 0.75rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #2495cf;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.45rem;
  padding-left: 0.45rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #2495cf;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.375rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.038465rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.61538rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 1rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.07692rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: #fff;
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 0.75rem;
  --bs-card-spacer-x: 0.75rem;
  --bs-card-title-spacer-y: 0.375rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: rgb(136.85, 144.2, 147.14);
  --bs-card-border-radius: 0.5rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(0.5rem - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.375rem;
  --bs-card-cap-padding-x: 0.75rem;
  --bs-card-cap-bg: rgb(195.5, 206, 210.2);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 0.75rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #2495cf;
  --bs-pagination-active-border-color: #2495cf;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.07692rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 0.75rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 2.25rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 0.75rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-preparation {
  --bs-alert-color: var(--bs-preparation-text-emphasis);
  --bs-alert-bg: var(--bs-preparation-bg-subtle);
  --bs-alert-border-color: var(--bs-preparation-border-subtle);
  --bs-alert-link-color: var(--bs-preparation-text-emphasis);
}

.alert-step {
  --bs-alert-color: var(--bs-step-text-emphasis);
  --bs-alert-bg: var(--bs-step-bg-subtle);
  --bs-alert-border-color: var(--bs-step-border-subtle);
  --bs-alert-link-color: var(--bs-step-text-emphasis);
}

.alert-action {
  --bs-alert-color: var(--bs-action-text-emphasis);
  --bs-alert-bg: var(--bs-action-bg-subtle);
  --bs-alert-border-color: var(--bs-action-border-subtle);
  --bs-alert-link-color: var(--bs-action-text-emphasis);
}

.alert-condition {
  --bs-alert-color: var(--bs-condition-text-emphasis);
  --bs-alert-bg: var(--bs-condition-bg-subtle);
  --bs-alert-border-color: var(--bs-condition-border-subtle);
  --bs-alert-link-color: var(--bs-condition-text-emphasis);
}

.alert-white {
  --bs-alert-color: var(--bs-white-text-emphasis);
  --bs-alert-bg: var(--bs-white-bg-subtle);
  --bs-alert-border-color: var(--bs-white-border-subtle);
  --bs-alert-link-color: var(--bs-white-text-emphasis);
}

.alert-transparent {
  --bs-alert-color: var(--bs-transparent-text-emphasis);
  --bs-alert-bg: var(--bs-transparent-bg-subtle);
  --bs-alert-border-color: var(--bs-transparent-border-subtle);
  --bs-alert-link-color: var(--bs-transparent-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 0.75rem;
  --bs-list-group-item-padding-y: 0.375rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #2495cf;
  --bs-list-group-active-border-color: #2495cf;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-preparation {
  --bs-list-group-color: var(--bs-preparation-text-emphasis);
  --bs-list-group-bg: var(--bs-preparation-bg-subtle);
  --bs-list-group-border-color: var(--bs-preparation-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-preparation-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-preparation-border-subtle);
  --bs-list-group-active-color: var(--bs-preparation-bg-subtle);
  --bs-list-group-active-bg: var(--bs-preparation-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-preparation-text-emphasis);
}

.list-group-item-step {
  --bs-list-group-color: var(--bs-step-text-emphasis);
  --bs-list-group-bg: var(--bs-step-bg-subtle);
  --bs-list-group-border-color: var(--bs-step-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-step-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-step-border-subtle);
  --bs-list-group-active-color: var(--bs-step-bg-subtle);
  --bs-list-group-active-bg: var(--bs-step-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-step-text-emphasis);
}

.list-group-item-action {
  --bs-list-group-color: var(--bs-action-text-emphasis);
  --bs-list-group-bg: var(--bs-action-bg-subtle);
  --bs-list-group-border-color: var(--bs-action-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-action-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-action-border-subtle);
  --bs-list-group-active-color: var(--bs-action-bg-subtle);
  --bs-list-group-active-bg: var(--bs-action-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-action-text-emphasis);
}

.list-group-item-condition {
  --bs-list-group-color: var(--bs-condition-text-emphasis);
  --bs-list-group-bg: var(--bs-condition-bg-subtle);
  --bs-list-group-border-color: var(--bs-condition-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-condition-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-condition-border-subtle);
  --bs-list-group-active-color: var(--bs-condition-bg-subtle);
  --bs-list-group-active-bg: var(--bs-condition-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-condition-text-emphasis);
}

.list-group-item-white {
  --bs-list-group-color: var(--bs-white-text-emphasis);
  --bs-list-group-bg: var(--bs-white-bg-subtle);
  --bs-list-group-border-color: var(--bs-white-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-white-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-white-border-subtle);
  --bs-list-group-active-color: var(--bs-white-bg-subtle);
  --bs-list-group-active-bg: var(--bs-white-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-white-text-emphasis);
}

.list-group-item-transparent {
  --bs-list-group-color: var(--bs-transparent-text-emphasis);
  --bs-list-group-bg: var(--bs-transparent-bg-subtle);
  --bs-list-group-border-color: var(--bs-transparent-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-transparent-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-transparent-border-subtle);
  --bs-list-group-active-color: var(--bs-transparent-bg-subtle);
  --bs-list-group-active-bg: var(--bs-transparent-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-transparent-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 1rem;
  --bs-toast-padding-y: 0.75rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: #fff;
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: 0.5rem;
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 400px;
  --bs-modal-padding: 0.75rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 0.75rem;
  --bs-modal-header-padding-y: 0.35rem;
  --bs-modal-header-padding: 0.35rem 0.75rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #fff;
  --bs-backdrop-opacity: 0.9;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 100%;
  --bs-tooltip-padding-x: 0.375rem;
  --bs-tooltip-padding-y: 0.1875rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: #212529;
  --bs-tooltip-bg: #212529;
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 0.75rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 0.75rem;
  --bs-popover-body-padding-y: 0.75rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 0.75rem;
  --bs-offcanvas-padding-y: 0.75rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.9;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-preparation {
  color: #000 !important;
  background-color: RGBA(var(--bs-preparation-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-step {
  color: #000 !important;
  background-color: RGBA(var(--bs-step-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-action {
  color: #000 !important;
  background-color: RGBA(var(--bs-action-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-condition {
  color: #000 !important;
  background-color: RGBA(var(--bs-condition-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-white {
  color: #000 !important;
  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-transparent {
  color: #fff !important;
  background-color: RGBA(var(--bs-transparent-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(29, 119, 166, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 119, 166, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(202, 77, 77, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(202, 77, 77, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(247, 232, 117, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 232, 117, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(139, 237, 139, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(139, 237, 139, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(41, 98, 146, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(41, 98, 146, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(63, 69, 71, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(63, 69, 71, var(--bs-link-underline-opacity, 1)) !important;
}

.link-preparation {
  color: RGBA(var(--bs-preparation-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-preparation-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-preparation:hover, .link-preparation:focus {
  color: RGBA(187, 199, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(187, 199, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-step {
  color: RGBA(var(--bs-step-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-step-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-step:hover, .link-step:focus {
  color: RGBA(134, 221, 153, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(134, 221, 153, var(--bs-link-underline-opacity, 1)) !important;
}

.link-action {
  color: RGBA(var(--bs-action-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-action-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-action:hover, .link-action:focus {
  color: RGBA(138, 209, 245, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(138, 209, 245, var(--bs-link-underline-opacity, 1)) !important;
}

.link-condition {
  color: RGBA(var(--bs-condition-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-condition-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-condition:hover, .link-condition:focus {
  color: RGBA(239, 216, 136, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(239, 216, 136, var(--bs-link-underline-opacity, 1)) !important;
}

.link-white {
  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-white:hover, .link-white:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-transparent {
  color: RGBA(var(--bs-transparent-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-transparent-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-transparent:hover, .link-transparent:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-preparation {
  --bs-focus-ring-color: rgba(var(--bs-preparation-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-step {
  --bs-focus-ring-color: rgba(var(--bs-step-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-action {
  --bs-focus-ring-color: rgba(var(--bs-action-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-condition {
  --bs-focus-ring-color: rgba(var(--bs-condition-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-white {
  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-transparent {
  --bs-focus-ring-color: rgba(var(--bs-transparent-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-preparation {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-preparation-rgb), var(--bs-border-opacity)) !important;
}

.border-step {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-step-rgb), var(--bs-border-opacity)) !important;
}

.border-action {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-action-rgb), var(--bs-border-opacity)) !important;
}

.border-condition {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-condition-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-transparent {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-transparent-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.1875rem !important;
}

.m-2 {
  margin: 0.375rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.m-4 {
  margin: 1.125rem !important;
}

.m-5 {
  margin: 1.6875rem !important;
}

.m-6 {
  margin: 2.53125rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.1875rem !important;
  margin-left: 0.1875rem !important;
}

.mx-2 {
  margin-right: 0.375rem !important;
  margin-left: 0.375rem !important;
}

.mx-3 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-4 {
  margin-right: 1.125rem !important;
  margin-left: 1.125rem !important;
}

.mx-5 {
  margin-right: 1.6875rem !important;
  margin-left: 1.6875rem !important;
}

.mx-6 {
  margin-right: 2.53125rem !important;
  margin-left: 2.53125rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.1875rem !important;
  margin-bottom: 0.1875rem !important;
}

.my-2 {
  margin-top: 0.375rem !important;
  margin-bottom: 0.375rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-4 {
  margin-top: 1.125rem !important;
  margin-bottom: 1.125rem !important;
}

.my-5 {
  margin-top: 1.6875rem !important;
  margin-bottom: 1.6875rem !important;
}

.my-6 {
  margin-top: 2.53125rem !important;
  margin-bottom: 2.53125rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.1875rem !important;
}

.mt-2 {
  margin-top: 0.375rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1.125rem !important;
}

.mt-5 {
  margin-top: 1.6875rem !important;
}

.mt-6 {
  margin-top: 2.53125rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.1875rem !important;
}

.me-2 {
  margin-right: 0.375rem !important;
}

.me-3 {
  margin-right: 0.75rem !important;
}

.me-4 {
  margin-right: 1.125rem !important;
}

.me-5 {
  margin-right: 1.6875rem !important;
}

.me-6 {
  margin-right: 2.53125rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.1875rem !important;
}

.mb-2 {
  margin-bottom: 0.375rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1.125rem !important;
}

.mb-5 {
  margin-bottom: 1.6875rem !important;
}

.mb-6 {
  margin-bottom: 2.53125rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.1875rem !important;
}

.ms-2 {
  margin-left: 0.375rem !important;
}

.ms-3 {
  margin-left: 0.75rem !important;
}

.ms-4 {
  margin-left: 1.125rem !important;
}

.ms-5 {
  margin-left: 1.6875rem !important;
}

.ms-6 {
  margin-left: 2.53125rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.1875rem !important;
}

.p-2 {
  padding: 0.375rem !important;
}

.p-3 {
  padding: 0.75rem !important;
}

.p-4 {
  padding: 1.125rem !important;
}

.p-5 {
  padding: 1.6875rem !important;
}

.p-6 {
  padding: 2.53125rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.1875rem !important;
  padding-left: 0.1875rem !important;
}

.px-2 {
  padding-right: 0.375rem !important;
  padding-left: 0.375rem !important;
}

.px-3 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-4 {
  padding-right: 1.125rem !important;
  padding-left: 1.125rem !important;
}

.px-5 {
  padding-right: 1.6875rem !important;
  padding-left: 1.6875rem !important;
}

.px-6 {
  padding-right: 2.53125rem !important;
  padding-left: 2.53125rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.1875rem !important;
  padding-bottom: 0.1875rem !important;
}

.py-2 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}

.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-4 {
  padding-top: 1.125rem !important;
  padding-bottom: 1.125rem !important;
}

.py-5 {
  padding-top: 1.6875rem !important;
  padding-bottom: 1.6875rem !important;
}

.py-6 {
  padding-top: 2.53125rem !important;
  padding-bottom: 2.53125rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.1875rem !important;
}

.pt-2 {
  padding-top: 0.375rem !important;
}

.pt-3 {
  padding-top: 0.75rem !important;
}

.pt-4 {
  padding-top: 1.125rem !important;
}

.pt-5 {
  padding-top: 1.6875rem !important;
}

.pt-6 {
  padding-top: 2.53125rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.1875rem !important;
}

.pe-2 {
  padding-right: 0.375rem !important;
}

.pe-3 {
  padding-right: 0.75rem !important;
}

.pe-4 {
  padding-right: 1.125rem !important;
}

.pe-5 {
  padding-right: 1.6875rem !important;
}

.pe-6 {
  padding-right: 2.53125rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.1875rem !important;
}

.pb-2 {
  padding-bottom: 0.375rem !important;
}

.pb-3 {
  padding-bottom: 0.75rem !important;
}

.pb-4 {
  padding-bottom: 1.125rem !important;
}

.pb-5 {
  padding-bottom: 1.6875rem !important;
}

.pb-6 {
  padding-bottom: 2.53125rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.1875rem !important;
}

.ps-2 {
  padding-left: 0.375rem !important;
}

.ps-3 {
  padding-left: 0.75rem !important;
}

.ps-4 {
  padding-left: 1.125rem !important;
}

.ps-5 {
  padding-left: 1.6875rem !important;
}

.ps-6 {
  padding-left: 2.53125rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.1875rem !important;
}

.gap-2 {
  gap: 0.375rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1.125rem !important;
}

.gap-5 {
  gap: 1.6875rem !important;
}

.gap-6 {
  gap: 2.53125rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.1875rem !important;
}

.row-gap-2 {
  row-gap: 0.375rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.row-gap-4 {
  row-gap: 1.125rem !important;
}

.row-gap-5 {
  row-gap: 1.6875rem !important;
}

.row-gap-6 {
  row-gap: 2.53125rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.1875rem !important;
}

.column-gap-2 {
  column-gap: 0.375rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.column-gap-4 {
  column-gap: 1.125rem !important;
}

.column-gap-5 {
  column-gap: 1.6875rem !important;
}

.column-gap-6 {
  column-gap: 2.53125rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.309615rem + 0.71538vw) !important;
}

.fs-2 {
  font-size: calc(1.286538rem + 0.438456vw) !important;
}

.fs-3 {
  font-size: calc(1.263462rem + 0.161544vw) !important;
}

.fs-4 {
  font-size: 1.23077rem !important;
}

.fs-5 {
  font-size: 1.07692rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-preparation {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-preparation-rgb), var(--bs-text-opacity)) !important;
}

.text-step {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-step-rgb), var(--bs-text-opacity)) !important;
}

.text-action {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-action-rgb), var(--bs-text-opacity)) !important;
}

.text-condition {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-condition-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-transparent {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-transparent-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-preparation {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-preparation-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-step {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-step-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-action {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-action-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-condition {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-condition-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-white {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-transparent {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-transparent-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-preparation {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-preparation-rgb), var(--bs-bg-opacity)) !important;
}

.bg-step {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-step-rgb), var(--bs-bg-opacity)) !important;
}

.bg-action {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-action-rgb), var(--bs-bg-opacity)) !important;
}

.bg-condition {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-condition-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.1875rem !important;
  }
  .m-sm-2 {
    margin: 0.375rem !important;
  }
  .m-sm-3 {
    margin: 0.75rem !important;
  }
  .m-sm-4 {
    margin: 1.125rem !important;
  }
  .m-sm-5 {
    margin: 1.6875rem !important;
  }
  .m-sm-6 {
    margin: 2.53125rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.1875rem !important;
    margin-left: 0.1875rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-sm-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.125rem !important;
    margin-left: 1.125rem !important;
  }
  .mx-sm-5 {
    margin-right: 1.6875rem !important;
    margin-left: 1.6875rem !important;
  }
  .mx-sm-6 {
    margin-right: 2.53125rem !important;
    margin-left: 2.53125rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.1875rem !important;
    margin-bottom: 0.1875rem !important;
  }
  .my-sm-2 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-sm-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-4 {
    margin-top: 1.125rem !important;
    margin-bottom: 1.125rem !important;
  }
  .my-sm-5 {
    margin-top: 1.6875rem !important;
    margin-bottom: 1.6875rem !important;
  }
  .my-sm-6 {
    margin-top: 2.53125rem !important;
    margin-bottom: 2.53125rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.1875rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.375rem !important;
  }
  .mt-sm-3 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.125rem !important;
  }
  .mt-sm-5 {
    margin-top: 1.6875rem !important;
  }
  .mt-sm-6 {
    margin-top: 2.53125rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.1875rem !important;
  }
  .me-sm-2 {
    margin-right: 0.375rem !important;
  }
  .me-sm-3 {
    margin-right: 0.75rem !important;
  }
  .me-sm-4 {
    margin-right: 1.125rem !important;
  }
  .me-sm-5 {
    margin-right: 1.6875rem !important;
  }
  .me-sm-6 {
    margin-right: 2.53125rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.1875rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.375rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.125rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 1.6875rem !important;
  }
  .mb-sm-6 {
    margin-bottom: 2.53125rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.1875rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.375rem !important;
  }
  .ms-sm-3 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.125rem !important;
  }
  .ms-sm-5 {
    margin-left: 1.6875rem !important;
  }
  .ms-sm-6 {
    margin-left: 2.53125rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.1875rem !important;
  }
  .p-sm-2 {
    padding: 0.375rem !important;
  }
  .p-sm-3 {
    padding: 0.75rem !important;
  }
  .p-sm-4 {
    padding: 1.125rem !important;
  }
  .p-sm-5 {
    padding: 1.6875rem !important;
  }
  .p-sm-6 {
    padding: 2.53125rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.1875rem !important;
    padding-left: 0.1875rem !important;
  }
  .px-sm-2 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-sm-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-4 {
    padding-right: 1.125rem !important;
    padding-left: 1.125rem !important;
  }
  .px-sm-5 {
    padding-right: 1.6875rem !important;
    padding-left: 1.6875rem !important;
  }
  .px-sm-6 {
    padding-right: 2.53125rem !important;
    padding-left: 2.53125rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.1875rem !important;
    padding-bottom: 0.1875rem !important;
  }
  .py-sm-2 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-sm-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-4 {
    padding-top: 1.125rem !important;
    padding-bottom: 1.125rem !important;
  }
  .py-sm-5 {
    padding-top: 1.6875rem !important;
    padding-bottom: 1.6875rem !important;
  }
  .py-sm-6 {
    padding-top: 2.53125rem !important;
    padding-bottom: 2.53125rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.1875rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.375rem !important;
  }
  .pt-sm-3 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.125rem !important;
  }
  .pt-sm-5 {
    padding-top: 1.6875rem !important;
  }
  .pt-sm-6 {
    padding-top: 2.53125rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.1875rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.375rem !important;
  }
  .pe-sm-3 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.125rem !important;
  }
  .pe-sm-5 {
    padding-right: 1.6875rem !important;
  }
  .pe-sm-6 {
    padding-right: 2.53125rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.1875rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.375rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.125rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 1.6875rem !important;
  }
  .pb-sm-6 {
    padding-bottom: 2.53125rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.1875rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.375rem !important;
  }
  .ps-sm-3 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.125rem !important;
  }
  .ps-sm-5 {
    padding-left: 1.6875rem !important;
  }
  .ps-sm-6 {
    padding-left: 2.53125rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.1875rem !important;
  }
  .gap-sm-2 {
    gap: 0.375rem !important;
  }
  .gap-sm-3 {
    gap: 0.75rem !important;
  }
  .gap-sm-4 {
    gap: 1.125rem !important;
  }
  .gap-sm-5 {
    gap: 1.6875rem !important;
  }
  .gap-sm-6 {
    gap: 2.53125rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.1875rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.375rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.125rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 1.6875rem !important;
  }
  .row-gap-sm-6 {
    row-gap: 2.53125rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.1875rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.375rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.125rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 1.6875rem !important;
  }
  .column-gap-sm-6 {
    column-gap: 2.53125rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.1875rem !important;
  }
  .m-md-2 {
    margin: 0.375rem !important;
  }
  .m-md-3 {
    margin: 0.75rem !important;
  }
  .m-md-4 {
    margin: 1.125rem !important;
  }
  .m-md-5 {
    margin: 1.6875rem !important;
  }
  .m-md-6 {
    margin: 2.53125rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.1875rem !important;
    margin-left: 0.1875rem !important;
  }
  .mx-md-2 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-md-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-4 {
    margin-right: 1.125rem !important;
    margin-left: 1.125rem !important;
  }
  .mx-md-5 {
    margin-right: 1.6875rem !important;
    margin-left: 1.6875rem !important;
  }
  .mx-md-6 {
    margin-right: 2.53125rem !important;
    margin-left: 2.53125rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.1875rem !important;
    margin-bottom: 0.1875rem !important;
  }
  .my-md-2 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-md-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-4 {
    margin-top: 1.125rem !important;
    margin-bottom: 1.125rem !important;
  }
  .my-md-5 {
    margin-top: 1.6875rem !important;
    margin-bottom: 1.6875rem !important;
  }
  .my-md-6 {
    margin-top: 2.53125rem !important;
    margin-bottom: 2.53125rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.1875rem !important;
  }
  .mt-md-2 {
    margin-top: 0.375rem !important;
  }
  .mt-md-3 {
    margin-top: 0.75rem !important;
  }
  .mt-md-4 {
    margin-top: 1.125rem !important;
  }
  .mt-md-5 {
    margin-top: 1.6875rem !important;
  }
  .mt-md-6 {
    margin-top: 2.53125rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.1875rem !important;
  }
  .me-md-2 {
    margin-right: 0.375rem !important;
  }
  .me-md-3 {
    margin-right: 0.75rem !important;
  }
  .me-md-4 {
    margin-right: 1.125rem !important;
  }
  .me-md-5 {
    margin-right: 1.6875rem !important;
  }
  .me-md-6 {
    margin-right: 2.53125rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.1875rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.375rem !important;
  }
  .mb-md-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.125rem !important;
  }
  .mb-md-5 {
    margin-bottom: 1.6875rem !important;
  }
  .mb-md-6 {
    margin-bottom: 2.53125rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.1875rem !important;
  }
  .ms-md-2 {
    margin-left: 0.375rem !important;
  }
  .ms-md-3 {
    margin-left: 0.75rem !important;
  }
  .ms-md-4 {
    margin-left: 1.125rem !important;
  }
  .ms-md-5 {
    margin-left: 1.6875rem !important;
  }
  .ms-md-6 {
    margin-left: 2.53125rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.1875rem !important;
  }
  .p-md-2 {
    padding: 0.375rem !important;
  }
  .p-md-3 {
    padding: 0.75rem !important;
  }
  .p-md-4 {
    padding: 1.125rem !important;
  }
  .p-md-5 {
    padding: 1.6875rem !important;
  }
  .p-md-6 {
    padding: 2.53125rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.1875rem !important;
    padding-left: 0.1875rem !important;
  }
  .px-md-2 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-md-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-4 {
    padding-right: 1.125rem !important;
    padding-left: 1.125rem !important;
  }
  .px-md-5 {
    padding-right: 1.6875rem !important;
    padding-left: 1.6875rem !important;
  }
  .px-md-6 {
    padding-right: 2.53125rem !important;
    padding-left: 2.53125rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.1875rem !important;
    padding-bottom: 0.1875rem !important;
  }
  .py-md-2 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-md-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-4 {
    padding-top: 1.125rem !important;
    padding-bottom: 1.125rem !important;
  }
  .py-md-5 {
    padding-top: 1.6875rem !important;
    padding-bottom: 1.6875rem !important;
  }
  .py-md-6 {
    padding-top: 2.53125rem !important;
    padding-bottom: 2.53125rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.1875rem !important;
  }
  .pt-md-2 {
    padding-top: 0.375rem !important;
  }
  .pt-md-3 {
    padding-top: 0.75rem !important;
  }
  .pt-md-4 {
    padding-top: 1.125rem !important;
  }
  .pt-md-5 {
    padding-top: 1.6875rem !important;
  }
  .pt-md-6 {
    padding-top: 2.53125rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.1875rem !important;
  }
  .pe-md-2 {
    padding-right: 0.375rem !important;
  }
  .pe-md-3 {
    padding-right: 0.75rem !important;
  }
  .pe-md-4 {
    padding-right: 1.125rem !important;
  }
  .pe-md-5 {
    padding-right: 1.6875rem !important;
  }
  .pe-md-6 {
    padding-right: 2.53125rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.1875rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.375rem !important;
  }
  .pb-md-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.125rem !important;
  }
  .pb-md-5 {
    padding-bottom: 1.6875rem !important;
  }
  .pb-md-6 {
    padding-bottom: 2.53125rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.1875rem !important;
  }
  .ps-md-2 {
    padding-left: 0.375rem !important;
  }
  .ps-md-3 {
    padding-left: 0.75rem !important;
  }
  .ps-md-4 {
    padding-left: 1.125rem !important;
  }
  .ps-md-5 {
    padding-left: 1.6875rem !important;
  }
  .ps-md-6 {
    padding-left: 2.53125rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.1875rem !important;
  }
  .gap-md-2 {
    gap: 0.375rem !important;
  }
  .gap-md-3 {
    gap: 0.75rem !important;
  }
  .gap-md-4 {
    gap: 1.125rem !important;
  }
  .gap-md-5 {
    gap: 1.6875rem !important;
  }
  .gap-md-6 {
    gap: 2.53125rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.1875rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.375rem !important;
  }
  .row-gap-md-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.125rem !important;
  }
  .row-gap-md-5 {
    row-gap: 1.6875rem !important;
  }
  .row-gap-md-6 {
    row-gap: 2.53125rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.1875rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.375rem !important;
  }
  .column-gap-md-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.125rem !important;
  }
  .column-gap-md-5 {
    column-gap: 1.6875rem !important;
  }
  .column-gap-md-6 {
    column-gap: 2.53125rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.1875rem !important;
  }
  .m-lg-2 {
    margin: 0.375rem !important;
  }
  .m-lg-3 {
    margin: 0.75rem !important;
  }
  .m-lg-4 {
    margin: 1.125rem !important;
  }
  .m-lg-5 {
    margin: 1.6875rem !important;
  }
  .m-lg-6 {
    margin: 2.53125rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.1875rem !important;
    margin-left: 0.1875rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-lg-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.125rem !important;
    margin-left: 1.125rem !important;
  }
  .mx-lg-5 {
    margin-right: 1.6875rem !important;
    margin-left: 1.6875rem !important;
  }
  .mx-lg-6 {
    margin-right: 2.53125rem !important;
    margin-left: 2.53125rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.1875rem !important;
    margin-bottom: 0.1875rem !important;
  }
  .my-lg-2 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-lg-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-4 {
    margin-top: 1.125rem !important;
    margin-bottom: 1.125rem !important;
  }
  .my-lg-5 {
    margin-top: 1.6875rem !important;
    margin-bottom: 1.6875rem !important;
  }
  .my-lg-6 {
    margin-top: 2.53125rem !important;
    margin-bottom: 2.53125rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.1875rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.375rem !important;
  }
  .mt-lg-3 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.125rem !important;
  }
  .mt-lg-5 {
    margin-top: 1.6875rem !important;
  }
  .mt-lg-6 {
    margin-top: 2.53125rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.1875rem !important;
  }
  .me-lg-2 {
    margin-right: 0.375rem !important;
  }
  .me-lg-3 {
    margin-right: 0.75rem !important;
  }
  .me-lg-4 {
    margin-right: 1.125rem !important;
  }
  .me-lg-5 {
    margin-right: 1.6875rem !important;
  }
  .me-lg-6 {
    margin-right: 2.53125rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.1875rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.375rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.125rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 1.6875rem !important;
  }
  .mb-lg-6 {
    margin-bottom: 2.53125rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.1875rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.375rem !important;
  }
  .ms-lg-3 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.125rem !important;
  }
  .ms-lg-5 {
    margin-left: 1.6875rem !important;
  }
  .ms-lg-6 {
    margin-left: 2.53125rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.1875rem !important;
  }
  .p-lg-2 {
    padding: 0.375rem !important;
  }
  .p-lg-3 {
    padding: 0.75rem !important;
  }
  .p-lg-4 {
    padding: 1.125rem !important;
  }
  .p-lg-5 {
    padding: 1.6875rem !important;
  }
  .p-lg-6 {
    padding: 2.53125rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.1875rem !important;
    padding-left: 0.1875rem !important;
  }
  .px-lg-2 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-lg-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-4 {
    padding-right: 1.125rem !important;
    padding-left: 1.125rem !important;
  }
  .px-lg-5 {
    padding-right: 1.6875rem !important;
    padding-left: 1.6875rem !important;
  }
  .px-lg-6 {
    padding-right: 2.53125rem !important;
    padding-left: 2.53125rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.1875rem !important;
    padding-bottom: 0.1875rem !important;
  }
  .py-lg-2 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-lg-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-4 {
    padding-top: 1.125rem !important;
    padding-bottom: 1.125rem !important;
  }
  .py-lg-5 {
    padding-top: 1.6875rem !important;
    padding-bottom: 1.6875rem !important;
  }
  .py-lg-6 {
    padding-top: 2.53125rem !important;
    padding-bottom: 2.53125rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.1875rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.375rem !important;
  }
  .pt-lg-3 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.125rem !important;
  }
  .pt-lg-5 {
    padding-top: 1.6875rem !important;
  }
  .pt-lg-6 {
    padding-top: 2.53125rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.1875rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.375rem !important;
  }
  .pe-lg-3 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.125rem !important;
  }
  .pe-lg-5 {
    padding-right: 1.6875rem !important;
  }
  .pe-lg-6 {
    padding-right: 2.53125rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.1875rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.375rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.125rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 1.6875rem !important;
  }
  .pb-lg-6 {
    padding-bottom: 2.53125rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.1875rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.375rem !important;
  }
  .ps-lg-3 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.125rem !important;
  }
  .ps-lg-5 {
    padding-left: 1.6875rem !important;
  }
  .ps-lg-6 {
    padding-left: 2.53125rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.1875rem !important;
  }
  .gap-lg-2 {
    gap: 0.375rem !important;
  }
  .gap-lg-3 {
    gap: 0.75rem !important;
  }
  .gap-lg-4 {
    gap: 1.125rem !important;
  }
  .gap-lg-5 {
    gap: 1.6875rem !important;
  }
  .gap-lg-6 {
    gap: 2.53125rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.1875rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.375rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.125rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 1.6875rem !important;
  }
  .row-gap-lg-6 {
    row-gap: 2.53125rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.1875rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.375rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.125rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 1.6875rem !important;
  }
  .column-gap-lg-6 {
    column-gap: 2.53125rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.1875rem !important;
  }
  .m-xl-2 {
    margin: 0.375rem !important;
  }
  .m-xl-3 {
    margin: 0.75rem !important;
  }
  .m-xl-4 {
    margin: 1.125rem !important;
  }
  .m-xl-5 {
    margin: 1.6875rem !important;
  }
  .m-xl-6 {
    margin: 2.53125rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.1875rem !important;
    margin-left: 0.1875rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.125rem !important;
    margin-left: 1.125rem !important;
  }
  .mx-xl-5 {
    margin-right: 1.6875rem !important;
    margin-left: 1.6875rem !important;
  }
  .mx-xl-6 {
    margin-right: 2.53125rem !important;
    margin-left: 2.53125rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.1875rem !important;
    margin-bottom: 0.1875rem !important;
  }
  .my-xl-2 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-4 {
    margin-top: 1.125rem !important;
    margin-bottom: 1.125rem !important;
  }
  .my-xl-5 {
    margin-top: 1.6875rem !important;
    margin-bottom: 1.6875rem !important;
  }
  .my-xl-6 {
    margin-top: 2.53125rem !important;
    margin-bottom: 2.53125rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.1875rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.375rem !important;
  }
  .mt-xl-3 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.125rem !important;
  }
  .mt-xl-5 {
    margin-top: 1.6875rem !important;
  }
  .mt-xl-6 {
    margin-top: 2.53125rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.1875rem !important;
  }
  .me-xl-2 {
    margin-right: 0.375rem !important;
  }
  .me-xl-3 {
    margin-right: 0.75rem !important;
  }
  .me-xl-4 {
    margin-right: 1.125rem !important;
  }
  .me-xl-5 {
    margin-right: 1.6875rem !important;
  }
  .me-xl-6 {
    margin-right: 2.53125rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.1875rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.125rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 1.6875rem !important;
  }
  .mb-xl-6 {
    margin-bottom: 2.53125rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.1875rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.375rem !important;
  }
  .ms-xl-3 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.125rem !important;
  }
  .ms-xl-5 {
    margin-left: 1.6875rem !important;
  }
  .ms-xl-6 {
    margin-left: 2.53125rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.1875rem !important;
  }
  .p-xl-2 {
    padding: 0.375rem !important;
  }
  .p-xl-3 {
    padding: 0.75rem !important;
  }
  .p-xl-4 {
    padding: 1.125rem !important;
  }
  .p-xl-5 {
    padding: 1.6875rem !important;
  }
  .p-xl-6 {
    padding: 2.53125rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.1875rem !important;
    padding-left: 0.1875rem !important;
  }
  .px-xl-2 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-4 {
    padding-right: 1.125rem !important;
    padding-left: 1.125rem !important;
  }
  .px-xl-5 {
    padding-right: 1.6875rem !important;
    padding-left: 1.6875rem !important;
  }
  .px-xl-6 {
    padding-right: 2.53125rem !important;
    padding-left: 2.53125rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.1875rem !important;
    padding-bottom: 0.1875rem !important;
  }
  .py-xl-2 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-4 {
    padding-top: 1.125rem !important;
    padding-bottom: 1.125rem !important;
  }
  .py-xl-5 {
    padding-top: 1.6875rem !important;
    padding-bottom: 1.6875rem !important;
  }
  .py-xl-6 {
    padding-top: 2.53125rem !important;
    padding-bottom: 2.53125rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.1875rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.375rem !important;
  }
  .pt-xl-3 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.125rem !important;
  }
  .pt-xl-5 {
    padding-top: 1.6875rem !important;
  }
  .pt-xl-6 {
    padding-top: 2.53125rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.1875rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.375rem !important;
  }
  .pe-xl-3 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.125rem !important;
  }
  .pe-xl-5 {
    padding-right: 1.6875rem !important;
  }
  .pe-xl-6 {
    padding-right: 2.53125rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.1875rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.125rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 1.6875rem !important;
  }
  .pb-xl-6 {
    padding-bottom: 2.53125rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.1875rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.375rem !important;
  }
  .ps-xl-3 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.125rem !important;
  }
  .ps-xl-5 {
    padding-left: 1.6875rem !important;
  }
  .ps-xl-6 {
    padding-left: 2.53125rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.1875rem !important;
  }
  .gap-xl-2 {
    gap: 0.375rem !important;
  }
  .gap-xl-3 {
    gap: 0.75rem !important;
  }
  .gap-xl-4 {
    gap: 1.125rem !important;
  }
  .gap-xl-5 {
    gap: 1.6875rem !important;
  }
  .gap-xl-6 {
    gap: 2.53125rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.1875rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.375rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.125rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 1.6875rem !important;
  }
  .row-gap-xl-6 {
    row-gap: 2.53125rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.1875rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.375rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.125rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 1.6875rem !important;
  }
  .column-gap-xl-6 {
    column-gap: 2.53125rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.1875rem !important;
  }
  .m-xxl-2 {
    margin: 0.375rem !important;
  }
  .m-xxl-3 {
    margin: 0.75rem !important;
  }
  .m-xxl-4 {
    margin: 1.125rem !important;
  }
  .m-xxl-5 {
    margin: 1.6875rem !important;
  }
  .m-xxl-6 {
    margin: 2.53125rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.1875rem !important;
    margin-left: 0.1875rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xxl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.125rem !important;
    margin-left: 1.125rem !important;
  }
  .mx-xxl-5 {
    margin-right: 1.6875rem !important;
    margin-left: 1.6875rem !important;
  }
  .mx-xxl-6 {
    margin-right: 2.53125rem !important;
    margin-left: 2.53125rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.1875rem !important;
    margin-bottom: 0.1875rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xxl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.125rem !important;
    margin-bottom: 1.125rem !important;
  }
  .my-xxl-5 {
    margin-top: 1.6875rem !important;
    margin-bottom: 1.6875rem !important;
  }
  .my-xxl-6 {
    margin-top: 2.53125rem !important;
    margin-bottom: 2.53125rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.1875rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.375rem !important;
  }
  .mt-xxl-3 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.125rem !important;
  }
  .mt-xxl-5 {
    margin-top: 1.6875rem !important;
  }
  .mt-xxl-6 {
    margin-top: 2.53125rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.1875rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.375rem !important;
  }
  .me-xxl-3 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.125rem !important;
  }
  .me-xxl-5 {
    margin-right: 1.6875rem !important;
  }
  .me-xxl-6 {
    margin-right: 2.53125rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.1875rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.125rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 1.6875rem !important;
  }
  .mb-xxl-6 {
    margin-bottom: 2.53125rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.1875rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.375rem !important;
  }
  .ms-xxl-3 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.125rem !important;
  }
  .ms-xxl-5 {
    margin-left: 1.6875rem !important;
  }
  .ms-xxl-6 {
    margin-left: 2.53125rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.1875rem !important;
  }
  .p-xxl-2 {
    padding: 0.375rem !important;
  }
  .p-xxl-3 {
    padding: 0.75rem !important;
  }
  .p-xxl-4 {
    padding: 1.125rem !important;
  }
  .p-xxl-5 {
    padding: 1.6875rem !important;
  }
  .p-xxl-6 {
    padding: 2.53125rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.1875rem !important;
    padding-left: 0.1875rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xxl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.125rem !important;
    padding-left: 1.125rem !important;
  }
  .px-xxl-5 {
    padding-right: 1.6875rem !important;
    padding-left: 1.6875rem !important;
  }
  .px-xxl-6 {
    padding-right: 2.53125rem !important;
    padding-left: 2.53125rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.1875rem !important;
    padding-bottom: 0.1875rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xxl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.125rem !important;
    padding-bottom: 1.125rem !important;
  }
  .py-xxl-5 {
    padding-top: 1.6875rem !important;
    padding-bottom: 1.6875rem !important;
  }
  .py-xxl-6 {
    padding-top: 2.53125rem !important;
    padding-bottom: 2.53125rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.1875rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.375rem !important;
  }
  .pt-xxl-3 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.125rem !important;
  }
  .pt-xxl-5 {
    padding-top: 1.6875rem !important;
  }
  .pt-xxl-6 {
    padding-top: 2.53125rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.1875rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.375rem !important;
  }
  .pe-xxl-3 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.125rem !important;
  }
  .pe-xxl-5 {
    padding-right: 1.6875rem !important;
  }
  .pe-xxl-6 {
    padding-right: 2.53125rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.1875rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.125rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 1.6875rem !important;
  }
  .pb-xxl-6 {
    padding-bottom: 2.53125rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.1875rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.375rem !important;
  }
  .ps-xxl-3 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.125rem !important;
  }
  .ps-xxl-5 {
    padding-left: 1.6875rem !important;
  }
  .ps-xxl-6 {
    padding-left: 2.53125rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.1875rem !important;
  }
  .gap-xxl-2 {
    gap: 0.375rem !important;
  }
  .gap-xxl-3 {
    gap: 0.75rem !important;
  }
  .gap-xxl-4 {
    gap: 1.125rem !important;
  }
  .gap-xxl-5 {
    gap: 1.6875rem !important;
  }
  .gap-xxl-6 {
    gap: 2.53125rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.1875rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.375rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.125rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 1.6875rem !important;
  }
  .row-gap-xxl-6 {
    row-gap: 2.53125rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.1875rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.375rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.125rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 1.6875rem !important;
  }
  .column-gap-xxl-6 {
    column-gap: 2.53125rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.84615rem !important;
  }
  .fs-2 {
    font-size: 1.61538rem !important;
  }
  .fs-3 {
    font-size: 1.38462rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/* component vars */
/* overwrite bootstrap standard behaviour */
ul {
  padding-left: 0;
}

ul li {
  list-style-position: inside;
}

.btn {
  border-width: 1px;
  border-style: solid;
}

.btn-group .btn {
  color: rgb(121.8, 124.2, 126.6);
}
.btn-group .btn.active {
  color: #212529;
}

.btn-primary {
  border-color: rgb(25.2, 104.3, 144.9);
}
.btn-primary:hover {
  border-color: rgb(30.6, 126.65, 175.95);
}
.btn-outline-primary {
  background-color: #fff;
  color: #212529;
}
.btn-outline-primary:hover {
  color: #212529;
  background-color: rgb(222.15, 239.1, 247.8);
  border-color: rgb(34.2, 141.55, 196.65);
}

.btn-danger {
  border-color: rgb(177.1, 67.2, 67.2);
}
.btn-danger:hover {
  border-color: rgb(215.05, 81.6, 81.6);
}
.btn-outline-danger {
  background-color: #fff;
  color: #212529;
}
.btn-outline-danger:hover {
  color: #212529;
  background-color: rgb(254.7, 231.15, 231.15);
  border-color: rgb(240.35, 91.2, 91.2);
}

.btn-warning {
  border-color: rgb(171.5, 158.2, 57.4);
}
.btn-warning:hover {
  border-color: rgb(208.25, 192.1, 69.7);
}
.btn-outline-warning {
  background-color: #fff;
  color: #212529;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: rgb(253.5, 250.65, 229.05);
  border-color: rgb(232.75, 214.7, 77.9);
}

.btn-success {
  border-color: rgb(77, 162.4, 77);
}
.btn-success:hover {
  border-color: rgb(93.5, 197.2, 93.5);
}
.btn-outline-success {
  background-color: #fff;
  color: #212529;
}
.btn-outline-success:hover {
  color: #212529;
  background-color: rgb(233.25, 251.55, 233.25);
  border-color: rgb(104.5, 220.4, 104.5);
}

.btn-secondary {
  border-color: rgb(35.7, 85.4, 128.1);
}
.btn-secondary:hover {
  border-color: rgb(43.35, 103.7, 155.55);
}
.btn-outline-secondary {
  background-color: #fff;
  color: #212529;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: rgb(224.4, 235.05, 244.2);
  border-color: rgb(48.45, 115.9, 173.85);
}

.btn-dark {
  border-color: rgb(55.3, 60.2, 62.3);
}
.btn-dark:hover {
  border-color: rgb(67.15, 73.1, 75.65);
}
.btn-outline-dark {
  background-color: #fff;
  color: #212529;
}
.btn-outline-dark:hover {
  color: #212529;
  background-color: rgb(228.6, 229.65, 230.1);
  border-color: rgb(75.05, 81.7, 84.55);
}

.btn-preparation {
  border-color: rgb(119, 129.5, 133.7);
}
.btn-preparation:hover {
  border-color: rgb(144.5, 157.25, 162.35);
}
.btn-outline-preparation {
  background-color: #fff;
  color: #212529;
}
.btn-outline-preparation:hover {
  color: #212529;
  background-color: rgb(242.25, 244.5, 245.4);
  border-color: rgb(161.5, 175.75, 181.45);
}

.btn-step {
  border-color: rgb(72.8, 148.4, 88.9);
}
.btn-step:hover {
  border-color: rgb(88.4, 180.2, 107.95);
}
.btn-outline-step {
  background-color: #fff;
  color: #212529;
}
.btn-outline-step:hover {
  color: #212529;
  background-color: rgb(232.35, 248.55, 235.8);
  border-color: rgb(98.8, 201.4, 120.65);
}

.btn-action {
  border-color: rgb(76.3, 137.9, 169.4);
}
.btn-action:hover {
  border-color: rgb(92.65, 167.45, 205.7);
}
.btn-outline-action {
  background-color: #fff;
  color: #212529;
}
.btn-outline-action:hover {
  color: #212529;
  background-color: rgb(233.1, 246.3, 253.05);
  border-color: rgb(103.55, 187.15, 229.9);
}

.btn-condition {
  border-color: rgb(164.5, 144.2, 74.2);
}
.btn-condition:hover {
  border-color: rgb(199.75, 175.1, 90.1);
}
.btn-outline-condition {
  background-color: #fff;
  color: #212529;
}
.btn-outline-condition:hover {
  color: #212529;
  background-color: rgb(252, 247.65, 232.65);
  border-color: rgb(223.25, 195.7, 100.7);
}

.form-control:disabled {
  color: rgb(121.8, 124.2, 126.6) !important;
}

.modal-dialog {
  min-height: 75%;
}
.modal-header * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}
.modal--primary .modal-content {
  border-color: rgb(25.2, 104.3, 144.9);
}
.modal--primary .modal-header,
.modal--primary .modal-footer {
  color: #fff;
  background-color: #2495cf;
}
.modal--danger .modal-content {
  border-color: rgb(177.1, 67.2, 67.2);
}
.modal--danger .modal-header,
.modal--danger .modal-footer {
  color: #fff;
  background-color: #fd6060;
}
.modal--warning .modal-content {
  border-color: rgb(171.5, 158.2, 57.4);
}
.modal--warning .modal-header,
.modal--warning .modal-footer {
  color: #000;
  background-color: #f5e252;
}
.modal--success .modal-content {
  border-color: rgb(77, 162.4, 77);
}
.modal--success .modal-header,
.modal--success .modal-footer {
  color: #000;
  background-color: #6ee86e;
}
.modal--secondary .modal-content {
  border-color: rgb(35.7, 85.4, 128.1);
}
.modal--secondary .modal-header,
.modal--secondary .modal-footer {
  color: #fff;
  background-color: #337ab7;
}
.modal--dark .modal-content {
  border-color: rgb(55.3, 60.2, 62.3);
}
.modal--dark .modal-header,
.modal--dark .modal-footer {
  color: #fff;
  background-color: #4f5659;
}
.modal--preparation .modal-content {
  border-color: rgb(119, 129.5, 133.7);
}
.modal--preparation .modal-header,
.modal--preparation .modal-footer {
  color: #000;
  background-color: #aab9bf;
}
.modal--step .modal-content {
  border-color: rgb(72.8, 148.4, 88.9);
}
.modal--step .modal-header,
.modal--step .modal-footer {
  color: #000;
  background-color: #68d47f;
}
.modal--action .modal-content {
  border-color: rgb(76.3, 137.9, 169.4);
}
.modal--action .modal-header,
.modal--action .modal-footer {
  color: #000;
  background-color: #6dc5f2;
}
.modal--condition .modal-content {
  border-color: rgb(164.5, 144.2, 74.2);
}
.modal--condition .modal-header,
.modal--condition .modal-footer {
  color: #000;
  background-color: #ebce6a;
}
.modal--white .modal-content {
  border-color: rgb(178.5, 178.5, 178.5);
}
.modal--white .modal-header,
.modal--white .modal-footer {
  color: #000;
  background-color: #ffffff;
}
.modal--transparent .modal-content {
  border-color: rgba(0, 0, 0, 0.3);
}
.modal--transparent .modal-header,
.modal--transparent .modal-footer {
  color: #fff;
  background-color: transparent;
}

.toast-header h3, .toast-header .h3,
.toast-header h4,
.toast-header .h4,
.toast-header h5,
.toast-header .h5 {
  margin: 0;
}
.toast-body {
  font-size: 13px;
}
.toast-body ul {
  margin-bottom: 0;
}

.toast--primary .toast-header {
  background-color: #2495cf;
}

.toast--danger .toast-header {
  background-color: #fd6060;
}

.toast--warning .toast-header {
  background-color: #f5e252;
}

.toast--success .toast-header {
  background-color: #6ee86e;
}

.toast--secondary .toast-header {
  background-color: #337ab7;
}

.toast--dark .toast-header {
  background-color: #4f5659;
}

.toast--preparation .toast-header {
  background-color: #aab9bf;
}

.toast--step .toast-header {
  background-color: #68d47f;
}

.toast--action .toast-header {
  background-color: #6dc5f2;
}

.toast--condition .toast-header {
  background-color: #ebce6a;
}

.toast--white .toast-header {
  background-color: #ffffff;
}

.toast--transparent .toast-header {
  background-color: transparent;
}

.tooltip-inner {
  border: 1px solid #212529;
  background-color: #fff;
}

/* styling for components from other libraries */
.react-datetime-picker {
  display: inline-flex;
  position: relative;
}

.react-datetime-picker,
.react-datetime-picker *,
.react-datetime-picker *:before,
.react-datetime-picker *:after {
  box-sizing: border-box;
}

.react-datetime-picker--disabled {
  background-color: #f0f0f0;
  color: #6d6d6d;
}

.react-datetime-picker__wrapper {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  border: thin solid gray;
}

.react-datetime-picker__inputGroup {
  min-width: calc(16px + 3.24em + 0.434em);
  flex-grow: 1;
  padding: 0 2px;
}

.react-datetime-picker__inputGroup__divider {
  padding: 1px 0;
  white-space: pre;
}

.react-datetime-picker__inputGroup__divider,
.react-datetime-picker__inputGroup__leadingZero {
  display: inline-block;
}

.react-datetime-picker__inputGroup__input {
  min-width: 0.54em;
  height: calc(100% - 2px);
  position: relative;
  padding: 1px;
  border: 0;
  background: none;
  color: currentColor;
  font: inherit;
  box-sizing: content-box;
  appearance: textfield;
}

.react-datetime-picker__inputGroup__input::-webkit-outer-spin-button,
.react-datetime-picker__inputGroup__input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.react-datetime-picker__inputGroup__input:invalid {
  background: rgba(255, 0, 0, 0.1);
}

.react-datetime-picker__inputGroup__input--hasLeadingZero {
  margin-left: -0.54em;
  padding-left: calc(1px + 0.54em);
}

.react-datetime-picker__inputGroup__amPm {
  font: inherit;
  appearance: menulist;
}

.react-datetime-picker__button {
  border: 0;
  background: transparent;
  padding: 4px 6px;
}

.react-datetime-picker__button:enabled {
  cursor: pointer;
}

.react-datetime-picker__button:enabled:hover .react-datetime-picker__button__icon,
.react-datetime-picker__button:enabled:focus .react-datetime-picker__button__icon {
  stroke: #0078d7;
}

.react-datetime-picker__button:disabled .react-datetime-picker__button__icon {
  stroke: #6d6d6d;
}

.react-datetime-picker__button svg {
  display: inherit;
}

.react-datetime-picker__calendar,
.react-datetime-picker__clock {
  z-index: 1;
}

.react-datetime-picker__calendar--closed,
.react-datetime-picker__clock--closed {
  display: none;
}

.react-datetime-picker__calendar {
  width: 350px;
  max-width: 100vw;
}

.react-datetime-picker__calendar .react-calendar {
  border-width: thin;
}

.react-datetime-picker__clock {
  width: 200px;
  height: 200px;
  max-width: 100vw;
  padding: 25px;
  background-color: white;
  border: thin solid #a0a096;
}

.react-calendar {
  width: 350px;
  max-width: 100%;
  background: white;
  border: 1px solid #a0a096;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
}

.react-calendar--doubleView {
  width: 700px;
}

.react-calendar--doubleView .react-calendar__viewContainer {
  display: flex;
  margin: -0.5em;
}

.react-calendar--doubleView .react-calendar__viewContainer > * {
  width: 50%;
  margin: 0.5em;
}

.react-calendar,
.react-calendar *,
.react-calendar *:before,
.react-calendar *:after {
  box-sizing: border-box;
}

.react-calendar button {
  margin: 0;
  border: 0;
  outline: none;
}

.react-calendar button:enabled:hover {
  cursor: pointer;
}

.react-calendar__navigation {
  display: flex;
  height: 44px;
  margin-bottom: 1em;
}

.react-calendar__navigation button {
  min-width: 44px;
  background: none;
}

.react-calendar__navigation button:disabled {
  background-color: #f0f0f0;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #e6e6e6;
}

.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font: inherit;
  font-size: 0.75em;
  font-weight: bold;
}

.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}

.react-calendar__month-view__weekNumbers .react-calendar__tile {
  display: flex;
  align-items: center;
  justify-content: center;
  font: inherit;
  font-size: 0.75em;
  font-weight: bold;
}

.react-calendar__month-view__days__day--weekend {
  color: #d10000;
}

.react-calendar__month-view__days__day--neighboringMonth,
.react-calendar__decade-view__years__year--neighboringDecade,
.react-calendar__century-view__decades__decade--neighboringCentury {
  color: #757575;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 2em 0.5em;
}

.react-calendar__tile {
  max-width: 100%;
  padding: 10px 6.6667px;
  background: none;
  text-align: center;
  line-height: 16px;
  font: inherit;
  font-size: 0.833em;
}

.react-calendar__tile:disabled {
  background-color: #f0f0f0;
  color: #ababab;
}

.react-calendar__month-view__days__day--neighboringMonth:disabled,
.react-calendar__decade-view__years__year--neighboringDecade:disabled,
.react-calendar__century-view__decades__decade--neighboringCentury:disabled {
  color: #cdcdcd;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: #e6e6e6;
}

.react-calendar__tile--now {
  background: #ffff76;
}

.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #ffffa9;
}

.react-calendar__tile--hasActive {
  background: #76baff;
}

.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #a9d4ff;
}

.react-calendar__tile--active {
  background: #006edc;
  color: white;
}

.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #1087ff;
}

.react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #e6e6e6;
}

.react-clock {
  display: block;
  position: relative;
}

.react-clock,
.react-clock *,
.react-clock *:before,
.react-clock *:after {
  box-sizing: border-box;
}

.react-clock__face {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border: 1px solid black;
  border-radius: 50%;
}

.react-clock__hand {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  right: 50%;
}

.react-clock__hand__body {
  position: absolute;
  background-color: black;
  transform: translateX(-50%);
}

.react-clock__mark {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  right: 50%;
}

.react-clock__mark__body {
  position: absolute;
  background-color: black;
  transform: translateX(-50%);
}

.react-clock__mark__number {
  position: absolute;
  left: -40px;
  width: 80px;
  text-align: center;
}

.react-clock__second-hand__body {
  background-color: red;
}

.ag-theme-kit {
  --ag-background-color: #fff;
  --ag-foreground-color: #181d1f;
  --ag-border-color: #dddddd;
  --ag-secondary-border-color: var(--ag-border-color);
  --ag-header-background-color: color-mix(
    in srgb,
    var(--ag-background-color),
    var(--ag-foreground-color) 2%
  );
  --ag-tooltip-background-color: var(--ag-header-background-color);
  --ag-control-panel-background-color: var(--ag-header-background-color);
  --ag-subheader-background-color: transparent;
  --ag-invalid-color: #e02525;
  --ag-checkbox-unchecked-color: color-mix(
    in srgb,
    var(--ag-background-color),
    var(--ag-foreground-color) 30%
  );
  --ag-advanced-filter-join-pill-color: #f08e8d;
  --ag-advanced-filter-column-pill-color: #a6e194;
  --ag-advanced-filter-option-pill-color: #f3c08b;
  --ag-advanced-filter-value-pill-color: #85c0e4;
  --ag-header-column-resize-handle-color: var(--ag-secondary-border-color);
  --ag-icon-font-color: color-mix(
    in srgb,
    transparent,
    var(--ag-foreground-color) 90%
  );
  --ag-selected-row-background-color: color-mix(
    in srgb,
    transparent,
    var(--ag-active-color) 8%
  );
  --ag-row-hover-color: color-mix(
    in srgb,
    transparent,
    var(--ag-active-color) 12%
  );
  --ag-column-hover-color: color-mix(
    in srgb,
    transparent,
    var(--ag-foreground-color) 5%
  );
  --ag-input-focus-border-color: var(--ag-active-color);
  --ag-input-focus-box-shadow: 0 0 0 3px
    color-mix(in srgb, transparent, var(--ag-input-focus-border-color) 47%);
  --ag-range-selection-background-color: color-mix(
    in srgb,
    transparent,
    var(--ag-active-color) 20%
  );
  --ag-range-selection-background-color-2: color-mix(
    in srgb,
    transparent,
    var(--ag-active-color) 36%
  );
  --ag-range-selection-background-color-3: color-mix(
    in srgb,
    transparent,
    var(--ag-active-color) 49%
  );
  --ag-range-selection-background-color-4: color-mix(
    in srgb,
    transparent,
    var(--ag-active-color) 59%
  );
  --ag-checkbox-background-color: var(--ag-background-color);
  --ag-checkbox-checked-color: var(--ag-active-color);
  --ag-range-selection-border-color: var(--ag-active-color);
  --ag-secondary-foreground-color: var(--ag-foreground-color);
  --ag-input-border-color: var(--ag-border-color);
  --ag-input-border-color-invalid: var(--ag-invalid-color);
  --ag-disabled-foreground-color: color-mix(
    in srgb,
    transparent,
    var(--ag-foreground-color) 50%
  );
  --ag-chip-background-color: color-mix(
    in srgb,
    transparent,
    var(--ag-foreground-color) 7%
  );
  --ag-chip-border-color: color-mix(
    in srgb,
    var(--ag-header-background-color),
    var(--ag-foreground-color) 13%
  );
  --ag-input-disabled-border-color: var(--ag-border-color);
  --ag-input-disabled-background-color: color-mix(
    in srgb,
    var(--ag-background-color),
    var(--ag-foreground-color) 6%
  );
  --ag-modal-overlay-background-color: color-mix(
    in srgb,
    transparent,
    var(--ag-background-color) 66%
  );
  --ag-borders: solid 1px;
  --ag-border-radius: 4px;
  --ag-wrapper-border-radius: 8px;
  --ag-borders-side-button: none;
  --ag-side-button-selected-background-color: transparent;
  --ag-header-column-resize-handle-display: block;
  --ag-header-column-resize-handle-width: 2px;
  --ag-header-column-resize-handle-height: 30%;
  --ag-grid-size: 8px;
  --ag-icon-size: 16px;
  --ag-header-height: calc(var(--ag-font-size) + var(--ag-grid-size) * 4.25);
  --ag-row-height: calc(var(--ag-font-size) + var(--ag-grid-size) * 3.5);
  --ag-list-item-height: calc(
    var(--ag-icon-size) + var(--ag-widget-vertical-spacing)
  );
  --ag-column-select-indent-size: var(--ag-icon-size);
  --ag-set-filter-indent-size: var(--ag-icon-size);
  --ag-advanced-filter-builder-indent-size: calc(
    var(--ag-icon-size) + var(--ag-grid-size) * 2
  );
  --ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 2);
  --ag-cell-widget-spacing: calc(var(--ag-grid-size) * 1.5);
  --ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 1.5);
  --ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 1.5);
  --ag-widget-horizontal-spacing: calc(var(--ag-grid-size) * 1.5);
  --ag-widget-vertical-spacing: calc(var(--ag-grid-size) * 1);
  --ag-toggle-button-height: 18px;
  --ag-toggle-button-width: 28px;
  --ag-toggle-button-border-width: 2px;
  --ag-font-family: inherit;
  --ag-font-size: 14px;
  --ag-icon-font-family: inherit;
  --ag-tab-min-width: 0;
  --ag-card-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);
  --ag-popup-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  --ag-side-bar-panel-width: 250px;
}
.ag-theme-kit--primary {
  --ag-active-color: #2495cf;
}
.ag-theme-kit--danger {
  --ag-active-color: #fd6060;
}
.ag-theme-kit--warning {
  --ag-active-color: #f5e252;
}
.ag-theme-kit--success {
  --ag-active-color: #6ee86e;
}
.ag-theme-kit--secondary {
  --ag-active-color: #337ab7;
}
.ag-theme-kit--dark {
  --ag-active-color: #4f5659;
}
.ag-theme-kit--preparation {
  --ag-active-color: #aab9bf;
}
.ag-theme-kit--step {
  --ag-active-color: #68d47f;
}
.ag-theme-kit--action {
  --ag-active-color: #6dc5f2;
}
.ag-theme-kit--condition {
  --ag-active-color: #ebce6a;
}
.ag-theme-kit--white {
  --ag-active-color: #ffffff;
}
.ag-theme-kit--transparent {
  --ag-active-color: transparent;
}

.ag-theme-kit .ag-icon-menu::before,
.ag-theme-kit .ag-icon-asc::before,
.ag-theme-kit .ag-icon-desc::before,
.ag-theme-kit .ag-icon-filter::before,
.ag-theme-kit .ag-icon-small-down::before {
  background-repeat: no-repeat;
  background-position: center;
  display: block;
  width: 16px;
  height: 16px;
  content: "";
}
.ag-theme-kit .ag-icon-menu::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.ag-theme-kit .ag-icon-asc::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.ag-theme-kit .ag-icon-desc::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.ag-theme-kit .ag-icon-filter::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.ag-theme-kit .ag-icon-small-down::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 16px 12px;
}
.ag-theme-kit .ag-radio-button-input-wrapper input {
  opacity: 1;
}
.ag-theme-kit .ag-radio-button-input-wrapper::after {
  display: none;
}
.ag-theme-kit .ag-filter-toolpanel-header,
.ag-theme-kit .ag-filter-toolpanel-search,
.ag-theme-kit .ag-status-bar,
.ag-theme-kit .ag-header-row,
.ag-theme-kit .ag-panel-title-bar-title,
.ag-theme-kit .ag-multi-filter-group-title-bar {
  font-weight: 500;
  color: var(--ag-header-foreground-color);
}
.ag-theme-kit input[class^=ag-]:not([type]),
.ag-theme-kit input[class^=ag-][type=text],
.ag-theme-kit input[class^=ag-][type=number],
.ag-theme-kit input[class^=ag-][type=tel],
.ag-theme-kit input[class^=ag-][type=date],
.ag-theme-kit input[class^=ag-][type=datetime-local],
.ag-theme-kit textarea[class^=ag-],
.ag-theme-kit .ag-ltr input[class^=ag-]:not([type]),
.ag-theme-kit .ag-ltr input[class^=ag-][type=text],
.ag-theme-kit .ag-ltr input[class^=ag-][type=number],
.ag-theme-kit .ag-ltr input[class^=ag-][type=tel],
.ag-theme-kit .ag-ltr input[class^=ag-][type=date],
.ag-theme-kit .ag-ltr input[class^=ag-][type=datetime-local],
.ag-theme-kit .ag-ltr textarea[class^=ag-] {
  padding-left: var(--ag-grid-size);
}
.ag-theme-kit .ag-rtl input[class^=ag-]:not([type]),
.ag-theme-kit .ag-rtl input[class^=ag-][type=text],
.ag-theme-kit .ag-rtl input[class^=ag-][type=number],
.ag-theme-kit .ag-rtl input[class^=ag-][type=tel],
.ag-theme-kit .ag-rtl input[class^=ag-][type=date],
.ag-theme-kit .ag-rtl input[class^=ag-][type=datetime-local],
.ag-theme-kit .ag-rtl textarea[class^=ag-] {
  padding-right: var(--ag-grid-size);
}
.ag-theme-kit .ag-picker-field-wrapper {
  min-height: calc(var(--ag-grid-size) * 4);
}
.ag-theme-kit .ag-tab {
  padding: var(--ag-grid-size);
  border-left: var(--ag-borders) transparent;
  border-right: var(--ag-borders) transparent;
  flex: 1 1 auto;
}
.ag-theme-kit .ag-tab-selected {
  background-color: var(--ag-background-color);
}
.ag-theme-kit .ag-ltr .ag-tab-selected:not(:first-of-type) {
  border-left-color: var(--ag-border-color);
}
.ag-theme-kit .ag-rtl .ag-tab-selected:not(:first-of-type) {
  border-right-color: var(--ag-border-color);
}
.ag-theme-kit .ag-ltr .ag-tab-selected:not(:last-of-type) {
  border-right-color: var(--ag-border-color);
}
.ag-theme-kit .ag-rtl .ag-tab-selected:not(:last-of-type) {
  border-left-color: var(--ag-border-color);
}
.ag-theme-kit .ag-tab:not(.ag-tab-selected) {
  opacity: 0.7;
}
.ag-theme-kit .ag-tab:not(.ag-tab-selected):hover {
  opacity: 1;
}
.ag-theme-kit .ag-menu {
  background-color: var(--ag-control-panel-background-color);
  color: color-mix(in srgb, transparent, var(--ag-foreground-color) 95%);
}
.ag-theme-kit .ag-menu.ag-tabs {
  min-width: 290px;
}
.ag-theme-kit .ag-menu-option .ag-icon {
  opacity: 65%;
}
.ag-theme-kit .ag-menu-header {
  background-color: var(--ag-control-panel-background-color);
}
.ag-theme-kit .ag-menu-option {
  font-weight: 500;
  cursor: pointer;
}
.ag-theme-kit .ag-ltr .ag-menu-option-popup-pointer .ag-icon {
  text-align: right;
}
.ag-theme-kit .ag-rtl .ag-menu-option-popup-pointer .ag-icon {
  text-align: left;
}
.ag-theme-kit .ag-tabs-header {
  border-bottom: var(--ag-borders) var(--ag-border-color);
  display: flex;
  background-color: color-mix(in srgb, transparent, var(--ag-foreground-color) 5%);
}
.ag-theme-kit .ag-side-bar {
  background-color: var(--ag-control-panel-background-color);
  min-width: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
}
.ag-theme-kit .ag-side-buttons {
  padding: 0;
  align-self: stretch;
  width: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);
  background: var(--ag-control-panel-background-color);
}
.ag-theme-kit .ag-side-button {
  border-top: var(--ag-borders) transparent;
  border-bottom: var(--ag-borders) transparent;
}
.ag-theme-kit .ag-side-button.ag-selected {
  border-bottom-color: var(--ag-border-color);
  background-color: var(--ag-background-color);
}
.ag-theme-kit .ag-side-button.ag-selected:not(:first-of-type) {
  border-top-color: var(--ag-border-color);
}
.ag-theme-kit .ag-column-panel-column-select {
  border-top: none;
  border-bottom: 1px solid var(--ag-secondary-border-color);
}
.ag-theme-kit .ag-filter-toolpanel-search {
  height: initial;
  margin-top: var(--ag-widget-container-vertical-padding);
}
.ag-theme-kit .ag-filter-toolpanel-search-input {
  margin: 0;
}
.ag-theme-kit .ag-filter-apply-panel {
  border: none;
  padding-top: var(--ag-widget-vertical-spacing);
}
.ag-theme-kit .ag-chart-tabbed-menu-body {
  position: relative;
}
.ag-theme-kit .ag-chart-tabbed-menu-body::after {
  content: "";
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  height: 16px;
  background: linear-gradient(var(--ag-control-panel-background-color), transparent);
}
.ag-theme-kit .ag-charts-settings-group-title-bar,
.ag-theme-kit .ag-charts-data-group-title-bar,
.ag-theme-kit .ag-charts-format-top-level-group-title-bar,
.ag-theme-kit .ag-charts-settings-group-container {
  border-top: none;
  padding: 0 calc(var(--ag-grid-size) * 1.5);
  font-weight: 500;
}
.ag-theme-kit .ag-charts-format-top-level-group-item {
  padding-bottom: 12px;
}
.ag-theme-kit .ag-charts-settings-group-container {
  margin-top: calc(var(--ag-grid-size));
}
.ag-theme-kit .ag-ltr .ag-charts-settings-group-container {
  padding-right: var(--ag-widget-container-horizontal-padding);
}
.ag-theme-kit .ag-rtl .ag-charts-settings-group-container {
  padding-left: var(--ag-widget-container-horizontal-padding);
}
.ag-theme-kit .ag-ltr .ag-charts-format-sub-level-group-container {
  padding-right: 0;
}
.ag-theme-kit .ag-rtl .ag-charts-format-sub-level-group-container {
  padding-left: 0;
}
.ag-theme-kit .ag-charts-format-top-level-group-toolbar {
  margin-top: var(--ag-grid-size);
}
.ag-theme-kit .ag-ltr .ag-charts-format-top-level-group-toolbar {
  padding-left: calc(var(--ag-grid-size) * 2);
}
.ag-theme-kit .ag-rtl .ag-charts-format-top-level-group-toolbar {
  padding-right: calc(var(--ag-grid-size) * 2);
}
.ag-theme-kit .ag-charts-settings-group-title-bar,
.ag-theme-kit .ag-charts-data-group-title-bar,
.ag-theme-kit .ag-charts-format-top-level-group-title-bar {
  margin-top: calc(var(--ag-grid-size) * 2);
}
.ag-theme-kit .ag-charts-format-top-level-group-container {
  padding: 0;
}
.ag-theme-kit .ag-ltr .ag-charts-format-top-level-group-container {
  padding-left: 0;
  padding-right: var(--ag-widget-container-horizontal-padding);
}
.ag-theme-kit .ag-rtl .ag-charts-format-top-level-group-container {
  padding-right: 0;
  padding-left: var(--ag-widget-container-horizontal-padding);
}
.ag-theme-kit .ag-charts-format-top-level-group-item {
  margin-top: calc(var(--ag-grid-size) * 2);
  margin-bottom: 0;
}
.ag-theme-kit .ag-chart-mini-thumbnail {
  background-color: var(--ag-background-color);
  margin-top: 0;
  margin-bottom: 0;
}
.ag-theme-kit .ag-chart-settings-nav-bar {
  border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);
}
.ag-theme-kit .ag-ltr .ag-group-title-bar-icon {
  margin-right: var(--ag-grid-size);
}
.ag-theme-kit .ag-rtl .ag-group-title-bar-icon {
  margin-left: var(--ag-grid-size);
}
.ag-theme-kit .ag-color-picker .ag-picker-field-wrapper {
  max-width: 55px;
  min-width: 55px;
}
.ag-theme-kit .ag-color-picker .ag-picker-field-display {
  height: 18px;
  width: 18px;
  flex: auto 0;
  margin: 6px;
  border-radius: 2px;
  border: solid 1px var(--ag-input-border-color);
}
.ag-theme-kit .ag-ltr .ag-color-picker .ag-picker-field-icon {
  margin-right: 4px;
}
.ag-theme-kit .ag-rtl .ag-color-picker .ag-picker-field-icon {
  margin-left: 4px;
}
.ag-theme-kit .ag-charts-format-sub-level-group {
  border-left: dashed 1px;
  border-left-color: var(--ag-border-color);
  padding-left: var(--ag-grid-size);
  margin-bottom: calc(var(--ag-grid-size) * 2);
}
.ag-theme-kit .ag-charts-format-sub-level-group-title-bar {
  padding-top: 0;
  padding-bottom: 0;
  background: none;
  font-weight: 500;
}
.ag-theme-kit .ag-charts-format-sub-level-group-container {
  padding-bottom: 0;
}
.ag-theme-kit .ag-charts-format-sub-level-group-item:last-child {
  margin-bottom: 0;
}
.ag-theme-kit .ag-theme-kit.ag-dnd-ghost {
  font-weight: 500;
}
.ag-theme-kit .ag-standard-button {
  font-family: inherit;
  appearance: none;
  -webkit-appearance: none;
  border-radius: var(--ag-border-radius);
  border: solid 1px var(--ag-input-border-color);
  background-color: var(--ag-background-color);
  padding: var(--ag-grid-size) calc(var(--ag-grid-size) * 2);
  cursor: pointer;
}
.ag-theme-kit .ag-standard-button:hover {
  background-color: var(--ag-row-hover-color);
}
.ag-theme-kit .ag-standard-button:active {
  border-color: var(--ag-active-color);
}
.ag-theme-kit .ag-standard-button:disabled {
  color: var(--ag-disabled-foreground-color);
  background-color: var(--ag-input-disabled-background-color);
  border-color: var(--ag-input-disabled-border-color);
}
.ag-theme-kit .ag-column-drop-cell {
  border-radius: calc(var(--ag-grid-size) * 3);
  height: calc(var(--ag-grid-size) * 3);
  padding: 0 var(--ag-grid-size);
}
.ag-theme-kit .ag-column-drop-cell-button {
  min-width: 0;
  margin: 0;
}
.ag-theme-kit .ag-column-drop-cell-drag-handle {
  margin-left: 0;
}
.ag-theme-kit .ag-column-drop-vertical {
  min-height: 75px;
}
.ag-theme-kit .ag-column-drop-vertical-title-bar {
  padding: var(--ag-widget-container-vertical-padding) calc(var(--ag-grid-size) * 2) 0;
}
.ag-theme-kit .ag-ltr .ag-column-drop-vertical-icon {
  margin-left: 0;
  margin-right: var(--ag-widget-horizontal-spacing);
}
.ag-theme-kit .ag-rtl .ag-column-drop-vertical-icon {
  margin-right: 0;
  margin-left: var(--ag-widget-horizontal-spacing);
}
.ag-theme-kit .ag-column-drop-vertical-empty-message {
  display: flex;
  align-items: center;
  justify-content: center;
  border: dashed 1px;
  border-color: var(--ag-border-color);
  margin: calc(var(--ag-grid-size) * 1.5) calc(var(--ag-grid-size) * 2);
  padding: calc(var(--ag-grid-size) * 2);
}
.ag-theme-kit .ag-column-drop-empty-message {
  color: var(--ag-foreground-color);
}
.ag-theme-kit .ag-status-bar {
  font-weight: normal;
}
.ag-theme-kit .ag-status-name-value {
  padding: var(--ag-widget-container-vertical-padding) 0;
}
.ag-theme-kit .ag-status-name-value-value,
.ag-theme-kit .ag-paging-number,
.ag-theme-kit .ag-paging-row-summary-panel-number {
  font-weight: 500;
}
.ag-theme-kit .ag-column-drop-cell-button {
  opacity: 0.75;
}
.ag-theme-kit .ag-column-drop-cell-button:hover {
  opacity: 1;
}
.ag-theme-kit .ag-header-cell-menu-button,
.ag-theme-kit .ag-panel-title-bar-button,
.ag-theme-kit .ag-header-expand-icon,
.ag-theme-kit .ag-column-group-icons,
.ag-theme-kit .ag-set-filter-group-icons,
.ag-theme-kit .ag-group-expanded .ag-icon,
.ag-theme-kit .ag-group-contracted .ag-icon,
.ag-theme-kit .ag-chart-settings-prev,
.ag-theme-kit .ag-chart-settings-next,
.ag-theme-kit .ag-group-title-bar-icon,
.ag-theme-kit .ag-column-select-header-icon,
.ag-theme-kit .ag-floating-filter-button-button,
.ag-theme-kit .ag-filter-toolpanel-expand,
.ag-theme-kit .ag-panel-title-bar-button-icon,
.ag-theme-kit .ag-chart-menu-icon,
.ag-theme-kit .ag-chart-menu-close {
  --ag-quartz-icon-hover-color: color-mix(
    in srgb,
    transparent,
    var(--ag-foreground-color) 10%
  );
}
.ag-theme-kit .ag-header-cell-menu-button:hover,
.ag-theme-kit .ag-panel-title-bar-button:hover,
.ag-theme-kit .ag-header-expand-icon:hover,
.ag-theme-kit .ag-column-group-icons:hover,
.ag-theme-kit .ag-set-filter-group-icons:hover,
.ag-theme-kit .ag-group-expanded .ag-icon:hover,
.ag-theme-kit .ag-group-contracted .ag-icon:hover,
.ag-theme-kit .ag-chart-settings-prev:hover,
.ag-theme-kit .ag-chart-settings-next:hover,
.ag-theme-kit .ag-group-title-bar-icon:hover,
.ag-theme-kit .ag-column-select-header-icon:hover,
.ag-theme-kit .ag-floating-filter-button-button:hover,
.ag-theme-kit .ag-filter-toolpanel-expand:hover,
.ag-theme-kit .ag-panel-title-bar-button-icon:hover,
.ag-theme-kit .ag-chart-menu-icon:hover,
.ag-theme-kit .ag-chart-menu-close:hover {
  border-radius: 1px;
  background-color: var(--ag-quartz-icon-hover-color);
  box-shadow: 0 0 0 4px var(--ag-quartz-icon-hover-color);
  cursor: pointer;
}
.ag-theme-kit .ag-chart-menu-close {
  --ag-quartz-icon-hover-color: color-mix(
    in srgb,
    var(--ag-background-color),
    var(--ag-foreground-color) 10%
  );
}
.ag-theme-kit .ag-chart-menu {
  --ag-icon-size: 20px;
  background-color: color-mix(in srgb, transparent, var(--ag-background-color) 30%);
  padding: 4px 2px;
}
.ag-theme-kit .ag-chart-menu-icon {
  opacity: 0.8;
}
.ag-theme-kit .ag-drag-handle {
  color: var(--ag-icon-font-color);
}
.ag-theme-kit .ag-chart-menu-close {
  background: var(--ag-background-color);
}
.ag-theme-kit .ag-chart-menu-close .ag-icon {
  border: 1px solid var(--ag-border-color);
}
.ag-theme-kit .ag-ltr .ag-chart-menu-close .ag-icon {
  border-right: none;
}
.ag-theme-kit .ag-rtl .ag-chart-menu-close .ag-icon {
  border-left: none;
}
.ag-theme-kit .ag-chart-docked-container {
  min-width: 260px;
}
.ag-theme-kit .ag-menu-option-icon,
.ag-theme-kit .ag-compact-menu-option-icon {
  width: var(--ag-icon-size);
  cursor: pointer;
}
.ag-theme-kit .ag-ltr .ag-menu-option-icon,
.ag-theme-kit .ag-ltr .ag-compact-menu-option-icon {
  padding-left: calc(var(--ag-grid-size) * 1.5);
}
.ag-theme-kit .ag-rtl .ag-menu-option-icon,
.ag-theme-kit .ag-rtl .ag-compact-menu-option-icon {
  padding-right: calc(var(--ag-grid-size) * 1.5);
}
.ag-theme-kit .ag-chart-settings-card-item.ag-not-selected:hover {
  opacity: 0.35;
}
.ag-theme-kit .ag-ltr .ag-panel-title-bar-button {
  margin-left: calc(var(--ag-grid-size) * 2);
  margin-right: var(--ag-grid-size);
}
.ag-theme-kit .ag-rtl .ag-panel-title-bar-button {
  margin-right: calc(var(--ag-grid-size) * 2);
  margin-left: var(--ag-grid-size);
}
.ag-theme-kit .ag-multi-filter-group-title-bar {
  padding: calc(var(--ag-grid-size) * 1.5) var(--ag-grid-size);
}
.ag-theme-kit .ag-ltr .ag-filter-toolpanel-group-container {
  padding-left: var(--ag-grid-size);
}
.ag-theme-kit .ag-rtl .ag-filter-toolpanel-group-container {
  padding-right: var(--ag-grid-size);
}
.ag-theme-kit .ag-filter-toolpanel-instance-filter {
  border: none;
  background-color: var(--ag-control-panel-background-color);
}
.ag-theme-kit .ag-ltr .ag-filter-toolpanel-instance-filter {
  margin-left: calc(var(--ag-icon-size) * 0.5);
}
.ag-theme-kit .ag-rtl .ag-filter-toolpanel-instance-filter {
  margin-right: calc(var(--ag-icon-size) * 0.5);
}
.ag-theme-kit .ag-filter-toolpanel-group-level-0 {
  border-top: none;
}
.ag-theme-kit .ag-filter-toolpanel-header {
  height: initial;
  padding-top: var(--ag-grid-size);
  padding-bottom: var(--ag-grid-size);
}
.ag-theme-kit .ag-filter-toolpanel-group-item {
  margin: 0;
}
.ag-theme-kit .ag-layout-auto-height .ag-center-cols-viewport,
.ag-theme-kit .ag-layout-auto-height .ag-center-cols-container,
.ag-theme-kit .ag-layout-print .ag-center-cols-viewport,
.ag-theme-kit .ag-layout-print .ag-center-cols-container {
  min-height: 150px;
}
.ag-theme-kit .ag-overlay-no-rows-wrapper.ag-layout-auto-height {
  padding-top: 60px;
}
.ag-theme-kit .ag-date-time-list-page-entry-is-current {
  background-color: var(--ag-active-color);
}
.ag-theme-kit .ag-advanced-filter-builder-button {
  padding: var(--ag-grid-size);
  font-weight: 600;
}
.ag-theme-kit .ag-advanced-filter-builder-item-button-disabled .ag-icon,
.ag-theme-kit .ag-disabled .ag-icon,
.ag-theme-kit .ag-column-select-column-group-readonly .ag-icon,
.ag-theme-kit [disabled] .ag-icon {
  opacity: 0.6;
}
.ag-theme-kit .ag-icon-grip {
  opacity: 0.7;
}
.ag-theme-kit .ag-column-select-column-readonly.ag-icon-grip,
.ag-theme-kit .ag-column-select-column-readonly .ag-icon-grip {
  opacity: 0.35;
}
.ag-theme-kit .ag-column-select-header-filter-wrapper .ag-input-wrapper::before,
.ag-theme-kit .ag-filter-toolpanel-search .ag-input-wrapper::before,
.ag-theme-kit .ag-mini-filter .ag-input-wrapper::before,
.ag-theme-kit .ag-filter-filter .ag-input-wrapper::before {
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-position: 50% 50%;
  background-size: contain;
  opacity: 40%;
  content: "";
  filter: var(--ag-icon-filter);
}
.ag-theme-kit .ag-theme-kit .ag-ltr .ag-column-select-header-filter-wrapper .ag-input-wrapper::before,
.ag-theme-kit .ag-ltr .ag-filter-toolpanel-search .ag-input-wrapper::before,
.ag-theme-kit .ag-ltr .ag-mini-filter .ag-input-wrapper::before,
.ag-theme-kit .ag-ltr .ag-filter-filter .ag-input-wrapper::before {
  margin-left: var(--ag-grid-size);
}
.ag-theme-kit .ag-theme-kit .ag-rtl .ag-column-select-header-filter-wrapper .ag-input-wrapper::before,
.ag-theme-kit .ag-rtl .ag-filter-toolpanel-search .ag-input-wrapper::before,
.ag-theme-kit .ag-rtl .ag-mini-filter .ag-input-wrapper::before,
.ag-theme-kit .ag-rtl .ag-filter-filter .ag-input-wrapper::before {
  margin-right: var(--ag-grid-size);
}
.ag-theme-kit .ag-theme-kit .ag-ltr .ag-column-select-header-filter-wrapper input.ag-text-field-input,
.ag-theme-kit .ag-theme-kit .ag-ltr .ag-column-select-header-filter-wrapper input.ag-number-field-input,
.ag-theme-kit .ag-ltr .ag-filter-toolpanel-search input.ag-text-field-input,
.ag-theme-kit .ag-ltr .ag-filter-toolpanel-search input.ag-number-field-input,
.ag-theme-kit .ag-ltr .ag-mini-filter input.ag-text-field-input,
.ag-theme-kit .ag-ltr .ag-mini-filter input.ag-number-field-input,
.ag-theme-kit .ag-ltr .ag-filter-filter input.ag-text-field-input,
.ag-theme-kit .ag-ltr .ag-filter-filter input.ag-number-field-input {
  padding-left: 26px;
}
.ag-theme-kit .ag-theme-kit .ag-rtl .ag-column-select-header-filter-wrapper input.ag-text-field-input,
.ag-theme-kit .ag-theme-kit .ag-rtl .ag-column-select-header-filter-wrapper input.ag-number-field-input,
.ag-theme-kit .ag-rtl .ag-filter-toolpanel-search input.ag-text-field-input,
.ag-theme-kit .ag-rtl .ag-filter-toolpanel-search input.ag-number-field-input,
.ag-theme-kit .ag-rtl .ag-mini-filter input.ag-text-field-input,
.ag-theme-kit .ag-rtl .ag-mini-filter input.ag-number-field-input,
.ag-theme-kit .ag-rtl .ag-filter-filter input.ag-text-field-input,
.ag-theme-kit .ag-rtl .ag-filter-filter input.ag-number-field-input {
  padding-right: 26px;
}
.ag-theme-kit .ag-ltr .ag-column-select-add-group-indent {
  margin-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 1.5);
}
.ag-theme-kit .ag-rtl .ag-column-select-add-group-indent {
  margin-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 1.5);
}
.ag-theme-kit .ag-text-field-input[disabled],
.ag-theme-kit .ag-menu-option-disabled {
  cursor: not-allowed;
}
.ag-theme-kit .ag-checkbox-input-wrapper.ag-checked.ag-disabled {
  --ag-checkbox-checked-color: var(--ag-checkbox-unchecked-color);
}
.ag-theme-kit .ag-checkbox-input,
.ag-theme-kit .ag-toggle-button-input,
.ag-theme-kit .ag-radio-button-input,
.ag-theme-kit input[class^=ag-][type=range] {
  cursor: pointer;
}
.ag-theme-kit .ag-details-row {
  padding: calc(var(--ag-grid-size) * 3.75);
}

.ag-cell .btn {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.react-datetime-picker--overwrite {
  width: 100%;
}
.react-datetime-picker--overwrite.react-datetime-picker--disabled .react-datetime-picker__wrapper {
  background-color: rgb(238, 241, 242.2);
  color: rgb(121.8, 124.2, 126.6);
}
.react-datetime-picker--overwrite.react-datetime-picker--disabled .react-datetime-picker__wrapper input {
  color: rgb(121.8, 124.2, 126.6);
}
.react-datetime-picker--overwrite .react-datetime-picker__wrapper {
  padding: 0.2rem 0.6rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
}
.react-datetime-picker--overwrite .react-datetime-picker__inputGroup {
  min-width: calc(16px + 3.24em + 0.434em);
  flex-grow: 1;
  padding: 0 2px;
}
.react-datetime-picker--overwrite .react-datetime-picker__inputGroup__divider {
  padding: 0;
}
.react-datetime-picker--overwrite .react-datetime-picker__button {
  padding: 0;
  margin-left: 8px;
}
.react-datetime-picker--overwrite .react-datetime-picker__button:enabled {
  cursor: pointer;
}
.react-datetime-picker--overwrite .react-datetime-picker__button:enabled:hover .react-datetime-picker__button__icon,
.react-datetime-picker--overwrite .react-datetime-picker__button:enabled:focus .react-datetime-picker__button__icon {
  stroke: #212529;
}
.react-datetime-picker--overwrite .react-datetime-picker__calendar .react-calendar {
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
}
.react-datetime-picker--overwrite .react-datetime-picker__clock {
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
}

.react-select--overwrite.is-invalid .react-select__control,
.react-select--overwrite.is-invalid .react-select__control:hover {
  border-color: #dc3545;
}
.react-select--overwrite .react-select__control, .react-select--overwrite .react-select__menu {
  display: block;
  width: 100%;
  padding: 0.2rem 0.6rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  vertical-align: middle;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.3rem;
  appearance: none;
}
.react-select--overwrite .react-select__control {
  display: flex;
  justify-content: space-between;
  min-height: auto !important;
}
.react-select--overwrite .react-select__control:hover {
  border-color: var(--bs-border-color);
}
.react-select--overwrite .react-select__control--menu-is-open {
  border-color: #2495cf;
}
.react-select--overwrite .react-select__control:focus, .react-select--overwrite .react-select__control--is-focused {
  border-color: rgba(36, 149, 207, 0.3);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.react-select--overwrite .react-select__control[multiple], .react-select--overwrite .react-select__control[size]:not([size="1"]) {
  padding-right: 0.6rem;
  background-image: none;
}
.react-select--overwrite .react-select__control:disabled, .react-select--overwrite .react-select__control--is-disabled {
  background-color: rgb(238, 241, 242.2);
}
.react-select--overwrite .react-select__indicator, .react-select--overwrite .react-select__value-container, .react-select--overwrite .react-select__input-container, .react-select--overwrite .react-select__placeholder, .react-select--overwrite .react-select__single-value, .react-select--overwrite .react-select__indicator-separator {
  padding: 0;
  margin: 0;
}
.react-select--overwrite .react-select__indicator {
  width: 1.75rem;
  height: 1rem;
}
.react-select--overwrite .react-select__indicator svg {
  display: none;
}
.react-select--overwrite .react-select__indicator.react-select__dropdown-indicator {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 16px 12px;
}
.react-select--overwrite .react-select__indicator.react-select__clear-indicator {
  margin-top: -0.5rem;
  width: 1rem;
  height: 1rem;
}
.react-select--overwrite .react-select__indicator.react-select__clear-indicator svg {
  display: inline;
}
.react-select--overwrite .react-select__menu {
  padding: 0.2rem 0;
  box-shadow: none;
  z-index: 10;
}
.react-select--overwrite .react-select__option {
  padding: 0.2rem 0.6rem;
}
.react-select--overwrite .react-select__option--is-selected, .react-select--overwrite .react-select__option--is-selected.react-select__option--is-focused {
  background-color: #2495cf;
}
.react-select--overwrite .react-select__option--is-focused {
  background-color: rgba(36, 149, 207, 0.3);
}

.draggable-element {
  cursor: auto !important;
}
.draggable-element--dragging {
  opacity: 0.2;
}

/* styling for generic page layout */
html, body, #root {
  height: 100%;
}

#root {
  --main-header-height: 4rem;
  display: flex;
  flex-direction: column;
  padding-top: var(--main-header-height);
}

/* components */
.reaction-header {
  margin-bottom: -24px;
  z-index: 20;
}

.reaction-header__scheme-accordion .accordion-body {
  padding: 0;
  overflow: hidden;
}
.reaction-header__scheme-container {
  position: relative;
}
.reaction-header__scheme-image {
  height: 280px;
  margin: 0 auto;
}
.reaction-header__scheme-image.reaction-header__scheme-image--enlarged {
  height: auto;
  width: 100%;
}
.reaction-header__scheme-enlarge-button-container {
  position: absolute;
  top: 20px;
  right: 20px;
}

.reaction-navbar .reaction-name {
  display: block;
}
.reaction-navbar .reaction-id {
  display: block;
  font-size: 1rem;
}

.scheme-drawer-button {
  --bs-btn-padding-y: 0;
  margin-top: -12px;
}
.scheme-drawer-button span {
  padding: 0 0.25em;
}
.scheme-drawer-button-container {
  position: relative;
  z-index: -1;
}

.activity {
  display: flex;
  flex-direction: column;
}
.activity > div:first-child {
  margin-bottom: 0.75rem;
}
.activity.activity--below-drag-position {
  flex-direction: column-reverse;
}
.activity.activity--below-drag-position > div:first-child {
  margin-bottom: 0;
  margin-top: 0.75rem;
}
.activity.activity--locked > div:first-child {
  margin: 0;
}

.activity-creator {
  margin-right: 0.75rem;
}

.activity-info__add {
  display: flex;
  align-items: flex-start;
}
.activity-info__text-block {
  flex-grow: 1;
}
.activity-info__description {
  padding-top: 4px;
  border-top: 1px solid;
  margin-top: 4px !important;
}
.procedure-card--condition .activity-info__description {
  border-top-color: rgb(164.5, 144.2, 74.2);
}
.procedure-card--action .activity-info__description {
  border-top-color: rgb(76.3, 137.9, 169.4);
}

.procedure-card--condition {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none;
  margin-left: 3rem;
}
.procedure-card--condition .card-header {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.procedure-card--condition .procedure-card__header-label {
  max-width: 27rem;
}
.procedure-card--condition .procedure-card__info {
  border-bottom-right-radius: 0 !important;
}

.condition-form--focus .condition-type-form-group__open-controls, .condition-form--focus > .form-buttons {
  display: none !important;
}

.insert-zone {
  min-height: 0.75rem;
  background-color: #ced4da;
  margin-right: 0.75rem;
}
.insert-zone.insert-zone--target {
  height: 3rem;
  border-color: #68d47f;
  border-style: dashed;
  border-width: 3px;
  background-color: rgb(239.9, 250.7, 242.2);
  display: flex;
  align-items: center;
}
.insert-zone.insert-zone--creator {
  background-color: transparent;
  margin-right: 0;
}
.insert-zone__drop-target-label {
  display: block;
  margin: 0 auto;
  color: #68d47f;
  font-weight: bold;
  animation: blinker 0.5s linear 1;
}
.insert-zone.insert-zone--inactive {
  display: none;
}
.insert-zone__reveal-creator-button {
  --bs-btn-hover-bg: var(--bs-btn-bg);
  --bs-btn-hover-color: var(--bs-btn-color);
  --bs-btn-hover-border-color: var(--bs-btn-border-color);
  display: none;
  width: 100%;
}
.insert-zone__visible-creator-button {
  --bs-btn-hover-bg: var(--bs-btn-bg);
  --bs-btn-hover-color: var(--bs-btn-color);
  --bs-btn-hover-border-color: var(--bs-btn-border-color);
  --bs-btn-color: var(--bs-body-color);
  width: 100%;
}
.insert-zone__reveal-creator-button {
  --bs-btn-color: var(--bs-body-color);
}
.insert-zone--default:hover .insert-zone__reveal-creator-button {
  display: block;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.filtration-step-form__solvent-list {
  border-color: var(--bs-border-color);
  border-width: 1px 1px 0;
  border-style: solid;
  border-radius: 0.3rem 0.3rem 0 0;
  background-color: var(--bs-body-bg);
}
.filtration-step-form__solvent-list .row {
  border-color: var(--bs-border-color);
  border-top-width: 1px;
  border-top-style: solid;
}
.filtration-step-form__solvent-list .row:first-child {
  border-top-width: 0;
  background-color: rgb(238, 241, 242.2);
}
.filtration-step-form__solvent-select .react-select__control {
  border-radius: 0 0 0.3rem 0.3rem;
}

.timer__info {
  border-top-width: 1px;
  border-top-style: solid;
}
.timer__info--primary {
  border-top-color: rgb(25.2, 104.3, 144.9);
}
.timer__info--danger {
  border-top-color: rgb(177.1, 67.2, 67.2);
}
.timer__info--warning {
  border-top-color: rgb(171.5, 158.2, 57.4);
}
.timer__info--success {
  border-top-color: rgb(77, 162.4, 77);
}
.timer__info--secondary {
  border-top-color: rgb(35.7, 85.4, 128.1);
}
.timer__info--dark {
  border-top-color: rgb(55.3, 60.2, 62.3);
}
.timer__info--preparation {
  border-top-color: rgb(119, 129.5, 133.7);
}
.timer__info--step {
  border-top-color: rgb(72.8, 148.4, 88.9);
}
.timer__info--action {
  border-top-color: rgb(76.3, 137.9, 169.4);
}
.timer__info--condition {
  border-top-color: rgb(164.5, 144.2, 74.2);
}
.timer__info--white {
  border-top-color: rgb(178.5, 178.5, 178.5);
}
.timer__info--transparent {
  border-top-color: rgba(0, 0, 0, 0.3);
}

.global-notification {
  --bs-offcanvas-padding-y: 4.5rem;
  --bs-offcanvas-bg: transparent;
  --bs-offcanvas-border-width: 0;
  pointer-events: none;
}

.main-header {
  height: var(--main-header-height);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1030;
}
.main-header .dropdown-item {
  font-size: 1.23077rem;
}
.main-header .nav-link,
.main-header .navbar-text,
.main-header .btn {
  font-size: 1.23077rem;
}
.main-header__brand {
  display: flex;
  align-items: center;
}
.main-header__brand-name {
  font-size: 1.61538rem;
}
.main-header__nav:before {
  margin-top: -0.2rem;
  display: inline-block;
  content: "|";
  color: #fff;
  font-size: 1.84615rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.user-drop-down__toggle {
  --bs-btn-padding-y: 0.4rem;
  display: flex;
  align-items: center;
  background-color: rgb(35.7, 85.4, 128.1);
  border: none;
}

.navbar-direct-link {
  width: 300px;
}

.ontologies-editor {
  --ontology-toolbar-height: 5rem;
}
.ontologies-editor__toolbar {
  height: var(--ontology-toolbar-height);
  position: sticky;
  top: var(--main-header-height);
  z-index: 1020;
}
.ontologies-editor__toolbar .navbar {
  flex-wrap: nowrap;
  height: 100%;
}
.ontologies-editor__table-header {
  --bs-table-bg: rgb(195.5, 206, 210.2);
  color: #000;
  position: sticky;
  top: calc(var(--main-header-height) + var(--ontology-toolbar-height));
  z-index: 1010;
}
.ontologies-editor__close-button.icon-button {
  --bs-btn-color: #dc3545;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-color: #fff;
  width: 2rem;
  height: 2rem;
  margin-right: 0.75rem;
  border: 2px solid #dc3545;
  border-radius: 0;
}

.icon-button.ontology-list-item__edit-button {
  --bs-btn-color: #2495cf;
  --bs-btn-hover-bg: #2495cf;
  --bs-btn-hover-color: #fff;
}

.badge.ontology-list-item__status-badge {
  color: #000;
  padding: 0.4rem 0.6rem;
}

.ontology-form__add-role {
  width: calc(15ch + 4rem);
}

.ontology-form__dependencies {
  min-width: 0;
  padding: 0.75rem;
}

.ontology-form__filtered-options {
  flex: 0 0 clamp(24rem, 40vw, 42rem);
}
.ontology-form__filtered-options .react-select__indicator.react-select__clear-indicator {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  margin-top: 0;
}
.ontology-form__filtered-options .react-select__indicator.react-select__clear-indicator svg {
  display: inline-block !important;
  width: 1.25rem;
  height: 1.25rem;
}
.ontology-form__filtered-options .react-select__option {
  white-space: nowrap;
}

.sample-molecule-image {
  width: 132px;
  height: 76px;
  object-fit: contain;
  border-color: var(--bs-card-border-color);
}

.amount-input {
  margin-bottom: -0.5rem;
}
.amount-input > * {
  position: relative;
}
.amount-input--active.amount-input--primary:before {
  content: "";
  background-color: rgb(211.2, 233.8, 245.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--danger:before {
  content: "";
  background-color: rgb(254.6, 223.2, 223.2);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--warning:before {
  content: "";
  background-color: rgb(253, 249.2, 220.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--success:before {
  content: "";
  background-color: rgb(226, 250.4, 226);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--secondary:before {
  content: "";
  background-color: rgb(214.2, 228.4, 240.6);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--dark:before {
  content: "";
  background-color: rgb(219.8, 221.2, 221.8);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--preparation:before {
  content: "";
  background-color: rgb(238, 241, 242.2);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--step:before {
  content: "";
  background-color: rgb(224.8, 246.4, 229.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--action:before {
  content: "";
  background-color: rgb(225.8, 243.4, 252.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--condition:before {
  content: "";
  background-color: rgb(251, 245.2, 225.2);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--white:before {
  content: "";
  background-color: white;
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--active.amount-input--transparent:before {
  content: "";
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: -1px;
  left: -0.75rem;
  z-index: 0;
}
.amount-input--passive .col-form-label {
  font-weight: normal;
}

.card-header-label-button {
  --bs-btn-padding-y: 0.125rem;
  --bs-btn-padding-x: 0.625rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: 0.875rem;
}

.create-button {
  display: flex;
  align-items: center;
}
.create-button .svg-inline--fa {
  margin: 0 0.5em 0 -0.2em;
  background-color: #fff;
  color: #212529;
  border-radius: 50%;
  padding: 0.1em;
  aspect-ratio: 1/1;
  object-fit: contain;
}
.create-button span {
  white-space: nowrap;
}

.duration-selection__form-label {
  width: auto;
  flex-grow: 1;
}
.duration-selection__input-container {
  width: 18%;
}

.form-buttons {
  padding: 0.5rem 0;
}

.form-section {
  padding: 0.5rem 0;
  margin-bottom: 0rem !important;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  position: relative;
}
.form-section--primary {
  border-bottom-color: rgb(25.2, 104.3, 144.9);
}
.form-section--danger {
  border-bottom-color: rgb(177.1, 67.2, 67.2);
}
.form-section--warning {
  border-bottom-color: rgb(171.5, 158.2, 57.4);
}
.form-section--success {
  border-bottom-color: rgb(77, 162.4, 77);
}
.form-section--secondary {
  border-bottom-color: rgb(35.7, 85.4, 128.1);
}
.form-section--dark {
  border-bottom-color: rgb(55.3, 60.2, 62.3);
}
.form-section--preparation {
  border-bottom-color: rgb(119, 129.5, 133.7);
}
.form-section--step {
  border-bottom-color: rgb(72.8, 148.4, 88.9);
}
.form-section--action {
  border-bottom-color: rgb(76.3, 137.9, 169.4);
}
.form-section--condition {
  border-bottom-color: rgb(164.5, 144.2, 74.2);
}
.form-section--white {
  border-bottom-color: rgb(178.5, 178.5, 178.5);
}
.form-section--transparent {
  border-bottom-color: rgba(0, 0, 0, 0.3);
}
.form-section > * {
  position: relative;
}
.form-section--disabled:before {
  content: "";
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute !important;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 1;
}
.form-section--active.form-section {
  z-index: 2;
}
.form-section--active.form-section--primary:before {
  content: "";
  background-color: rgb(211.2, 233.8, 245.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--danger:before {
  content: "";
  background-color: rgb(254.6, 223.2, 223.2);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--warning:before {
  content: "";
  background-color: rgb(253, 249.2, 220.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--success:before {
  content: "";
  background-color: rgb(226, 250.4, 226);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--secondary:before {
  content: "";
  background-color: rgb(214.2, 228.4, 240.6);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--dark:before {
  content: "";
  background-color: rgb(219.8, 221.2, 221.8);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--preparation:before {
  content: "";
  background-color: rgb(238, 241, 242.2);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--step:before {
  content: "";
  background-color: rgb(224.8, 246.4, 229.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--action:before {
  content: "";
  background-color: rgb(225.8, 243.4, 252.4);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--condition:before {
  content: "";
  background-color: rgb(251, 245.2, 225.2);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--white:before {
  content: "";
  background-color: white;
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}
.form-section--active.form-section--transparent:before {
  content: "";
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  right: -0.75rem;
  bottom: 0;
  left: -0.75rem;
  z-index: 0;
}

@container step-column (min-width: 560px) {
  .activity-form.action-form .form-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    column-gap: 1rem;
    align-items: start;
  }
  .activity-form.action-form .form-section > * {
    min-width: 0;
  }
  .activity-form.action-form .form-section > .form-buttons {
    grid-column: 1/-1;
  }
}
.icon-button {
  border-radius: 50%;
  border-style: none;
  padding: 4px;
  --bs-btn-color: white;
  --bs-btn-hover-color: var(--bs-body-color);
  --bs-btn-hover-bg: white;
  font-size: 1.07692rem;
  line-height: 1em;
}
.icon-button.btn-lg, .btn-group-lg > .icon-button.btn {
  font-size: 1.38462rem;
  padding: 6px;
}
.icon-button.icon-button--positive {
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-hover-color: white;
  --bs-btn-hover-bg: var(--bs-body-color);
}
.icon-button svg {
  width: 1em;
}

.circle-button {
  font-size: 75%;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.label--disabled {
  opacity: 0.5;
}

.multi-input-form-group {
  padding: 1rem 0 0.25rem;
  margin: 1rem 0 0.75rem;
  border-width: 1px 0;
  border-style: solid;
}
.multi-input-form-group--primary {
  border-color: rgb(25.2, 104.3, 144.9);
}
.multi-input-form-group--danger {
  border-color: rgb(177.1, 67.2, 67.2);
}
.multi-input-form-group--warning {
  border-color: rgb(171.5, 158.2, 57.4);
}
.multi-input-form-group--success {
  border-color: rgb(77, 162.4, 77);
}
.multi-input-form-group--secondary {
  border-color: rgb(35.7, 85.4, 128.1);
}
.multi-input-form-group--dark {
  border-color: rgb(55.3, 60.2, 62.3);
}
.multi-input-form-group--preparation {
  border-color: rgb(119, 129.5, 133.7);
}
.multi-input-form-group--step {
  border-color: rgb(72.8, 148.4, 88.9);
}
.multi-input-form-group--action {
  border-color: rgb(76.3, 137.9, 169.4);
}
.multi-input-form-group--condition {
  border-color: rgb(164.5, 144.2, 74.2);
}
.multi-input-form-group--white {
  border-color: rgb(178.5, 178.5, 178.5);
}
.multi-input-form-group--transparent {
  border-color: rgba(0, 0, 0, 0.3);
}

.metrics-input {
  display: flex;
  align-items: center;
}

.procedure-card {
  --bs-card-spacer-x: 0;
  --bs-card-spacer-y: 0;
  --bs-card-cap-padding-x: 0.75rem;
  --bs-card-cap-padding-y: 0.35rem;
}
.procedure-card--action {
  margin-right: 0.75rem;
}
.procedure-card__header-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30rem;
}
.procedure-card__info, .procedure-card__form, .procedure-card__details, .procedure-card__type-panel {
  padding: var(--bs-card-cap-padding-x);
}
.procedure-card__type-panel {
  padding-top: 0;
}
.procedure-card__info {
  padding-top: 0;
  font-size: 0.875rem;
}
.procedure-card__info--editable {
  cursor: pointer;
}
.procedure-card__info .sample-molecule-image {
  margin-right: 1rem;
}
.procedure-card__info h6, .procedure-card__info .h6,
.procedure-card__info p {
  margin-bottom: 0;
}
.procedure-card__info-line {
  display: block;
  padding-top: 0.1875rem;
}
.procedure-card__info:last-child {
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
}
.procedure-card__info-section {
  margin-top: 0.75rem;
  padding-top: 0.375rem;
  border-top-width: 1px;
  border-top-style: solid;
}
.procedure-card__info-section--primary {
  border-top-color: rgb(25.2, 104.3, 144.9);
}
.procedure-card__info-section--danger {
  border-top-color: rgb(177.1, 67.2, 67.2);
}
.procedure-card__info-section--warning {
  border-top-color: rgb(171.5, 158.2, 57.4);
}
.procedure-card__info-section--success {
  border-top-color: rgb(77, 162.4, 77);
}
.procedure-card__info-section--secondary {
  border-top-color: rgb(35.7, 85.4, 128.1);
}
.procedure-card__info-section--dark {
  border-top-color: rgb(55.3, 60.2, 62.3);
}
.procedure-card__info-section--preparation {
  border-top-color: rgb(119, 129.5, 133.7);
}
.procedure-card__info-section--step {
  border-top-color: rgb(72.8, 148.4, 88.9);
}
.procedure-card__info-section--action {
  border-top-color: rgb(76.3, 137.9, 169.4);
}
.procedure-card__info-section--condition {
  border-top-color: rgb(164.5, 144.2, 74.2);
}
.procedure-card__info-section--white {
  border-top-color: rgb(178.5, 178.5, 178.5);
}
.procedure-card__info-section--transparent {
  border-top-color: rgba(0, 0, 0, 0.3);
}
.procedure-card__info-section ~ .procedure-card__info-section {
  margin-top: 0.375rem;
}
.procedure-card__details {
  border-top-width: 1px;
  border-top-style: solid;
}
.procedure-card__details--primary {
  border-top-color: rgb(25.2, 104.3, 144.9);
}
.procedure-card__details--danger {
  border-top-color: rgb(177.1, 67.2, 67.2);
}
.procedure-card__details--warning {
  border-top-color: rgb(171.5, 158.2, 57.4);
}
.procedure-card__details--success {
  border-top-color: rgb(77, 162.4, 77);
}
.procedure-card__details--secondary {
  border-top-color: rgb(35.7, 85.4, 128.1);
}
.procedure-card__details--dark {
  border-top-color: rgb(55.3, 60.2, 62.3);
}
.procedure-card__details--preparation {
  border-top-color: rgb(119, 129.5, 133.7);
}
.procedure-card__details--step {
  border-top-color: rgb(72.8, 148.4, 88.9);
}
.procedure-card__details--action {
  border-top-color: rgb(76.3, 137.9, 169.4);
}
.procedure-card__details--condition {
  border-top-color: rgb(164.5, 144.2, 74.2);
}
.procedure-card__details--white {
  border-top-color: rgb(178.5, 178.5, 178.5);
}
.procedure-card__details--transparent {
  border-top-color: rgba(0, 0, 0, 0.3);
}
.procedure-card__details > * {
  margin-bottom: 12px;
}
.procedure-card__details > *:last-child {
  margin-bottom: 0;
}
.procedure-card .card-header {
  border-bottom: none;
}
.procedure-card--editable .card-header h3, .procedure-card--editable .card-header .h3,
.procedure-card--editable .card-header h4,
.procedure-card--editable .card-header .h4,
.procedure-card--editable .card-header h5,
.procedure-card--editable .card-header .h5,
.procedure-card--editable .card-header h6,
.procedure-card--editable .card-header .h6 {
  cursor: pointer;
}
.procedure-card--editable .procedure-card__info {
  cursor: pointer;
}
.procedure-card--primary {
  border-color: rgb(25.2, 104.3, 144.9);
}
.procedure-card--danger {
  border-color: rgb(177.1, 67.2, 67.2);
}
.procedure-card--warning {
  border-color: rgb(171.5, 158.2, 57.4);
}
.procedure-card--success {
  border-color: rgb(77, 162.4, 77);
}
.procedure-card--secondary {
  border-color: rgb(35.7, 85.4, 128.1);
}
.procedure-card--dark {
  border-color: rgb(55.3, 60.2, 62.3);
}
.procedure-card--preparation {
  border-color: rgb(119, 129.5, 133.7);
}
.procedure-card--step {
  border-color: rgb(72.8, 148.4, 88.9);
}
.procedure-card--action {
  border-color: rgb(76.3, 137.9, 169.4);
}
.procedure-card--condition {
  border-color: rgb(164.5, 144.2, 74.2);
}
.procedure-card--white {
  border-color: rgb(178.5, 178.5, 178.5);
}
.procedure-card--transparent {
  border-color: rgba(0, 0, 0, 0.3);
}
.procedure-card--column {
  width: 360px;
}
.procedure-card.step-column-card {
  width: 100%;
  min-width: 280px;
  max-width: 80vw;
}
.procedure-card--step .step-column-card__condition-container {
  border-color: rgb(164.5, 144.2, 74.2);
  border-style: solid;
  border-width: 0 6px 0 0;
}
.procedure-card--step .step-column-card__condition-container > * {
  margin-bottom: 12px;
}
.procedure-card--step .step-column-card__condition-container > *:last-child {
  margin-bottom: 0;
}

.step-column-card__resize-container {
  position: relative;
  flex: 0 0 auto;
  min-width: 280px;
  max-width: 80vw;
  container: step-column/inline-size;
}
.step-column-card__resize-handle {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  width: 10px;
  cursor: ew-resize;
  touch-action: none;
}
.step-column-card__resize-handle--left {
  left: -5px;
}
.step-column-card__resize-handle--right {
  right: -5px;
}

.procedure-card--primary .card-header,
.procedure-card--primary .procedure-card__info {
  background-color: #2495cf;
}

.procedure-card--danger .card-header,
.procedure-card--danger .procedure-card__info {
  background-color: #fd6060;
}

.procedure-card--warning .card-header,
.procedure-card--warning .procedure-card__info {
  background-color: #f5e252;
}

.procedure-card--success .card-header,
.procedure-card--success .procedure-card__info {
  background-color: #6ee86e;
}

.procedure-card--secondary .card-header,
.procedure-card--secondary .procedure-card__info {
  background-color: #337ab7;
}

.procedure-card--dark .card-header,
.procedure-card--dark .procedure-card__info {
  background-color: #4f5659;
}

.procedure-card--preparation .card-header,
.procedure-card--preparation .procedure-card__info {
  background-color: #aab9bf;
}

.procedure-card--step .card-header,
.procedure-card--step .procedure-card__info {
  background-color: #68d47f;
}

.procedure-card--action .card-header,
.procedure-card--action .procedure-card__info {
  background-color: #6dc5f2;
}

.procedure-card--condition .card-header,
.procedure-card--condition .procedure-card__info {
  background-color: #ebce6a;
}

.procedure-card--white .card-header,
.procedure-card--white .procedure-card__info {
  background-color: #ffffff;
}

.procedure-card--transparent .card-header,
.procedure-card--transparent .procedure-card__info {
  background-color: transparent;
}

.sample-selection {
  padding: 0.375rem;
  border-color: var(--bs-border-color);
  border-style: solid;
  border-width: 1px;
  border-radius: 0.3rem;
  background-color: rgb(238, 241, 242.2);
}

.spinner-with-message {
  --bs-modal-width: 100%;
  --bs-modal-border-radius: 0;
}
.spinner-with-message .modal-content {
  background-color: #337ab7;
  border: none;
  padding: 20px;
  margin-top: -100px;
}
.spinner-with-message__content {
  height: 160px;
}
.spinner-with-message .spinner__container {
  width: 108px;
  min-height: 108px;
  margin: 16px;
  background-color: #fff;
  border-radius: 50%;
  border-width: 8px;
  border-style: solid;
  border-color: #4f5659;
  position: relative;
}
.spinner-with-message .spinner-transformer {
  position: absolute;
}
.spinner-with-message .spinner-transformer:first-child {
  left: 6px;
  top: 6px;
}
.spinner-with-message .spinner-transformer:first-child .spinner-border {
  height: 80px;
  width: 80px;
}
.spinner-with-message .spinner-transformer:nth-child(2) {
  left: 16px;
  top: 16px;
  transform: scaleX(-1);
}
.spinner-with-message .spinner-transformer:nth-child(2) .spinner-border {
  height: 60px;
  width: 60px;
}
.spinner-with-message .spinner-transformer:last-child {
  left: 26px;
  top: 26px;
}
.spinner-with-message .spinner-transformer:last-child .spinner-border {
  height: 40px;
  width: 40px;
}

.type-selection-panel {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.375rem;
}
.type-selection-panel__action {
  margin-bottom: 1.375rem;
}
.type-selection-panel__cluster {
  padding: 0.75rem 0.375rem 0;
}
.type-selection-panel__cluster .btn {
  margin-bottom: 0.5rem;
}
.type-selection-panel__cluster .btn:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/css/chemotion_theme.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/css/base/bootstrap_overwrite/reboot.scss","webpack://./src/css/base/bootstrap_overwrite/btn.scss","webpack://./src/css/base/bootstrap_overwrite/form-control.scss","webpack://./src/css/base/bootstrap_overwrite/modal.scss","webpack://./src/css/base/bootstrap_overwrite/toast.scss","webpack://./src/css/base/bootstrap_overwrite/tooltip.scss","webpack://./node_modules/react-datetime-picker/dist/DateTimePicker.css","webpack://./node_modules/react-calendar/dist/Calendar.css","webpack://./node_modules/react-clock/dist/Clock.css","webpack://./src/css/base/other_libraries_overwrite/ag-grid.scss","webpack://./src/css/base/other_libraries_overwrite/react-datetime-picker.scss","webpack://./src/css/base/other_libraries_overwrite/react_select.scss","webpack://./src/css/base/other_libraries_overwrite/react-dnd.scss","webpack://./src/css/layout.scss","webpack://./src/css/components/reactions/ReactionNavbar.scss","webpack://./src/css/components/activities/Activity.scss","webpack://./src/css/components/activities/ActivityCreator.scss","webpack://./src/css/components/activities/ActivityInfo.scss","webpack://./src/css/components/activities/ConditionCard.scss","webpack://./src/css/components/activities/ConditionForm.scss","webpack://./src/css/components/activities/InsertZone.scss","webpack://./src/css/components/activities/purification/FiltrationStepForm.scss","webpack://./src/css/components/activities/timing/Timer.scss","webpack://./src/css/base/mixins/borders.scss","webpack://./src/css/components/layout/GlobalNotification.scss","webpack://./src/css/components/layout/MainHeader.scss","webpack://./src/css/components/ontologies/OntologiesEditor.scss","webpack://./src/css/components/samples/SampleMoleculeImage.scss","webpack://./src/css/components/utilities/AmountInput.scss","webpack://./src/css/base/mixins/backgrounds.scss","webpack://./src/css/components/utilities/CardHeaderLabelButton.scss","webpack://./src/css/components/utilities/CreateButton.scss","webpack://./src/css/components/utilities/DurationSelection.scss","webpack://./src/css/components/utilities/FormButtons.scss","webpack://./src/css/components/utilities/FormSection.scss","webpack://./src/css/components/utilities/IconButton.scss","webpack://./src/css/components/utilities/CircleButton.scss","webpack://./src/css/components/utilities/Label.scss","webpack://./src/css/components/utilities/MultiInputFormGroup.scss","webpack://./src/css/components/utilities/MetricsInputFormGroup.scss","webpack://./src/css/components/utilities/ProcedureCard.scss","webpack://./src/css/base/mixins/spacing.scss","webpack://./src/css/components/utilities/SampleSelection.scss","webpack://./src/css/components/utilities/SpinnerWithMessage.scss","webpack://./src/css/components/utilities/ActionTypeSelectionPanel.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB,mBAAA;AACA,WAAA;AA+BA,sBAAA;AAiDA,uDAAA;AAMA,oCAAA;ACzFE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA,mBAAA;EAAA,6BAAA;EAIA,8BAAA;EAAA,4BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,yBAAA;EAAA,mCAAA;EAAA,4BAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,6BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAKE,yBAAA;EAEF,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFaF;;AI7HI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AFaJ;;AKrLA;;;EAGE,sBAAA;ALwLF;;AK/KA;EFoQM,mCALI;AH5EV;AK7KI;EANJ;IAOM,uBAAA;ELgLJ;AACF;;AKnKA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALsKF;;AK7JA;EACE,iBAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;ANzd9B;;AKtJA;EACE,aAAA;EACA,uBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALuJF;;AKpJA;EFuMQ,wCAAA;AH/CR;AG7GI;EE3CJ;IF8MQ,qBAAA;EHlDN;AACF;;AKxJA;EFkMQ,yCAAA;AHtCR;AGtHI;EEtCJ;IFyMQ,qBAAA;EHzCN;AACF;;AK5JA;EF6LQ,yCAAA;AH7BR;AG/HI;EEjCJ;IFoMQ,qBAAA;EHhCN;AACF;;AKhKA;EFoLM,qBALI;AHXV;;AK/JA;EF+KM,qBALI;AHPV;;AK9JA;EF0KM,eALI;AHHV;;AKvJA;EACE,aAAA;EACA,mBCwV0B;AN9L5B;;AKhJA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ALmJF;;AK7IA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALgJF;;AK1IA;;EAEE,kBAAA;AL6IF;;AK1IA;;;EAGE,aAAA;EACA,mBAAA;AL6IF;;AK1IA;;;;EAIE,gBAAA;AL6IF;;AK1IA;EACE,gBC6b4B;ANhT9B;;AKxIA;EACE,qBAAA;EACA,cAAA;AL2IF;;AKrIA;EACE,gBAAA;ALwIF;;AKhIA;;EAEE,mBCsa4B;ANnS9B;;AK3HA;EF6EM,kBALI;AHuDV;;AKxHA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AL2HF;;AKlHA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALqHF;;AKlHA;EAAM,eAAA;ALsHN;;AKrHA;EAAM,WAAA;ALyHN;;AKpHA;EACE,gEAAA;EACA,0BCgNwC;ANzF1C;AKrHE;EACE,mDAAA;ALuHJ;;AK5GE;EAEE,cAAA;EACA,qBAAA;AL8GJ;;AKvGA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AHkGV;;AKnGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH0GV;AKlGE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALoGJ;;AKhGA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ALmGF;AKhGE;EACE,cAAA;ALkGJ;;AK9FA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;APuYJ;AK/FE;EACE,UAAA;EF7BE,cALI;AHoIV;;AKvFA;EACE,gBAAA;AL0FF;;AKpFA;;EAEE,sBAAA;ALuFF;;AK/EA;EACE,oBAAA;EACA,yBAAA;ALkFF;;AK/EA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALkFF;;AK3EA;EAEE,mBAAA;EACA,gCAAA;AL6EF;;AK1EA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AL6EF;;AKrEA;EACE,qBAAA;ALwEF;;AKlEA;EAEE,gBAAA;ALoEF;;AK5DA;EACE,UAAA;AL+DF;;AK1DA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AL6DF;;AKzDA;;EAEE,oBAAA;AL4DF;;AKvDA;EACE,eAAA;AL0DF;;AKvDA;EAGE,iBAAA;ALwDF;AKrDE;EACE,UAAA;ALuDJ;;AKhDA;EACE,wBAAA;ALmDF;;AK3CA;;;;EAIE,0BAAA;AL8CF;AK3CI;;;;EACE,eAAA;ALgDN;;AKzCA;EACE,UAAA;EACA,kBAAA;AL4CF;;AKvCA;EACE,gBAAA;AL0CF;;AKhCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALmCF;;AK3BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AHiPR;AG7YI;EEyWJ;IFtMQ,iBAAA;EH8ON;AACF;AKhCE;EACE,WAAA;ALkCJ;;AK3BA;;;;;;;EAOE,UAAA;AL8BF;;AK3BA;EACE,YAAA;AL8BF;;AKrBA;EACE,6BAAA;EACA,oBAAA;ALwBF;;AKhBA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALgBF;;AKXA;EACE,UAAA;ALcF;;AKPA;EACE,aAAA;EACA,0BAAA;ALUF;;AKLA;EACE,qBAAA;ALQF;;AKHA;EACE,SAAA;ALMF;;AKCA;EACE,kBAAA;EACA,eAAA;ALEF;;AKMA;EACE,wBAAA;ALHF;;AKWA;EACE,wBAAA;ALRF;;AQ7jBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANxE9B;;AQ3jBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHiUR;AG7dI;EKpGF;ILuQM,eAAA;EH8TN;AACF;;AQtkBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH4UR;AGxeI;EKpGF;ILuQM,iBAAA;EHyUN;AACF;;AQjlBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHuVR;AGnfI;EKpGF;ILuQM,eAAA;EHoVN;AACF;;AQ5lBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHkWR;AG9fI;EKpGF;ILuQM,iBAAA;EH+VN;AACF;;AQvmBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH6WR;AGzgBI;EKpGF;ILuQM,eAAA;EH0WN;AACF;;AQlnBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHwXR;AGphBI;EKpGF;ILuQM,iBAAA;EHqXN;AACF;;AQrmBA;ECvDE,eAAA;EACA,gBAAA;ATgqBF;;AQrmBA;EC5DE,eAAA;EACA,gBAAA;ATqqBF;;AQvmBA;EACE,qBAAA;AR0mBF;AQxmBE;EACE,oBFsoB0B;AN5B9B;;AQhmBA;EL8MM,kBALI;EKvMR,yBAAA;ARmmBF;;AQ/lBA;EACE,sBRhEO;EGuQH,kBALI;AHiaV;AQhmBE;EACE,gBAAA;ARkmBJ;;AQ9lBA;EACE,oBAAA;EACA,sBR1EO;EGuQH,kBALI;EKtLR,cFtFS;ANurBX;AQ/lBE;EACE,aAAA;ARimBJ;;AUjsBA;ECIE,eAAA;EAGA,YAAA;AX+rBF;;AUhsBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AXwsBF;;AU1rBA;EAEE,qBAAA;AV4rBF;;AUzrBA;EACE,uBAAA;EACA,cAAA;AV4rBF;;AUzrBA;EPyPM,kBALI;EOlPR,gCJkjDkC;ANt3BpC;;AY9tBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ab2uBF;;AcrrBI;EF5CE;IACE,gBNkee;ENmQrB;AACF;Ac3rBI;EF5CE;IACE,gBNkee;ENwQrB;AACF;AchsBI;EF5CE;IACE,gBNkee;EN6QrB;AACF;AcrsBI;EF5CE;IACE,iBNkee;ENkRrB;AACF;Ac1sBI;EF5CE;IACE,iBNkee;ENuRrB;AACF;Ae1wBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfgxBJ;;Ae3wBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBoxBF;AelxBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhB8wBF;;AgB/tBM;EACE,SAAA;AhBkuBR;;AgB/tBM;EApCJ,cAAA;EACA,WAAA;AhBuwBF;;AgBzvBE;EACE,cAAA;EACA,WAAA;AhB4vBJ;;AgB9vBE;EACE,cAAA;EACA,UAAA;AhBiwBJ;;AgBnwBE;EACE,cAAA;EACA,mBAAA;AhBswBJ;;AgBxwBE;EACE,cAAA;EACA,UAAA;AhB2wBJ;;AgB7wBE;EACE,cAAA;EACA,UAAA;AhBgxBJ;;AgBlxBE;EACE,cAAA;EACA,mBAAA;AhBqxBJ;;AgBtvBM;EAhDJ,cAAA;EACA,WAAA;AhB0yBF;;AgBrvBU;EAhEN,cAAA;EACA,kBAAA;AhByzBJ;;AgB1vBU;EAhEN,cAAA;EACA,mBAAA;AhB8zBJ;;AgB/vBU;EAhEN,cAAA;EACA,UAAA;AhBm0BJ;;AgBpwBU;EAhEN,cAAA;EACA,mBAAA;AhBw0BJ;;AgBzwBU;EAhEN,cAAA;EACA,mBAAA;AhB60BJ;;AgB9wBU;EAhEN,cAAA;EACA,UAAA;AhBk1BJ;;AgBnxBU;EAhEN,cAAA;EACA,mBAAA;AhBu1BJ;;AgBxxBU;EAhEN,cAAA;EACA,mBAAA;AhB41BJ;;AgB7xBU;EAhEN,cAAA;EACA,UAAA;AhBi2BJ;;AgBlyBU;EAhEN,cAAA;EACA,mBAAA;AhBs2BJ;;AgBvyBU;EAhEN,cAAA;EACA,mBAAA;AhB22BJ;;AgB5yBU;EAhEN,cAAA;EACA,WAAA;AhBg3BJ;;AgBzyBY;EAxDV,wBAAA;AhBq2BF;;AgB7yBY;EAxDV,yBAAA;AhBy2BF;;AgBjzBY;EAxDV,gBAAA;AhB62BF;;AgBrzBY;EAxDV,yBAAA;AhBi3BF;;AgBzzBY;EAxDV,yBAAA;AhBq3BF;;AgB7zBY;EAxDV,gBAAA;AhBy3BF;;AgBj0BY;EAxDV,yBAAA;AhB63BF;;AgBr0BY;EAxDV,yBAAA;AhBi4BF;;AgBz0BY;EAxDV,gBAAA;AhBq4BF;;AgB70BY;EAxDV,yBAAA;AhBy4BF;;AgBj1BY;EAxDV,yBAAA;AhB64BF;;AgB10BQ;;EAEE,gBAAA;AhB60BV;;AgB10BQ;;EAEE,gBAAA;AhB60BV;;AgBp1BQ;;EAEE,wBAAA;AhBu1BV;;AgBp1BQ;;EAEE,wBAAA;AhBu1BV;;AgB91BQ;;EAEE,uBAAA;AhBi2BV;;AgB91BQ;;EAEE,uBAAA;AhBi2BV;;AgBx2BQ;;EAEE,sBAAA;AhB22BV;;AgBx2BQ;;EAEE,sBAAA;AhB22BV;;AgBl3BQ;;EAEE,uBAAA;AhBq3BV;;AgBl3BQ;;EAEE,uBAAA;AhBq3BV;;AgB53BQ;;EAEE,wBAAA;AhB+3BV;;AgB53BQ;;EAEE,wBAAA;AhB+3BV;;AgBt4BQ;;EAEE,yBAAA;AhBy4BV;;AgBt4BQ;;EAEE,yBAAA;AhBy4BV;;Acn8BI;EEUE;IACE,SAAA;EhB67BN;EgB17BI;IApCJ,cAAA;IACA,WAAA;EhBi+BA;EgBn9BA;IACE,cAAA;IACA,WAAA;EhBq9BF;EgBv9BA;IACE,cAAA;IACA,UAAA;EhBy9BF;EgB39BA;IACE,cAAA;IACA,mBAAA;EhB69BF;EgB/9BA;IACE,cAAA;IACA,UAAA;EhBi+BF;EgBn+BA;IACE,cAAA;IACA,UAAA;EhBq+BF;EgBv+BA;IACE,cAAA;IACA,mBAAA;EhBy+BF;EgB18BI;IAhDJ,cAAA;IACA,WAAA;EhB6/BA;EgBx8BQ;IAhEN,cAAA;IACA,kBAAA;EhB2gCF;EgB58BQ;IAhEN,cAAA;IACA,mBAAA;EhB+gCF;EgBh9BQ;IAhEN,cAAA;IACA,UAAA;EhBmhCF;EgBp9BQ;IAhEN,cAAA;IACA,mBAAA;EhBuhCF;EgBx9BQ;IAhEN,cAAA;IACA,mBAAA;EhB2hCF;EgB59BQ;IAhEN,cAAA;IACA,UAAA;EhB+hCF;EgBh+BQ;IAhEN,cAAA;IACA,mBAAA;EhBmiCF;EgBp+BQ;IAhEN,cAAA;IACA,mBAAA;EhBuiCF;EgBx+BQ;IAhEN,cAAA;IACA,UAAA;EhB2iCF;EgB5+BQ;IAhEN,cAAA;IACA,mBAAA;EhB+iCF;EgBh/BQ;IAhEN,cAAA;IACA,mBAAA;EhBmjCF;EgBp/BQ;IAhEN,cAAA;IACA,WAAA;EhBujCF;EgBh/BU;IAxDV,cAAA;EhB2iCA;EgBn/BU;IAxDV,wBAAA;EhB8iCA;EgBt/BU;IAxDV,yBAAA;EhBijCA;EgBz/BU;IAxDV,gBAAA;EhBojCA;EgB5/BU;IAxDV,yBAAA;EhBujCA;EgB//BU;IAxDV,yBAAA;EhB0jCA;EgBlgCU;IAxDV,gBAAA;EhB6jCA;EgBrgCU;IAxDV,yBAAA;EhBgkCA;EgBxgCU;IAxDV,yBAAA;EhBmkCA;EgB3gCU;IAxDV,gBAAA;EhBskCA;EgB9gCU;IAxDV,yBAAA;EhBykCA;EgBjhCU;IAxDV,yBAAA;EhB4kCA;EgBzgCM;;IAEE,gBAAA;EhB2gCR;EgBxgCM;;IAEE,gBAAA;EhB0gCR;EgBjhCM;;IAEE,wBAAA;EhBmhCR;EgBhhCM;;IAEE,wBAAA;EhBkhCR;EgBzhCM;;IAEE,uBAAA;EhB2hCR;EgBxhCM;;IAEE,uBAAA;EhB0hCR;EgBjiCM;;IAEE,sBAAA;EhBmiCR;EgBhiCM;;IAEE,sBAAA;EhBkiCR;EgBziCM;;IAEE,uBAAA;EhB2iCR;EgBxiCM;;IAEE,uBAAA;EhB0iCR;EgBjjCM;;IAEE,wBAAA;EhBmjCR;EgBhjCM;;IAEE,wBAAA;EhBkjCR;EgBzjCM;;IAEE,yBAAA;EhB2jCR;EgBxjCM;;IAEE,yBAAA;EhB0jCR;AACF;AcrnCI;EEUE;IACE,SAAA;EhB8mCN;EgB3mCI;IApCJ,cAAA;IACA,WAAA;EhBkpCA;EgBpoCA;IACE,cAAA;IACA,WAAA;EhBsoCF;EgBxoCA;IACE,cAAA;IACA,UAAA;EhB0oCF;EgB5oCA;IACE,cAAA;IACA,mBAAA;EhB8oCF;EgBhpCA;IACE,cAAA;IACA,UAAA;EhBkpCF;EgBppCA;IACE,cAAA;IACA,UAAA;EhBspCF;EgBxpCA;IACE,cAAA;IACA,mBAAA;EhB0pCF;EgB3nCI;IAhDJ,cAAA;IACA,WAAA;EhB8qCA;EgBznCQ;IAhEN,cAAA;IACA,kBAAA;EhB4rCF;EgB7nCQ;IAhEN,cAAA;IACA,mBAAA;EhBgsCF;EgBjoCQ;IAhEN,cAAA;IACA,UAAA;EhBosCF;EgBroCQ;IAhEN,cAAA;IACA,mBAAA;EhBwsCF;EgBzoCQ;IAhEN,cAAA;IACA,mBAAA;EhB4sCF;EgB7oCQ;IAhEN,cAAA;IACA,UAAA;EhBgtCF;EgBjpCQ;IAhEN,cAAA;IACA,mBAAA;EhBotCF;EgBrpCQ;IAhEN,cAAA;IACA,mBAAA;EhBwtCF;EgBzpCQ;IAhEN,cAAA;IACA,UAAA;EhB4tCF;EgB7pCQ;IAhEN,cAAA;IACA,mBAAA;EhBguCF;EgBjqCQ;IAhEN,cAAA;IACA,mBAAA;EhBouCF;EgBrqCQ;IAhEN,cAAA;IACA,WAAA;EhBwuCF;EgBjqCU;IAxDV,cAAA;EhB4tCA;EgBpqCU;IAxDV,wBAAA;EhB+tCA;EgBvqCU;IAxDV,yBAAA;EhBkuCA;EgB1qCU;IAxDV,gBAAA;EhBquCA;EgB7qCU;IAxDV,yBAAA;EhBwuCA;EgBhrCU;IAxDV,yBAAA;EhB2uCA;EgBnrCU;IAxDV,gBAAA;EhB8uCA;EgBtrCU;IAxDV,yBAAA;EhBivCA;EgBzrCU;IAxDV,yBAAA;EhBovCA;EgB5rCU;IAxDV,gBAAA;EhBuvCA;EgB/rCU;IAxDV,yBAAA;EhB0vCA;EgBlsCU;IAxDV,yBAAA;EhB6vCA;EgB1rCM;;IAEE,gBAAA;EhB4rCR;EgBzrCM;;IAEE,gBAAA;EhB2rCR;EgBlsCM;;IAEE,wBAAA;EhBosCR;EgBjsCM;;IAEE,wBAAA;EhBmsCR;EgB1sCM;;IAEE,uBAAA;EhB4sCR;EgBzsCM;;IAEE,uBAAA;EhB2sCR;EgBltCM;;IAEE,sBAAA;EhBotCR;EgBjtCM;;IAEE,sBAAA;EhBmtCR;EgB1tCM;;IAEE,uBAAA;EhB4tCR;EgBztCM;;IAEE,uBAAA;EhB2tCR;EgBluCM;;IAEE,wBAAA;EhBouCR;EgBjuCM;;IAEE,wBAAA;EhBmuCR;EgB1uCM;;IAEE,yBAAA;EhB4uCR;EgBzuCM;;IAEE,yBAAA;EhB2uCR;AACF;ActyCI;EEUE;IACE,SAAA;EhB+xCN;EgB5xCI;IApCJ,cAAA;IACA,WAAA;EhBm0CA;EgBrzCA;IACE,cAAA;IACA,WAAA;EhBuzCF;EgBzzCA;IACE,cAAA;IACA,UAAA;EhB2zCF;EgB7zCA;IACE,cAAA;IACA,mBAAA;EhB+zCF;EgBj0CA;IACE,cAAA;IACA,UAAA;EhBm0CF;EgBr0CA;IACE,cAAA;IACA,UAAA;EhBu0CF;EgBz0CA;IACE,cAAA;IACA,mBAAA;EhB20CF;EgB5yCI;IAhDJ,cAAA;IACA,WAAA;EhB+1CA;EgB1yCQ;IAhEN,cAAA;IACA,kBAAA;EhB62CF;EgB9yCQ;IAhEN,cAAA;IACA,mBAAA;EhBi3CF;EgBlzCQ;IAhEN,cAAA;IACA,UAAA;EhBq3CF;EgBtzCQ;IAhEN,cAAA;IACA,mBAAA;EhBy3CF;EgB1zCQ;IAhEN,cAAA;IACA,mBAAA;EhB63CF;EgB9zCQ;IAhEN,cAAA;IACA,UAAA;EhBi4CF;EgBl0CQ;IAhEN,cAAA;IACA,mBAAA;EhBq4CF;EgBt0CQ;IAhEN,cAAA;IACA,mBAAA;EhBy4CF;EgB10CQ;IAhEN,cAAA;IACA,UAAA;EhB64CF;EgB90CQ;IAhEN,cAAA;IACA,mBAAA;EhBi5CF;EgBl1CQ;IAhEN,cAAA;IACA,mBAAA;EhBq5CF;EgBt1CQ;IAhEN,cAAA;IACA,WAAA;EhBy5CF;EgBl1CU;IAxDV,cAAA;EhB64CA;EgBr1CU;IAxDV,wBAAA;EhBg5CA;EgBx1CU;IAxDV,yBAAA;EhBm5CA;EgB31CU;IAxDV,gBAAA;EhBs5CA;EgB91CU;IAxDV,yBAAA;EhBy5CA;EgBj2CU;IAxDV,yBAAA;EhB45CA;EgBp2CU;IAxDV,gBAAA;EhB+5CA;EgBv2CU;IAxDV,yBAAA;EhBk6CA;EgB12CU;IAxDV,yBAAA;EhBq6CA;EgB72CU;IAxDV,gBAAA;EhBw6CA;EgBh3CU;IAxDV,yBAAA;EhB26CA;EgBn3CU;IAxDV,yBAAA;EhB86CA;EgB32CM;;IAEE,gBAAA;EhB62CR;EgB12CM;;IAEE,gBAAA;EhB42CR;EgBn3CM;;IAEE,wBAAA;EhBq3CR;EgBl3CM;;IAEE,wBAAA;EhBo3CR;EgB33CM;;IAEE,uBAAA;EhB63CR;EgB13CM;;IAEE,uBAAA;EhB43CR;EgBn4CM;;IAEE,sBAAA;EhBq4CR;EgBl4CM;;IAEE,sBAAA;EhBo4CR;EgB34CM;;IAEE,uBAAA;EhB64CR;EgB14CM;;IAEE,uBAAA;EhB44CR;EgBn5CM;;IAEE,wBAAA;EhBq5CR;EgBl5CM;;IAEE,wBAAA;EhBo5CR;EgB35CM;;IAEE,yBAAA;EhB65CR;EgB15CM;;IAEE,yBAAA;EhB45CR;AACF;Acv9CI;EEUE;IACE,SAAA;EhBg9CN;EgB78CI;IApCJ,cAAA;IACA,WAAA;EhBo/CA;EgBt+CA;IACE,cAAA;IACA,WAAA;EhBw+CF;EgB1+CA;IACE,cAAA;IACA,UAAA;EhB4+CF;EgB9+CA;IACE,cAAA;IACA,mBAAA;EhBg/CF;EgBl/CA;IACE,cAAA;IACA,UAAA;EhBo/CF;EgBt/CA;IACE,cAAA;IACA,UAAA;EhBw/CF;EgB1/CA;IACE,cAAA;IACA,mBAAA;EhB4/CF;EgB79CI;IAhDJ,cAAA;IACA,WAAA;EhBghDA;EgB39CQ;IAhEN,cAAA;IACA,kBAAA;EhB8hDF;EgB/9CQ;IAhEN,cAAA;IACA,mBAAA;EhBkiDF;EgBn+CQ;IAhEN,cAAA;IACA,UAAA;EhBsiDF;EgBv+CQ;IAhEN,cAAA;IACA,mBAAA;EhB0iDF;EgB3+CQ;IAhEN,cAAA;IACA,mBAAA;EhB8iDF;EgB/+CQ;IAhEN,cAAA;IACA,UAAA;EhBkjDF;EgBn/CQ;IAhEN,cAAA;IACA,mBAAA;EhBsjDF;EgBv/CQ;IAhEN,cAAA;IACA,mBAAA;EhB0jDF;EgB3/CQ;IAhEN,cAAA;IACA,UAAA;EhB8jDF;EgB//CQ;IAhEN,cAAA;IACA,mBAAA;EhBkkDF;EgBngDQ;IAhEN,cAAA;IACA,mBAAA;EhBskDF;EgBvgDQ;IAhEN,cAAA;IACA,WAAA;EhB0kDF;EgBngDU;IAxDV,cAAA;EhB8jDA;EgBtgDU;IAxDV,wBAAA;EhBikDA;EgBzgDU;IAxDV,yBAAA;EhBokDA;EgB5gDU;IAxDV,gBAAA;EhBukDA;EgB/gDU;IAxDV,yBAAA;EhB0kDA;EgBlhDU;IAxDV,yBAAA;EhB6kDA;EgBrhDU;IAxDV,gBAAA;EhBglDA;EgBxhDU;IAxDV,yBAAA;EhBmlDA;EgB3hDU;IAxDV,yBAAA;EhBslDA;EgB9hDU;IAxDV,gBAAA;EhBylDA;EgBjiDU;IAxDV,yBAAA;EhB4lDA;EgBpiDU;IAxDV,yBAAA;EhB+lDA;EgB5hDM;;IAEE,gBAAA;EhB8hDR;EgB3hDM;;IAEE,gBAAA;EhB6hDR;EgBpiDM;;IAEE,wBAAA;EhBsiDR;EgBniDM;;IAEE,wBAAA;EhBqiDR;EgB5iDM;;IAEE,uBAAA;EhB8iDR;EgB3iDM;;IAEE,uBAAA;EhB6iDR;EgBpjDM;;IAEE,sBAAA;EhBsjDR;EgBnjDM;;IAEE,sBAAA;EhBqjDR;EgB5jDM;;IAEE,uBAAA;EhB8jDR;EgB3jDM;;IAEE,uBAAA;EhB6jDR;EgBpkDM;;IAEE,wBAAA;EhBskDR;EgBnkDM;;IAEE,wBAAA;EhBqkDR;EgB5kDM;;IAEE,yBAAA;EhB8kDR;EgB3kDM;;IAEE,yBAAA;EhB6kDR;AACF;AcxoDI;EEUE;IACE,SAAA;EhBioDN;EgB9nDI;IApCJ,cAAA;IACA,WAAA;EhBqqDA;EgBvpDA;IACE,cAAA;IACA,WAAA;EhBypDF;EgB3pDA;IACE,cAAA;IACA,UAAA;EhB6pDF;EgB/pDA;IACE,cAAA;IACA,mBAAA;EhBiqDF;EgBnqDA;IACE,cAAA;IACA,UAAA;EhBqqDF;EgBvqDA;IACE,cAAA;IACA,UAAA;EhByqDF;EgB3qDA;IACE,cAAA;IACA,mBAAA;EhB6qDF;EgB9oDI;IAhDJ,cAAA;IACA,WAAA;EhBisDA;EgB5oDQ;IAhEN,cAAA;IACA,kBAAA;EhB+sDF;EgBhpDQ;IAhEN,cAAA;IACA,mBAAA;EhBmtDF;EgBppDQ;IAhEN,cAAA;IACA,UAAA;EhButDF;EgBxpDQ;IAhEN,cAAA;IACA,mBAAA;EhB2tDF;EgB5pDQ;IAhEN,cAAA;IACA,mBAAA;EhB+tDF;EgBhqDQ;IAhEN,cAAA;IACA,UAAA;EhBmuDF;EgBpqDQ;IAhEN,cAAA;IACA,mBAAA;EhBuuDF;EgBxqDQ;IAhEN,cAAA;IACA,mBAAA;EhB2uDF;EgB5qDQ;IAhEN,cAAA;IACA,UAAA;EhB+uDF;EgBhrDQ;IAhEN,cAAA;IACA,mBAAA;EhBmvDF;EgBprDQ;IAhEN,cAAA;IACA,mBAAA;EhBuvDF;EgBxrDQ;IAhEN,cAAA;IACA,WAAA;EhB2vDF;EgBprDU;IAxDV,cAAA;EhB+uDA;EgBvrDU;IAxDV,wBAAA;EhBkvDA;EgB1rDU;IAxDV,yBAAA;EhBqvDA;EgB7rDU;IAxDV,gBAAA;EhBwvDA;EgBhsDU;IAxDV,yBAAA;EhB2vDA;EgBnsDU;IAxDV,yBAAA;EhB8vDA;EgBtsDU;IAxDV,gBAAA;EhBiwDA;EgBzsDU;IAxDV,yBAAA;EhBowDA;EgB5sDU;IAxDV,yBAAA;EhBuwDA;EgB/sDU;IAxDV,gBAAA;EhB0wDA;EgBltDU;IAxDV,yBAAA;EhB6wDA;EgBrtDU;IAxDV,yBAAA;EhBgxDA;EgB7sDM;;IAEE,gBAAA;EhB+sDR;EgB5sDM;;IAEE,gBAAA;EhB8sDR;EgBrtDM;;IAEE,wBAAA;EhButDR;EgBptDM;;IAEE,wBAAA;EhBstDR;EgB7tDM;;IAEE,uBAAA;EhB+tDR;EgB5tDM;;IAEE,uBAAA;EhB8tDR;EgBruDM;;IAEE,sBAAA;EhBuuDR;EgBpuDM;;IAEE,sBAAA;EhBsuDR;EgB7uDM;;IAEE,uBAAA;EhB+uDR;EgB5uDM;;IAEE,uBAAA;EhB8uDR;EgBrvDM;;IAEE,wBAAA;EhBuvDR;EgBpvDM;;IAEE,wBAAA;EhBsvDR;EgB7vDM;;IAEE,yBAAA;EhB+vDR;EgB5vDM;;IAEE,yBAAA;EhB8vDR;AACF;AiBp3DA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,sBjBCO;EiBAP,mBXusB4B;EWtsB5B,0CAAA;AjBm3DF;AiB52DE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjB62DJ;AiB12DE;EACE,uBAAA;AjB42DJ;AiBz2DE;EACE,sBAAA;AjB22DJ;;AiBv2DA;EACE,+DAAA;AjB02DF;;AiBn2DA;EACE,iBAAA;AjBs2DF;;AiB51DE;EACE,wBAAA;AjB+1DJ;;AiBh1DE;EACE,sCAAA;AjBm1DJ;AiBh1DI;EACE,sCAAA;AjBk1DN;;AiB30DE;EACE,sBAAA;AjB80DJ;AiB30DE;EACE,mBAAA;AjB60DJ;;AiBn0DE;EACE,oDAAA;EACA,8CAAA;AjBs0DJ;;AiBh0DE;EACE,oDAAA;EACA,8CAAA;AjBm0DJ;;AiB3zDA;EACE,oDAAA;EACA,8CAAA;AjB8zDF;;AiBtzDE;EACE,mDAAA;EACA,6CAAA;AjByzDJ;;AkBr8DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBi8DJ;;AkBn9DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB+8DJ;;AkBj+DE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB69DJ;;AkB/+DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB2+DJ;;AkB7/DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBy/DJ;;AkB3gEE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBugEJ;;AkBzhEE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBqhEJ;;AkBviEE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBmiEJ;;AiBl5DI;EACE,gBAAA;EACA,iCAAA;AjBq5DN;;Ach/DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB25DJ;AACF;Acv/DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBi6DJ;AACF;Ac7/DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBu6DJ;AACF;AcngEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB66DJ;AACF;AczgEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBm7DJ;AACF;AmBvlEA;EACE,qBbu2BsC;Eap2BtC,gBnBwDuB;AA+hEzB;;AmBjlEA;EACE,kDAAA;EACA,qDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBtQR,gBnB4CuB;EmB3CvB,gBb+lB4B;ANo/C9B;;AmB/kEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,qBALI;AHo1DV;;AmB/kEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AH01DV;;AoBhnEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;ANkxCxC;;AqBtnEA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,crBLS;EqBMT,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,qBAAA;EeHE,wEDMJ;ArBonEF;AsBtnEM;EDhBN;ICiBQ,gBAAA;EtBynEN;AACF;AqBvnEE;EACE,gBAAA;ArBynEJ;AqBvnEI;EACE,eAAA;ArBynEN;AqBpnEE;EACE,crB3BO;EqB4BP,mCfg2BoC;Ee/1BpC,qCrByBuB;EqBxBvB,UAAA;EAKE,kDfkhBkB;ANgmDxB;AqB9mEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBkmEJ;AqB7lEE;EACE,cAAA;EACA,UAAA;ArB+lEJ;AqB3lEE;EACE,gCf40BoC;Ee10BpC,UAAA;ArB4lEJ;AqBplEE;EAEE,sCrB5BgB;EqB+BhB,UAAA;ArBmlEJ;AqB/kEE;EACE,sBAAA;EACA,uBAAA;EACA,yBrB1CkB;EqB2ClB,crB3FO;EuBHT,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArBilEJ;AsBvqEM;ED0EJ;ICzEM,gBAAA;EtB0qEN;AACF;AqBnlEE;EACE,wCf47B8B;ANypClC;;AqB5kEA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArB+kEF;AqB7kEE;EACE,UAAA;ArB+kEJ;AqB5kEE;EAEE,gBAAA;EACA,eAAA;ArB6kEJ;;AqBlkEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AP0sEJ;AqBnkEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;ANi8C9B;;AqBjkEA;EACE,mEfgwBsC;Ee/vBtC,sBAAA;ElB4HI,qBALI;EIvQN,yCAAA;APstEJ;AqBlkEE;EACE,sBAAA;EACA,uBAAA;EACA,yBrBjHqB;AAqrEzB;;AqB5jEE;EACE,mEf6uBoC;ANk1CxC;AqB5jEE;EACE,mEf0uBoC;ANo1CxC;AqB3jEE;EACE,mEfuuBoC;ANs1CxC;;AqBxjEA;EACE,WfquBsC;EepuBtC,+Df8tBsC;Ee7tBtC,erB3IoB;AAssEtB;AqBzjEE;EACE,eAAA;ArB2jEJ;AqBxjEE;EACE,oBAAA;EdvLA,qBAAA;APkvEJ;AqBvjEE;EACE,oBAAA;Ed5LA,qBAAA;APsvEJ;AqBtjEE;EAAoB,+Df8sBkB;AN22CxC;AqBxjEE;EAAoB,+Df8sBkB;AN62CxC;;AwB1wEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,oCAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,cxBRS;EwBST,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,wClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,qBAAA;EeHE,wEESJ;AxB0wEF;AsB/wEM;EEfN;IFgBQ,gBAAA;EtBkxEN;AACF;AwB7wEE;EACE,qCxBiCuB;EwBhCvB,UAAA;EAKE,kDlBi+B4B;AN0yClC;AwBvwEE;EAEE,qBxBekB;EwBdlB,sBAAA;AxBwwEJ;AwBrwEE;EAEE,sCxBagB;AAyvEpB;AwBjwEE;EACE,kBAAA;EACA,0BAAA;AxBmwEJ;;AwB/vEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AP6yEJ;;AwB/vEA;EACE,mBxBRuB;EwBSvB,sBxBTuB;EwBUvB,oBxBXuB;EGsOnB,qBALI;EIvQN,yCAAA;APqzEJ;;AwB7vEI;EACE,gEAAA;AxBgwEN;;AyBx0EA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;ANs6C1C;AyBz0EE;EACE,WAAA;EACA,mBAAA;AzB20EJ;;AyBv0EA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzB00EF;AyBx0EE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzB00EJ;;AyBt0EA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AzBw0EF;AyBr0EE;ElB3BE,qBAAA;APm2EJ;AyBp0EE;EAEE,kBnBm4BsC;ANk8C1C;AyBl0EE;EACE,uBnB03BsC;AN08C1C;AyBj0EE;EACE,qCzBCuB;EyBAvB,UAAA;EACA,kDnB8foB;ANq0DxB;AyBh0EE;EACE,yBzBNkB;EyBOlB,qBzBPkB;AAy0EtB;AyBh0EI;EAII,iEAAA;AzB+zER;AyB3zEI;EAII,iEAAA;AzB0zER;AyBrzEE;EACE,yBzB3BkB;EyB4BlB,qBzB5BkB;EyBiChB,iEAAA;AzBmzEN;AyB/yEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AN+8C3C;AyB1yEI;EACE,eAAA;EACA,YnBy1BqC;ANm9C3C;;AyB9xEA;EACE,mBnBo1BgC;AN68ClC;AyB/xEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzBgyEJ;AsBl5EM;EG0GJ;IHzGM,gBAAA;EtBq5EN;AACF;AyBnyEI;EACE,4DAAA;AzBqyEN;AyBlyEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzBgyER;AyB3xEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzB6xEJ;AyB3xEI;EACE,oBAAA;EACA,cAAA;AzB6xEN;;AyBxxEA;EACE,qBAAA;EACA,kBnBsyBgC;ANq/ClC;;AyBxxEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB2xEF;AyBvxEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;ANmoD9B;;AyBlxEI;EACE,4DAAA;AzBqxEN;;A0Bx8EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1B28EF;A0Bz8EE;EACE,UAAA;A1B28EJ;A0Bv8EI;EAA0B,kEpB8gCa;AN47C3C;A0Bz8EI;EAA0B,kEpB6gCa;AN+7C3C;A0Bz8EE;EACE,SAAA;A1B28EJ;A0Bx8EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBvBwDoB;E0B5BlB,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1By8EJ;AsBx9EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB29EN;AACF;A0B58EI;EHjCF,0CjB8hCyC;ANk9C3C;A0B18EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AP0+EJ;A0Bx8EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBvBwDoB;E0BFlB,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1By8EJ;AsBl/EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBq/EN;AACF;A0B58EI;EH3DF,0CjB8hCyC;AN4+C3C;A0B18EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;APogFJ;A0Bx8EE;EACE,oBAAA;A1B08EJ;A0Bx8EI;EACE,2CpBg9BqC;AN0/C3C;A0Bv8EI;EACE,2CpB48BqC;AN6/C3C;;A2BhiFA;EACE,kBAAA;A3BmiFF;A2BjiFE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AN4/CxC;A2BhiFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A3BkiFJ;AsBziFM;EKTJ;ILUM,gBAAA;EtB4iFN;AACF;A2BpiFE;;EAEE,oBAAA;A3BsiFJ;A2BpiFI;;EACE,kBAAA;A3BuiFN;A2BpiFI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;AN6hDxC;A2BpiFI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;ANkiDxC;A2BniFE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,oB3BEkB;AAmiFtB;A2B9hFI;;;;EACE,8DrBy/BkC;AN0iDxC;A2B9hFI;EACE,8DrBm/BkC;AN6iDxC;A2B3hFI;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,qBAAA;AP0lFJ;A2B3hFE;EACE,sC3BxBgB;AAqjFpB;A2BzhFI;EACE,sCAAA;A3B2hFN;A2BvhFE;;EAEE,crBhFO;ANymFX;;A4BnnFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5BsnFF;A4BpnFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5BsnFJ;A4BlnFE;;;EAGE,UAAA;A5BonFJ;A4B9mFE;EACE,kBAAA;EACA,UAAA;A5BgnFJ;A4B9mFI;EACE,UAAA;A5BgnFN;;A4BrmFA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,c5B9CS;E4B+CT,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,qBAAA;AP+oFJ;;A4B/lFA;;;;EAIE,sBAAA;EzBwNI,qBALI;EIvQN,yCAAA;APwpFJ;;A4B/lFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;APiqFJ;;A4B/lFA;;EAEE,qBAAA;A5BkmFF;;A4BrlFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AP6pFJ;A4BplFI;;;;ErB1EA,0BAAA;EACA,6BAAA;APoqFJ;A4B9kFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AP2pFJ;A4B9kFE;;ErB9EE,yBAAA;EACA,4BAAA;APgqFJ;;A6BxrFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;ANwoDzB;;A6BvrFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;APqtFJ;;A6BrrFI;;;;EAEE,cAAA;A7B0rFN;;A6BzuFI;EAqDE,+CvBuhCmB;EuBphCjB,mCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,wDAAA;EACA,4DAAA;A7BsrFR;A6BnrFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AN0qDzB;;A6BtvFI;EA+EI,mCvBu0BgC;EuBt0BhC,4EAAA;A7B2qFR;;A6B3vFI;EAuFE,+CvBq/BmB;ANmrDzB;A6BrqFQ;EAEE,iEAAA;EACA,qBvBq5B8B;EuBp5B9B,6DAAA;EACA,uEAAA;A7BsqFV;A6BlqFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AN6rDzB;;A6BzwFI;EAkHI,wCAAA;A7B2pFR;;A6B7wFI;EAyHE,+CvBm9BmB;ANqsDzB;A6BtpFM;EACE,4CvBg9BiB;ANwsDzB;A6BrpFM;EACE,2DvB48BiB;AN2sDzB;A6BppFM;EACE,iCvBw8BiB;AN8sDzB;;A6BjpFI;EACE,kBAAA;A7BopFN;;A6B9xFI;;;;;EAoJM,UAAA;A7BkpFV;;A6BlxFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;ANkuDzB;;A6BjxFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;AP+yFJ;;A6B/wFI;;;;EAEE,cAAA;A7BoxFN;;A6Bn0FI;EAqDE,iDvBuhCmB;EuBphCjB,mCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,wDAAA;EACA,4DAAA;A7BgxFR;A6B7wFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;ANowDzB;;A6Bh1FI;EA+EI,mCvBu0BgC;EuBt0BhC,4EAAA;A7BqwFR;;A6Br1FI;EAuFE,iDvBq/BmB;AN6wDzB;A6B/vFQ;EAEE,kEAAA;EACA,qBvBq5B8B;EuBp5B9B,6DAAA;EACA,uEAAA;A7BgwFV;A6B5vFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;ANuxDzB;;A6Bn2FI;EAkHI,wCAAA;A7BqvFR;;A6Bv2FI;EAyHE,iDvBm9BmB;AN+xDzB;A6BhvFM;EACE,8CvBg9BiB;ANkyDzB;A6B/uFM;EACE,0DvB48BiB;ANqyDzB;A6B9uFM;EACE,mCvBw8BiB;ANwyDzB;;A6B3uFI;EACE,kBAAA;A7B8uFN;;A6Bx3FI;;;;;EAsJM,UAAA;A7B0uFV;;A8Bl4FA;EAEE,0BAAA;EACA,0BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Bg4FF;AsBp5FM;EQhBN;IRiBQ,gBAAA;EtBu5FN;AACF;A8Bn4FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9Bo4FJ;A8Bj4FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9Bk4FJ;A8B/3FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B63FN;A8Bz3FE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Bu3FN;A8Bn3FE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9B+2FJ;A8B52FI;EAKI,0CAAA;A9B02FR;A8Br2FE;EAKI,0CAAA;A9Bm2FN;A8B/1FE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9B81FJ;;A8Bl1FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bq8FF;;A8Bn2FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bs9FF;;A8Bp3FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bu+FF;;A8Br4FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EACA,qDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bw/FF;;A8Bt5FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BygGF;;A8Bv6FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B0hGF;;A8Bx7FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B2iGF;;A8Bz8FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,uCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B4jGF;;A8B19FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,uCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B6kGF;;A8B3+FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B8lGF;;A8B5/FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B+mGF;;A8B7gGE;EC/GA,oBAAA;EACA,wBAAA;EACA,kCAAA;EACA,0BAAA;EACA,sCAAA;EACA,+CAAA;EACA,wCAAA;EACA,2BAAA;EACA,sCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,iCAAA;EACA,2CAAA;A/BgoGF;;A8BpgGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BwnGF;;A8BrhGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/ByoGF;;A8BtiGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B0pGF;;A8BvjGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B2qGF;;A8BxkGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B4rGF;;A8BzlGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6sGF;;A8B1mGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B8tGF;;A8B3nGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B+uGF;;A8B5oGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BgwGF;;A8B7pGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BixGF;;A8B9qGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BkyGF;;A8B/rGE;EChHA,2BAAA;EACA,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,wCAAA;EACA,kCAAA;EACA,2BAAA;EACA,+BAAA;EACA,yCAAA;EACA,4DAAA;EACA,oCAAA;EACA,iCAAA;EACA,2CAAA;EACA,mBAAA;A/BmzGF;;A8BpsGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;ANw7F1C;A8B5rGE;EACE,0BAAA;A9B8rGJ;A8B3rGE;EACE,gCAAA;A9B6rGJ;;A8BlrGA;ECjJE,0BAAA;EACA,0BAAA;E5B8NI,8BALI;E4BvNR,kDAAA;A/Bu0GF;;A8BrrGA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/B80GF;;AgCj5GA;EVgBM,gCUfJ;AhCo5GF;AsBj4GM;EUpBN;IVqBQ,gBAAA;EtBo4GN;AACF;AgCv5GE;EACE,UAAA;AhCy5GJ;;AgCn5GE;EACE,aAAA;AhCs5GJ;;AgCl5GA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhCq5GF;AsBn5GM;EULN;IVMQ,gBAAA;EtBs5GN;AACF;AgCx5GE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhC05GJ;AsB75GM;EUAJ;IVCM,gBAAA;EtBg6GN;AACF;;AiCr7GA;;;;;;EAME,kBAAA;AjCw7GF;;AiCr7GA;EACE,mBAAA;AjCw7GF;AkCh6GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlCw8GF;AkC94GI;EACE,cAAA;AlCg5GN;;AiC97GA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,wCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,qCAAA;EACA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;APw+GJ;AiC37GE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjC67GJ;;AiCr6GI;EACE,oBAAA;AjCw6GN;AiCt6GM;EACE,WAAA;EACA,OAAA;AjCw6GR;;AiCp6GI;EACE,kBAAA;AjCu6GN;AiCr6GM;EACE,QAAA;EACA,UAAA;AjCu6GR;;Acj9GI;EmB4BA;IACE,oBAAA;EjCy7GJ;EiCv7GI;IACE,WAAA;IACA,OAAA;EjCy7GN;EiCr7GE;IACE,kBAAA;EjCu7GJ;EiCr7GI;IACE,QAAA;IACA,UAAA;EjCu7GN;AACF;Acl+GI;EmB4BA;IACE,oBAAA;EjCy8GJ;EiCv8GI;IACE,WAAA;IACA,OAAA;EjCy8GN;EiCr8GE;IACE,kBAAA;EjCu8GJ;EiCr8GI;IACE,QAAA;IACA,UAAA;EjCu8GN;AACF;Acl/GI;EmB4BA;IACE,oBAAA;EjCy9GJ;EiCv9GI;IACE,WAAA;IACA,OAAA;EjCy9GN;EiCr9GE;IACE,kBAAA;EjCu9GJ;EiCr9GI;IACE,QAAA;IACA,UAAA;EjCu9GN;AACF;AclgHI;EmB4BA;IACE,oBAAA;EjCy+GJ;EiCv+GI;IACE,WAAA;IACA,OAAA;EjCy+GN;EiCr+GE;IACE,kBAAA;EjCu+GJ;EiCr+GI;IACE,QAAA;IACA,UAAA;EjCu+GN;AACF;AclhHI;EmB4BA;IACE,oBAAA;EjCy/GJ;EiCv/GI;IACE,WAAA;IACA,OAAA;EjCy/GN;EiCr/GE;IACE,kBAAA;EjCu/GJ;EiCr/GI;IACE,QAAA;IACA,UAAA;EjCu/GN;AACF;AiC9+GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjCg/GJ;AkCpkHI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlCqmHF;AkCljHI;EACE,cAAA;AlCojHN;;AiCp/GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjCu/GJ;AkCzlHI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlCmnHF;AkCvkHI;EACE,cAAA;AlCykHN;AiC//GI;EACE,iBAAA;AjCigHN;;AiC3/GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjC8/GJ;AkCjnHI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlCmnHN;AkCxmHM;EACE,aAAA;AlC0mHR;AkCvmHM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlC6oHF;AkCvmHI;EACE,cAAA;AlCymHN;AiC9gHI;EACE,iBAAA;AjCghHN;;AiCzgHA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjC4gHF;;AiCtgHA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;APgrHJ;AiCvgHE;EAEE,0CAAA;EV1LF,kDU4LuB;AjCugHzB;AiCpgHE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjCqgHzB;AiClgHE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjCmgHJ;;AiC7/GA;EACE,cAAA;AjCggHF;;AiC5/GA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjC+/GF;;AiC3/GA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjC8/GF;;AiC1/GA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjC4/GF;;AmClvHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCqvHF;AmCnvHE;;EACE,kBAAA;EACA,cAAA;AnCsvHJ;AmCjvHE;;;;;;;;;;;;EAME,UAAA;AnCyvHJ;;AmCpvHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCuvHF;AmCrvHE;EACE,WAAA;AnCuvHJ;;AmCnvHA;E5BhBI,sCAAA;APuwHJ;AmCnvHE;;EAEE,8CAAA;AnCqvHJ;AmCjvHE;;;E5BVE,0BAAA;EACA,6BAAA;APgwHJ;AmC7uHE;;;E5BNE,yBAAA;EACA,4BAAA;APwvHJ;;AmChuHA;EACE,sBAAA;EACA,qBAAA;AnCmuHF;AmCjuHE;EAGE,cAAA;AnCiuHJ;AmC9tHE;EACE,eAAA;AnCguHJ;;AmC5tHA;EACE,uBAAA;EACA,sBAAA;AnC+tHF;;AmC5tHA;EACE,qBAAA;EACA,oBAAA;AnC+tHF;;AmC3sHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnC8sHF;AmC5sHE;;EAEE,WAAA;AnC8sHJ;AmC3sHE;;EAEE,6CAAA;AnC6sHJ;AmCzsHE;;E5B1FE,6BAAA;EACA,4BAAA;APuyHJ;AmCrsHE;;;E5BjHE,yBAAA;EACA,0BAAA;AP2zHJ;;AoCn1HA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApCk1HF;;AoC/0HA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApCk1HF;AsB91HM;EcGN;IdFQ,gBAAA;EtBi2HN;AACF;AoCr1HE;EAEE,qCAAA;ApCs1HJ;AoCl1HE;EACE,UAAA;EACA,kD9BkhBoB;ANk0GxB;AoCh1HE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApCi1HJ;;AoCz0HA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApCy0HF;AoCv0HE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;APu3HJ;AoCx0HI;EAGE,kBAAA;EACA,wDAAA;ApCw0HN;AoCp0HE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApCs0HJ;AoCn0HE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;APs4HJ;;AoC3zHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApC6zHF;AoC1zHE;E7B5FE,gDAAA;APy5HJ;AoCzzHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApC2zHzB;;AoClzHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApCkzHF;AoChzHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApCkzHJ;AoChzHI;EAEE,iCAAA;ApCizHN;AoC7yHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApC+yHJ;;AoCryHE;;EAEE,cAAA;EACA,kBAAA;ApCwyHJ;;AoCnyHE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ApCsyHJ;;AoChyHE;;EACE,WAAA;ApCoyHJ;;AoC1xHE;EACE,aAAA;ApC6xHJ;AoC3xHE;EACE,cAAA;ApC6xHJ;;AqC19HA;EAEE,wBAAA;EACA,+BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,wCAAA;EACA,kCAAA;EACA,uCAAA;EACA,8DAAA;EACA,oEAAA;EACA,oCAAA;EACA,sCAAA;EACA,sCAAA;EACA,yCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArC09HF;AqCp9HE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArC49HJ;AqCx8HA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArC08HF;AqCx8HE;EAEE,yCAAA;ArCy8HJ;;AqC/7HA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArC87HF;AqC37HI;EAEE,oCAAA;ArC47HN;AqCx7HE;EACE,gBAAA;ArC07HJ;;AqCj7HA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArCo7HF;AqCl7HE;;;EAGE,oCAAA;ArCo7HJ;;AqCv6HA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ArCw6HF;;AqCp6HA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArCu6HF;AsBhjIM;EeiIN;IfhIQ,gBAAA;EtBmjIN;AACF;AqC16HE;EACE,qBAAA;ArC46HJ;AqCz6HE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArC26HJ;;AqCr6HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCw6HF;;AqCr6HA;EACE,yCAAA;EACA,gBAAA;ArCw6HF;;AcliII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC+5HN;EqC75HM;IACE,mBAAA;ErC+5HR;EqC75HQ;IACE,kBAAA;ErC+5HV;EqC55HQ;IACE,kDAAA;IACA,iDAAA;ErC85HV;EqC15HM;IACE,iBAAA;ErC45HR;EqCz5HM;IACE,wBAAA;IACA,gBAAA;ErC25HR;EqCx5HM;IACE,aAAA;ErC05HR;EqCv5HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCu5HR;EqCp5HQ;IACE,aAAA;ErCs5HV;EqCn5HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCq5HV;AACF;AcllII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC88HN;EqC58HM;IACE,mBAAA;ErC88HR;EqC58HQ;IACE,kBAAA;ErC88HV;EqC38HQ;IACE,kDAAA;IACA,iDAAA;ErC68HV;EqCz8HM;IACE,iBAAA;ErC28HR;EqCx8HM;IACE,wBAAA;IACA,gBAAA;ErC08HR;EqCv8HM;IACE,aAAA;ErCy8HR;EqCt8HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCs8HR;EqCn8HQ;IACE,aAAA;ErCq8HV;EqCl8HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCo8HV;AACF;AcjoII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC6/HN;EqC3/HM;IACE,mBAAA;ErC6/HR;EqC3/HQ;IACE,kBAAA;ErC6/HV;EqC1/HQ;IACE,kDAAA;IACA,iDAAA;ErC4/HV;EqCx/HM;IACE,iBAAA;ErC0/HR;EqCv/HM;IACE,wBAAA;IACA,gBAAA;ErCy/HR;EqCt/HM;IACE,aAAA;ErCw/HR;EqCr/HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCq/HR;EqCl/HQ;IACE,aAAA;ErCo/HV;EqCj/HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCm/HV;AACF;AchrII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC4iIN;EqC1iIM;IACE,mBAAA;ErC4iIR;EqC1iIQ;IACE,kBAAA;ErC4iIV;EqCziIQ;IACE,kDAAA;IACA,iDAAA;ErC2iIV;EqCviIM;IACE,iBAAA;ErCyiIR;EqCtiIM;IACE,wBAAA;IACA,gBAAA;ErCwiIR;EqCriIM;IACE,aAAA;ErCuiIR;EqCpiIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCoiIR;EqCjiIQ;IACE,aAAA;ErCmiIV;EqChiIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCkiIV;AACF;Ac/tII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC2lIN;EqCzlIM;IACE,mBAAA;ErC2lIR;EqCzlIQ;IACE,kBAAA;ErC2lIV;EqCxlIQ;IACE,kDAAA;IACA,iDAAA;ErC0lIV;EqCtlIM;IACE,iBAAA;ErCwlIR;EqCrlIM;IACE,wBAAA;IACA,gBAAA;ErCulIR;EqCplIM;IACE,aAAA;ErCslIR;EqCnlIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCmlIR;EqChlIQ;IACE,aAAA;ErCklIV;EqC/kIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCilIV;AACF;AqCxoII;EAEI,iBAAA;EACA,2BAAA;ArCyoIR;AqCvoIQ;EACE,mBAAA;ArCyoIV;AqCvoIU;EACE,kBAAA;ArCyoIZ;AqCtoIU;EACE,kDAAA;EACA,iDAAA;ArCwoIZ;AqCpoIQ;EACE,iBAAA;ArCsoIV;AqCnoIQ;EACE,wBAAA;EACA,gBAAA;ArCqoIV;AqCloIQ;EACE,aAAA;ArCooIV;AqCjoIQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArCioIV;AqC9nIU;EACE,aAAA;ArCgoIZ;AqC7nIU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArC+nIZ;;AqC9mIA;;EAGE,uBAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArCgnIF;;AqC1mII;EACE,qEAAA;ArC6mIN;;AsCt4IA;EAEE,2BAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,kDAAA;EACA,+BAAA;EACA,sBAAA;EACA,sEAAA;EACA,iCAAA;EACA,gCAAA;EACA,wCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,sCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;APw5IJ;AsCn4IE;EACE,eAAA;EACA,cAAA;AtCq4IJ;AsCl4IE;EACE,mBAAA;EACA,sBAAA;AtCo4IJ;AsCl4II;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AP25IJ;AsCl4II;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;APk5IJ;AsC/3IE;;EAEE,aAAA;AtCi4IJ;;AsC73IA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtC83IF;;AsC33IA;EACE,4CAAA;EACA,iCAAA;AtC83IF;;AsC33IA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtC83IF;;AsC33IA;EACE,gBAAA;AtC83IF;;AsCt3IE;EACE,oCAAA;AtCy3IJ;;AsCj3IA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtCo3IF;AsCl3IE;E/B7FE,wFAAA;APk9IJ;;AsCh3IA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtCm3IF;AsCj3IE;E/BxGE,wFAAA;AP49IJ;;AsC12IA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtC62IF;AsC32IE;EACE,mCAAA;EACA,sCAAA;AtC62IJ;;AsCz2IA;EACE,uDAAA;EACA,sDAAA;AtC42IF;;AsCx2IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;APs/IJ;;AsCx2IA;;;EAGE,WAAA;AtC22IF;;AsCx2IA;;E/B3II,0DAAA;EACA,2DAAA;APw/IJ;;AsCz2IA;;E/BlII,8DAAA;EACA,6DAAA;APg/IJ;;AsCl2IE;EACE,0CAAA;AtCq2IJ;Ach+II;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtCq2IF;EsCl2IE;IACE,SAAA;IACA,gBAAA;EtCo2IJ;EsCl2II;IACE,cAAA;IACA,cAAA;EtCo2IN;EsC/1IM;I/B1KJ,0BAAA;IACA,6BAAA;EP4gJF;EsCh2IQ;;IAGE,0BAAA;EtCi2IV;EsC/1IQ;;IAGE,6BAAA;EtCg2IV;EsC51IM;I/B3KJ,yBAAA;IACA,4BAAA;EP0gJF;EsC71IQ;;IAGE,yBAAA;EtC81IV;EsC51IQ;;IAGE,4BAAA;EtC61IV;AACF;;AuCjkJA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvCmkJF;;AuC/jJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvCkkJF;AsBzlJM;EiBUN;IjBTQ,gBAAA;EtB4lJN;AACF;AuCrkJE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvCukJJ;AuCrkJI;EACE,qDAAA;EACA,iDAAA;AvCukJN;AuClkJE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvCokJJ;AsBlnJM;EiBqCJ;IjBpCM,gBAAA;EtBqnJN;AACF;AuCtkJE;EACE,UAAA;AvCwkJJ;AuCrkJE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvCukJJ;;AuCnkJA;EACE,gBAAA;AvCskJF;;AuCnkJA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvCskJF;AuCpkJE;EhC7DE,yDAAA;EACA,0DAAA;APooJJ;AuCrkJI;EhChEA,+DAAA;EACA,gEAAA;APwoJJ;AuCpkJE;EACE,aAAA;AvCskJJ;AuClkJE;EhC5DE,6DAAA;EACA,4DAAA;APioJJ;AuClkJM;EhChEF,mEAAA;EACA,kEAAA;APqoJJ;AuCjkJI;EhCrEA,6DAAA;EACA,4DAAA;APyoJJ;;AuC/jJA;EACE,8EAAA;AvCkkJF;;AuCzjJE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AP2qJJ;AuC1jJI;EAAgB,aAAA;AvC6jJpB;AuC5jJI;EAAe,gBAAA;AvC+jJnB;AuC5jJI;;;EhCrHA,gBAAA;APsrJJ;;AuCtjJI;EACE,iEAAA;EACA,wEAAA;AvCyjJN;;AwC9sJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AP8sJJ;;AwCxsJE;EACE,iDAAA;AxC2sJJ;AwCzsJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxC2sJN;AwCvsJE;EACE,6CAAA;AxCysJJ;;AyC9uJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;ATmwJF;;AyC5uJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzC+uJF;AsBhwJM;EmBQN;InBPQ,gBAAA;EtBmwJN;AACF;AyClvJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzCmvJJ;AyChvJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzCkvJJ;AyC/uJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzCgvJJ;AyC7uJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzC8uJJ;;AyCzuJE;EACE,8CnC8sCgC;AN8hHpC;AyCvuJM;ElC9BF,0DAAA;EACA,6DAAA;APwwJJ;AyCruJM;ElClDF,2DAAA;EACA,8DAAA;AP0xJJ;;AyCxtJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,qCALI;EuCnRR,yDAAA;A1C8zJF;;AyC3tJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1Cq0JF;;A2Cv0JA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AP40JJ;A2Cn0JE;EACE,aAAA;A3Cq0JJ;;A2Ch0JA;EACE,kBAAA;EACA,SAAA;A3Cm0JF;;A4Cn2JA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;APu2JJ;;A4C/1JA;EAEE,cAAA;A5Ci2JF;;A4C71JA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5Cg2JF;;A4Cx1JA;EACE,sBtCs+C8B;ANq3GhC;A4Cx1JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;A5C01JJ;;A4Cl1JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5Cq1JJ;;A4Cz1JE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5C41JJ;;A4Ch2JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5Cm2JJ;;A4Cv2JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C02JJ;;A4C92JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5Ci3JJ;;A4Cr3JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5Cw3JJ;;A4C53JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A5C+3JJ;;A4Cn4JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5Cs4JJ;;A4C14JE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5C64JJ;;A4Cj5JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5Co5JJ;;A4Cx5JE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5C25JJ;;A4C/5JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A5Ck6JJ;;A6C99JE;EACE;IAAK,gDAAA;E7Ck+JP;AACF;A6C99JA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;APs+JJ;;A6Cz9JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7C49JF;AsBj/JM;EuBYN;IvBXQ,gBAAA;EtBo/JN;AACF;;A6C99JA;EtBAE,qMAAA;EsBEA,oEAAA;A7Ci+JF;;A6C99JA;EACE,iBAAA;A7Ci+JF;;A6C99JA;EACE,WAAA;A7Ci+JF;;A6C79JE;EACE,kDAAA;A7Cg+JJ;A6C79JM;EAJJ;IAKM,eAAA;E7Cg+JN;AACF;;A8C5hKA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uCAAA;EACA,wCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;APsiKJ;;A8CvhKA;EACE,qBAAA;EACA,sBAAA;A9C0hKF;A8CxhKE;EAEE,oCAAA;EACA,0BAAA;A9CyhKJ;;A8CjhKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9CohKF;A8ClhKE;EvC9BE,+BAAA;EACA,gCAAA;APmjKJ;A8ClhKE;EvCpBE,mCAAA;EACA,kCAAA;APyiKJ;A8ClhKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CmhKJ;A8C/gKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CihKJ;A8C7gKE;EACE,mBAAA;A9C+gKJ;A8C7gKI;EACE,wDAAA;EACA,mDAAA;A9C+gKN;;A8CrgKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9CwgKF;A8CpgKI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9CqgKN;A8ClgKI;EACE,+CAAA;EACA,uDAAA;A9CogKN;;A8Cv/JI;EACE,mBAAA;A9C0/JN;A8Cv/JQ;EvCzDJ,6DAAA;EAZA,0BAAA;APgkKJ;A8Ct/JQ;EvC1EJ,2DAAA;EAYA,4BAAA;APwjKJ;A8Cr/JQ;EACE,aAAA;A9Cu/JV;A8Cp/JQ;EACE,mDAAA;EACA,oBAAA;A9Cs/JV;A8Cp/JU;EACE,yDAAA;EACA,oDAAA;A9Cs/JZ;;Ac9kKI;EgCgEA;IACE,mBAAA;E9CkhKJ;E8C/gKM;IvCzDJ,6DAAA;IAZA,0BAAA;EPwlKF;E8C9gKM;IvC1EJ,2DAAA;IAYA,4BAAA;EPglKF;E8C7gKM;IACE,aAAA;E9C+gKR;E8C5gKM;IACE,mDAAA;IACA,oBAAA;E9C8gKR;E8C5gKQ;IACE,yDAAA;IACA,oDAAA;E9C8gKV;AACF;AcvmKI;EgCgEA;IACE,mBAAA;E9C0iKJ;E8CviKM;IvCzDJ,6DAAA;IAZA,0BAAA;EPgnKF;E8CtiKM;IvC1EJ,2DAAA;IAYA,4BAAA;EPwmKF;E8CriKM;IACE,aAAA;E9CuiKR;E8CpiKM;IACE,mDAAA;IACA,oBAAA;E9CsiKR;E8CpiKQ;IACE,yDAAA;IACA,oDAAA;E9CsiKV;AACF;Ac/nKI;EgCgEA;IACE,mBAAA;E9CkkKJ;E8C/jKM;IvCzDJ,6DAAA;IAZA,0BAAA;EPwoKF;E8C9jKM;IvC1EJ,2DAAA;IAYA,4BAAA;EPgoKF;E8C7jKM;IACE,aAAA;E9C+jKR;E8C5jKM;IACE,mDAAA;IACA,oBAAA;E9C8jKR;E8C5jKQ;IACE,yDAAA;IACA,oDAAA;E9C8jKV;AACF;AcvpKI;EgCgEA;IACE,mBAAA;E9C0lKJ;E8CvlKM;IvCzDJ,6DAAA;IAZA,0BAAA;EPgqKF;E8CtlKM;IvC1EJ,2DAAA;IAYA,4BAAA;EPwpKF;E8CrlKM;IACE,aAAA;E9CulKR;E8CplKM;IACE,mDAAA;IACA,oBAAA;E9CslKR;E8CplKQ;IACE,yDAAA;IACA,oDAAA;E9CslKV;AACF;Ac/qKI;EgCgEA;IACE,mBAAA;E9CknKJ;E8C/mKM;IvCzDJ,6DAAA;IAZA,0BAAA;EPwrKF;E8C9mKM;IvC1EJ,2DAAA;IAYA,4BAAA;EPgrKF;E8C7mKM;IACE,aAAA;E9C+mKR;E8C5mKM;IACE,mDAAA;IACA,oBAAA;E9C8mKR;E8C5mKQ;IACE,yDAAA;IACA,oDAAA;E9C8mKV;AACF;A8CjmKA;EvClJI,gBAAA;APsvKJ;A8CjmKE;EACE,mDAAA;A9CmmKJ;A8CjmKI;EACE,sBAAA;A9CmmKN;;A8CtlKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9CylKJ;;A8CnmKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9CsmKJ;;A8ChnKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9CmnKJ;;A8C7nKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9CgoKJ;;A8C1oKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9C6oKJ;;A8CvpKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9C0pKJ;;A8CpqKE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A9CuqKJ;;A8CjrKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9CorKJ;;A8C9rKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9CisKJ;;A8C3sKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9C8sKJ;;A8CxtKE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9C2tKJ;;A8CruKE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A9CwuKJ;;A+Ct6KA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/Cs6KF;A+Cn6KE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/Cq6KJ;A+Cl6KE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/Co6KJ;A+Cj6KE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/Ck6KJ;;A+C15KA;EAHE,iEAAA;A/Ci6KF;;A+C15KA;;EAEE,uBAAA;A/C65KF;;AIx8KI;E2CkCF,iEAAA;A/C06KF;;AgD39KA;EAEE,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,2DAAA;EACA,gCAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;APo+KJ;AgDz9KE;EACE,UAAA;AhD29KJ;AgDx9KE;EACE,aAAA;AhD09KJ;;AgDt9KA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhDw9KF;AgDt9KE;EACE,sCAAA;AhDw9KJ;;AgDp9KA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;APw/KJ;AgDt9KE;EACE,oDAAA;EACA,sCAAA;AhDw9KJ;;AgDp9KA;EACE,kCAAA;EACA,qBAAA;AhDu9KF;;AiDrhLA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjDmhLF;;AiD5gLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjD8gLF;AiD3gLE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AjD6gLJ;AsBvjLM;E2BwCJ;I3BvCM,gBAAA;EtB0jLN;AACF;AiDhhLE;EACE,e3Cg8CgC;ANklIpC;AiD9gLE;EACE,sB3C67CgC;ANmlIpC;;AiD5gLA;EACE,+CAAA;AjD+gLF;AiD7gLE;EACE,gBAAA;EACA,gBAAA;AjD+gLJ;AiD5gLE;EACE,gBAAA;AjD8gLJ;;AiD1gLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjD6gLF;;AiDzgLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjDygLF;;AiDrgLA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjD2gL9D;AkDvnLE;EAAS,UAAA;AlD0nLX;AkDznLE;EAAS,mCD2GiF;AjDihL5F;;AiD5gLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;APqnLJ;AiD9gLE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AjD+gLJ;;AiD1gLA;EACE,gBAAA;EACA,8CAAA;AjD6gLF;;AiDxgLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjDygLF;;AiDrgLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;APsoLJ;AiDpgLE;EACE,8CAAA;AjDsgLJ;;AcrnLI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EjDogLF;EiDhgLA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjDkgLF;EiD//KA;IACE,uBAAA;EjDigLF;AACF;AcpoLI;EmCuIF;;IAEE,uBAAA;EjDggLF;AACF;Ac1oLI;EmC8IF;IACE,wBAAA;EjD+/KF;AACF;AiDt/KI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjDw/KN;AiDt/KM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;APssLJ;AiDr/KM;;E1CjNF,gBAAA;AP0sLJ;AiDp/KM;EACE,gBAAA;AjDs/KR;;AcppLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD4gLJ;EiD1gLI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP0tLF;EiDzgLI;;I1CjNF,gBAAA;EP8tLF;EiDxgLI;IACE,gBAAA;EjD0gLN;AACF;AczqLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDgiLJ;EiD9hLI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP8uLF;EiD7hLI;;I1CjNF,gBAAA;EPkvLF;EiD5hLI;IACE,gBAAA;EjD8hLN;AACF;Ac7rLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDojLJ;EiDljLI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPkwLF;EiDjjLI;;I1CjNF,gBAAA;EPswLF;EiDhjLI;IACE,gBAAA;EjDkjLN;AACF;AcjtLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDwkLJ;EiDtkLI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPsxLF;EiDrkLI;;I1CjNF,gBAAA;EP0xLF;EiDpkLI;IACE,gBAAA;EjDskLN;AACF;AcruLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD4lLJ;EiD1lLI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP0yLF;EiDzlLI;;I1CjNF,gBAAA;EP8yLF;EiDxlLI;IACE,gBAAA;EjD0lLN;AACF;AmDp0LA;EAEE,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,2BAAA;EACA,wBAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnD40LF;AmD10LE;EAAS,kCAAA;AnD60LX;AmD30LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnD60LJ;AmD30LI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnD60LN;;AmDx0LA;EACE,iDAAA;AnD20LF;AmDz0LE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnD20LJ;;AmDv0LA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnD00LF;AmDx0LE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnD00LJ;;AmDt0LA,mBAAA;AAEA;EACE,8CAAA;AnDw0LF;AmDt0LE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDw0LJ;;AmDp0LA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDu0LF;AmDr0LE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDu0LJ;;AmDn0LA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APu5LJ;;AqD16LA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,sCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;APq8LJ;AqDj7LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDm7LJ;AqDj7LI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArDk7LN;;AqD56LE;EACE,oFAAA;ArD+6LJ;AqD76LI;EAEE,wFAAA;ArD86LN;AqD36LI;EACE,SAAA;EACA,gDAAA;ArD66LN;AqD16LI;EACE,sCAAA;EACA,sCAAA;ArD46LN;;AqDv6LA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArDy6LJ;AqDv6LI;EAEE,kIAAA;ArDw6LN;AqDr6LI;EACE,OAAA;EACA,kDAAA;ArDu6LN;AqDp6LI;EACE,oCAAA;EACA,wCAAA;ArDs6LN;;AqDj6LA,mBAAA;AAGE;EACE,iFAAA;ArDk6LJ;AqDh6LI;EAEE,wFAAA;ArDi6LN;AqD95LI;EACE,MAAA;EACA,mDAAA;ArDg6LN;AqD75LI;EACE,mCAAA;EACA,yCAAA;ArD+5LN;AqD15LE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArD45LJ;;AqDx5LA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArD05LJ;AqDx5LI;EAEE,kIAAA;ArDy5LN;AqDt5LI;EACE,QAAA;EACA,iDAAA;ArDw5LN;AqDr5LI;EACE,qCAAA;EACA,uCAAA;ArDu5LN;;AqDl5LA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;APiiMJ;AqDn4LE;EACE,aAAA;ArDq4LJ;;AqDj4LA;EACE,0EAAA;EACA,mCAAA;ArDo4LF;;AsDzjMA;EACE,kBAAA;AtD4jMF;;AsDzjMA;EACE,mBAAA;AtD4jMF;;AsDzjMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD4jMF;AuDllME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDolMJ;;AsD7jMA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtDgkMF;AsB/kMM;EgCQN;IhCPQ,gBAAA;EtBklMN;AACF;;AsDlkMA;;;EAGE,cAAA;AtDqkMF;;AsDlkMA;;EAEE,2BAAA;AtDqkMF;;AsDlkMA;;EAEE,4BAAA;AtDqkMF;;AsD5jME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtD+jMJ;AsD5jME;;;EAGE,UAAA;EACA,UAAA;AtD8jMJ;AsD3jME;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtD6jMJ;AsBtnMM;EgCqDJ;;IhCpDM,gBAAA;EtB0nMN;AACF;;AsD1jMA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WtD7FM;EsD8FN,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AtD4jMF;AsBhpMM;EgCkEN;;IhCjEQ,gBAAA;EtBopMN;AACF;AsD/jME;;;EAEE,WtDxGI;EsDyGJ,qBAAA;EACA,UAAA;EACA,YhDogDiC;AN8jJrC;;AsD/jMA;EACE,OAAA;AtDkkMF;;AsD/jMA;EACE,QAAA;AtDkkMF;;AsD7jMA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtDgkMF;;AsD7jMA;EACE,0TAAA;AtDgkMF;;AsD9jMA;EACE,yTAAA;AtDikMF;;AsDzjMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;ANwmJrC;AsDzjME;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AtD0jMJ;AsBxtMM;EgC6IJ;IhC5IM,gBAAA;EtB2tMN;AACF;AsD5jME;EACE,UhDw8CiC;ANsnJrC;;AsDrjMA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AtDwjMF;;AsD7iMA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AtDsjMF;;AsD/iMA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AtDkjMF;;AI7vMI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AtDmkMF;;AwD9wMA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxDgxMF;;AwD5wMA;EACE;IAAK,0CAAA;ExDgxML;AACF;AwD7wMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxD4wMF;;AwDzwMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxD2wMF;;AwDlwMA;EACE;IACE,mBAAA;ExDqwMF;EwDnwMA;IACE,UAAA;IACA,eAAA;ExDqwMF;AACF;AwDjwMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxDgwMF;;AwD7vMA;EACE,wBAAA;EACA,yBAAA;AxDgwMF;;AwD5vME;EACE;;IAEE,kCAAA;ExD+vMJ;AACF;AyD/0MA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzDg1MF;;AcnxMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDi0MJ;AACF;AsB51MM;EmCYJ;InCXM,gBAAA;EtB+1MN;AACF;AczyMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDw0MN;EyDr0MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDu0MN;EyDp0MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDs0MN;EyDn0MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDq0MN;EyDl0MI;IAEE,eAAA;EzDm0MN;EyDh0MI;IAGE,mBAAA;EzDg0MN;AACF;Ac71MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD+zMN;EyD7zMM;IACE,aAAA;EzD+zMR;EyD5zMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD6zMR;AACF;;Acj2MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD+4MJ;AACF;AsB16MM;EmCYJ;InCXM,gBAAA;EtB66MN;AACF;Acv3MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDs5MN;EyDn5MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDq5MN;EyDl5MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDo5MN;EyDj5MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDm5MN;EyDh5MI;IAEE,eAAA;EzDi5MN;EyD94MI;IAGE,mBAAA;EzD84MN;AACF;Ac36MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD64MN;EyD34MM;IACE,aAAA;EzD64MR;EyD14MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD24MR;AACF;;Ac/6MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD69MJ;AACF;AsBx/MM;EmCYJ;InCXM,gBAAA;EtB2/MN;AACF;Acr8MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDo+MN;EyDj+MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDm+MN;EyDh+MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDk+MN;EyD/9MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDi+MN;EyD99MI;IAEE,eAAA;EzD+9MN;EyD59MI;IAGE,mBAAA;EzD49MN;AACF;Acz/MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD29MN;EyDz9MM;IACE,aAAA;EzD29MR;EyDx9MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDy9MR;AACF;;Ac7/MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD2iNJ;AACF;AsBtkNM;EmCYJ;InCXM,gBAAA;EtBykNN;AACF;AcnhNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDkjNN;EyD/iNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDijNN;EyD9iNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDgjNN;EyD7iNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD+iNN;EyD5iNI;IAEE,eAAA;EzD6iNN;EyD1iNI;IAGE,mBAAA;EzD0iNN;AACF;AcvkNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDyiNN;EyDviNM;IACE,aAAA;EzDyiNR;EyDtiNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDuiNR;AACF;;Ac3kNI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDynNJ;AACF;AsBppNM;EmCYJ;InCXM,gBAAA;EtBupNN;AACF;AcjmNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDgoNN;EyD7nNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD+nNN;EyD5nNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD8nNN;EyD3nNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD6nNN;EyD1nNI;IAEE,eAAA;EzD2nNN;EyDxnNI;IAGE,mBAAA;EzDwnNN;AACF;AcrpNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDunNN;EyDrnNM;IACE,aAAA;EzDunNR;EyDpnNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDqnNR;AACF;;AyDrsNE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzDssNN;AsBhuNM;EmCYJ;InCXM,gBAAA;EtBmuNN;AACF;AyDzsNM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzD2sNR;AyDxsNM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzD0sNR;AyDvsNM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDysNR;AyDtsNM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDwsNR;AyDrsNM;EAEE,eAAA;AzDssNR;AyDnsNM;EAGE,mBAAA;AzDmsNR;;AyDxqNA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sBlDHM;AAmyNR;AkD7xNE;EAAS,UAAA;AlDgyNX;AkD/xNE;EAAS,YlDmDc;AA+uNzB;;AyDprNA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzDurNF;AyDrrNE;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AzDsrNJ;;AyDlrNA;EACE,gBAAA;EACA,kDAAA;AzDqrNF;;AyDlrNA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDqrNF;;A0Dt0NA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;ANyhLpC;A0Dv0NE;EACE,qBAAA;EACA,WAAA;A1Dy0NJ;;A0Dp0NA;EACE,iBAAA;A1Du0NF;;A0Dp0NA;EACE,iBAAA;A1Du0NF;;A0Dp0NA;EACE,iBAAA;A1Du0NF;;A0Dl0NE;EACE,mDAAA;A1Dq0NJ;;A0Dj0NA;EACE;IACE,YpDmxCgC;ENijLlC;AACF;A0Dj0NA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1Dm0NF;;A0Dh0NA;EACE;IACE,uBAAA;E1Dm0NF;AACF;AuDl3NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDo3NJ;;A2Dv3NE;EACE,sBAAA;EACA,iFAAA;A3D03NJ;;A2D53NE;EACE,sBAAA;EACA,gFAAA;A3D+3NJ;;A2Dj4NE;EACE,sBAAA;EACA,iFAAA;A3Do4NJ;;A2Dt4NE;EACE,sBAAA;EACA,iFAAA;A3Dy4NJ;;A2D34NE;EACE,sBAAA;EACA,mFAAA;A3D84NJ;;A2Dh5NE;EACE,sBAAA;EACA,8EAAA;A3Dm5NJ;;A2Dr5NE;EACE,sBAAA;EACA,qFAAA;A3Dw5NJ;;A2D15NE;EACE,sBAAA;EACA,8EAAA;A3D65NJ;;A2D/5NE;EACE,sBAAA;EACA,gFAAA;A3Dk6NJ;;A2Dp6NE;EACE,sBAAA;EACA,mFAAA;A3Du6NJ;;A2Dz6NE;EACE,sBAAA;EACA,+EAAA;A3D46NJ;;A2D96NE;EACE,sBAAA;EACA,qFAAA;A3Di7NJ;;A4Dn7NE;EACE,wEAAA;EACA,kGAAA;A5Ds7NJ;A4Dn7NM;EAGE,+DAAA;EACA,yFAAA;A5Dm7NR;;A4D57NE;EACE,uEAAA;EACA,iGAAA;A5D+7NJ;A4D57NM;EAGE,8DAAA;EACA,wFAAA;A5D47NR;;A4Dr8NE;EACE,wEAAA;EACA,kGAAA;A5Dw8NJ;A4Dr8NM;EAGE,gEAAA;EACA,0FAAA;A5Dq8NR;;A4D98NE;EACE,wEAAA;EACA,kGAAA;A5Di9NJ;A4D98NM;EAGE,gEAAA;EACA,0FAAA;A5D88NR;;A4Dv9NE;EACE,0EAAA;EACA,oGAAA;A5D09NJ;A4Dv9NM;EAGE,8DAAA;EACA,wFAAA;A5Du9NR;;A4Dh+NE;EACE,qEAAA;EACA,+FAAA;A5Dm+NJ;A4Dh+NM;EAGE,6DAAA;EACA,uFAAA;A5Dg+NR;;A4Dz+NE;EACE,4EAAA;EACA,sGAAA;A5D4+NJ;A4Dz+NM;EAGE,gEAAA;EACA,0FAAA;A5Dy+NR;;A4Dl/NE;EACE,qEAAA;EACA,+FAAA;A5Dq/NJ;A4Dl/NM;EAGE,gEAAA;EACA,0FAAA;A5Dk/NR;;A4D3/NE;EACE,uEAAA;EACA,iGAAA;A5D8/NJ;A4D3/NM;EAGE,gEAAA;EACA,0FAAA;A5D2/NR;;A4DpgOE;EACE,0EAAA;EACA,oGAAA;A5DugOJ;A4DpgOM;EAGE,gEAAA;EACA,0FAAA;A5DogOR;;A4D7gOE;EACE,sEAAA;EACA,gGAAA;A5DghOJ;A4D7gOM;EAGE,gEAAA;EACA,0FAAA;A5D6gOR;;A4DthOE;EACE,4EAAA;EACA,sGAAA;A5DyhOJ;A4DthOM;EAGE,0DAAA;EACA,oFAAA;A5DshOR;;A4D/gOA;EACE,+EAAA;EACA,yGAAA;A5DkhOF;A4D/gOI;EAEE,kFAAA;EACA,4GAAA;A5DghON;;A6D1iOA;EACE,UAAA;EAEA,kJAAA;A7D4iOF;;A8D/iOA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A9DkjOF;A8DhjOE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9DkjOJ;AsB3iOM;EwCZJ;IxCaM,gBAAA;EtB8iON;AACF;;A8DhjOI;EACE,mEAAA;A9DmjON;;A+DtkOA;EACE,kBAAA;EACA,WAAA;A/DykOF;A+DvkOE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/DykOJ;A+DtkOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/DwkOJ;;A+DnkOE;EACE,uBAAA;A/DskOJ;;A+DvkOE;EACE,sBAAA;A/D0kOJ;;A+D3kOE;EACE,yBAAA;A/D8kOJ;;A+D/kOE;EACE,iCAAA;A/DklOJ;;AgEvmOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANmgMpC;;AgEvmOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AN2gMpC;;AgElmOI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANkhMpC;;AgElmOI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;ANwhMpC;;ActkOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN+hMlC;EgE/mOE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENoiMlC;AACF;AcnlOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN2iMlC;EgE3nOE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENgjMlC;AACF;Ac/lOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENujMlC;EgEvoOE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN4jMlC;AACF;Ac3mOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENmkMlC;EgEnpOE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENwkMlC;AACF;AcvnOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN+kMlC;EgE/pOE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENolMlC;AACF;AiEjsOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEmsOF;;AiEhsOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEmsOF;;AkE3sOA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnE4sOF;AmEzsOE;;EACE,6BAAA;AnE4sOJ;AmExsOE;;EACE,2BAAA;AnE2sOJ;;AoE9tOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEiuOJ;;AqEzuOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE6uOF;;AuEnvOA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AN2jN9B;;AwE1rOQ;EAOI,mCAAA;AxEurOZ;;AwE9rOQ;EAOI,8BAAA;AxE2rOZ;;AwElsOQ;EAOI,iCAAA;AxE+rOZ;;AwEtsOQ;EAOI,iCAAA;AxEmsOZ;;AwE1sOQ;EAOI,sCAAA;AxEusOZ;;AwE9sOQ;EAOI,mCAAA;AxE2sOZ;;AwEltOQ;EAOI,sBAAA;AxE+sOZ;;AwEttOQ;EAOI,uBAAA;AxEmtOZ;;AwE1tOQ;EAOI,sBAAA;AxEutOZ;;AwE9tOQ;EAOI,8BAAA;AxE2tOZ;;AwEluOQ;EAOI,4BAAA;AxE+tOZ;;AwEtuOQ;EAOI,2BAAA;AxEmuOZ;;AwE1uOQ;EAOI,iCAAA;AxEuuOZ;;AwE9uOQ;EAOI,2BAAA;AxE2uOZ;;AwElvOQ;EAOI,qBAAA;AxE+uOZ;;AwEtvOQ;EAOI,wBAAA;AxEmvOZ;;AwE1vOQ;EAOI,uBAAA;AxEuvOZ;;AwE9vOQ;EAOI,wBAAA;AxE2vOZ;;AwElwOQ;EAOI,qBAAA;AxE+vOZ;;AwEtwOQ;EAOI,yBAAA;AxEmwOZ;;AwE1wOQ;EAOI,2BAAA;AxEuwOZ;;AwE9wOQ;EAOI,4BAAA;AxE2wOZ;;AwElxOQ;EAOI,2BAAA;AxE+wOZ;;AwEtxOQ;EAOI,2BAAA;AxEmxOZ;;AwE1xOQ;EAOI,6BAAA;AxEuxOZ;;AwE9xOQ;EAOI,8BAAA;AxE2xOZ;;AwElyOQ;EAOI,6BAAA;AxE+xOZ;;AwEtyOQ;EAOI,2BAAA;AxEmyOZ;;AwE1yOQ;EAOI,6BAAA;AxEuyOZ;;AwE9yOQ;EAOI,8BAAA;AxE2yOZ;;AwElzOQ;EAOI,6BAAA;AxE+yOZ;;AwEtzOQ;EAOI,0BAAA;AxEmzOZ;;AwE1zOQ;EAOI,gCAAA;AxEuzOZ;;AwE9zOQ;EAOI,yBAAA;AxE2zOZ;;AwEl0OQ;EAOI,wBAAA;AxE+zOZ;;AwEt0OQ;EAOI,+BAAA;AxEm0OZ;;AwE10OQ;EAOI,yBAAA;AxEu0OZ;;AwE90OQ;EAOI,6BAAA;AxE20OZ;;AwEl1OQ;EAOI,8BAAA;AxE+0OZ;;AwEt1OQ;EAOI,wBAAA;AxEm1OZ;;AwE11OQ;EAOI,+BAAA;AxEu1OZ;;AwE91OQ;EAOI,wBAAA;AxE21OZ;;AwEl2OQ;EAOI,2CAAA;AxE+1OZ;;AwEt2OQ;EAOI,8CAAA;AxEm2OZ;;AwE12OQ;EAOI,8CAAA;AxEu2OZ;;AwE92OQ;EAOI,2BAAA;AxE22OZ;;AwE53OQ;EACE,gFAAA;AxE+3OV;;AwEh4OQ;EACE,+EAAA;AxEm4OV;;AwEp4OQ;EACE,gFAAA;AxEu4OV;;AwEx4OQ;EACE,gFAAA;AxE24OV;;AwE54OQ;EACE,kFAAA;AxE+4OV;;AwEh5OQ;EACE,6EAAA;AxEm5OV;;AwEp5OQ;EACE,oFAAA;AxEu5OV;;AwEx5OQ;EACE,6EAAA;AxE25OV;;AwE55OQ;EACE,+EAAA;AxE+5OV;;AwEh6OQ;EACE,kFAAA;AxEm6OV;;AwEp6OQ;EACE,8EAAA;AxEu6OV;;AwEx6OQ;EACE,oFAAA;AxE26OV;;AwEl6OQ;EAOI,2BAAA;AxE+5OZ;;AwEt6OQ;EAOI,6BAAA;AxEm6OZ;;AwE16OQ;EAOI,6BAAA;AxEu6OZ;;AwE96OQ;EAOI,0BAAA;AxE26OZ;;AwEl7OQ;EAOI,2BAAA;AxE+6OZ;;AwEt7OQ;EAOI,iBAAA;AxEm7OZ;;AwE17OQ;EAOI,mBAAA;AxEu7OZ;;AwE97OQ;EAOI,oBAAA;AxE27OZ;;AwEl8OQ;EAOI,oBAAA;AxE+7OZ;;AwEt8OQ;EAOI,sBAAA;AxEm8OZ;;AwE18OQ;EAOI,uBAAA;AxEu8OZ;;AwE98OQ;EAOI,kBAAA;AxE28OZ;;AwEl9OQ;EAOI,oBAAA;AxE+8OZ;;AwEt9OQ;EAOI,qBAAA;AxEm9OZ;;AwE19OQ;EAOI,mBAAA;AxEu9OZ;;AwE99OQ;EAOI,qBAAA;AxE29OZ;;AwEl+OQ;EAOI,sBAAA;AxE+9OZ;;AwEt+OQ;EAOI,2CAAA;AxEm+OZ;;AwE1+OQ;EAOI,sCAAA;AxEu+OZ;;AwE9+OQ;EAOI,sCAAA;AxE2+OZ;;AwEl/OQ;EAOI,uFAAA;AxE++OZ;;AwEt/OQ;EAOI,oBAAA;AxEm/OZ;;AwE1/OQ;EAOI,2FAAA;AxEu/OZ;;AwE9/OQ;EAOI,wBAAA;AxE2/OZ;;AwElgPQ;EAOI,6FAAA;AxE+/OZ;;AwEtgPQ;EAOI,0BAAA;AxEmgPZ;;AwE1gPQ;EAOI,8FAAA;AxEugPZ;;AwE9gPQ;EAOI,2BAAA;AxE2gPZ;;AwElhPQ;EAOI,4FAAA;AxE+gPZ;;AwEthPQ;EAOI,yBAAA;AxEmhPZ;;AwE1hPQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEwhPZ;;AwE/hPQ;EAIQ,sBAAA;EAGJ,6EAAA;AxE6hPZ;;AwEpiPQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEkiPZ;;AwEziPQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEuiPZ;;AwE9iPQ;EAIQ,sBAAA;EAGJ,gFAAA;AxE4iPZ;;AwEnjPQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEijPZ;;AwExjPQ;EAIQ,sBAAA;EAGJ,kFAAA;AxEsjPZ;;AwE7jPQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE2jPZ;;AwElkPQ;EAIQ,sBAAA;EAGJ,6EAAA;AxEgkPZ;;AwEvkPQ;EAIQ,sBAAA;EAGJ,gFAAA;AxEqkPZ;;AwE5kPQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE0kPZ;;AwEjlPQ;EAIQ,sBAAA;EAGJ,kFAAA;AxE+kPZ;;AwEtlPQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEolPZ;;AwE3lPQ;EAOI,wDAAA;AxEwlPZ;;AwE/lPQ;EAOI,0DAAA;AxE4lPZ;;AwEnmPQ;EAOI,wDAAA;AxEgmPZ;;AwEvmPQ;EAOI,qDAAA;AxEomPZ;;AwE3mPQ;EAOI,wDAAA;AxEwmPZ;;AwE/mPQ;EAOI,uDAAA;AxE4mPZ;;AwEnnPQ;EAOI,sDAAA;AxEgnPZ;;AwEvnPQ;EAOI,qDAAA;AxEonPZ;;AwE3nPQ;EAOI,4BAAA;AxEwnPZ;;AwE/nPQ;EAOI,4BAAA;AxE4nPZ;;AwEnoPQ;EAOI,4BAAA;AxEgoPZ;;AwEvoPQ;EAOI,4BAAA;AxEooPZ;;AwE3oPQ;EAOI,4BAAA;AxEwoPZ;;AwEzpPQ;EACE,wBAAA;AxE4pPV;;AwE7pPQ;EACE,yBAAA;AxEgqPV;;AwEjqPQ;EACE,wBAAA;AxEoqPV;;AwErqPQ;EACE,yBAAA;AxEwqPV;;AwEzqPQ;EACE,sBAAA;AxE4qPV;;AwEnqPQ;EAOI,qBAAA;AxEgqPZ;;AwEvqPQ;EAOI,qBAAA;AxEoqPZ;;AwE3qPQ;EAOI,qBAAA;AxEwqPZ;;AwE/qPQ;EAOI,sBAAA;AxE4qPZ;;AwEnrPQ;EAOI,sBAAA;AxEgrPZ;;AwEvrPQ;EAOI,0BAAA;AxEorPZ;;AwE3rPQ;EAOI,uBAAA;AxEwrPZ;;AwE/rPQ;EAOI,2BAAA;AxE4rPZ;;AwEnsPQ;EAOI,sBAAA;AxEgsPZ;;AwEvsPQ;EAOI,sBAAA;AxEosPZ;;AwE3sPQ;EAOI,sBAAA;AxEwsPZ;;AwE/sPQ;EAOI,uBAAA;AxE4sPZ;;AwEntPQ;EAOI,uBAAA;AxEgtPZ;;AwEvtPQ;EAOI,2BAAA;AxEotPZ;;AwE3tPQ;EAOI,wBAAA;AxEwtPZ;;AwE/tPQ;EAOI,4BAAA;AxE4tPZ;;AwEnuPQ;EAOI,yBAAA;AxEguPZ;;AwEvuPQ;EAOI,8BAAA;AxEouPZ;;AwE3uPQ;EAOI,iCAAA;AxEwuPZ;;AwE/uPQ;EAOI,sCAAA;AxE4uPZ;;AwEnvPQ;EAOI,yCAAA;AxEgvPZ;;AwEvvPQ;EAOI,uBAAA;AxEovPZ;;AwE3vPQ;EAOI,uBAAA;AxEwvPZ;;AwE/vPQ;EAOI,yBAAA;AxE4vPZ;;AwEnwPQ;EAOI,yBAAA;AxEgwPZ;;AwEvwPQ;EAOI,0BAAA;AxEowPZ;;AwE3wPQ;EAOI,4BAAA;AxEwwPZ;;AwE/wPQ;EAOI,kCAAA;AxE4wPZ;;AwEnxPQ;EAOI,sCAAA;AxEgxPZ;;AwEvxPQ;EAOI,oCAAA;AxEoxPZ;;AwE3xPQ;EAOI,kCAAA;AxEwxPZ;;AwE/xPQ;EAOI,yCAAA;AxE4xPZ;;AwEnyPQ;EAOI,wCAAA;AxEgyPZ;;AwEvyPQ;EAOI,wCAAA;AxEoyPZ;;AwE3yPQ;EAOI,kCAAA;AxEwyPZ;;AwE/yPQ;EAOI,gCAAA;AxE4yPZ;;AwEnzPQ;EAOI,8BAAA;AxEgzPZ;;AwEvzPQ;EAOI,gCAAA;AxEozPZ;;AwE3zPQ;EAOI,+BAAA;AxEwzPZ;;AwE/zPQ;EAOI,oCAAA;AxE4zPZ;;AwEn0PQ;EAOI,kCAAA;AxEg0PZ;;AwEv0PQ;EAOI,gCAAA;AxEo0PZ;;AwE30PQ;EAOI,uCAAA;AxEw0PZ;;AwE/0PQ;EAOI,sCAAA;AxE40PZ;;AwEn1PQ;EAOI,iCAAA;AxEg1PZ;;AwEv1PQ;EAOI,2BAAA;AxEo1PZ;;AwE31PQ;EAOI,iCAAA;AxEw1PZ;;AwE/1PQ;EAOI,+BAAA;AxE41PZ;;AwEn2PQ;EAOI,6BAAA;AxEg2PZ;;AwEv2PQ;EAOI,+BAAA;AxEo2PZ;;AwE32PQ;EAOI,8BAAA;AxEw2PZ;;AwE/2PQ;EAOI,oBAAA;AxE42PZ;;AwEn3PQ;EAOI,mBAAA;AxEg3PZ;;AwEv3PQ;EAOI,mBAAA;AxEo3PZ;;AwE33PQ;EAOI,mBAAA;AxEw3PZ;;AwE/3PQ;EAOI,mBAAA;AxE43PZ;;AwEn4PQ;EAOI,mBAAA;AxEg4PZ;;AwEv4PQ;EAOI,mBAAA;AxEo4PZ;;AwE34PQ;EAOI,mBAAA;AxEw4PZ;;AwE/4PQ;EAOI,oBAAA;AxE44PZ;;AwEn5PQ;EAOI,4BAAA;AxEg5PZ;;AwEv5PQ;EAOI,2BAAA;AxEo5PZ;;AwE35PQ;EAOI,0BAAA;AxEw5PZ;;AwE/5PQ;EAOI,2BAAA;AxE45PZ;;AwEn6PQ;EAOI,4BAAA;AxEg6PZ;;AwEv6PQ;EAOI,6BAAA;AxEo6PZ;;AwE36PQ;EAOI,uBAAA;AxEw6PZ;;AwE/6PQ;EAOI,0BAAA;EAAA,yBAAA;AxE66PZ;;AwEp7PQ;EAOI,kCAAA;EAAA,iCAAA;AxEk7PZ;;AwEz7PQ;EAOI,iCAAA;EAAA,gCAAA;AxEu7PZ;;AwE97PQ;EAOI,gCAAA;EAAA,+BAAA;AxE47PZ;;AwEn8PQ;EAOI,iCAAA;EAAA,gCAAA;AxEi8PZ;;AwEx8PQ;EAOI,kCAAA;EAAA,iCAAA;AxEs8PZ;;AwE78PQ;EAOI,mCAAA;EAAA,kCAAA;AxE28PZ;;AwEl9PQ;EAOI,6BAAA;EAAA,4BAAA;AxEg9PZ;;AwEv9PQ;EAOI,wBAAA;EAAA,2BAAA;AxEq9PZ;;AwE59PQ;EAOI,gCAAA;EAAA,mCAAA;AxE09PZ;;AwEj+PQ;EAOI,+BAAA;EAAA,kCAAA;AxE+9PZ;;AwEt+PQ;EAOI,8BAAA;EAAA,iCAAA;AxEo+PZ;;AwE3+PQ;EAOI,+BAAA;EAAA,kCAAA;AxEy+PZ;;AwEh/PQ;EAOI,gCAAA;EAAA,mCAAA;AxE8+PZ;;AwEr/PQ;EAOI,iCAAA;EAAA,oCAAA;AxEm/PZ;;AwE1/PQ;EAOI,2BAAA;EAAA,8BAAA;AxEw/PZ;;AwE//PQ;EAOI,wBAAA;AxE4/PZ;;AwEngQQ;EAOI,gCAAA;AxEggQZ;;AwEvgQQ;EAOI,+BAAA;AxEogQZ;;AwE3gQQ;EAOI,8BAAA;AxEwgQZ;;AwE/gQQ;EAOI,+BAAA;AxE4gQZ;;AwEnhQQ;EAOI,gCAAA;AxEghQZ;;AwEvhQQ;EAOI,iCAAA;AxEohQZ;;AwE3hQQ;EAOI,2BAAA;AxEwhQZ;;AwE/hQQ;EAOI,0BAAA;AxE4hQZ;;AwEniQQ;EAOI,kCAAA;AxEgiQZ;;AwEviQQ;EAOI,iCAAA;AxEoiQZ;;AwE3iQQ;EAOI,gCAAA;AxEwiQZ;;AwE/iQQ;EAOI,iCAAA;AxE4iQZ;;AwEnjQQ;EAOI,kCAAA;AxEgjQZ;;AwEvjQQ;EAOI,mCAAA;AxEojQZ;;AwE3jQQ;EAOI,6BAAA;AxEwjQZ;;AwE/jQQ;EAOI,2BAAA;AxE4jQZ;;AwEnkQQ;EAOI,mCAAA;AxEgkQZ;;AwEvkQQ;EAOI,kCAAA;AxEokQZ;;AwE3kQQ;EAOI,iCAAA;AxEwkQZ;;AwE/kQQ;EAOI,kCAAA;AxE4kQZ;;AwEnlQQ;EAOI,mCAAA;AxEglQZ;;AwEvlQQ;EAOI,oCAAA;AxEolQZ;;AwE3lQQ;EAOI,8BAAA;AxEwlQZ;;AwE/lQQ;EAOI,yBAAA;AxE4lQZ;;AwEnmQQ;EAOI,iCAAA;AxEgmQZ;;AwEvmQQ;EAOI,gCAAA;AxEomQZ;;AwE3mQQ;EAOI,+BAAA;AxEwmQZ;;AwE/mQQ;EAOI,gCAAA;AxE4mQZ;;AwEnnQQ;EAOI,iCAAA;AxEgnQZ;;AwEvnQQ;EAOI,kCAAA;AxEonQZ;;AwE3nQQ;EAOI,4BAAA;AxEwnQZ;;AwE/nQQ;EAOI,qBAAA;AxE4nQZ;;AwEnoQQ;EAOI,6BAAA;AxEgoQZ;;AwEvoQQ;EAOI,4BAAA;AxEooQZ;;AwE3oQQ;EAOI,2BAAA;AxEwoQZ;;AwE/oQQ;EAOI,4BAAA;AxE4oQZ;;AwEnpQQ;EAOI,6BAAA;AxEgpQZ;;AwEvpQQ;EAOI,8BAAA;AxEopQZ;;AwE3pQQ;EAOI,2BAAA;EAAA,0BAAA;AxEypQZ;;AwEhqQQ;EAOI,mCAAA;EAAA,kCAAA;AxE8pQZ;;AwErqQQ;EAOI,kCAAA;EAAA,iCAAA;AxEmqQZ;;AwE1qQQ;EAOI,iCAAA;EAAA,gCAAA;AxEwqQZ;;AwE/qQQ;EAOI,kCAAA;EAAA,iCAAA;AxE6qQZ;;AwEprQQ;EAOI,mCAAA;EAAA,kCAAA;AxEkrQZ;;AwEzrQQ;EAOI,oCAAA;EAAA,mCAAA;AxEurQZ;;AwE9rQQ;EAOI,yBAAA;EAAA,4BAAA;AxE4rQZ;;AwEnsQQ;EAOI,iCAAA;EAAA,oCAAA;AxEisQZ;;AwExsQQ;EAOI,gCAAA;EAAA,mCAAA;AxEssQZ;;AwE7sQQ;EAOI,+BAAA;EAAA,kCAAA;AxE2sQZ;;AwEltQQ;EAOI,gCAAA;EAAA,mCAAA;AxEgtQZ;;AwEvtQQ;EAOI,iCAAA;EAAA,oCAAA;AxEqtQZ;;AwE5tQQ;EAOI,kCAAA;EAAA,qCAAA;AxE0tQZ;;AwEjuQQ;EAOI,yBAAA;AxE8tQZ;;AwEruQQ;EAOI,iCAAA;AxEkuQZ;;AwEzuQQ;EAOI,gCAAA;AxEsuQZ;;AwE7uQQ;EAOI,+BAAA;AxE0uQZ;;AwEjvQQ;EAOI,gCAAA;AxE8uQZ;;AwErvQQ;EAOI,iCAAA;AxEkvQZ;;AwEzvQQ;EAOI,kCAAA;AxEsvQZ;;AwE7vQQ;EAOI,2BAAA;AxE0vQZ;;AwEjwQQ;EAOI,mCAAA;AxE8vQZ;;AwErwQQ;EAOI,kCAAA;AxEkwQZ;;AwEzwQQ;EAOI,iCAAA;AxEswQZ;;AwE7wQQ;EAOI,kCAAA;AxE0wQZ;;AwEjxQQ;EAOI,mCAAA;AxE8wQZ;;AwErxQQ;EAOI,oCAAA;AxEkxQZ;;AwEzxQQ;EAOI,4BAAA;AxEsxQZ;;AwE7xQQ;EAOI,oCAAA;AxE0xQZ;;AwEjyQQ;EAOI,mCAAA;AxE8xQZ;;AwEryQQ;EAOI,kCAAA;AxEkyQZ;;AwEzyQQ;EAOI,mCAAA;AxEsyQZ;;AwE7yQQ;EAOI,oCAAA;AxE0yQZ;;AwEjzQQ;EAOI,qCAAA;AxE8yQZ;;AwErzQQ;EAOI,0BAAA;AxEkzQZ;;AwEzzQQ;EAOI,kCAAA;AxEszQZ;;AwE7zQQ;EAOI,iCAAA;AxE0zQZ;;AwEj0QQ;EAOI,gCAAA;AxE8zQZ;;AwEr0QQ;EAOI,iCAAA;AxEk0QZ;;AwEz0QQ;EAOI,kCAAA;AxEs0QZ;;AwE70QQ;EAOI,mCAAA;AxE00QZ;;AwEj1QQ;EAOI,iBAAA;AxE80QZ;;AwEr1QQ;EAOI,yBAAA;AxEk1QZ;;AwEz1QQ;EAOI,wBAAA;AxEs1QZ;;AwE71QQ;EAOI,uBAAA;AxE01QZ;;AwEj2QQ;EAOI,wBAAA;AxE81QZ;;AwEr2QQ;EAOI,yBAAA;AxEk2QZ;;AwEz2QQ;EAOI,0BAAA;AxEs2QZ;;AwE72QQ;EAOI,qBAAA;AxE02QZ;;AwEj3QQ;EAOI,6BAAA;AxE82QZ;;AwEr3QQ;EAOI,4BAAA;AxEk3QZ;;AwEz3QQ;EAOI,2BAAA;AxEs3QZ;;AwE73QQ;EAOI,4BAAA;AxE03QZ;;AwEj4QQ;EAOI,6BAAA;AxE83QZ;;AwEr4QQ;EAOI,8BAAA;AxEk4QZ;;AwEz4QQ;EAOI,wBAAA;AxEs4QZ;;AwE74QQ;EAOI,gCAAA;AxE04QZ;;AwEj5QQ;EAOI,+BAAA;AxE84QZ;;AwEr5QQ;EAOI,8BAAA;AxEk5QZ;;AwEz5QQ;EAOI,+BAAA;AxEs5QZ;;AwE75QQ;EAOI,gCAAA;AxE05QZ;;AwEj6QQ;EAOI,iCAAA;AxE85QZ;;AwEr6QQ;EAOI,gDAAA;AxEk6QZ;;AwEz6QQ;EAOI,mDAAA;AxEs6QZ;;AwE76QQ;EAOI,oDAAA;AxE06QZ;;AwEj7QQ;EAOI,oDAAA;AxE86QZ;;AwEr7QQ;EAOI,gCAAA;AxEk7QZ;;AwEz7QQ;EAOI,gCAAA;AxEs7QZ;;AwE77QQ;EAOI,0BAAA;AxE07QZ;;AwEj8QQ;EAOI,6BAAA;AxE87QZ;;AwEr8QQ;EAOI,6BAAA;AxEk8QZ;;AwEz8QQ;EAOI,+BAAA;AxEs8QZ;;AwE78QQ;EAOI,2BAAA;AxE08QZ;;AwEj9QQ;EAOI,2BAAA;AxE88QZ;;AwEr9QQ;EAOI,2BAAA;AxEk9QZ;;AwEz9QQ;EAOI,2BAAA;AxEs9QZ;;AwE79QQ;EAOI,2BAAA;AxE09QZ;;AwEj+QQ;EAOI,8BAAA;AxE89QZ;;AwEr+QQ;EAOI,yBAAA;AxEk+QZ;;AwEz+QQ;EAOI,4BAAA;AxEs+QZ;;AwE7+QQ;EAOI,2BAAA;AxE0+QZ;;AwEj/QQ;EAOI,yBAAA;AxE8+QZ;;AwEr/QQ;EAOI,2BAAA;AxEk/QZ;;AwEz/QQ;EAOI,4BAAA;AxEs/QZ;;AwE7/QQ;EAOI,6BAAA;AxE0/QZ;;AwEjgRQ;EAOI,gCAAA;AxE8/QZ;;AwErgRQ;EAOI,qCAAA;AxEkgRZ;;AwEzgRQ;EAOI,wCAAA;AxEsgRZ;;AwE7gRQ;EAOI,oCAAA;AxE0gRZ;;AwEjhRQ;EAOI,oCAAA;AxE8gRZ;;AwErhRQ;EAOI,qCAAA;AxEkhRZ;;AwEzhRQ;EAOI,8BAAA;AxEshRZ;;AwE7hRQ;EAOI,8BAAA;AxE0hRZ;;AwE/iRQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxEgiRZ;;AwE7gRQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxEsiRZ;;AwE7iRQ;EAIQ,oBAAA;EAGJ,oEAAA;AxE2iRZ;;AwEljRQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEgjRZ;;AwEvjRQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEqjRZ;;AwE5jRQ;EAIQ,oBAAA;EAGJ,uEAAA;AxE0jRZ;;AwEjkRQ;EAIQ,oBAAA;EAGJ,kEAAA;AxE+jRZ;;AwEtkRQ;EAIQ,oBAAA;EAGJ,yEAAA;AxEokRZ;;AwE3kRQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEykRZ;;AwEhlRQ;EAIQ,oBAAA;EAGJ,oEAAA;AxE8kRZ;;AwErlRQ;EAIQ,oBAAA;EAGJ,uEAAA;AxEmlRZ;;AwE1lRQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEwlRZ;;AwE/lRQ;EAIQ,oBAAA;EAGJ,yEAAA;AxE6lRZ;;AwEpmRQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEkmRZ;;AwEzmRQ;EAIQ,oBAAA;EAGJ,wEAAA;AxEumRZ;;AwE9mRQ;EAIQ,oBAAA;EAGJ,2CAAA;AxE4mRZ;;AwEnnRQ;EAIQ,oBAAA;EAGJ,oCAAA;AxEinRZ;;AwExnRQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEsnRZ;;AwE7nRQ;EAIQ,oBAAA;EAGJ,2CAAA;AxE2nRZ;;AwEloRQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEgoRZ;;AwEvoRQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEqoRZ;;AwE5oRQ;EAIQ,oBAAA;EAGJ,yBAAA;AxE0oRZ;;AwE3pRQ;EACE,uBAAA;AxE8pRV;;AwE/pRQ;EACE,sBAAA;AxEkqRV;;AwEnqRQ;EACE,uBAAA;AxEsqRV;;AwEvqRQ;EACE,oBAAA;AxE0qRV;;AwEjqRQ;EAOI,iDAAA;AxE8pRZ;;AwErqRQ;EAOI,mDAAA;AxEkqRZ;;AwEzqRQ;EAOI,iDAAA;AxEsqRZ;;AwE7qRQ;EAOI,8CAAA;AxE0qRZ;;AwEjrRQ;EAOI,iDAAA;AxE8qRZ;;AwErrRQ;EAOI,gDAAA;AxEkrRZ;;AwEzrRQ;EAOI,+CAAA;AxEsrRZ;;AwE7rRQ;EAOI,8CAAA;AxE0rRZ;;AwE3sRQ;EACE,sBAAA;AxE8sRV;;AwE1sRU;EACE,sBAAA;AxE6sRZ;;AwEntRQ;EACE,uBAAA;AxEstRV;;AwEltRU;EACE,uBAAA;AxEqtRZ;;AwE3tRQ;EACE,sBAAA;AxE8tRV;;AwE1tRU;EACE,sBAAA;AxE6tRZ;;AwEnuRQ;EACE,uBAAA;AxEsuRV;;AwEluRU;EACE,uBAAA;AxEquRZ;;AwE3uRQ;EACE,oBAAA;AxE8uRV;;AwE1uRU;EACE,oBAAA;AxE6uRZ;;AwEzuRQ;EAOI,yCAAA;AxEsuRZ;;AwEjuRU;EAOI,yCAAA;AxE8tRd;;AwEjvRQ;EAOI,wCAAA;AxE8uRZ;;AwEzuRU;EAOI,wCAAA;AxEsuRd;;AwEzvRQ;EAOI,yCAAA;AxEsvRZ;;AwEjvRU;EAOI,yCAAA;AxE8uRd;;AwEjwRQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE+vRZ;;AwEtwRQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEowRZ;;AwE3wRQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEywRZ;;AwEhxRQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE8wRZ;;AwErxRQ;EAIQ,8BAAA;EAGJ,iGAAA;AxEmxRZ;;AwE1xRQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEwxRZ;;AwE/xRQ;EAIQ,8BAAA;EAGJ,mGAAA;AxE6xRZ;;AwEpyRQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEkyRZ;;AwEzyRQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEuyRZ;;AwE9yRQ;EAIQ,8BAAA;EAGJ,iGAAA;AxE4yRZ;;AwEnzRQ;EAIQ,8BAAA;EAGJ,6FAAA;AxEizRZ;;AwExzRQ;EAIQ,8BAAA;EAGJ,mGAAA;AxEszRZ;;AwE7zRQ;EAIQ,8BAAA;EAGJ,qGAAA;AxE2zRZ;;AwE50RQ;EACE,8BAAA;AxE+0RV;;AwE30RU;EACE,8BAAA;AxE80RZ;;AwEp1RQ;EACE,gCAAA;AxEu1RV;;AwEn1RU;EACE,gCAAA;AxEs1RZ;;AwE51RQ;EACE,iCAAA;AxE+1RV;;AwE31RU;EACE,iCAAA;AxE81RZ;;AwEp2RQ;EACE,gCAAA;AxEu2RV;;AwEn2RU;EACE,gCAAA;AxEs2RZ;;AwE52RQ;EACE,iCAAA;AxE+2RV;;AwE32RU;EACE,iCAAA;AxE82RZ;;AwEp3RQ;EACE,8BAAA;AxEu3RV;;AwEn3RU;EACE,8BAAA;AxEs3RZ;;AwEl3RQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEg3RZ;;AwEv3RQ;EAIQ,kBAAA;EAGJ,6EAAA;AxEq3RZ;;AwE53RQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE03RZ;;AwEj4RQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE+3RZ;;AwEt4RQ;EAIQ,kBAAA;EAGJ,gFAAA;AxEo4RZ;;AwE34RQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEy4RZ;;AwEh5RQ;EAIQ,kBAAA;EAGJ,kFAAA;AxE84RZ;;AwEr5RQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEm5RZ;;AwE15RQ;EAIQ,kBAAA;EAGJ,6EAAA;AxEw5RZ;;AwE/5RQ;EAIQ,kBAAA;EAGJ,gFAAA;AxE65RZ;;AwEp6RQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEk6RZ;;AwEz6RQ;EAIQ,kBAAA;EAGJ,wCAAA;AxEu6RZ;;AwE96RQ;EAIQ,kBAAA;EAGJ,4EAAA;AxE46RZ;;AwEn7RQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEi7RZ;;AwEx7RQ;EAIQ,kBAAA;EAGJ,mFAAA;AxEs7RZ;;AwE77RQ;EAIQ,kBAAA;EAGJ,kFAAA;AxE27RZ;;AwE58RQ;EACE,oBAAA;AxE+8RV;;AwEh9RQ;EACE,qBAAA;AxEm9RV;;AwEp9RQ;EACE,oBAAA;AxEu9RV;;AwEx9RQ;EACE,qBAAA;AxE29RV;;AwE59RQ;EACE,kBAAA;AxE+9RV;;AwEt9RQ;EAOI,wDAAA;AxEm9RZ;;AwE19RQ;EAOI,0DAAA;AxEu9RZ;;AwE99RQ;EAOI,wDAAA;AxE29RZ;;AwEl+RQ;EAOI,qDAAA;AxE+9RZ;;AwEt+RQ;EAOI,wDAAA;AxEm+RZ;;AwE1+RQ;EAOI,uDAAA;AxEu+RZ;;AwE9+RQ;EAOI,sDAAA;AxE2+RZ;;AwEl/RQ;EAOI,qDAAA;AxE++RZ;;AwEt/RQ;EAOI,+CAAA;AxEm/RZ;;AwE1/RQ;EAOI,mCAAA;UAAA,2BAAA;AxEu/RZ;;AwE9/RQ;EAOI,oCAAA;UAAA,4BAAA;AxE2/RZ;;AwElgSQ;EAOI,oCAAA;UAAA,4BAAA;AxE+/RZ;;AwEtgSQ;EAOI,+BAAA;AxEmgSZ;;AwE1gSQ;EAOI,+BAAA;AxEugSZ;;AwE9gSQ;EAOI,iDAAA;AxE2gSZ;;AwElhSQ;EAOI,2BAAA;AxE+gSZ;;AwEthSQ;EAOI,oDAAA;AxEmhSZ;;AwE1hSQ;EAOI,iDAAA;AxEuhSZ;;AwE9hSQ;EAOI,oDAAA;AxE2hSZ;;AwEliSQ;EAOI,oDAAA;AxE+hSZ;;AwEtiSQ;EAOI,qDAAA;AxEmiSZ;;AwE1iSQ;EAOI,6BAAA;AxEuiSZ;;AwE9iSQ;EAOI,sDAAA;AxE2iSZ;;AwEljSQ;EAOI,0DAAA;EAAA,2DAAA;AxEgjSZ;;AwEvjSQ;EAOI,oCAAA;EAAA,qCAAA;AxEqjSZ;;AwE5jSQ;EAOI,6DAAA;EAAA,8DAAA;AxE0jSZ;;AwEjkSQ;EAOI,0DAAA;EAAA,2DAAA;AxE+jSZ;;AwEtkSQ;EAOI,6DAAA;EAAA,8DAAA;AxEokSZ;;AwE3kSQ;EAOI,6DAAA;EAAA,8DAAA;AxEykSZ;;AwEhlSQ;EAOI,8DAAA;EAAA,+DAAA;AxE8kSZ;;AwErlSQ;EAOI,sCAAA;EAAA,uCAAA;AxEmlSZ;;AwE1lSQ;EAOI,+DAAA;EAAA,gEAAA;AxEwlSZ;;AwE/lSQ;EAOI,2DAAA;EAAA,8DAAA;AxE6lSZ;;AwEpmSQ;EAOI,qCAAA;EAAA,wCAAA;AxEkmSZ;;AwEzmSQ;EAOI,8DAAA;EAAA,iEAAA;AxEumSZ;;AwE9mSQ;EAOI,2DAAA;EAAA,8DAAA;AxE4mSZ;;AwEnnSQ;EAOI,8DAAA;EAAA,iEAAA;AxEinSZ;;AwExnSQ;EAOI,8DAAA;EAAA,iEAAA;AxEsnSZ;;AwE7nSQ;EAOI,+DAAA;EAAA,kEAAA;AxE2nSZ;;AwEloSQ;EAOI,uCAAA;EAAA,0CAAA;AxEgoSZ;;AwEvoSQ;EAOI,gEAAA;EAAA,mEAAA;AxEqoSZ;;AwE5oSQ;EAOI,8DAAA;EAAA,6DAAA;AxE0oSZ;;AwEjpSQ;EAOI,wCAAA;EAAA,uCAAA;AxE+oSZ;;AwEtpSQ;EAOI,iEAAA;EAAA,gEAAA;AxEopSZ;;AwE3pSQ;EAOI,8DAAA;EAAA,6DAAA;AxEypSZ;;AwEhqSQ;EAOI,iEAAA;EAAA,gEAAA;AxE8pSZ;;AwErqSQ;EAOI,iEAAA;EAAA,gEAAA;AxEmqSZ;;AwE1qSQ;EAOI,kEAAA;EAAA,iEAAA;AxEwqSZ;;AwE/qSQ;EAOI,0CAAA;EAAA,yCAAA;AxE6qSZ;;AwEprSQ;EAOI,mEAAA;EAAA,kEAAA;AxEkrSZ;;AwEzrSQ;EAOI,6DAAA;EAAA,0DAAA;AxEurSZ;;AwE9rSQ;EAOI,uCAAA;EAAA,oCAAA;AxE4rSZ;;AwEnsSQ;EAOI,gEAAA;EAAA,6DAAA;AxEisSZ;;AwExsSQ;EAOI,6DAAA;EAAA,0DAAA;AxEssSZ;;AwE7sSQ;EAOI,gEAAA;EAAA,6DAAA;AxE2sSZ;;AwEltSQ;EAOI,gEAAA;EAAA,6DAAA;AxEgtSZ;;AwEvtSQ;EAOI,iEAAA;EAAA,8DAAA;AxEqtSZ;;AwE5tSQ;EAOI,yCAAA;EAAA,sCAAA;AxE0tSZ;;AwEjuSQ;EAOI,kEAAA;EAAA,+DAAA;AxE+tSZ;;AwEtuSQ;EAOI,8BAAA;AxEmuSZ;;AwE1uSQ;EAOI,6BAAA;AxEuuSZ;;AwE9uSQ;EAOI,sBAAA;AxE2uSZ;;AwElvSQ;EAOI,qBAAA;AxE+uSZ;;AwEtvSQ;EAOI,qBAAA;AxEmvSZ;;AwE1vSQ;EAOI,qBAAA;AxEuvSZ;;AwE9vSQ;EAOI,qBAAA;AxE2vSZ;;AcrwSI;E0DGI;IAOI,sBAAA;ExEgwSV;EwEvwSM;IAOI,uBAAA;ExEmwSV;EwE1wSM;IAOI,sBAAA;ExEswSV;EwE7wSM;IAOI,8BAAA;ExEywSV;EwEhxSM;IAOI,4BAAA;ExE4wSV;EwEnxSM;IAOI,2BAAA;ExE+wSV;EwEtxSM;IAOI,iCAAA;ExEkxSV;EwEzxSM;IAOI,2BAAA;ExEqxSV;EwE5xSM;IAOI,0BAAA;ExEwxSV;EwE/xSM;IAOI,gCAAA;ExE2xSV;EwElySM;IAOI,yBAAA;ExE8xSV;EwErySM;IAOI,wBAAA;ExEiySV;EwExySM;IAOI,+BAAA;ExEoySV;EwE3ySM;IAOI,yBAAA;ExEuySV;EwE9ySM;IAOI,6BAAA;ExE0ySV;EwEjzSM;IAOI,8BAAA;ExE6ySV;EwEpzSM;IAOI,wBAAA;ExEgzSV;EwEvzSM;IAOI,+BAAA;ExEmzSV;EwE1zSM;IAOI,wBAAA;ExEszSV;EwE7zSM;IAOI,yBAAA;ExEyzSV;EwEh0SM;IAOI,8BAAA;ExE4zSV;EwEn0SM;IAOI,iCAAA;ExE+zSV;EwEt0SM;IAOI,sCAAA;ExEk0SV;EwEz0SM;IAOI,yCAAA;ExEq0SV;EwE50SM;IAOI,uBAAA;ExEw0SV;EwE/0SM;IAOI,uBAAA;ExE20SV;EwEl1SM;IAOI,yBAAA;ExE80SV;EwEr1SM;IAOI,yBAAA;ExEi1SV;EwEx1SM;IAOI,0BAAA;ExEo1SV;EwE31SM;IAOI,4BAAA;ExEu1SV;EwE91SM;IAOI,kCAAA;ExE01SV;EwEj2SM;IAOI,sCAAA;ExE61SV;EwEp2SM;IAOI,oCAAA;ExEg2SV;EwEv2SM;IAOI,kCAAA;ExEm2SV;EwE12SM;IAOI,yCAAA;ExEs2SV;EwE72SM;IAOI,wCAAA;ExEy2SV;EwEh3SM;IAOI,wCAAA;ExE42SV;EwEn3SM;IAOI,kCAAA;ExE+2SV;EwEt3SM;IAOI,gCAAA;ExEk3SV;EwEz3SM;IAOI,8BAAA;ExEq3SV;EwE53SM;IAOI,gCAAA;ExEw3SV;EwE/3SM;IAOI,+BAAA;ExE23SV;EwEl4SM;IAOI,oCAAA;ExE83SV;EwEr4SM;IAOI,kCAAA;ExEi4SV;EwEx4SM;IAOI,gCAAA;ExEo4SV;EwE34SM;IAOI,uCAAA;ExEu4SV;EwE94SM;IAOI,sCAAA;ExE04SV;EwEj5SM;IAOI,iCAAA;ExE64SV;EwEp5SM;IAOI,2BAAA;ExEg5SV;EwEv5SM;IAOI,iCAAA;ExEm5SV;EwE15SM;IAOI,+BAAA;ExEs5SV;EwE75SM;IAOI,6BAAA;ExEy5SV;EwEh6SM;IAOI,+BAAA;ExE45SV;EwEn6SM;IAOI,8BAAA;ExE+5SV;EwEt6SM;IAOI,oBAAA;ExEk6SV;EwEz6SM;IAOI,mBAAA;ExEq6SV;EwE56SM;IAOI,mBAAA;ExEw6SV;EwE/6SM;IAOI,mBAAA;ExE26SV;EwEl7SM;IAOI,mBAAA;ExE86SV;EwEr7SM;IAOI,mBAAA;ExEi7SV;EwEx7SM;IAOI,mBAAA;ExEo7SV;EwE37SM;IAOI,mBAAA;ExEu7SV;EwE97SM;IAOI,oBAAA;ExE07SV;EwEj8SM;IAOI,4BAAA;ExE67SV;EwEp8SM;IAOI,2BAAA;ExEg8SV;EwEv8SM;IAOI,0BAAA;ExEm8SV;EwE18SM;IAOI,2BAAA;ExEs8SV;EwE78SM;IAOI,4BAAA;ExEy8SV;EwEh9SM;IAOI,6BAAA;ExE48SV;EwEn9SM;IAOI,uBAAA;ExE+8SV;EwEt9SM;IAOI,0BAAA;IAAA,yBAAA;ExEm9SV;EwE19SM;IAOI,kCAAA;IAAA,iCAAA;ExEu9SV;EwE99SM;IAOI,iCAAA;IAAA,gCAAA;ExE29SV;EwEl+SM;IAOI,gCAAA;IAAA,+BAAA;ExE+9SV;EwEt+SM;IAOI,iCAAA;IAAA,gCAAA;ExEm+SV;EwE1+SM;IAOI,kCAAA;IAAA,iCAAA;ExEu+SV;EwE9+SM;IAOI,mCAAA;IAAA,kCAAA;ExE2+SV;EwEl/SM;IAOI,6BAAA;IAAA,4BAAA;ExE++SV;EwEt/SM;IAOI,wBAAA;IAAA,2BAAA;ExEm/SV;EwE1/SM;IAOI,gCAAA;IAAA,mCAAA;ExEu/SV;EwE9/SM;IAOI,+BAAA;IAAA,kCAAA;ExE2/SV;EwElgTM;IAOI,8BAAA;IAAA,iCAAA;ExE+/SV;EwEtgTM;IAOI,+BAAA;IAAA,kCAAA;ExEmgTV;EwE1gTM;IAOI,gCAAA;IAAA,mCAAA;ExEugTV;EwE9gTM;IAOI,iCAAA;IAAA,oCAAA;ExE2gTV;EwElhTM;IAOI,2BAAA;IAAA,8BAAA;ExE+gTV;EwEthTM;IAOI,wBAAA;ExEkhTV;EwEzhTM;IAOI,gCAAA;ExEqhTV;EwE5hTM;IAOI,+BAAA;ExEwhTV;EwE/hTM;IAOI,8BAAA;ExE2hTV;EwEliTM;IAOI,+BAAA;ExE8hTV;EwEriTM;IAOI,gCAAA;ExEiiTV;EwExiTM;IAOI,iCAAA;ExEoiTV;EwE3iTM;IAOI,2BAAA;ExEuiTV;EwE9iTM;IAOI,0BAAA;ExE0iTV;EwEjjTM;IAOI,kCAAA;ExE6iTV;EwEpjTM;IAOI,iCAAA;ExEgjTV;EwEvjTM;IAOI,gCAAA;ExEmjTV;EwE1jTM;IAOI,iCAAA;ExEsjTV;EwE7jTM;IAOI,kCAAA;ExEyjTV;EwEhkTM;IAOI,mCAAA;ExE4jTV;EwEnkTM;IAOI,6BAAA;ExE+jTV;EwEtkTM;IAOI,2BAAA;ExEkkTV;EwEzkTM;IAOI,mCAAA;ExEqkTV;EwE5kTM;IAOI,kCAAA;ExEwkTV;EwE/kTM;IAOI,iCAAA;ExE2kTV;EwEllTM;IAOI,kCAAA;ExE8kTV;EwErlTM;IAOI,mCAAA;ExEilTV;EwExlTM;IAOI,oCAAA;ExEolTV;EwE3lTM;IAOI,8BAAA;ExEulTV;EwE9lTM;IAOI,yBAAA;ExE0lTV;EwEjmTM;IAOI,iCAAA;ExE6lTV;EwEpmTM;IAOI,gCAAA;ExEgmTV;EwEvmTM;IAOI,+BAAA;ExEmmTV;EwE1mTM;IAOI,gCAAA;ExEsmTV;EwE7mTM;IAOI,iCAAA;ExEymTV;EwEhnTM;IAOI,kCAAA;ExE4mTV;EwEnnTM;IAOI,4BAAA;ExE+mTV;EwEtnTM;IAOI,qBAAA;ExEknTV;EwEznTM;IAOI,6BAAA;ExEqnTV;EwE5nTM;IAOI,4BAAA;ExEwnTV;EwE/nTM;IAOI,2BAAA;ExE2nTV;EwEloTM;IAOI,4BAAA;ExE8nTV;EwEroTM;IAOI,6BAAA;ExEioTV;EwExoTM;IAOI,8BAAA;ExEooTV;EwE3oTM;IAOI,2BAAA;IAAA,0BAAA;ExEwoTV;EwE/oTM;IAOI,mCAAA;IAAA,kCAAA;ExE4oTV;EwEnpTM;IAOI,kCAAA;IAAA,iCAAA;ExEgpTV;EwEvpTM;IAOI,iCAAA;IAAA,gCAAA;ExEopTV;EwE3pTM;IAOI,kCAAA;IAAA,iCAAA;ExEwpTV;EwE/pTM;IAOI,mCAAA;IAAA,kCAAA;ExE4pTV;EwEnqTM;IAOI,oCAAA;IAAA,mCAAA;ExEgqTV;EwEvqTM;IAOI,yBAAA;IAAA,4BAAA;ExEoqTV;EwE3qTM;IAOI,iCAAA;IAAA,oCAAA;ExEwqTV;EwE/qTM;IAOI,gCAAA;IAAA,mCAAA;ExE4qTV;EwEnrTM;IAOI,+BAAA;IAAA,kCAAA;ExEgrTV;EwEvrTM;IAOI,gCAAA;IAAA,mCAAA;ExEorTV;EwE3rTM;IAOI,iCAAA;IAAA,oCAAA;ExEwrTV;EwE/rTM;IAOI,kCAAA;IAAA,qCAAA;ExE4rTV;EwEnsTM;IAOI,yBAAA;ExE+rTV;EwEtsTM;IAOI,iCAAA;ExEksTV;EwEzsTM;IAOI,gCAAA;ExEqsTV;EwE5sTM;IAOI,+BAAA;ExEwsTV;EwE/sTM;IAOI,gCAAA;ExE2sTV;EwEltTM;IAOI,iCAAA;ExE8sTV;EwErtTM;IAOI,kCAAA;ExEitTV;EwExtTM;IAOI,2BAAA;ExEotTV;EwE3tTM;IAOI,mCAAA;ExEutTV;EwE9tTM;IAOI,kCAAA;ExE0tTV;EwEjuTM;IAOI,iCAAA;ExE6tTV;EwEpuTM;IAOI,kCAAA;ExEguTV;EwEvuTM;IAOI,mCAAA;ExEmuTV;EwE1uTM;IAOI,oCAAA;ExEsuTV;EwE7uTM;IAOI,4BAAA;ExEyuTV;EwEhvTM;IAOI,oCAAA;ExE4uTV;EwEnvTM;IAOI,mCAAA;ExE+uTV;EwEtvTM;IAOI,kCAAA;ExEkvTV;EwEzvTM;IAOI,mCAAA;ExEqvTV;EwE5vTM;IAOI,oCAAA;ExEwvTV;EwE/vTM;IAOI,qCAAA;ExE2vTV;EwElwTM;IAOI,0BAAA;ExE8vTV;EwErwTM;IAOI,kCAAA;ExEiwTV;EwExwTM;IAOI,iCAAA;ExEowTV;EwE3wTM;IAOI,gCAAA;ExEuwTV;EwE9wTM;IAOI,iCAAA;ExE0wTV;EwEjxTM;IAOI,kCAAA;ExE6wTV;EwEpxTM;IAOI,mCAAA;ExEgxTV;EwEvxTM;IAOI,iBAAA;ExEmxTV;EwE1xTM;IAOI,yBAAA;ExEsxTV;EwE7xTM;IAOI,wBAAA;ExEyxTV;EwEhyTM;IAOI,uBAAA;ExE4xTV;EwEnyTM;IAOI,wBAAA;ExE+xTV;EwEtyTM;IAOI,yBAAA;ExEkyTV;EwEzyTM;IAOI,0BAAA;ExEqyTV;EwE5yTM;IAOI,qBAAA;ExEwyTV;EwE/yTM;IAOI,6BAAA;ExE2yTV;EwElzTM;IAOI,4BAAA;ExE8yTV;EwErzTM;IAOI,2BAAA;ExEizTV;EwExzTM;IAOI,4BAAA;ExEozTV;EwE3zTM;IAOI,6BAAA;ExEuzTV;EwE9zTM;IAOI,8BAAA;ExE0zTV;EwEj0TM;IAOI,wBAAA;ExE6zTV;EwEp0TM;IAOI,gCAAA;ExEg0TV;EwEv0TM;IAOI,+BAAA;ExEm0TV;EwE10TM;IAOI,8BAAA;ExEs0TV;EwE70TM;IAOI,+BAAA;ExEy0TV;EwEh1TM;IAOI,gCAAA;ExE40TV;EwEn1TM;IAOI,iCAAA;ExE+0TV;EwEt1TM;IAOI,2BAAA;ExEk1TV;EwEz1TM;IAOI,4BAAA;ExEq1TV;EwE51TM;IAOI,6BAAA;ExEw1TV;AACF;Acn2TI;E0DGI;IAOI,sBAAA;ExE61TV;EwEp2TM;IAOI,uBAAA;ExEg2TV;EwEv2TM;IAOI,sBAAA;ExEm2TV;EwE12TM;IAOI,8BAAA;ExEs2TV;EwE72TM;IAOI,4BAAA;ExEy2TV;EwEh3TM;IAOI,2BAAA;ExE42TV;EwEn3TM;IAOI,iCAAA;ExE+2TV;EwEt3TM;IAOI,2BAAA;ExEk3TV;EwEz3TM;IAOI,0BAAA;ExEq3TV;EwE53TM;IAOI,gCAAA;ExEw3TV;EwE/3TM;IAOI,yBAAA;ExE23TV;EwEl4TM;IAOI,wBAAA;ExE83TV;EwEr4TM;IAOI,+BAAA;ExEi4TV;EwEx4TM;IAOI,yBAAA;ExEo4TV;EwE34TM;IAOI,6BAAA;ExEu4TV;EwE94TM;IAOI,8BAAA;ExE04TV;EwEj5TM;IAOI,wBAAA;ExE64TV;EwEp5TM;IAOI,+BAAA;ExEg5TV;EwEv5TM;IAOI,wBAAA;ExEm5TV;EwE15TM;IAOI,yBAAA;ExEs5TV;EwE75TM;IAOI,8BAAA;ExEy5TV;EwEh6TM;IAOI,iCAAA;ExE45TV;EwEn6TM;IAOI,sCAAA;ExE+5TV;EwEt6TM;IAOI,yCAAA;ExEk6TV;EwEz6TM;IAOI,uBAAA;ExEq6TV;EwE56TM;IAOI,uBAAA;ExEw6TV;EwE/6TM;IAOI,yBAAA;ExE26TV;EwEl7TM;IAOI,yBAAA;ExE86TV;EwEr7TM;IAOI,0BAAA;ExEi7TV;EwEx7TM;IAOI,4BAAA;ExEo7TV;EwE37TM;IAOI,kCAAA;ExEu7TV;EwE97TM;IAOI,sCAAA;ExE07TV;EwEj8TM;IAOI,oCAAA;ExE67TV;EwEp8TM;IAOI,kCAAA;ExEg8TV;EwEv8TM;IAOI,yCAAA;ExEm8TV;EwE18TM;IAOI,wCAAA;ExEs8TV;EwE78TM;IAOI,wCAAA;ExEy8TV;EwEh9TM;IAOI,kCAAA;ExE48TV;EwEn9TM;IAOI,gCAAA;ExE+8TV;EwEt9TM;IAOI,8BAAA;ExEk9TV;EwEz9TM;IAOI,gCAAA;ExEq9TV;EwE59TM;IAOI,+BAAA;ExEw9TV;EwE/9TM;IAOI,oCAAA;ExE29TV;EwEl+TM;IAOI,kCAAA;ExE89TV;EwEr+TM;IAOI,gCAAA;ExEi+TV;EwEx+TM;IAOI,uCAAA;ExEo+TV;EwE3+TM;IAOI,sCAAA;ExEu+TV;EwE9+TM;IAOI,iCAAA;ExE0+TV;EwEj/TM;IAOI,2BAAA;ExE6+TV;EwEp/TM;IAOI,iCAAA;ExEg/TV;EwEv/TM;IAOI,+BAAA;ExEm/TV;EwE1/TM;IAOI,6BAAA;ExEs/TV;EwE7/TM;IAOI,+BAAA;ExEy/TV;EwEhgUM;IAOI,8BAAA;ExE4/TV;EwEngUM;IAOI,oBAAA;ExE+/TV;EwEtgUM;IAOI,mBAAA;ExEkgUV;EwEzgUM;IAOI,mBAAA;ExEqgUV;EwE5gUM;IAOI,mBAAA;ExEwgUV;EwE/gUM;IAOI,mBAAA;ExE2gUV;EwElhUM;IAOI,mBAAA;ExE8gUV;EwErhUM;IAOI,mBAAA;ExEihUV;EwExhUM;IAOI,mBAAA;ExEohUV;EwE3hUM;IAOI,oBAAA;ExEuhUV;EwE9hUM;IAOI,4BAAA;ExE0hUV;EwEjiUM;IAOI,2BAAA;ExE6hUV;EwEpiUM;IAOI,0BAAA;ExEgiUV;EwEviUM;IAOI,2BAAA;ExEmiUV;EwE1iUM;IAOI,4BAAA;ExEsiUV;EwE7iUM;IAOI,6BAAA;ExEyiUV;EwEhjUM;IAOI,uBAAA;ExE4iUV;EwEnjUM;IAOI,0BAAA;IAAA,yBAAA;ExEgjUV;EwEvjUM;IAOI,kCAAA;IAAA,iCAAA;ExEojUV;EwE3jUM;IAOI,iCAAA;IAAA,gCAAA;ExEwjUV;EwE/jUM;IAOI,gCAAA;IAAA,+BAAA;ExE4jUV;EwEnkUM;IAOI,iCAAA;IAAA,gCAAA;ExEgkUV;EwEvkUM;IAOI,kCAAA;IAAA,iCAAA;ExEokUV;EwE3kUM;IAOI,mCAAA;IAAA,kCAAA;ExEwkUV;EwE/kUM;IAOI,6BAAA;IAAA,4BAAA;ExE4kUV;EwEnlUM;IAOI,wBAAA;IAAA,2BAAA;ExEglUV;EwEvlUM;IAOI,gCAAA;IAAA,mCAAA;ExEolUV;EwE3lUM;IAOI,+BAAA;IAAA,kCAAA;ExEwlUV;EwE/lUM;IAOI,8BAAA;IAAA,iCAAA;ExE4lUV;EwEnmUM;IAOI,+BAAA;IAAA,kCAAA;ExEgmUV;EwEvmUM;IAOI,gCAAA;IAAA,mCAAA;ExEomUV;EwE3mUM;IAOI,iCAAA;IAAA,oCAAA;ExEwmUV;EwE/mUM;IAOI,2BAAA;IAAA,8BAAA;ExE4mUV;EwEnnUM;IAOI,wBAAA;ExE+mUV;EwEtnUM;IAOI,gCAAA;ExEknUV;EwEznUM;IAOI,+BAAA;ExEqnUV;EwE5nUM;IAOI,8BAAA;ExEwnUV;EwE/nUM;IAOI,+BAAA;ExE2nUV;EwEloUM;IAOI,gCAAA;ExE8nUV;EwEroUM;IAOI,iCAAA;ExEioUV;EwExoUM;IAOI,2BAAA;ExEooUV;EwE3oUM;IAOI,0BAAA;ExEuoUV;EwE9oUM;IAOI,kCAAA;ExE0oUV;EwEjpUM;IAOI,iCAAA;ExE6oUV;EwEppUM;IAOI,gCAAA;ExEgpUV;EwEvpUM;IAOI,iCAAA;ExEmpUV;EwE1pUM;IAOI,kCAAA;ExEspUV;EwE7pUM;IAOI,mCAAA;ExEypUV;EwEhqUM;IAOI,6BAAA;ExE4pUV;EwEnqUM;IAOI,2BAAA;ExE+pUV;EwEtqUM;IAOI,mCAAA;ExEkqUV;EwEzqUM;IAOI,kCAAA;ExEqqUV;EwE5qUM;IAOI,iCAAA;ExEwqUV;EwE/qUM;IAOI,kCAAA;ExE2qUV;EwElrUM;IAOI,mCAAA;ExE8qUV;EwErrUM;IAOI,oCAAA;ExEirUV;EwExrUM;IAOI,8BAAA;ExEorUV;EwE3rUM;IAOI,yBAAA;ExEurUV;EwE9rUM;IAOI,iCAAA;ExE0rUV;EwEjsUM;IAOI,gCAAA;ExE6rUV;EwEpsUM;IAOI,+BAAA;ExEgsUV;EwEvsUM;IAOI,gCAAA;ExEmsUV;EwE1sUM;IAOI,iCAAA;ExEssUV;EwE7sUM;IAOI,kCAAA;ExEysUV;EwEhtUM;IAOI,4BAAA;ExE4sUV;EwEntUM;IAOI,qBAAA;ExE+sUV;EwEttUM;IAOI,6BAAA;ExEktUV;EwEztUM;IAOI,4BAAA;ExEqtUV;EwE5tUM;IAOI,2BAAA;ExEwtUV;EwE/tUM;IAOI,4BAAA;ExE2tUV;EwEluUM;IAOI,6BAAA;ExE8tUV;EwEruUM;IAOI,8BAAA;ExEiuUV;EwExuUM;IAOI,2BAAA;IAAA,0BAAA;ExEquUV;EwE5uUM;IAOI,mCAAA;IAAA,kCAAA;ExEyuUV;EwEhvUM;IAOI,kCAAA;IAAA,iCAAA;ExE6uUV;EwEpvUM;IAOI,iCAAA;IAAA,gCAAA;ExEivUV;EwExvUM;IAOI,kCAAA;IAAA,iCAAA;ExEqvUV;EwE5vUM;IAOI,mCAAA;IAAA,kCAAA;ExEyvUV;EwEhwUM;IAOI,oCAAA;IAAA,mCAAA;ExE6vUV;EwEpwUM;IAOI,yBAAA;IAAA,4BAAA;ExEiwUV;EwExwUM;IAOI,iCAAA;IAAA,oCAAA;ExEqwUV;EwE5wUM;IAOI,gCAAA;IAAA,mCAAA;ExEywUV;EwEhxUM;IAOI,+BAAA;IAAA,kCAAA;ExE6wUV;EwEpxUM;IAOI,gCAAA;IAAA,mCAAA;ExEixUV;EwExxUM;IAOI,iCAAA;IAAA,oCAAA;ExEqxUV;EwE5xUM;IAOI,kCAAA;IAAA,qCAAA;ExEyxUV;EwEhyUM;IAOI,yBAAA;ExE4xUV;EwEnyUM;IAOI,iCAAA;ExE+xUV;EwEtyUM;IAOI,gCAAA;ExEkyUV;EwEzyUM;IAOI,+BAAA;ExEqyUV;EwE5yUM;IAOI,gCAAA;ExEwyUV;EwE/yUM;IAOI,iCAAA;ExE2yUV;EwElzUM;IAOI,kCAAA;ExE8yUV;EwErzUM;IAOI,2BAAA;ExEizUV;EwExzUM;IAOI,mCAAA;ExEozUV;EwE3zUM;IAOI,kCAAA;ExEuzUV;EwE9zUM;IAOI,iCAAA;ExE0zUV;EwEj0UM;IAOI,kCAAA;ExE6zUV;EwEp0UM;IAOI,mCAAA;ExEg0UV;EwEv0UM;IAOI,oCAAA;ExEm0UV;EwE10UM;IAOI,4BAAA;ExEs0UV;EwE70UM;IAOI,oCAAA;ExEy0UV;EwEh1UM;IAOI,mCAAA;ExE40UV;EwEn1UM;IAOI,kCAAA;ExE+0UV;EwEt1UM;IAOI,mCAAA;ExEk1UV;EwEz1UM;IAOI,oCAAA;ExEq1UV;EwE51UM;IAOI,qCAAA;ExEw1UV;EwE/1UM;IAOI,0BAAA;ExE21UV;EwEl2UM;IAOI,kCAAA;ExE81UV;EwEr2UM;IAOI,iCAAA;ExEi2UV;EwEx2UM;IAOI,gCAAA;ExEo2UV;EwE32UM;IAOI,iCAAA;ExEu2UV;EwE92UM;IAOI,kCAAA;ExE02UV;EwEj3UM;IAOI,mCAAA;ExE62UV;EwEp3UM;IAOI,iBAAA;ExEg3UV;EwEv3UM;IAOI,yBAAA;ExEm3UV;EwE13UM;IAOI,wBAAA;ExEs3UV;EwE73UM;IAOI,uBAAA;ExEy3UV;EwEh4UM;IAOI,wBAAA;ExE43UV;EwEn4UM;IAOI,yBAAA;ExE+3UV;EwEt4UM;IAOI,0BAAA;ExEk4UV;EwEz4UM;IAOI,qBAAA;ExEq4UV;EwE54UM;IAOI,6BAAA;ExEw4UV;EwE/4UM;IAOI,4BAAA;ExE24UV;EwEl5UM;IAOI,2BAAA;ExE84UV;EwEr5UM;IAOI,4BAAA;ExEi5UV;EwEx5UM;IAOI,6BAAA;ExEo5UV;EwE35UM;IAOI,8BAAA;ExEu5UV;EwE95UM;IAOI,wBAAA;ExE05UV;EwEj6UM;IAOI,gCAAA;ExE65UV;EwEp6UM;IAOI,+BAAA;ExEg6UV;EwEv6UM;IAOI,8BAAA;ExEm6UV;EwE16UM;IAOI,+BAAA;ExEs6UV;EwE76UM;IAOI,gCAAA;ExEy6UV;EwEh7UM;IAOI,iCAAA;ExE46UV;EwEn7UM;IAOI,2BAAA;ExE+6UV;EwEt7UM;IAOI,4BAAA;ExEk7UV;EwEz7UM;IAOI,6BAAA;ExEq7UV;AACF;Ach8UI;E0DGI;IAOI,sBAAA;ExE07UV;EwEj8UM;IAOI,uBAAA;ExE67UV;EwEp8UM;IAOI,sBAAA;ExEg8UV;EwEv8UM;IAOI,8BAAA;ExEm8UV;EwE18UM;IAOI,4BAAA;ExEs8UV;EwE78UM;IAOI,2BAAA;ExEy8UV;EwEh9UM;IAOI,iCAAA;ExE48UV;EwEn9UM;IAOI,2BAAA;ExE+8UV;EwEt9UM;IAOI,0BAAA;ExEk9UV;EwEz9UM;IAOI,gCAAA;ExEq9UV;EwE59UM;IAOI,yBAAA;ExEw9UV;EwE/9UM;IAOI,wBAAA;ExE29UV;EwEl+UM;IAOI,+BAAA;ExE89UV;EwEr+UM;IAOI,yBAAA;ExEi+UV;EwEx+UM;IAOI,6BAAA;ExEo+UV;EwE3+UM;IAOI,8BAAA;ExEu+UV;EwE9+UM;IAOI,wBAAA;ExE0+UV;EwEj/UM;IAOI,+BAAA;ExE6+UV;EwEp/UM;IAOI,wBAAA;ExEg/UV;EwEv/UM;IAOI,yBAAA;ExEm/UV;EwE1/UM;IAOI,8BAAA;ExEs/UV;EwE7/UM;IAOI,iCAAA;ExEy/UV;EwEhgVM;IAOI,sCAAA;ExE4/UV;EwEngVM;IAOI,yCAAA;ExE+/UV;EwEtgVM;IAOI,uBAAA;ExEkgVV;EwEzgVM;IAOI,uBAAA;ExEqgVV;EwE5gVM;IAOI,yBAAA;ExEwgVV;EwE/gVM;IAOI,yBAAA;ExE2gVV;EwElhVM;IAOI,0BAAA;ExE8gVV;EwErhVM;IAOI,4BAAA;ExEihVV;EwExhVM;IAOI,kCAAA;ExEohVV;EwE3hVM;IAOI,sCAAA;ExEuhVV;EwE9hVM;IAOI,oCAAA;ExE0hVV;EwEjiVM;IAOI,kCAAA;ExE6hVV;EwEpiVM;IAOI,yCAAA;ExEgiVV;EwEviVM;IAOI,wCAAA;ExEmiVV;EwE1iVM;IAOI,wCAAA;ExEsiVV;EwE7iVM;IAOI,kCAAA;ExEyiVV;EwEhjVM;IAOI,gCAAA;ExE4iVV;EwEnjVM;IAOI,8BAAA;ExE+iVV;EwEtjVM;IAOI,gCAAA;ExEkjVV;EwEzjVM;IAOI,+BAAA;ExEqjVV;EwE5jVM;IAOI,oCAAA;ExEwjVV;EwE/jVM;IAOI,kCAAA;ExE2jVV;EwElkVM;IAOI,gCAAA;ExE8jVV;EwErkVM;IAOI,uCAAA;ExEikVV;EwExkVM;IAOI,sCAAA;ExEokVV;EwE3kVM;IAOI,iCAAA;ExEukVV;EwE9kVM;IAOI,2BAAA;ExE0kVV;EwEjlVM;IAOI,iCAAA;ExE6kVV;EwEplVM;IAOI,+BAAA;ExEglVV;EwEvlVM;IAOI,6BAAA;ExEmlVV;EwE1lVM;IAOI,+BAAA;ExEslVV;EwE7lVM;IAOI,8BAAA;ExEylVV;EwEhmVM;IAOI,oBAAA;ExE4lVV;EwEnmVM;IAOI,mBAAA;ExE+lVV;EwEtmVM;IAOI,mBAAA;ExEkmVV;EwEzmVM;IAOI,mBAAA;ExEqmVV;EwE5mVM;IAOI,mBAAA;ExEwmVV;EwE/mVM;IAOI,mBAAA;ExE2mVV;EwElnVM;IAOI,mBAAA;ExE8mVV;EwErnVM;IAOI,mBAAA;ExEinVV;EwExnVM;IAOI,oBAAA;ExEonVV;EwE3nVM;IAOI,4BAAA;ExEunVV;EwE9nVM;IAOI,2BAAA;ExE0nVV;EwEjoVM;IAOI,0BAAA;ExE6nVV;EwEpoVM;IAOI,2BAAA;ExEgoVV;EwEvoVM;IAOI,4BAAA;ExEmoVV;EwE1oVM;IAOI,6BAAA;ExEsoVV;EwE7oVM;IAOI,uBAAA;ExEyoVV;EwEhpVM;IAOI,0BAAA;IAAA,yBAAA;ExE6oVV;EwEppVM;IAOI,kCAAA;IAAA,iCAAA;ExEipVV;EwExpVM;IAOI,iCAAA;IAAA,gCAAA;ExEqpVV;EwE5pVM;IAOI,gCAAA;IAAA,+BAAA;ExEypVV;EwEhqVM;IAOI,iCAAA;IAAA,gCAAA;ExE6pVV;EwEpqVM;IAOI,kCAAA;IAAA,iCAAA;ExEiqVV;EwExqVM;IAOI,mCAAA;IAAA,kCAAA;ExEqqVV;EwE5qVM;IAOI,6BAAA;IAAA,4BAAA;ExEyqVV;EwEhrVM;IAOI,wBAAA;IAAA,2BAAA;ExE6qVV;EwEprVM;IAOI,gCAAA;IAAA,mCAAA;ExEirVV;EwExrVM;IAOI,+BAAA;IAAA,kCAAA;ExEqrVV;EwE5rVM;IAOI,8BAAA;IAAA,iCAAA;ExEyrVV;EwEhsVM;IAOI,+BAAA;IAAA,kCAAA;ExE6rVV;EwEpsVM;IAOI,gCAAA;IAAA,mCAAA;ExEisVV;EwExsVM;IAOI,iCAAA;IAAA,oCAAA;ExEqsVV;EwE5sVM;IAOI,2BAAA;IAAA,8BAAA;ExEysVV;EwEhtVM;IAOI,wBAAA;ExE4sVV;EwEntVM;IAOI,gCAAA;ExE+sVV;EwEttVM;IAOI,+BAAA;ExEktVV;EwEztVM;IAOI,8BAAA;ExEqtVV;EwE5tVM;IAOI,+BAAA;ExEwtVV;EwE/tVM;IAOI,gCAAA;ExE2tVV;EwEluVM;IAOI,iCAAA;ExE8tVV;EwEruVM;IAOI,2BAAA;ExEiuVV;EwExuVM;IAOI,0BAAA;ExEouVV;EwE3uVM;IAOI,kCAAA;ExEuuVV;EwE9uVM;IAOI,iCAAA;ExE0uVV;EwEjvVM;IAOI,gCAAA;ExE6uVV;EwEpvVM;IAOI,iCAAA;ExEgvVV;EwEvvVM;IAOI,kCAAA;ExEmvVV;EwE1vVM;IAOI,mCAAA;ExEsvVV;EwE7vVM;IAOI,6BAAA;ExEyvVV;EwEhwVM;IAOI,2BAAA;ExE4vVV;EwEnwVM;IAOI,mCAAA;ExE+vVV;EwEtwVM;IAOI,kCAAA;ExEkwVV;EwEzwVM;IAOI,iCAAA;ExEqwVV;EwE5wVM;IAOI,kCAAA;ExEwwVV;EwE/wVM;IAOI,mCAAA;ExE2wVV;EwElxVM;IAOI,oCAAA;ExE8wVV;EwErxVM;IAOI,8BAAA;ExEixVV;EwExxVM;IAOI,yBAAA;ExEoxVV;EwE3xVM;IAOI,iCAAA;ExEuxVV;EwE9xVM;IAOI,gCAAA;ExE0xVV;EwEjyVM;IAOI,+BAAA;ExE6xVV;EwEpyVM;IAOI,gCAAA;ExEgyVV;EwEvyVM;IAOI,iCAAA;ExEmyVV;EwE1yVM;IAOI,kCAAA;ExEsyVV;EwE7yVM;IAOI,4BAAA;ExEyyVV;EwEhzVM;IAOI,qBAAA;ExE4yVV;EwEnzVM;IAOI,6BAAA;ExE+yVV;EwEtzVM;IAOI,4BAAA;ExEkzVV;EwEzzVM;IAOI,2BAAA;ExEqzVV;EwE5zVM;IAOI,4BAAA;ExEwzVV;EwE/zVM;IAOI,6BAAA;ExE2zVV;EwEl0VM;IAOI,8BAAA;ExE8zVV;EwEr0VM;IAOI,2BAAA;IAAA,0BAAA;ExEk0VV;EwEz0VM;IAOI,mCAAA;IAAA,kCAAA;ExEs0VV;EwE70VM;IAOI,kCAAA;IAAA,iCAAA;ExE00VV;EwEj1VM;IAOI,iCAAA;IAAA,gCAAA;ExE80VV;EwEr1VM;IAOI,kCAAA;IAAA,iCAAA;ExEk1VV;EwEz1VM;IAOI,mCAAA;IAAA,kCAAA;ExEs1VV;EwE71VM;IAOI,oCAAA;IAAA,mCAAA;ExE01VV;EwEj2VM;IAOI,yBAAA;IAAA,4BAAA;ExE81VV;EwEr2VM;IAOI,iCAAA;IAAA,oCAAA;ExEk2VV;EwEz2VM;IAOI,gCAAA;IAAA,mCAAA;ExEs2VV;EwE72VM;IAOI,+BAAA;IAAA,kCAAA;ExE02VV;EwEj3VM;IAOI,gCAAA;IAAA,mCAAA;ExE82VV;EwEr3VM;IAOI,iCAAA;IAAA,oCAAA;ExEk3VV;EwEz3VM;IAOI,kCAAA;IAAA,qCAAA;ExEs3VV;EwE73VM;IAOI,yBAAA;ExEy3VV;EwEh4VM;IAOI,iCAAA;ExE43VV;EwEn4VM;IAOI,gCAAA;ExE+3VV;EwEt4VM;IAOI,+BAAA;ExEk4VV;EwEz4VM;IAOI,gCAAA;ExEq4VV;EwE54VM;IAOI,iCAAA;ExEw4VV;EwE/4VM;IAOI,kCAAA;ExE24VV;EwEl5VM;IAOI,2BAAA;ExE84VV;EwEr5VM;IAOI,mCAAA;ExEi5VV;EwEx5VM;IAOI,kCAAA;ExEo5VV;EwE35VM;IAOI,iCAAA;ExEu5VV;EwE95VM;IAOI,kCAAA;ExE05VV;EwEj6VM;IAOI,mCAAA;ExE65VV;EwEp6VM;IAOI,oCAAA;ExEg6VV;EwEv6VM;IAOI,4BAAA;ExEm6VV;EwE16VM;IAOI,oCAAA;ExEs6VV;EwE76VM;IAOI,mCAAA;ExEy6VV;EwEh7VM;IAOI,kCAAA;ExE46VV;EwEn7VM;IAOI,mCAAA;ExE+6VV;EwEt7VM;IAOI,oCAAA;ExEk7VV;EwEz7VM;IAOI,qCAAA;ExEq7VV;EwE57VM;IAOI,0BAAA;ExEw7VV;EwE/7VM;IAOI,kCAAA;ExE27VV;EwEl8VM;IAOI,iCAAA;ExE87VV;EwEr8VM;IAOI,gCAAA;ExEi8VV;EwEx8VM;IAOI,iCAAA;ExEo8VV;EwE38VM;IAOI,kCAAA;ExEu8VV;EwE98VM;IAOI,mCAAA;ExE08VV;EwEj9VM;IAOI,iBAAA;ExE68VV;EwEp9VM;IAOI,yBAAA;ExEg9VV;EwEv9VM;IAOI,wBAAA;ExEm9VV;EwE19VM;IAOI,uBAAA;ExEs9VV;EwE79VM;IAOI,wBAAA;ExEy9VV;EwEh+VM;IAOI,yBAAA;ExE49VV;EwEn+VM;IAOI,0BAAA;ExE+9VV;EwEt+VM;IAOI,qBAAA;ExEk+VV;EwEz+VM;IAOI,6BAAA;ExEq+VV;EwE5+VM;IAOI,4BAAA;ExEw+VV;EwE/+VM;IAOI,2BAAA;ExE2+VV;EwEl/VM;IAOI,4BAAA;ExE8+VV;EwEr/VM;IAOI,6BAAA;ExEi/VV;EwEx/VM;IAOI,8BAAA;ExEo/VV;EwE3/VM;IAOI,wBAAA;ExEu/VV;EwE9/VM;IAOI,gCAAA;ExE0/VV;EwEjgWM;IAOI,+BAAA;ExE6/VV;EwEpgWM;IAOI,8BAAA;ExEggWV;EwEvgWM;IAOI,+BAAA;ExEmgWV;EwE1gWM;IAOI,gCAAA;ExEsgWV;EwE7gWM;IAOI,iCAAA;ExEygWV;EwEhhWM;IAOI,2BAAA;ExE4gWV;EwEnhWM;IAOI,4BAAA;ExE+gWV;EwEthWM;IAOI,6BAAA;ExEkhWV;AACF;Ac7hWI;E0DGI;IAOI,sBAAA;ExEuhWV;EwE9hWM;IAOI,uBAAA;ExE0hWV;EwEjiWM;IAOI,sBAAA;ExE6hWV;EwEpiWM;IAOI,8BAAA;ExEgiWV;EwEviWM;IAOI,4BAAA;ExEmiWV;EwE1iWM;IAOI,2BAAA;ExEsiWV;EwE7iWM;IAOI,iCAAA;ExEyiWV;EwEhjWM;IAOI,2BAAA;ExE4iWV;EwEnjWM;IAOI,0BAAA;ExE+iWV;EwEtjWM;IAOI,gCAAA;ExEkjWV;EwEzjWM;IAOI,yBAAA;ExEqjWV;EwE5jWM;IAOI,wBAAA;ExEwjWV;EwE/jWM;IAOI,+BAAA;ExE2jWV;EwElkWM;IAOI,yBAAA;ExE8jWV;EwErkWM;IAOI,6BAAA;ExEikWV;EwExkWM;IAOI,8BAAA;ExEokWV;EwE3kWM;IAOI,wBAAA;ExEukWV;EwE9kWM;IAOI,+BAAA;ExE0kWV;EwEjlWM;IAOI,wBAAA;ExE6kWV;EwEplWM;IAOI,yBAAA;ExEglWV;EwEvlWM;IAOI,8BAAA;ExEmlWV;EwE1lWM;IAOI,iCAAA;ExEslWV;EwE7lWM;IAOI,sCAAA;ExEylWV;EwEhmWM;IAOI,yCAAA;ExE4lWV;EwEnmWM;IAOI,uBAAA;ExE+lWV;EwEtmWM;IAOI,uBAAA;ExEkmWV;EwEzmWM;IAOI,yBAAA;ExEqmWV;EwE5mWM;IAOI,yBAAA;ExEwmWV;EwE/mWM;IAOI,0BAAA;ExE2mWV;EwElnWM;IAOI,4BAAA;ExE8mWV;EwErnWM;IAOI,kCAAA;ExEinWV;EwExnWM;IAOI,sCAAA;ExEonWV;EwE3nWM;IAOI,oCAAA;ExEunWV;EwE9nWM;IAOI,kCAAA;ExE0nWV;EwEjoWM;IAOI,yCAAA;ExE6nWV;EwEpoWM;IAOI,wCAAA;ExEgoWV;EwEvoWM;IAOI,wCAAA;ExEmoWV;EwE1oWM;IAOI,kCAAA;ExEsoWV;EwE7oWM;IAOI,gCAAA;ExEyoWV;EwEhpWM;IAOI,8BAAA;ExE4oWV;EwEnpWM;IAOI,gCAAA;ExE+oWV;EwEtpWM;IAOI,+BAAA;ExEkpWV;EwEzpWM;IAOI,oCAAA;ExEqpWV;EwE5pWM;IAOI,kCAAA;ExEwpWV;EwE/pWM;IAOI,gCAAA;ExE2pWV;EwElqWM;IAOI,uCAAA;ExE8pWV;EwErqWM;IAOI,sCAAA;ExEiqWV;EwExqWM;IAOI,iCAAA;ExEoqWV;EwE3qWM;IAOI,2BAAA;ExEuqWV;EwE9qWM;IAOI,iCAAA;ExE0qWV;EwEjrWM;IAOI,+BAAA;ExE6qWV;EwEprWM;IAOI,6BAAA;ExEgrWV;EwEvrWM;IAOI,+BAAA;ExEmrWV;EwE1rWM;IAOI,8BAAA;ExEsrWV;EwE7rWM;IAOI,oBAAA;ExEyrWV;EwEhsWM;IAOI,mBAAA;ExE4rWV;EwEnsWM;IAOI,mBAAA;ExE+rWV;EwEtsWM;IAOI,mBAAA;ExEksWV;EwEzsWM;IAOI,mBAAA;ExEqsWV;EwE5sWM;IAOI,mBAAA;ExEwsWV;EwE/sWM;IAOI,mBAAA;ExE2sWV;EwEltWM;IAOI,mBAAA;ExE8sWV;EwErtWM;IAOI,oBAAA;ExEitWV;EwExtWM;IAOI,4BAAA;ExEotWV;EwE3tWM;IAOI,2BAAA;ExEutWV;EwE9tWM;IAOI,0BAAA;ExE0tWV;EwEjuWM;IAOI,2BAAA;ExE6tWV;EwEpuWM;IAOI,4BAAA;ExEguWV;EwEvuWM;IAOI,6BAAA;ExEmuWV;EwE1uWM;IAOI,uBAAA;ExEsuWV;EwE7uWM;IAOI,0BAAA;IAAA,yBAAA;ExE0uWV;EwEjvWM;IAOI,kCAAA;IAAA,iCAAA;ExE8uWV;EwErvWM;IAOI,iCAAA;IAAA,gCAAA;ExEkvWV;EwEzvWM;IAOI,gCAAA;IAAA,+BAAA;ExEsvWV;EwE7vWM;IAOI,iCAAA;IAAA,gCAAA;ExE0vWV;EwEjwWM;IAOI,kCAAA;IAAA,iCAAA;ExE8vWV;EwErwWM;IAOI,mCAAA;IAAA,kCAAA;ExEkwWV;EwEzwWM;IAOI,6BAAA;IAAA,4BAAA;ExEswWV;EwE7wWM;IAOI,wBAAA;IAAA,2BAAA;ExE0wWV;EwEjxWM;IAOI,gCAAA;IAAA,mCAAA;ExE8wWV;EwErxWM;IAOI,+BAAA;IAAA,kCAAA;ExEkxWV;EwEzxWM;IAOI,8BAAA;IAAA,iCAAA;ExEsxWV;EwE7xWM;IAOI,+BAAA;IAAA,kCAAA;ExE0xWV;EwEjyWM;IAOI,gCAAA;IAAA,mCAAA;ExE8xWV;EwEryWM;IAOI,iCAAA;IAAA,oCAAA;ExEkyWV;EwEzyWM;IAOI,2BAAA;IAAA,8BAAA;ExEsyWV;EwE7yWM;IAOI,wBAAA;ExEyyWV;EwEhzWM;IAOI,gCAAA;ExE4yWV;EwEnzWM;IAOI,+BAAA;ExE+yWV;EwEtzWM;IAOI,8BAAA;ExEkzWV;EwEzzWM;IAOI,+BAAA;ExEqzWV;EwE5zWM;IAOI,gCAAA;ExEwzWV;EwE/zWM;IAOI,iCAAA;ExE2zWV;EwEl0WM;IAOI,2BAAA;ExE8zWV;EwEr0WM;IAOI,0BAAA;ExEi0WV;EwEx0WM;IAOI,kCAAA;ExEo0WV;EwE30WM;IAOI,iCAAA;ExEu0WV;EwE90WM;IAOI,gCAAA;ExE00WV;EwEj1WM;IAOI,iCAAA;ExE60WV;EwEp1WM;IAOI,kCAAA;ExEg1WV;EwEv1WM;IAOI,mCAAA;ExEm1WV;EwE11WM;IAOI,6BAAA;ExEs1WV;EwE71WM;IAOI,2BAAA;ExEy1WV;EwEh2WM;IAOI,mCAAA;ExE41WV;EwEn2WM;IAOI,kCAAA;ExE+1WV;EwEt2WM;IAOI,iCAAA;ExEk2WV;EwEz2WM;IAOI,kCAAA;ExEq2WV;EwE52WM;IAOI,mCAAA;ExEw2WV;EwE/2WM;IAOI,oCAAA;ExE22WV;EwEl3WM;IAOI,8BAAA;ExE82WV;EwEr3WM;IAOI,yBAAA;ExEi3WV;EwEx3WM;IAOI,iCAAA;ExEo3WV;EwE33WM;IAOI,gCAAA;ExEu3WV;EwE93WM;IAOI,+BAAA;ExE03WV;EwEj4WM;IAOI,gCAAA;ExE63WV;EwEp4WM;IAOI,iCAAA;ExEg4WV;EwEv4WM;IAOI,kCAAA;ExEm4WV;EwE14WM;IAOI,4BAAA;ExEs4WV;EwE74WM;IAOI,qBAAA;ExEy4WV;EwEh5WM;IAOI,6BAAA;ExE44WV;EwEn5WM;IAOI,4BAAA;ExE+4WV;EwEt5WM;IAOI,2BAAA;ExEk5WV;EwEz5WM;IAOI,4BAAA;ExEq5WV;EwE55WM;IAOI,6BAAA;ExEw5WV;EwE/5WM;IAOI,8BAAA;ExE25WV;EwEl6WM;IAOI,2BAAA;IAAA,0BAAA;ExE+5WV;EwEt6WM;IAOI,mCAAA;IAAA,kCAAA;ExEm6WV;EwE16WM;IAOI,kCAAA;IAAA,iCAAA;ExEu6WV;EwE96WM;IAOI,iCAAA;IAAA,gCAAA;ExE26WV;EwEl7WM;IAOI,kCAAA;IAAA,iCAAA;ExE+6WV;EwEt7WM;IAOI,mCAAA;IAAA,kCAAA;ExEm7WV;EwE17WM;IAOI,oCAAA;IAAA,mCAAA;ExEu7WV;EwE97WM;IAOI,yBAAA;IAAA,4BAAA;ExE27WV;EwEl8WM;IAOI,iCAAA;IAAA,oCAAA;ExE+7WV;EwEt8WM;IAOI,gCAAA;IAAA,mCAAA;ExEm8WV;EwE18WM;IAOI,+BAAA;IAAA,kCAAA;ExEu8WV;EwE98WM;IAOI,gCAAA;IAAA,mCAAA;ExE28WV;EwEl9WM;IAOI,iCAAA;IAAA,oCAAA;ExE+8WV;EwEt9WM;IAOI,kCAAA;IAAA,qCAAA;ExEm9WV;EwE19WM;IAOI,yBAAA;ExEs9WV;EwE79WM;IAOI,iCAAA;ExEy9WV;EwEh+WM;IAOI,gCAAA;ExE49WV;EwEn+WM;IAOI,+BAAA;ExE+9WV;EwEt+WM;IAOI,gCAAA;ExEk+WV;EwEz+WM;IAOI,iCAAA;ExEq+WV;EwE5+WM;IAOI,kCAAA;ExEw+WV;EwE/+WM;IAOI,2BAAA;ExE2+WV;EwEl/WM;IAOI,mCAAA;ExE8+WV;EwEr/WM;IAOI,kCAAA;ExEi/WV;EwEx/WM;IAOI,iCAAA;ExEo/WV;EwE3/WM;IAOI,kCAAA;ExEu/WV;EwE9/WM;IAOI,mCAAA;ExE0/WV;EwEjgXM;IAOI,oCAAA;ExE6/WV;EwEpgXM;IAOI,4BAAA;ExEggXV;EwEvgXM;IAOI,oCAAA;ExEmgXV;EwE1gXM;IAOI,mCAAA;ExEsgXV;EwE7gXM;IAOI,kCAAA;ExEygXV;EwEhhXM;IAOI,mCAAA;ExE4gXV;EwEnhXM;IAOI,oCAAA;ExE+gXV;EwEthXM;IAOI,qCAAA;ExEkhXV;EwEzhXM;IAOI,0BAAA;ExEqhXV;EwE5hXM;IAOI,kCAAA;ExEwhXV;EwE/hXM;IAOI,iCAAA;ExE2hXV;EwEliXM;IAOI,gCAAA;ExE8hXV;EwEriXM;IAOI,iCAAA;ExEiiXV;EwExiXM;IAOI,kCAAA;ExEoiXV;EwE3iXM;IAOI,mCAAA;ExEuiXV;EwE9iXM;IAOI,iBAAA;ExE0iXV;EwEjjXM;IAOI,yBAAA;ExE6iXV;EwEpjXM;IAOI,wBAAA;ExEgjXV;EwEvjXM;IAOI,uBAAA;ExEmjXV;EwE1jXM;IAOI,wBAAA;ExEsjXV;EwE7jXM;IAOI,yBAAA;ExEyjXV;EwEhkXM;IAOI,0BAAA;ExE4jXV;EwEnkXM;IAOI,qBAAA;ExE+jXV;EwEtkXM;IAOI,6BAAA;ExEkkXV;EwEzkXM;IAOI,4BAAA;ExEqkXV;EwE5kXM;IAOI,2BAAA;ExEwkXV;EwE/kXM;IAOI,4BAAA;ExE2kXV;EwEllXM;IAOI,6BAAA;ExE8kXV;EwErlXM;IAOI,8BAAA;ExEilXV;EwExlXM;IAOI,wBAAA;ExEolXV;EwE3lXM;IAOI,gCAAA;ExEulXV;EwE9lXM;IAOI,+BAAA;ExE0lXV;EwEjmXM;IAOI,8BAAA;ExE6lXV;EwEpmXM;IAOI,+BAAA;ExEgmXV;EwEvmXM;IAOI,gCAAA;ExEmmXV;EwE1mXM;IAOI,iCAAA;ExEsmXV;EwE7mXM;IAOI,2BAAA;ExEymXV;EwEhnXM;IAOI,4BAAA;ExE4mXV;EwEnnXM;IAOI,6BAAA;ExE+mXV;AACF;Ac1nXI;E0DGI;IAOI,sBAAA;ExEonXV;EwE3nXM;IAOI,uBAAA;ExEunXV;EwE9nXM;IAOI,sBAAA;ExE0nXV;EwEjoXM;IAOI,8BAAA;ExE6nXV;EwEpoXM;IAOI,4BAAA;ExEgoXV;EwEvoXM;IAOI,2BAAA;ExEmoXV;EwE1oXM;IAOI,iCAAA;ExEsoXV;EwE7oXM;IAOI,2BAAA;ExEyoXV;EwEhpXM;IAOI,0BAAA;ExE4oXV;EwEnpXM;IAOI,gCAAA;ExE+oXV;EwEtpXM;IAOI,yBAAA;ExEkpXV;EwEzpXM;IAOI,wBAAA;ExEqpXV;EwE5pXM;IAOI,+BAAA;ExEwpXV;EwE/pXM;IAOI,yBAAA;ExE2pXV;EwElqXM;IAOI,6BAAA;ExE8pXV;EwErqXM;IAOI,8BAAA;ExEiqXV;EwExqXM;IAOI,wBAAA;ExEoqXV;EwE3qXM;IAOI,+BAAA;ExEuqXV;EwE9qXM;IAOI,wBAAA;ExE0qXV;EwEjrXM;IAOI,yBAAA;ExE6qXV;EwEprXM;IAOI,8BAAA;ExEgrXV;EwEvrXM;IAOI,iCAAA;ExEmrXV;EwE1rXM;IAOI,sCAAA;ExEsrXV;EwE7rXM;IAOI,yCAAA;ExEyrXV;EwEhsXM;IAOI,uBAAA;ExE4rXV;EwEnsXM;IAOI,uBAAA;ExE+rXV;EwEtsXM;IAOI,yBAAA;ExEksXV;EwEzsXM;IAOI,yBAAA;ExEqsXV;EwE5sXM;IAOI,0BAAA;ExEwsXV;EwE/sXM;IAOI,4BAAA;ExE2sXV;EwEltXM;IAOI,kCAAA;ExE8sXV;EwErtXM;IAOI,sCAAA;ExEitXV;EwExtXM;IAOI,oCAAA;ExEotXV;EwE3tXM;IAOI,kCAAA;ExEutXV;EwE9tXM;IAOI,yCAAA;ExE0tXV;EwEjuXM;IAOI,wCAAA;ExE6tXV;EwEpuXM;IAOI,wCAAA;ExEguXV;EwEvuXM;IAOI,kCAAA;ExEmuXV;EwE1uXM;IAOI,gCAAA;ExEsuXV;EwE7uXM;IAOI,8BAAA;ExEyuXV;EwEhvXM;IAOI,gCAAA;ExE4uXV;EwEnvXM;IAOI,+BAAA;ExE+uXV;EwEtvXM;IAOI,oCAAA;ExEkvXV;EwEzvXM;IAOI,kCAAA;ExEqvXV;EwE5vXM;IAOI,gCAAA;ExEwvXV;EwE/vXM;IAOI,uCAAA;ExE2vXV;EwElwXM;IAOI,sCAAA;ExE8vXV;EwErwXM;IAOI,iCAAA;ExEiwXV;EwExwXM;IAOI,2BAAA;ExEowXV;EwE3wXM;IAOI,iCAAA;ExEuwXV;EwE9wXM;IAOI,+BAAA;ExE0wXV;EwEjxXM;IAOI,6BAAA;ExE6wXV;EwEpxXM;IAOI,+BAAA;ExEgxXV;EwEvxXM;IAOI,8BAAA;ExEmxXV;EwE1xXM;IAOI,oBAAA;ExEsxXV;EwE7xXM;IAOI,mBAAA;ExEyxXV;EwEhyXM;IAOI,mBAAA;ExE4xXV;EwEnyXM;IAOI,mBAAA;ExE+xXV;EwEtyXM;IAOI,mBAAA;ExEkyXV;EwEzyXM;IAOI,mBAAA;ExEqyXV;EwE5yXM;IAOI,mBAAA;ExEwyXV;EwE/yXM;IAOI,mBAAA;ExE2yXV;EwElzXM;IAOI,oBAAA;ExE8yXV;EwErzXM;IAOI,4BAAA;ExEizXV;EwExzXM;IAOI,2BAAA;ExEozXV;EwE3zXM;IAOI,0BAAA;ExEuzXV;EwE9zXM;IAOI,2BAAA;ExE0zXV;EwEj0XM;IAOI,4BAAA;ExE6zXV;EwEp0XM;IAOI,6BAAA;ExEg0XV;EwEv0XM;IAOI,uBAAA;ExEm0XV;EwE10XM;IAOI,0BAAA;IAAA,yBAAA;ExEu0XV;EwE90XM;IAOI,kCAAA;IAAA,iCAAA;ExE20XV;EwEl1XM;IAOI,iCAAA;IAAA,gCAAA;ExE+0XV;EwEt1XM;IAOI,gCAAA;IAAA,+BAAA;ExEm1XV;EwE11XM;IAOI,iCAAA;IAAA,gCAAA;ExEu1XV;EwE91XM;IAOI,kCAAA;IAAA,iCAAA;ExE21XV;EwEl2XM;IAOI,mCAAA;IAAA,kCAAA;ExE+1XV;EwEt2XM;IAOI,6BAAA;IAAA,4BAAA;ExEm2XV;EwE12XM;IAOI,wBAAA;IAAA,2BAAA;ExEu2XV;EwE92XM;IAOI,gCAAA;IAAA,mCAAA;ExE22XV;EwEl3XM;IAOI,+BAAA;IAAA,kCAAA;ExE+2XV;EwEt3XM;IAOI,8BAAA;IAAA,iCAAA;ExEm3XV;EwE13XM;IAOI,+BAAA;IAAA,kCAAA;ExEu3XV;EwE93XM;IAOI,gCAAA;IAAA,mCAAA;ExE23XV;EwEl4XM;IAOI,iCAAA;IAAA,oCAAA;ExE+3XV;EwEt4XM;IAOI,2BAAA;IAAA,8BAAA;ExEm4XV;EwE14XM;IAOI,wBAAA;ExEs4XV;EwE74XM;IAOI,gCAAA;ExEy4XV;EwEh5XM;IAOI,+BAAA;ExE44XV;EwEn5XM;IAOI,8BAAA;ExE+4XV;EwEt5XM;IAOI,+BAAA;ExEk5XV;EwEz5XM;IAOI,gCAAA;ExEq5XV;EwE55XM;IAOI,iCAAA;ExEw5XV;EwE/5XM;IAOI,2BAAA;ExE25XV;EwEl6XM;IAOI,0BAAA;ExE85XV;EwEr6XM;IAOI,kCAAA;ExEi6XV;EwEx6XM;IAOI,iCAAA;ExEo6XV;EwE36XM;IAOI,gCAAA;ExEu6XV;EwE96XM;IAOI,iCAAA;ExE06XV;EwEj7XM;IAOI,kCAAA;ExE66XV;EwEp7XM;IAOI,mCAAA;ExEg7XV;EwEv7XM;IAOI,6BAAA;ExEm7XV;EwE17XM;IAOI,2BAAA;ExEs7XV;EwE77XM;IAOI,mCAAA;ExEy7XV;EwEh8XM;IAOI,kCAAA;ExE47XV;EwEn8XM;IAOI,iCAAA;ExE+7XV;EwEt8XM;IAOI,kCAAA;ExEk8XV;EwEz8XM;IAOI,mCAAA;ExEq8XV;EwE58XM;IAOI,oCAAA;ExEw8XV;EwE/8XM;IAOI,8BAAA;ExE28XV;EwEl9XM;IAOI,yBAAA;ExE88XV;EwEr9XM;IAOI,iCAAA;ExEi9XV;EwEx9XM;IAOI,gCAAA;ExEo9XV;EwE39XM;IAOI,+BAAA;ExEu9XV;EwE99XM;IAOI,gCAAA;ExE09XV;EwEj+XM;IAOI,iCAAA;ExE69XV;EwEp+XM;IAOI,kCAAA;ExEg+XV;EwEv+XM;IAOI,4BAAA;ExEm+XV;EwE1+XM;IAOI,qBAAA;ExEs+XV;EwE7+XM;IAOI,6BAAA;ExEy+XV;EwEh/XM;IAOI,4BAAA;ExE4+XV;EwEn/XM;IAOI,2BAAA;ExE++XV;EwEt/XM;IAOI,4BAAA;ExEk/XV;EwEz/XM;IAOI,6BAAA;ExEq/XV;EwE5/XM;IAOI,8BAAA;ExEw/XV;EwE//XM;IAOI,2BAAA;IAAA,0BAAA;ExE4/XV;EwEngYM;IAOI,mCAAA;IAAA,kCAAA;ExEggYV;EwEvgYM;IAOI,kCAAA;IAAA,iCAAA;ExEogYV;EwE3gYM;IAOI,iCAAA;IAAA,gCAAA;ExEwgYV;EwE/gYM;IAOI,kCAAA;IAAA,iCAAA;ExE4gYV;EwEnhYM;IAOI,mCAAA;IAAA,kCAAA;ExEghYV;EwEvhYM;IAOI,oCAAA;IAAA,mCAAA;ExEohYV;EwE3hYM;IAOI,yBAAA;IAAA,4BAAA;ExEwhYV;EwE/hYM;IAOI,iCAAA;IAAA,oCAAA;ExE4hYV;EwEniYM;IAOI,gCAAA;IAAA,mCAAA;ExEgiYV;EwEviYM;IAOI,+BAAA;IAAA,kCAAA;ExEoiYV;EwE3iYM;IAOI,gCAAA;IAAA,mCAAA;ExEwiYV;EwE/iYM;IAOI,iCAAA;IAAA,oCAAA;ExE4iYV;EwEnjYM;IAOI,kCAAA;IAAA,qCAAA;ExEgjYV;EwEvjYM;IAOI,yBAAA;ExEmjYV;EwE1jYM;IAOI,iCAAA;ExEsjYV;EwE7jYM;IAOI,gCAAA;ExEyjYV;EwEhkYM;IAOI,+BAAA;ExE4jYV;EwEnkYM;IAOI,gCAAA;ExE+jYV;EwEtkYM;IAOI,iCAAA;ExEkkYV;EwEzkYM;IAOI,kCAAA;ExEqkYV;EwE5kYM;IAOI,2BAAA;ExEwkYV;EwE/kYM;IAOI,mCAAA;ExE2kYV;EwEllYM;IAOI,kCAAA;ExE8kYV;EwErlYM;IAOI,iCAAA;ExEilYV;EwExlYM;IAOI,kCAAA;ExEolYV;EwE3lYM;IAOI,mCAAA;ExEulYV;EwE9lYM;IAOI,oCAAA;ExE0lYV;EwEjmYM;IAOI,4BAAA;ExE6lYV;EwEpmYM;IAOI,oCAAA;ExEgmYV;EwEvmYM;IAOI,mCAAA;ExEmmYV;EwE1mYM;IAOI,kCAAA;ExEsmYV;EwE7mYM;IAOI,mCAAA;ExEymYV;EwEhnYM;IAOI,oCAAA;ExE4mYV;EwEnnYM;IAOI,qCAAA;ExE+mYV;EwEtnYM;IAOI,0BAAA;ExEknYV;EwEznYM;IAOI,kCAAA;ExEqnYV;EwE5nYM;IAOI,iCAAA;ExEwnYV;EwE/nYM;IAOI,gCAAA;ExE2nYV;EwEloYM;IAOI,iCAAA;ExE8nYV;EwEroYM;IAOI,kCAAA;ExEioYV;EwExoYM;IAOI,mCAAA;ExEooYV;EwE3oYM;IAOI,iBAAA;ExEuoYV;EwE9oYM;IAOI,yBAAA;ExE0oYV;EwEjpYM;IAOI,wBAAA;ExE6oYV;EwEppYM;IAOI,uBAAA;ExEgpYV;EwEvpYM;IAOI,wBAAA;ExEmpYV;EwE1pYM;IAOI,yBAAA;ExEspYV;EwE7pYM;IAOI,0BAAA;ExEypYV;EwEhqYM;IAOI,qBAAA;ExE4pYV;EwEnqYM;IAOI,6BAAA;ExE+pYV;EwEtqYM;IAOI,4BAAA;ExEkqYV;EwEzqYM;IAOI,2BAAA;ExEqqYV;EwE5qYM;IAOI,4BAAA;ExEwqYV;EwE/qYM;IAOI,6BAAA;ExE2qYV;EwElrYM;IAOI,8BAAA;ExE8qYV;EwErrYM;IAOI,wBAAA;ExEirYV;EwExrYM;IAOI,gCAAA;ExEorYV;EwE3rYM;IAOI,+BAAA;ExEurYV;EwE9rYM;IAOI,8BAAA;ExE0rYV;EwEjsYM;IAOI,+BAAA;ExE6rYV;EwEpsYM;IAOI,gCAAA;ExEgsYV;EwEvsYM;IAOI,iCAAA;ExEmsYV;EwE1sYM;IAOI,2BAAA;ExEssYV;EwE7sYM;IAOI,4BAAA;ExEysYV;EwEhtYM;IAOI,6BAAA;ExE4sYV;AACF;AyEnwYA;ED+CQ;IAOI,gCAAA;ExEitYV;EwExtYM;IAOI,gCAAA;ExEotYV;EwE3tYM;IAOI,gCAAA;ExEutYV;AACF;AyE3vYA;ED4BQ;IAOI,0BAAA;ExE4tYV;EwEnuYM;IAOI,gCAAA;ExE+tYV;EwEtuYM;IAOI,yBAAA;ExEkuYV;EwEzuYM;IAOI,wBAAA;ExEquYV;EwE5uYM;IAOI,+BAAA;ExEwuYV;EwE/uYM;IAOI,yBAAA;ExE2uYV;EwElvYM;IAOI,6BAAA;ExE8uYV;EwErvYM;IAOI,8BAAA;ExEivYV;EwExvYM;IAOI,wBAAA;ExEovYV;EwE3vYM;IAOI,+BAAA;ExEuvYV;EwE9vYM;IAOI,wBAAA;ExE0vYV;AACF;AAvuYA,mBAAA;AAIA,2CAAA;A0EjGA;EACE,eAAA;A1Ew0YF;;A0Et0YA;EACE,2BAAA;A1Ey0YF;;A2E30YA;EACE,iBAAA;EACA,mBAAA;A3E80YF;;A2E30YA;EACE,+B3EuFqB;AAuvYvB;A2E70YE;EACE,c3EHO;AAk1YX;;A2Ez0YM;EACE,qCAAA;A3E40YR;A2E10YQ;EACE,uCAAA;A3E40YV;A2Ex0YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA61YX;A2Ex0YQ;EACE,c3EtBC;E2EuBD,2CAAA;EACA,uCAAA;A3E00YV;;A2Ez1YM;EACE,oCAAA;A3E41YR;A2E11YQ;EACE,qCAAA;A3E41YV;A2Ex1YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA62YX;A2Ex1YQ;EACE,c3EtBC;E2EuBD,4CAAA;EACA,qCAAA;A3E01YV;;A2Ez2YM;EACE,qCAAA;A3E42YR;A2E12YQ;EACE,sCAAA;A3E42YV;A2Ex2YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA63YX;A2Ex2YQ;EACE,c3EtBC;E2EuBD,4CAAA;EACA,sCAAA;A3E02YV;;A2Ez3YM;EACE,gCAAA;A3E43YR;A2E13YQ;EACE,oCAAA;A3E43YV;A2Ex3YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA64YX;A2Ex3YQ;EACE,c3EtBC;E2EuBD,6CAAA;EACA,sCAAA;A3E03YV;;A2Ez4YM;EACE,oCAAA;A3E44YR;A2E14YQ;EACE,uCAAA;A3E44YV;A2Ex4YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA65YX;A2Ex4YQ;EACE,c3EtBC;E2EuBD,2CAAA;EACA,uCAAA;A3E04YV;;A2Ez5YM;EACE,mCAAA;A3E45YR;A2E15YQ;EACE,qCAAA;A3E45YV;A2Ex5YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA66YX;A2Ex5YQ;EACE,c3EtBC;E2EuBD,2CAAA;EACA,qCAAA;A3E05YV;;A2Ez6YM;EACE,oCAAA;A3E46YR;A2E16YQ;EACE,wCAAA;A3E46YV;A2Ex6YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA67YX;A2Ex6YQ;EACE,c3EtBC;E2EuBD,2CAAA;EACA,wCAAA;A3E06YV;;A2Ez7YM;EACE,oCAAA;A3E47YR;A2E17YQ;EACE,sCAAA;A3E47YV;A2Ex7YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA68YX;A2Ex7YQ;EACE,c3EtBC;E2EuBD,4CAAA;EACA,sCAAA;A3E07YV;;A2Ez8YM;EACE,qCAAA;A3E48YR;A2E18YQ;EACE,uCAAA;A3E48YV;A2Ex8YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA69YX;A2Ex8YQ;EACE,c3EtBC;E2EuBD,2CAAA;EACA,wCAAA;A3E08YV;;A2Ez9YM;EACE,qCAAA;A3E49YR;A2E19YQ;EACE,sCAAA;A3E49YV;A2Ex9YM;EACE,sB3EpBA;E2EqBA,c3EnBG;AA6+YX;A2Ex9YQ;EACE,c3EtBC;E2EuBD,0CAAA;EACA,uCAAA;A3E09YV;;A4Ex/YE;EACE,0CAAA;A5E2/YJ;;A6E1/YE;EACE,eAAA;A7E6/YJ;A6E3/YE;EACE,8CAAA;A7E6/YJ;A6Ex/YM;EACE,qCAAA;A7E0/YR;A6Ex/YM;;EAEE,WAAA;EACA,yBAAA;A7E0/YR;A6EhgZM;EACE,oCAAA;A7EkgZR;A6EhgZM;;EAEE,WAAA;EACA,yBAAA;A7EkgZR;A6ExgZM;EACE,qCAAA;A7E0gZR;A6ExgZM;;EAEE,WAAA;EACA,yBAAA;A7E0gZR;A6EhhZM;EACE,gCAAA;A7EkhZR;A6EhhZM;;EAEE,WAAA;EACA,yBAAA;A7EkhZR;A6ExhZM;EACE,oCAAA;A7E0hZR;A6ExhZM;;EAEE,WAAA;EACA,yBAAA;A7E0hZR;A6EhiZM;EACE,mCAAA;A7EkiZR;A6EhiZM;;EAEE,WAAA;EACA,yBAAA;A7EkiZR;A6ExiZM;EACE,oCAAA;A7E0iZR;A6ExiZM;;EAEE,WAAA;EACA,yBAAA;A7E0iZR;A6EhjZM;EACE,oCAAA;A7EkjZR;A6EhjZM;;EAEE,WAAA;EACA,yBAAA;A7EkjZR;A6ExjZM;EACE,qCAAA;A7E0jZR;A6ExjZM;;EAEE,WAAA;EACA,yBAAA;A7E0jZR;A6EhkZM;EACE,qCAAA;A7EkkZR;A6EhkZM;;EAEE,WAAA;EACA,yBAAA;A7EkkZR;A6ExkZM;EACE,sCAAA;A7E0kZR;A6ExkZM;;EAEE,WAAA;EACA,yBAAA;A7E0kZR;A6EhlZM;EACE,gCAAA;A7EklZR;A6EhlZM;;EAEE,WAAA;EACA,6BAAA;A7EklZR;;A8EhmZI;;;;;EAGE,SAAA;A9EqmZN;A8ElmZE;EACE,e9EiCa;AAmkZjB;A8EnmZI;EACE,gBAAA;A9EqmZN;;A8E/lZI;EACE,yBAAA;A9EkmZN;;A8EnmZI;EACE,yBAAA;A9EsmZN;;A8EvmZI;EACE,yBAAA;A9E0mZN;;A8E3mZI;EACE,yBAAA;A9E8mZN;;A8E/mZI;EACE,yBAAA;A9EknZN;;A8EnnZI;EACE,yBAAA;A9EsnZN;;A8EvnZI;EACE,yBAAA;A9E0nZN;;A8E3nZI;EACE,yBAAA;A9E8nZN;;A8E/nZI;EACE,yBAAA;A9EkoZN;;A8EnoZI;EACE,yBAAA;A9EsoZN;;A8EvoZI;EACE,yBAAA;A9E0oZN;;A8E3oZI;EACE,6BAAA;A9E8oZN;;A+ElqZA;EACE,yBAAA;EACA,sB/EGM;AAkqZR;;AA/jZA,gDAAA;AgFxGA;EACE,oBAAA;EACA,kBAAA;AhF2qZF;;AgFxqZA;;;;EAME,sBAAA;AhF2qZF;;AgFxqZA;EACE,yBAAA;EACA,cAAA;AhF2qZF;;AgFxqZA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;AhF2qZF;;AgFxqZA;EACE,wCAAA;EACA,YAAA;EACA,cAAA;AhF2qZF;;AgFxqZA;EACE,cAAA;EACA,gBAAA;AhF2qZF;;AgFxqZA;;EAEE,qBAAA;AhF2qZF;;AgFxqZA;EACE,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAGA,qBAAA;AhF2qZF;;AgFxqZA;;EAIE,gBAAA;EACA,SAAA;AhF2qZF;;AgFxqZA;EACE,gCAAA;AhF2qZF;;AgFxqZA;EACE,oBAAA;EACA,gCAAA;AhF2qZF;;AgFxqZA;EACE,aAAA;EAGA,oBAAA;AhF2qZF;;AgFxqZA;EACE,SAAA;EACA,uBAAA;EACA,gBAAA;AhF2qZF;;AgFxqZA;EACE,eAAA;AhF2qZF;;AgFxqZA;;EAEE,eAAA;AhF2qZF;;AgFxqZA;EACE,eAAA;AhF2qZF;;AgFxqZA;EACE,gBAAA;AhF2qZF;;AgFxqZA;;EAEE,UAAA;AhF2qZF;;AgFxqZA;;EAEE,aAAA;AhF2qZF;;AgFxqZA;EACE,YAAA;EACA,gBAAA;AhF2qZF;;AgFxqZA;EACE,kBAAA;AhF2qZF;;AgFxqZA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;AhF2qZF;;AiF5yZA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,oBAAA;AjF+yZF;;AiF5yZA;EACE,YAAA;AjF+yZF;;AiF5yZA;EACE,aAAA;EACA,cAAA;AjF+yZF;;AiF5yZA;EACE,UAAA;EACA,aAAA;AjF+yZF;;AiF5yZA;;;;EAME,sBAAA;AjF+yZF;;AiF5yZA;EACE,SAAA;EACA,SAAA;EACA,aAAA;AjF+yZF;;AiF5yZA;EACE,eAAA;AjF+yZF;;AiF5yZA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AjF+yZF;;AiF5yZA;EACE,eAAA;EACA,gBAAA;AjF+yZF;;AiF5yZA;EACE,yBAAA;AjF+yZF;;AiF5yZA;;EAEE,yBAAA;AjF+yZF;;AiF5yZA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;AjF+yZF;;AiF5yZA;EACE,cAAA;AjF+yZF;;AiF5yZA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;AjF+yZF;;AiF5yZA;EACE,cAAA;AjF+yZF;;AiF5yZA;;;EAGE,cAAA;AjF+yZF;;AiF5yZA;;;EAGE,kBAAA;AjF+yZF;;AiF5yZA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AjF+yZF;;AiF5yZA;EACE,yBAAA;EACA,cAAA;AjF+yZF;;AiF5yZA;;;EAGE,cAAA;AjF+yZF;;AiF5yZA;;EAEE,yBAAA;AjF+yZF;;AiF5yZA;EACE,mBAAA;AjF+yZF;;AiF5yZA;;EAEE,mBAAA;AjF+yZF;;AiF5yZA;EACE,mBAAA;AjF+yZF;;AiF5yZA;;EAEE,mBAAA;AjF+yZF;;AiF5yZA;EACE,mBAAA;EACA,YAAA;AjF+yZF;;AiF5yZA;;EAEE,mBAAA;AjF+yZF;;AiF5yZA;EACE,yBAAA;AjF+yZF;;AkFz8ZA;EACE,cAAA;EACA,kBAAA;AlF48ZF;;AkFz8ZA;;;;EAME,sBAAA;AlF48ZF;;AkFz8ZA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AlF48ZF;;AkFz8ZA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AlF48ZF;;AkFz8ZA;EACE,kBAAA;EACA,uBAAA;EACA,2BAAA;AlF48ZF;;AkFz8ZA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AlF48ZF;;AkFz8ZA;EACE,kBAAA;EACA,uBAAA;EACA,2BAAA;AlF48ZF;;AkFz8ZA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AlF48ZF;;AkFz8ZA;EACE,qBAAA;AlF48ZF;;AmFrgaA;EAME,2BAAA;EACA,8BAAA;EACA,0BAAA;EACA,mDAAA;EACA;;;;GAAA;EAKA,gEAAA;EACA,sEAAA;EACA,4CAAA;EACA,2BAAA;EACA;;;;GAAA;EAKA,6CAAA;EACA,+CAAA;EACA,+CAAA;EACA,8CAAA;EACA,wEAAA;EACA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA,qDAAA;EACA;2EAAA;EAEA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA,0DAAA;EACA,mDAAA;EACA,yDAAA;EACA,2DAAA;EACA,+CAAA;EACA,wDAAA;EACA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA,wDAAA;EACA;;;;GAAA;EAKA;;;;GAAA;EAKA,uBAAA;EACA,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,uDAAA;EACA,+CAAA;EACA,2CAAA;EACA,4CAAA;EACA,mBAAA;EACA,oBAAA;EACA,0EAAA;EACA,sEAAA;EACA;;GAAA;EAGA,mDAAA;EACA,gDAAA;EACA;;GAAA;EAGA,2DAAA;EACA,yDAAA;EACA,uEAAA;EACA,yEAAA;EACA,+DAAA;EACA,2DAAA;EACA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,oBAAA;EACA,8BAAA;EACA,qBAAA;EACA,wDAAA;EACA,+CAAA;EACA,gCAAA;AnFmgaF;AmF5oaI;EACE,0BAAA;AnF8oaN;AmF/oaI;EACE,0BAAA;AnFipaN;AmFlpaI;EACE,0BAAA;AnFopaN;AmFrpaI;EACE,0BAAA;AnFupaN;AmFxpaI;EACE,0BAAA;AnF0paN;AmF3paI;EACE,0BAAA;AnF6paN;AmF9paI;EACE,0BAAA;AnFgqaN;AmFjqaI;EACE,0BAAA;AnFmqaN;AmFpqaI;EACE,0BAAA;AnFsqaN;AmFvqaI;EACE,0BAAA;AnFyqaN;AmF1qaI;EACE,0BAAA;AnF4qaN;AmF7qaI;EACE,8BAAA;AnF+qaN;;AmF/haI;;;;;EACE,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AnFsiaN;AmFliaE;EACE,0DAAA;AnFoiaJ;AmFjiaE;EACE,0DAAA;AnFmiaJ;AmFhiaE;EACE,0DAAA;AnFkiaJ;AmF/haE;EACE,0DAAA;AnFiiaJ;AmF7haI;EACE,yDAAA;EACA,4BAAA;EACA,iCAAA;EACA,0B7E+zB8B;ANguYpC;AmF3haE;EACE,UAAA;AnF6haJ;AmF1haE;EACE,aAAA;AnF4haJ;AmFzhaE;;;;;;EAME,gBAAA;EACA,wCAAA;AnF2haJ;AmFzhaE;;;;;;;;;;;;;;EAcE,iCAAA;AnF2haJ;AmFxhaE;;;;;;;EAOE,kCAAA;AnF0haJ;AmFvhaE;EACE,yCAAA;AnFyhaJ;AmFvhaE;EACE,4BAAA;EACA,0CAAA;EACA,2CAAA;EACA,cAAA;AnFyhaJ;AmFvhaE;EACE,4CAAA;AnFyhaJ;AmFvhaE;EACE,yCAAA;AnFyhaJ;AmFthaE;EACE,0CAAA;AnFwhaJ;AmFrhaE;EACE,0CAAA;AnFuhaJ;AmFphaE;EACE,yCAAA;AnFshaJ;AmFnhaE;EACE,YAAA;AnFqhaJ;AmFnhaE;EACE,UAAA;AnFqhaJ;AmFnhaE;EACE,0DAAA;EACA,sEAAA;AnFqhaJ;AmFnhaE;EACE,gBAAA;AnFqhaJ;AmFnhaE;EACE,YAAA;AnFqhaJ;AmFnhaE;EACE,0DAAA;AnFqhaJ;AmFnhaE;EACE,gBAAA;EACA,eAAA;AnFqhaJ;AmFnhaE;EACE,iBAAA;AnFqhaJ;AmFlhaE;EACE,gBAAA;AnFohaJ;AmFjhaE;EACE,uDAAA;EACA,aAAA;EACA,gFAAA;AnFmhaJ;AmF7gaE;EACE,0DAAA;EACA,8DAAA;AnF+gaJ;AmF7gaE;EACE,UAAA;EACA,mBAAA;EACA,0DAAA;EACA,oDAAA;AnF+gaJ;AmF7gaE;EACE,yCAAA;EACA,4CAAA;AnF+gaJ;AmF7gaE;EACE,2CAAA;EACA,4CAAA;AnF+gaJ;AmF7gaE;EACE,wCAAA;AnF+gaJ;AmF7gaE;EACE,gBAAA;EACA,yDAAA;AnF+gaJ;AmF7gaE;EACE,eAAA;EACA,uDAAA;AnF+gaJ;AmF7gaE;EACE,SAAA;AnF+gaJ;AmF7gaE;EACE,YAAA;EACA,8CAAA;AnF+gaJ;AmF7gaE;EACE,kBAAA;AnF+gaJ;AmF7gaE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kFAAA;AnF+gaJ;AmF1gaE;;;;EAIE,gBAAA;EACA,0CAAA;EACA,gBAAA;AnF4gaJ;AmF1gaE;EACE,oBAAA;AnF4gaJ;AmF1gaE;EACE,qCAAA;AnF4gaJ;AmF1gaE;EACE,4DAAA;AnF4gaJ;AmFzgaE;EACE,2DAAA;AnF2gaJ;AmFxgaE;EACE,gBAAA;AnF0gaJ;AmFvgaE;EACE,eAAA;AnFygaJ;AmFtgaE;EACE,+BAAA;AnFwgaJ;AmFtgaE;EACE,2CAAA;AnFwgaJ;AmFrgaE;EACE,4CAAA;AnFugaJ;AmFpgaE;;;EAGE,yCAAA;AnFsgaJ;AmFpgaE;EACE,UAAA;AnFsgaJ;AmFpgaE;EACE,eAAA;EACA,4DAAA;AnFsgaJ;AmFngaE;EACE,gBAAA;EACA,2DAAA;AnFqgaJ;AmFlgaE;EACE,yCAAA;EACA,gBAAA;AnFogaJ;AmFlgaE;EACE,4CAAA;EACA,aAAA;EACA,gBAAA;AnFogaJ;AmFlgaE;EACE,wEAAA;AnFogaJ;AmFlgaE;EACE,iCAAA;AnFogaJ;AmFjgaE;EACE,gCAAA;AnFmgaJ;AmFhgaE;EACE,eAAA;EACA,eAAA;AnFkgaJ;AmFhgaE;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,8CAAA;AnFkgaJ;AmFhgaE;EACE,iBAAA;AnFkgaJ;AmF//ZE;EACE,gBAAA;AnFigaJ;AmF9/ZE;EACE,uBAAA;EACA,yCAAA;EACA,iCAAA;EACA,4CAAA;AnFggaJ;AmF9/ZE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AnFggaJ;AmF9/ZE;EACE,iBAAA;AnFggaJ;AmF9/ZE;EACE,gBAAA;AnFggaJ;AmF9/ZE;EACE,gBAAA;AnFggaJ;AmF9/ZE;EACE,oBAAA;EACA,gBAAA;EACA,wBAAA;EACA,sCAAA;EACA,8CAAA;EACA,4CAAA;EACA,0DAAA;EACA,eAAA;AnFggaJ;AmF9/ZE;EACE,2CAAA;AnFggaJ;AmF9/ZE;EACE,oCAAA;AnFggaJ;AmF9/ZE;EACE,0CAAA;EACA,2DAAA;EACA,mDAAA;AnFggaJ;AmF9/ZE;EACE,4CAAA;EACA,qCAAA;EACA,8BAAA;AnFggaJ;AmF9/ZE;EACE,YAAA;EACA,SAAA;AnFggaJ;AmF9/ZE;EACE,cAAA;AnFggaJ;AmF9/ZE;EACE,gBAAA;AnFggaJ;AmF9/ZE;EACE,oFAAA;AnFggaJ;AmF7/ZE;EACE,cAAA;EACA,iDAAA;AnF+/ZJ;AmF5/ZE;EACE,eAAA;EACA,gDAAA;AnF8/ZJ;AmF3/ZE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,qEAAA;EACA,sCAAA;AnF6/ZJ;AmF3/ZE;EACE,iCAAA;AnF6/ZJ;AmF3/ZE;EACE,mBAAA;AnF6/ZJ;AmF3/ZE;EACE,sDAAA;AnF6/ZJ;AmF3/ZE;;;EAGE,gBAAA;AnF6/ZJ;AmF3/ZE;EACE,aAAA;AnF6/ZJ;AmF3/ZE;EACE,UAAA;AnF6/ZJ;AmF3/ZE;;;;;;;;;;;;;;;;EAgBE;;;;GAAA;AnFigaJ;AmF3/ZE;;;;;;;;;;;;;;;;EAgBE,kBAAA;EACA,mDAAA;EACA,uDAAA;EACA,eAAA;AnF6/ZJ;AmF3/ZE;EACE;;;;GAAA;AnFigaJ;AmF3/ZE;EACE,oBAAA;EACA,iFAAA;EAKA,gBAAA;AnFy/ZJ;AmFv/ZE;EACE,YAAA;AnFy/ZJ;AmFv/ZE;EACE,gCAAA;AnFy/ZJ;AmFv/ZE;EACE,sCAAA;AnFy/ZJ;AmFv/ZE;EACE,wCAAA;AnFy/ZJ;AmFv/ZE;EACE,kBAAA;AnFy/ZJ;AmFt/ZE;EACE,iBAAA;AnFw/ZJ;AmFr/ZE;EACE,gBAAA;AnFu/ZJ;AmFr/ZE;;EAEE,0BAAA;EACA,eAAA;AnFu/ZJ;AmFr/ZE;;EAEE,6CAAA;AnFu/ZJ;AmFp/ZE;;EAEE,8CAAA;AnFs/ZJ;AmFn/ZE;EACE,aAAA;AnFq/ZJ;AmFn/ZE;EACE,0CAAA;EACA,iCAAA;AnFq/ZJ;AmFl/ZE;EACE,2CAAA;EACA,gCAAA;AnFo/ZJ;AmFj/ZE;EACE,4DAAA;AnFm/ZJ;AmFj/ZE;EACE,iCAAA;AnFm/ZJ;AmFh/ZE;EACE,kCAAA;AnFk/ZJ;AmF/+ZE;EACE,YAAA;EACA,0DAAA;AnFi/ZJ;AmF/+ZE;EACE,4CAAA;AnFi/ZJ;AmF9+ZE;EACE,6CAAA;AnFg/ZJ;AmF7+ZE;EACE,gBAAA;AnF++ZJ;AmF7+ZE;EACE,eAAA;EACA,gCAAA;EACA,mCAAA;AnF++ZJ;AmF7+ZE;EACE,SAAA;AnF++ZJ;AmF7+ZE;;;;EAIE,iBAAA;AnF++ZJ;AmF7+ZE;EACE,iBAAA;AnF++ZJ;AmF7+ZE;EACE,wCAAA;AnF++ZJ;AmF7+ZE;EACE,4BAAA;EACA,gBAAA;AnF++ZJ;AmF7+ZE;;;;EAIE,YAAA;AnF++ZJ;AmF7+ZE;EACE,YAAA;AnF++ZJ;AmF7+ZE;;EAEE,aAAA;AnF++ZJ;AmF7+ZE;;;;EAIE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AnF++ZJ;AmF7+ZE;;;;EAOE,gCAAA;AnF4+ZJ;AmFz+ZE;;;;EAOE,iCAAA;AnFw+ZJ;AmFr+ZE;;;;;;;;EAcE,kBAAA;AnFi+ZJ;AmF99ZE;;;;;;;;EAcE,mBAAA;AnF09ZJ;AmFv9ZE;EACE,kEAAA;AnFy9ZJ;AmFt9ZE;EACE,mEAAA;AnFw9ZJ;AmFr9ZE;;EAEE,mBAAA;AnFu9ZJ;AmFr9ZE;EACE,+DAAA;AnFu9ZJ;AmFr9ZE;;;;EAIE,eAAA;AnFu9ZJ;AmFr9ZE;EACE,yCAAA;AnFu9ZJ;;AmFn9ZA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AnFs9ZF;;AoF1wbA;EACE,WAAA;ApF6wbF;AoF1wbI;EACE,sCpFsDc;EoFpDd,+BpFwFiB;AAmrbvB;AoF1wbM;EACE,+BpFsFe;AAsrbvB;AoFvwbE;EACE,sBAAA;EACA,mC9Em3BoC;E8El3BpC,2DAAA;E7EEA,qBAAA;APwwbJ;AoFrwbE;EACE,wCAAA;EACA,YAAA;EACA,cAAA;ApFuwbJ;AoFpwbE;EACE,UAAA;ApFswbJ;AoFnwbE;EACE,UAAA;EACA,gBAAA;ApFqwbJ;AoFlwbE;EACE,eAAA;ApFowbJ;AoFjwbE;;EAIE,epFtCO;AAuybX;AoF1vbE;EACE,2DAAA;E7ElCA,qBAAA;AP+xbJ;AoFzvbE;EACE,mC9Ey0BoC;E8Ex0BpC,2DAAA;E7ExCA,qBAAA;APoybJ;;AqF/ybI;;EAEE,qB/EgCI;ANkxbV;AqF5ybI;EAEE,cAAA;EACA,WAAA;EACA,sBAAA;ElF2QA,eALI;EkFnQJ,gB/EqlBwB;E+EplBxB,gB/E4lBwB;E+E3lBxB,crFlBK;EqFmBL,sBAAA;EACA,mC/Ew2BkC;E+Ev2BlC,2DAAA;E9ETF,qBAAA;E8EYE,gBAAA;ArF2ybN;AqFxybI;EACE,aAAA;EACA,8BAAA;EACA,2BAAA;ArF0ybN;AqFxybM;EACE,oC/Ei2BgC;ANy8ZxC;AqFvybM;EACE,qBAAA;ArFyybR;AqFtybM;EAEE,qCrFYmB;EqFXnB,UAAA;EAQE,kD/Ey8BwB;ANu1ZlC;AqF5xbM;EAEE,qBrFTc;EqFUd,sBAAA;ArF6xbR;AqF1xbM;EAGE,sCrFZY;AAsybpB;AqFrxbI;EAME,UAAA;EACA,SAAA;ArFkxbN;AqF/wbI;EACE,cAAA;EACA,YAAA;ArFixbN;AqF/wbM;EACE,aAAA;ArFixbR;AqF9wbM;EACE,yDAAA;EACA,4BAAA;EACA,iCAAA;EACA,0B/Ek5B4B;AN83ZpC;AqF7wbM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;ArF+wbR;AqF7wbQ;EACE,eAAA;ArF+wbV;AqF1wbI;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;ArF4wbN;AqFzwbI;EACE,sBAAA;ArF2wbN;AqFzwbM;EAEE,yBAAA;ArF0wbR;AqFvwbM;EACE,yCrFlEmB;AA20b3B;;AsFx4bA;EACI,uBAAA;AtF24bJ;AsFz4bI;EACI,YAAA;AtF24bR;;AA/xbA,oCAAA;AuFhHA;EACE,YAAA;AvFm5bF;;AuFj5bA;EACE,0BAAA;EAEA,aAAA;EACA,sBAAA;EACA,sCAAA;AvFm5bF;;AAzybA,eAAA;AwFlHA;EACE,oBAAA;EACA,WAAA;AxF+5bF;;AwF35bE;EACE,UAAA;EACA,gBAAA;AxF85bJ;AwF55bE;EACE,kBAAA;AxF85bJ;AwF55bE;EACE,aAAA;EACA,cAAA;AxF85bJ;AwF75bI;EACE,YAAA;EACA,WAAA;AxF+5bN;AwF55bE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AxF85bJ;;AwF15bE;EACE,cAAA;AxF65bJ;AwF35bE;EACE,cAAA;EACA,elFqkB0B;ANw1a9B;;AwF15bA;EACE,qBAAA;EACA,iBAAA;AxF65bF;AwF55bE;EACE,iBAAA;AxF85bJ;AwF55bE;EACE,kBAAA;EACA,WAAA;AxF85bJ;;AyF18bA;EACE,aAAA;EACA,sBAAA;AzF68bF;AyF58bE;EACE,sBAAA;AzF88bJ;AyF58bE;EACE,8BAAA;AzF88bJ;AyF78bI;EACE,gBAAA;EACA,mBAAA;AzF+8bN;AyF38bI;EACE,SAAA;AzF68bN;;A0F59bA;EACE,qBAAA;A1F+9bF;;A2F/9bE;EACE,aAAA;EACA,uBAAA;A3Fk+bJ;A2Fh+bE;EACE,YAAA;A3Fk+bJ;A2Fh+bE;EACE,gBAAA;EACA,qBAAA;EACA,0BAAA;A3Fk+bJ;A2Fj+bI;EACE,yCAAA;A3Fm+bN;A2Fj+bI;EACE,yCAAA;A3Fm+bN;;A4F/+bA;EACE,qCAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAN2B;A5Fw/b7B;A4Fj/bE;EACE,qCAAA;EACA,wCAAA;A5Fm/bJ;A4Fj/bE;EACE,gBAAA;A5Fm/bJ;A4Fj/bE;EACE,wCAAA;A5Fm/bJ;;A6FngcE;EACE,wBAAA;A7FsgcJ;;A8FxgcA;EACE,mBAAA;EACA,yBxFUS;EwFTT,qBAAA;A9F2gcF;A8FzgcE;EACE,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;A9F2gcJ;A8FxgcE;EACE,6BAAA;EACA,eAAA;A9F0gcJ;A8FvgcE;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,gCAAA;A9FygcJ;A8FtgcE;EACE,aAAA;A9FwgcJ;A8FrgcE;EACE,mCAAA;EACA,yCAAA;EACA,uDAAA;EACA,aAAA;EACA,WAAA;A9FugcJ;A8FpgcE;EACE,mCAAA;EACA,yCAAA;EACA,uDAAA;EACA,oCAAA;EACA,WAAA;A9FsgcJ;A8FngcE;EACE,oCAAA;A9FqgcJ;A8FlgcE;EACE,cAAA;A9FogcJ;;A8FhgcA;EACE;IACE,UAAA;E9FmgcF;AACF;A+F9jcI;EACI,oCzFu4BgC;EyFt4BhC,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mCzF63BgC;ANmsaxC;A+F/jcQ;EACI,oCzFi4B4B;EyFh4B5B,qBAAA;EACA,uBAAA;A/FikcZ;A+FhkcY;EACI,mBAAA;EACA,sC/F8CI;AAohcpB;A+F9jcI;EACI,gCAAA;A/FgkcR;;AgGllcA;ECgBE,qBAAA;EACA,uBAAA;AjGskcF;AiGnlcI;EAEI,yCAAA;AjGolcR;AiGtlcI;EAEI,wCAAA;AjGulcR;AiGzlcI;EAEI,yCAAA;AjG0lcR;AiG5lcI;EAEI,oCAAA;AjG6lcR;AiG/lcI;EAEI,wCAAA;AjGgmcR;AiGlmcI;EAEI,uCAAA;AjGmmcR;AiGrmcI;EAEI,wCAAA;AjGsmcR;AiGxmcI;EAEI,wCAAA;AjGymcR;AiG3mcI;EAEI,yCAAA;AjG4mcR;AiG9mcI;EAEI,yCAAA;AjG+mcR;AiGjncI;EAEI,0CAAA;AjGkncR;AiGpncI;EAEI,oCAAA;AjGqncR;;AkG3ncA;EACE,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,oBAAA;AlG8ncF;;AmGlocA;EACE,iCAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;AnGqocF;AmGnocE;EACE,qBnGwCW;AA6lcf;AmGlocE;;;EAGE,qBnGkCW;AAkmcf;AmGjocE;EACE,aAAA;EACA,mBAAA;AnGmocJ;AmGjocI;EACE,qBnG4BS;AAumcf;AmG9ncI;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,WnG1BE;EmG2BF,qBnGmBS;EmGlBT,iBnGwCsB;EmGvCtB,kB7F6oC8B;ANm/ZpC;;AmG1ncE;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,YAAA;AnG6ncJ;;AmGzncA;EACE,YAAA;AnG4ncF;;AoG9qcA;EACE,+BAAA;ApGircF;AoG/qcE;EACE,sCAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;ApGircJ;AoG/qcI;EACE,iBAAA;EACA,YAAA;ApGircN;AoG7qcE;EACE,qCAAA;EAEA,WpGZI;EoGaJ,gBAAA;EACA,qEAAA;EACA,aAAA;ApG8qcJ;AoG3qcE;EACE,uBAAA;EACA,0BAAA;EACA,0BAAA;EAEA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;ApG4qcJ;;AoGxqcA;EACE,uBAAA;EACA,0BAAA;EACA,0BAAA;ApG2qcF;;AoGxqcA;EACE,WpGtCM;EoGuCN,sBAAA;ApG2qcF;;AoGxqcA;EACE,wBAAA;ApG2qcF;;AoGxqcA;EACE,YAAA;EACA,gBpG9BO;AAyscT;;AoGxqcA;EACE,mCAAA;ApG2qcF;AoGzqcE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;ApG2qcJ;AoGzqcI;EACE,gCAAA;EACA,cAAA;EACA,eAAA;ApG2qcN;AoGvqcE;EACE,mBAAA;ApGyqcJ;;AqGtvcA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;ArGyvcF;;AsG7vcA;EACE,sBAAA;AtGgwcF;AsG/vcE;EACE,kBAAA;AtGiwcJ;AuG/vcM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGiwcR;AuGzwcM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvG2wcR;AuGnxcM;EACE,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGqxcR;AuG7xcM;EACE,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvG+xcR;AuGvycM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGyycR;AuGjzcM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGmzcR;AuG3zcM;EACE,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvG6zcR;AuGr0cM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGu0cR;AuG/0cM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGi1cR;AuGz1cM;EACE,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvG21cR;AuGn2cM;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvGq2cR;AuG72cM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AvG+2cR;AsGn3cI;EACE,mBAAA;AtGq3cN;;AwG/3cA;EzEgEE,4BAAA;EACA,4BAAA;E5B8NI,4BALI;E4BvNR,gCAAA;A/Bm0cF;;AyGt4cA;EACE,aAAA;EACA,mBAAA;AzGy4cF;AyGx4cE;EACE,wBAAA;EACA,sBAAA;EACA,czGCO;EyGAP,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AzG04cJ;AyGx4cE;EACE,mBAAA;AzG04cJ;;A0Gt5cE;EACE,WAAA;EACA,YAAA;A1Gy5cJ;A0Gv5cE;EACE,UAAA;A1Gy5cJ;;A2G/5cA;EACE,iBAAA;A3Gk6cF;;A4Gj6cA;EACE,iBAAA;EACA,8BAAA;EXYA,wBAAA;EACA,0BAAA;EWXA,kBAAA;A5Gq6cF;AiGv6cI;EAEI,4CAAA;AjGw6cR;AiG16cI;EAEI,2CAAA;AjG26cR;AiG76cI;EAEI,4CAAA;AjG86cR;AiGh7cI;EAEI,uCAAA;AjGi7cR;AiGn7cI;EAEI,2CAAA;AjGo7cR;AiGt7cI;EAEI,0CAAA;AjGu7cR;AiGz7cI;EAEI,2CAAA;AjG07cR;AiG57cI;EAEI,2CAAA;AjG67cR;AiG/7cI;EAEI,4CAAA;AjGg8cR;AiGl8cI;EAEI,4CAAA;AjGm8cR;AiGr8cI;EAEI,6CAAA;AjGs8cR;AiGx8cI;EAEI,uCAAA;AjGy8cR;A4Gx8cE;EACE,kBAAA;A5G08cJ;A4Gv8cI;EACE,WAAA;EACA,0CAAA;EACA,6BAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;A5Gy8cN;A4Gr8cI;EACE,UAAA;A5Gu8cN;AuG19cM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvG49cR;AuGp+cM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGs+cR;AuG9+cM;EACE,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGg/cR;AuGx/cM;EACE,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvG0/cR;AuGlgdM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGogdR;AuG5gdM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvG8gdR;AuGthdM;EACE,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGwhdR;AuGhidM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGkidR;AuG1idM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvG4idR;AuGpjdM;EACE,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGsjdR;AuG9jdM;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvGgkdR;AuGxkdM;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;AvG0kdR;;A4GzjdA;EACE;IACE,aAAA;IACA,2DAAA;IACA,gBAAA;IACA,kBAAA;E5G4jdF;E4G1jdE;IACE,YAAA;E5G4jdJ;E4GzjdE;IACE,iBAAA;E5G2jdJ;AACF;A6GtmdA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,0CAAA;EACA,wBAAA;EACA,qB7GsCa;E6GrCb,gBAAA;A7GwmdF;A6GvmdE;EACE,qB7GuCW;E6GtCX,YAAA;A7GymdJ;A6GvmdE;EACE,oCAAA;EACA,2BAAA;EACA,uCAAA;A7GymdJ;A6GvmdE;EACE,UAAA;A7GymdJ;;A8G5ndA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A9G+ndF;;A+GnodA;EACE,YAAA;A/GsodF;;AgHvodA;EACE,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AhH0odF;AiG1odI;EAKI,qCAAA;AjGwodR;AiG7odI;EAKI,oCAAA;AjG2odR;AiGhpdI;EAKI,qCAAA;AjG8odR;AiGnpdI;EAKI,gCAAA;AjGipdR;AiGtpdI;EAKI,oCAAA;AjGopdR;AiGzpdI;EAKI,mCAAA;AjGupdR;AiG5pdI;EAKI,oCAAA;AjG0pdR;AiG/pdI;EAKI,oCAAA;AjG6pdR;AiGlqdI;EAKI,qCAAA;AjGgqdR;AiGrqdI;EAKI,qCAAA;AjGmqdR;AiGxqdI;EAKI,sCAAA;AjGsqdR;AiG3qdI;EAKI,gCAAA;AjGyqdR;;AiHlrdA;EACE,aAAA;EACA,mBAAA;AjHqrdF;;AkHrrdA;EACE,qBAAA;EACA,qBAAA;EACA,gCAAA;EACA,gCAAA;AlHwrdF;AkHvrdE;EACE,qBAAA;AlHyrdJ;AkHvrdE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBlHgFc;AAymdlB;AkHvrdE;EAIE,qCAAA;AlHsrdJ;AkHprdE;EACE,cAAA;AlHsrdJ;AkHprdE;EACE,cAAA;EACA,mB5G4kB0B;AN0mc9B;AkHrrdI;EACE,eAAA;AlHurdN;AkHrrdI;EACE,kBAAA;AlHurdN;AkHrrdI;;EAEE,gBAAA;AlHurdN;AkHrrdI;EACE,cAAA;EACA,sBAAA;AlHurdN;AkHrrdI;EACE,6DAAA;EACA,8DAAA;AlHurdN;AkHrrdI;EACE,mBAAA;EACA,qBAAA;EjBhCJ,qBAAA;EACA,uBAAA;AjGwtdF;AiGrudI;EAEI,yCAAA;AjGsudR;AiGxudI;EAEI,wCAAA;AjGyudR;AiG3udI;EAEI,yCAAA;AjG4udR;AiG9udI;EAEI,oCAAA;AjG+udR;AiGjvdI;EAEI,wCAAA;AjGkvdR;AiGpvdI;EAEI,uCAAA;AjGqvdR;AiGvvdI;EAEI,wCAAA;AjGwvdR;AiG1vdI;EAEI,wCAAA;AjG2vdR;AiG7vdI;EAEI,yCAAA;AjG8vdR;AiGhwdI;EAEI,yCAAA;AjGiwdR;AiGnwdI;EAEI,0CAAA;AjGowdR;AiGtwdI;EAEI,oCAAA;AjGuwdR;AkH3tdM;EACE,oBAAA;AlH6tdR;AkHztdE;EjBvCA,qBAAA;EACA,uBAAA;AjGmwdF;AiGhxdI;EAEI,yCAAA;AjGixdR;AiGnxdI;EAEI,wCAAA;AjGoxdR;AiGtxdI;EAEI,yCAAA;AjGuxdR;AiGzxdI;EAEI,oCAAA;AjG0xdR;AiG5xdI;EAEI,wCAAA;AjG6xdR;AiG/xdI;EAEI,uCAAA;AjGgydR;AiGlydI;EAEI,wCAAA;AjGmydR;AiGrydI;EAEI,wCAAA;AjGsydR;AiGxydI;EAEI,yCAAA;AjGyydR;AiG3ydI;EAEI,yCAAA;AjG4ydR;AiG9ydI;EAEI,0CAAA;AjG+ydR;AiGjzdI;EAEI,oCAAA;AjGkzdR;AmHvzdE;EACE,mBAAA;AnHyzdJ;AmHxzdI;EACE,gBAAA;AnH0zdN;AkHnwdE;EACE,mBAAA;AlHqwdJ;AkHjwdM;;;;;;;EAIE,eAAA;AlHswdR;AkHnwdI;EACE,eAAA;AlHqwdN;AiGz0dI;EAKI,qCAAA;AjGu0dR;AiG50dI;EAKI,oCAAA;AjG00dR;AiG/0dI;EAKI,qCAAA;AjG60dR;AiGl1dI;EAKI,gCAAA;AjGg1dR;AiGr1dI;EAKI,oCAAA;AjGm1dR;AiGx1dI;EAKI,mCAAA;AjGs1dR;AiG31dI;EAKI,oCAAA;AjGy1dR;AiG91dI;EAKI,oCAAA;AjG41dR;AiGj2dI;EAKI,qCAAA;AjG+1dR;AiGp2dI;EAKI,qCAAA;AjGk2dR;AiGv2dI;EAKI,sCAAA;AjGq2dR;AiG12dI;EAKI,gCAAA;AjGw2dR;AkHrydE;EACE,YAAA;AlHuydJ;AkHrydE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AlHuydJ;AkHpydI;EACE,qCAAA;EACA,mBAAA;EACA,uBAAA;AlHsydN;AmH73dE;EACE,mBAAA;AnH+3dJ;AmH93dI;EACE,gBAAA;AnHg4dN;;AkHrydE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;AlHwydJ;AkHtydE;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AlHwydJ;AkHvydI;EACE,UAAA;AlHyydN;AkHvydI;EACE,WAAA;AlHyydN;;AkHlydI;;EAEE,yBAAA;AlHqydN;;AkHvydI;;EAEE,yBAAA;AlH0ydN;;AkH5ydI;;EAEE,yBAAA;AlH+ydN;;AkHjzdI;;EAEE,yBAAA;AlHozdN;;AkHtzdI;;EAEE,yBAAA;AlHyzdN;;AkH3zdI;;EAEE,yBAAA;AlH8zdN;;AkHh0dI;;EAEE,yBAAA;AlHm0dN;;AkHr0dI;;EAEE,yBAAA;AlHw0dN;;AkH10dI;;EAEE,yBAAA;AlH60dN;;AkH/0dI;;EAEE,yBAAA;AlHk1dN;;AkHp1dI;;EAEE,yBAAA;AlHu1dN;;AkHz1dI;;EAEE,6BAAA;AlH41dN;;AoHv9dA;EACE,iBAAA;EACA,oC9Gu4BsC;E8Gt4BtC,mBAAA;EACA,iBAAA;EACA,qBpH4DoB;EoH3DpB,sCpHqDkB;AAq6dpB;;AqHh+dA;EACE,sBAAA;EACA,2BAAA;ArHm+dF;AqHj+dE;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ArHm+dJ;AqHj+dE;EACE,aAAA;ArHm+dJ;AqHj+dE;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBrHZI;EqHaJ,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;ArHm+dJ;AqHj+dE;EACE,kBAAA;ArHm+dJ;AqHl+dI;EACE,SAAA;EACA,QAAA;ArHo+dN;AqHn+dM;EACE,YAAA;EACA,WAAA;ArHq+dR;AqHl+dI;EACE,UAAA;EACA,SAAA;EACA,qBAAA;ArHo+dN;AqHn+dM;EACE,YAAA;EACA,WAAA;ArHq+dR;AqHl+dI;EACE,UAAA;EACA,SAAA;ArHo+dN;AqHn+dM;EACE,YAAA;EACA,WAAA;ArHq+dR;;AsHrheA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AtHwheF;AsHtheE;EACE,uBAAA;AtHwheJ;AsHrheE;EACE,2BAAA;AtHuheJ;AsHrheI;EAEE,qBAAA;AtHsheN;AsHpheM;EACE,gBAAA;AtHsheR","sourcesContent":["@use \"sass:color\";\n@use \"sass:math\";\n\n/* bootstrap vars */\n/* colors */\n$white: #fff;\n$black: #000;\n$gray-900: #212529 !default;\n\n$theme-colors: (\n  \"primary\": #2495cf,\n  \"danger\": #fd6060,\n  \"warning\": #f5e252,\n  \"success\": #6ee86e,\n  \"secondary\": #337ab7,\n  \"dark\": #4f5659,\n  \"preparation\": #aab9bf,\n  \"step\": #68d47f,\n  \"action\": #6dc5f2,\n  \"condition\": #ebce6a,\n  \"white\": #ffffff,\n  \"transparent\": transparent,\n);\n\n$spacer: 0.75rem;\n$spacers: (\n  0: 0,\n  1: math.div($spacer, 4),\n  2: math.div($spacer, 2),\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 2.25,\n  6: $spacer * 3.375,\n);\n\n/* general functions */\n@import \"~bootstrap/scss/_functions\";\n@import \"base/mixins/colors\";\n@import \"base/mixins/backgrounds\";\n@import \"base/mixins/borders\";\n@import \"base/mixins/spacing\";\n$body-color: $gray-900 !default;\n$color-contrast-dark: $black;\n$color-contrast-light: $white;\n$font-size-root: 13px;\n$font-size-lg: 1.07692rem;\n$h6-font-size: 1rem;\n$h5-font-size: $font-size-lg;\n$h4-font-size: 1.23077rem;\n$h3-font-size: 1.38462rem;\n$h2-font-size: 1.61538rem;\n$h1-font-size: 1.84615rem;\n$body-bg: $white;\n$min-contrast-ratio: 2.5;\n$input-color: $body-color !default;\n$input-btn-padding-x: 0.6rem;\n$input-btn-padding-y: 0.2rem;\n$input-btn-padding-x-lg: 0.8rem;\n$input-btn-padding-y-lg: 0.3rem;\n$input-disabled-bg: tint-color(color(\"preparation\"), 80%);\n$component-active-bg: color(\"primary\");\n$input-focus-border-color: color.change(color(\"primary\"), $alpha: 0.3);\n$modal-backdrop-bg: $body-bg;\n$modal-backdrop-opacity: 0.9;\n$form-label-font-weight: 500;\n$input-border-radius: 0.3rem;\n\n$card-border-radius: 0.5rem;\n$card-cap-bg: tint-color(color(\"preparation\"), 30%);\n$card-border-color: shade-color($card-cap-bg, 30%);\n$modal-md: 400px;\n$modal-header-padding-x: 0.75rem;\n$modal-header-padding-y: 0.35rem;\n$navbar-nav-link-padding-x: 1rem;\n$navbar-brand-font-size: $h2-font-size;\n$navbar-dark-color: $color-contrast-light;\n$toast-background-color: $body-bg;\n$toast-border-radius: $card-border-radius;\n$toast-padding-x: 1rem;\n$toast-padding-y: 0.75rem;\n$tooltip-bg: $body-color; //inject colot to define arrow-color\n$tooltip-color: $body-color;\n$tooltip-max-width: 100%;\n\n/* fort awesome svg icons for background image values */\n$svg-filter-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z'></path></svg>\");\n$svg-bars-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z'></path></svg>\");\n$svg-sort-down-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z'></path></svg>\");\n$svg-sort-up-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z'></path></svg>\");\n\n/* import bootstrap to set changes */\n@import \"~bootstrap/scss/bootstrap\";\n\n/* component vars */\n$max-label-width: 30rem;\n$input-disabled-color: tint-color($input-color, 40%);\n\n/* overwrite bootstrap standard behaviour */\n@import \"base/bootstrap_overwrite/reboot\";\n@import \"base/bootstrap_overwrite/btn\";\n@import \"base/bootstrap_overwrite/form-control\";\n@import \"base/bootstrap_overwrite/modal\";\n@import \"base/bootstrap_overwrite/toast\";\n@import \"base/bootstrap_overwrite/tooltip\";\n/* styling for components from other libraries */\n@import \"node_modules/react-datetime-picker/dist/DateTimePicker\";\n@import \"node_modules/react-calendar/dist/Calendar\";\n@import \"node_modules/react-clock/dist/Clock\";\n@import \"base/other_libraries_overwrite/ag-grid\";\n@import \"base/other_libraries_overwrite/react-datetime-picker\";\n@import \"base/other_libraries_overwrite/react_select\";\n@import \"base/other_libraries_overwrite/react-dnd\";\n/* styling for generic page layout */\n@import \"layout\";\n/* components */\n@import \"components/reactions/ReactionNavbar\";\n@import \"components/activities/Activity\";\n@import \"components/activities/ActivityCreator\";\n@import \"components/activities/ActivityInfo\";\n@import \"components/activities/ConditionCard\";\n@import \"components/activities/ConditionForm\";\n@import \"components/activities/InsertZone\";\n@import \"components/activities/purification/FiltrationStepForm\";\n@import \"components/activities/timing/Timer\";\n@import \"components/layout/GlobalNotification\";\n@import \"components/layout/MainHeader\";\n@import \"components/ontologies/OntologiesEditor\";\n@import \"components/samples/SampleMoleculeImage\";\n@import \"components/utilities/AmountInput\";\n@import \"components/utilities/CardHeaderLabelButton\";\n@import \"components/utilities/CreateButton\";\n@import \"components/utilities/DurationSelection\";\n@import \"components/utilities/FormButtons\";\n@import \"components/utilities/FormSection\";\n@import \"components/utilities/IconButton\";\n@import \"components/utilities/CircleButton\";\n@import \"components/utilities/Label\";\n@import \"components/utilities/MultiInputFormGroup\";\n@import \"components/utilities/MetricsInputFormGroup\";\n@import \"components/utilities/ProcedureCard\";\n@import \"components/utilities/SampleSelection\";\n@import \"components/utilities/SpinnerWithMessage\";\n@import \"components/utilities/ActionTypeSelectionPanel\";\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.6 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","ul {\n  padding-left: 0;\n}\nul li {\n  list-style-position: inside;\n}\n","@use \"sass:map\";\n\n.btn {\n  border-width: 1px;\n  border-style: solid;\n}\n\n.btn-group .btn {\n  color: $input-disabled-color;\n  &.active {\n    color: $input-color;\n  }\n}\n@each $color, $value in $theme-colors {\n  @if $color != 'white' and $color != 'transparent' {\n    .btn {\n      &-#{$color} {\n        border-color: border-color($color);\n\n        &:hover {\n          border-color: shade-color($value, 15%);\n        }\n      }\n\n      &-outline-#{$color} {\n        background-color: $body-bg;\n        color: $body-color;\n\n        &:hover {\n          color: $body-color;\n          background-color: tint-color($value, 85%);\n          border-color: shade-color($value, 5%);\n        }\n      }\n    }\n  }\n}\n",".form-control {\n  &:disabled {\n    color: $input-disabled-color !important;\n  }\n}\n","@use \"sass:map\";\n\n.modal {\n  &-dialog {\n    min-height: 75%;\n  }\n  &-header * {\n    margin: calc(var(--bs-modal-footer-gap) * 0.5);\n  }\n\n  @each $color, $value in $theme-colors {\n    &--#{$color} {\n      .modal-content {\n        border-color: border-color($color);\n      }\n      .modal-header,\n      .modal-footer {\n        color: color-contrast($value);\n        background-color: #{$value};\n      }\n    }\n  }\n}\n","@use \"sass:map\";\n\n.toast {\n  &-header {\n    h3,\n    h4,\n    h5 {\n      margin: 0;\n    }\n  }\n  &-body {\n    font-size: $font-size-root;\n    ul {\n      margin-bottom: 0;\n    }\n  }\n}\n@each $color, $value in $theme-colors {\n  .toast--#{$color} {\n    .toast-header {\n      background-color: #{$value};\n    }\n  }\n}\n",".tooltip-inner {\n  border: 1px solid $body-color;\n  background-color: $body-bg;\n}\n",".react-datetime-picker {\n  display: inline-flex;\n  position: relative;\n}\n\n.react-datetime-picker,\n.react-datetime-picker *,\n.react-datetime-picker *:before,\n.react-datetime-picker *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.react-datetime-picker--disabled {\n  background-color: #f0f0f0;\n  color: #6d6d6d;\n}\n\n.react-datetime-picker__wrapper {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  border: thin solid gray;\n}\n\n.react-datetime-picker__inputGroup {\n  min-width: calc(4px + (4px * 3) + 0.54em * 6 + 0.217em * 2);\n  flex-grow: 1;\n  padding: 0 2px;\n}\n\n.react-datetime-picker__inputGroup__divider {\n  padding: 1px 0;\n  white-space: pre;\n}\n\n.react-datetime-picker__inputGroup__divider,\n.react-datetime-picker__inputGroup__leadingZero {\n  display: inline-block;\n}\n\n.react-datetime-picker__inputGroup__input {\n  min-width: 0.54em;\n  height: calc(100% - 2px);\n  position: relative;\n  padding: 1px;\n  border: 0;\n  background: none;\n  color: currentColor;\n  font: inherit;\n  box-sizing: content-box;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.react-datetime-picker__inputGroup__input::-webkit-outer-spin-button,\n.react-datetime-picker__inputGroup__input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.react-datetime-picker__inputGroup__input:invalid {\n  background: rgba(255, 0, 0, 0.1);\n}\n\n.react-datetime-picker__inputGroup__input--hasLeadingZero {\n  margin-left: -0.54em;\n  padding-left: calc(1px + 0.54em);\n}\n\n.react-datetime-picker__inputGroup__amPm {\n  font: inherit;\n  -webkit-appearance: menulist;\n  -moz-appearance: menulist;\n  appearance: menulist;\n}\n\n.react-datetime-picker__button {\n  border: 0;\n  background: transparent;\n  padding: 4px 6px;\n}\n\n.react-datetime-picker__button:enabled {\n  cursor: pointer;\n}\n\n.react-datetime-picker__button:enabled:hover .react-datetime-picker__button__icon,\n.react-datetime-picker__button:enabled:focus .react-datetime-picker__button__icon {\n  stroke: #0078d7;\n}\n\n.react-datetime-picker__button:disabled .react-datetime-picker__button__icon {\n  stroke: #6d6d6d;\n}\n\n.react-datetime-picker__button svg {\n  display: inherit;\n}\n\n.react-datetime-picker__calendar,\n.react-datetime-picker__clock {\n  z-index: 1;\n}\n\n.react-datetime-picker__calendar--closed,\n.react-datetime-picker__clock--closed {\n  display: none;\n}\n\n.react-datetime-picker__calendar {\n  width: 350px;\n  max-width: 100vw;\n}\n\n.react-datetime-picker__calendar .react-calendar {\n  border-width: thin;\n}\n\n.react-datetime-picker__clock {\n  width: 200px;\n  height: 200px;\n  max-width: 100vw;\n  padding: 25px;\n  background-color: white;\n  border: thin solid #a0a096;\n}\n",".react-calendar {\n  width: 350px;\n  max-width: 100%;\n  background: white;\n  border: 1px solid #a0a096;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n}\n\n.react-calendar--doubleView {\n  width: 700px;\n}\n\n.react-calendar--doubleView .react-calendar__viewContainer {\n  display: flex;\n  margin: -0.5em;\n}\n\n.react-calendar--doubleView .react-calendar__viewContainer > * {\n  width: 50%;\n  margin: 0.5em;\n}\n\n.react-calendar,\n.react-calendar *,\n.react-calendar *:before,\n.react-calendar *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.react-calendar button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n\n.react-calendar button:enabled:hover {\n  cursor: pointer;\n}\n\n.react-calendar__navigation {\n  display: flex;\n  height: 44px;\n  margin-bottom: 1em;\n}\n\n.react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n}\n\n.react-calendar__navigation button:disabled {\n  background-color: #f0f0f0;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #e6e6e6;\n}\n\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font: inherit;\n  font-size: 0.75em;\n  font-weight: bold;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n  padding: 0.5em;\n}\n\n.react-calendar__month-view__weekNumbers .react-calendar__tile {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font: inherit;\n  font-size: 0.75em;\n  font-weight: bold;\n}\n\n.react-calendar__month-view__days__day--weekend {\n  color: #d10000;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth,\n.react-calendar__decade-view__years__year--neighboringDecade,\n.react-calendar__century-view__decades__decade--neighboringCentury {\n  color: #757575;\n}\n\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 2em 0.5em;\n}\n\n.react-calendar__tile {\n  max-width: 100%;\n  padding: 10px 6.6667px;\n  background: none;\n  text-align: center;\n  line-height: 16px;\n  font: inherit;\n  font-size: 0.833em;\n}\n\n.react-calendar__tile:disabled {\n  background-color: #f0f0f0;\n  color: #ababab;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth:disabled,\n.react-calendar__decade-view__years__year--neighboringDecade:disabled,\n.react-calendar__century-view__decades__decade--neighboringCentury:disabled {\n  color: #cdcdcd;\n}\n\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background-color: #e6e6e6;\n}\n\n.react-calendar__tile--now {\n  background: #ffff76;\n}\n\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  background: #ffffa9;\n}\n\n.react-calendar__tile--hasActive {\n  background: #76baff;\n}\n\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n  background: #a9d4ff;\n}\n\n.react-calendar__tile--active {\n  background: #006edc;\n  color: white;\n}\n\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #1087ff;\n}\n\n.react-calendar--selectRange .react-calendar__tile--hover {\n  background-color: #e6e6e6;\n}\n",".react-clock {\n  display: block;\n  position: relative;\n}\n\n.react-clock,\n.react-clock *,\n.react-clock *:before,\n.react-clock *:after {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.react-clock__face {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border: 1px solid black;\n  border-radius: 50%;\n}\n\n.react-clock__hand {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  right: 50%;\n}\n\n.react-clock__hand__body {\n  position: absolute;\n  background-color: black;\n  transform: translateX(-50%);\n}\n\n.react-clock__mark {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  right: 50%;\n}\n\n.react-clock__mark__body {\n  position: absolute;\n  background-color: black;\n  transform: translateX(-50%);\n}\n\n.react-clock__mark__number {\n  position: absolute;\n  left: -40px;\n  width: 80px;\n  text-align: center;\n}\n\n.react-clock__second-hand__body {\n  background-color: red;\n}\n","@import \"~ag-grid-community/styles/ag-grid.css\";\n// @import \"~ag-grid-community/styles/ag-theme-kit.css\";\n\n.ag-theme-kit {\n  @each $color, $value in $theme-colors {\n    &--#{$color} {\n      --ag-active-color: #{$value};\n    }\n  }\n  --ag-background-color: #fff;\n  --ag-foreground-color: #181d1f;\n  --ag-border-color: #dddddd;\n  --ag-secondary-border-color: var(--ag-border-color);\n  --ag-header-background-color: color-mix(\n    in srgb,\n    var(--ag-background-color),\n    var(--ag-foreground-color) 2%\n  );\n  --ag-tooltip-background-color: var(--ag-header-background-color);\n  --ag-control-panel-background-color: var(--ag-header-background-color);\n  --ag-subheader-background-color: transparent;\n  --ag-invalid-color: #e02525;\n  --ag-checkbox-unchecked-color: color-mix(\n    in srgb,\n    var(--ag-background-color),\n    var(--ag-foreground-color) 30%\n  );\n  --ag-advanced-filter-join-pill-color: #f08e8d;\n  --ag-advanced-filter-column-pill-color: #a6e194;\n  --ag-advanced-filter-option-pill-color: #f3c08b;\n  --ag-advanced-filter-value-pill-color: #85c0e4;\n  --ag-header-column-resize-handle-color: var(--ag-secondary-border-color);\n  --ag-icon-font-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-foreground-color) 90%\n  );\n  --ag-selected-row-background-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-active-color) 8%\n  );\n  --ag-row-hover-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-active-color) 12%\n  );\n  --ag-column-hover-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-foreground-color) 5%\n  );\n  --ag-input-focus-border-color: var(--ag-active-color);\n  --ag-input-focus-box-shadow: 0 0 0 3px\n    color-mix(in srgb, transparent, var(--ag-input-focus-border-color) 47%);\n  --ag-range-selection-background-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-active-color) 20%\n  );\n  --ag-range-selection-background-color-2: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-active-color) 36%\n  );\n  --ag-range-selection-background-color-3: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-active-color) 49%\n  );\n  --ag-range-selection-background-color-4: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-active-color) 59%\n  );\n  --ag-checkbox-background-color: var(--ag-background-color);\n  --ag-checkbox-checked-color: var(--ag-active-color);\n  --ag-range-selection-border-color: var(--ag-active-color);\n  --ag-secondary-foreground-color: var(--ag-foreground-color);\n  --ag-input-border-color: var(--ag-border-color);\n  --ag-input-border-color-invalid: var(--ag-invalid-color);\n  --ag-disabled-foreground-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-foreground-color) 50%\n  );\n  --ag-chip-background-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-foreground-color) 7%\n  );\n  --ag-chip-border-color: color-mix(\n    in srgb,\n    var(--ag-header-background-color),\n    var(--ag-foreground-color) 13%\n  );\n  --ag-input-disabled-border-color: var(--ag-border-color);\n  --ag-input-disabled-background-color: color-mix(\n    in srgb,\n    var(--ag-background-color),\n    var(--ag-foreground-color) 6%\n  );\n  --ag-modal-overlay-background-color: color-mix(\n    in srgb,\n    transparent,\n    var(--ag-background-color) 66%\n  );\n  --ag-borders: solid 1px;\n  --ag-border-radius: 4px;\n  --ag-wrapper-border-radius: 8px;\n  --ag-borders-side-button: none;\n  --ag-side-button-selected-background-color: transparent;\n  --ag-header-column-resize-handle-display: block;\n  --ag-header-column-resize-handle-width: 2px;\n  --ag-header-column-resize-handle-height: 30%;\n  --ag-grid-size: 8px;\n  --ag-icon-size: 16px;\n  --ag-header-height: calc(var(--ag-font-size) + var(--ag-grid-size) * 4.25);\n  --ag-row-height: calc(var(--ag-font-size) + var(--ag-grid-size) * 3.5);\n  --ag-list-item-height: calc(\n    var(--ag-icon-size) + var(--ag-widget-vertical-spacing)\n  );\n  --ag-column-select-indent-size: var(--ag-icon-size);\n  --ag-set-filter-indent-size: var(--ag-icon-size);\n  --ag-advanced-filter-builder-indent-size: calc(\n    var(--ag-icon-size) + var(--ag-grid-size) * 2\n  );\n  --ag-cell-horizontal-padding: calc(var(--ag-grid-size) * 2);\n  --ag-cell-widget-spacing: calc(var(--ag-grid-size) * 1.5);\n  --ag-widget-container-vertical-padding: calc(var(--ag-grid-size) * 1.5);\n  --ag-widget-container-horizontal-padding: calc(var(--ag-grid-size) * 1.5);\n  --ag-widget-horizontal-spacing: calc(var(--ag-grid-size) * 1.5);\n  --ag-widget-vertical-spacing: calc(var(--ag-grid-size) * 1);\n  --ag-toggle-button-height: 18px;\n  --ag-toggle-button-width: 28px;\n  --ag-toggle-button-border-width: 2px;\n  --ag-font-family: inherit;\n  --ag-font-size: 14px;\n  --ag-icon-font-family: inherit;\n  --ag-tab-min-width: 0;\n  --ag-card-shadow: 0 1px 4px 1px rgba(186, 191, 199, 0.4);\n  --ag-popup-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n  --ag-side-bar-panel-width: 250px;\n}\n.ag-theme-kit {\n  .ag-icon-menu,\n  .ag-icon-asc,\n  .ag-icon-desc,\n  .ag-icon-filter,\n  .ag-icon-small-down {\n    &::before {\n      background-repeat: no-repeat;\n      background-position: center;\n      display: block;\n      width: 16px;\n      height: 16px;\n      content: \"\";\n    }\n  }\n\n  .ag-icon-menu::before {\n    background-image: escape-svg($svg-bars-icon);\n  }\n\n  .ag-icon-asc::before {\n    background-image: escape-svg($svg-sort-down-icon);\n  }\n\n  .ag-icon-desc::before {\n    background-image: escape-svg($svg-sort-up-icon);\n  }\n\n  .ag-icon-filter::before {\n    background-image: escape-svg($svg-filter-icon);\n  }\n\n  .ag-icon-small-down {\n    &::after {\n      background-image: escape-svg($form-select-indicator);\n      background-repeat: no-repeat;\n      background-position: right center;\n      background-size: $form-select-bg-size;\n    }\n  }\n\n  .ag-radio-button-input-wrapper input {\n    opacity: 1;\n  }\n\n  .ag-radio-button-input-wrapper::after {\n    display: none;\n  }\n\n  .ag-filter-toolpanel-header,\n  .ag-filter-toolpanel-search,\n  .ag-status-bar,\n  .ag-header-row,\n  .ag-panel-title-bar-title,\n  .ag-multi-filter-group-title-bar {\n    font-weight: 500;\n    color: var(--ag-header-foreground-color);\n  }\n  input[class^=\"ag-\"]:not([type]),\n  input[class^=\"ag-\"][type=\"text\"],\n  input[class^=\"ag-\"][type=\"number\"],\n  input[class^=\"ag-\"][type=\"tel\"],\n  input[class^=\"ag-\"][type=\"date\"],\n  input[class^=\"ag-\"][type=\"datetime-local\"],\n  textarea[class^=\"ag-\"],\n  .ag-ltr input[class^=\"ag-\"]:not([type]),\n  .ag-ltr input[class^=\"ag-\"][type=\"text\"],\n  .ag-ltr input[class^=\"ag-\"][type=\"number\"],\n  .ag-ltr input[class^=\"ag-\"][type=\"tel\"],\n  .ag-ltr input[class^=\"ag-\"][type=\"date\"],\n  .ag-ltr input[class^=\"ag-\"][type=\"datetime-local\"],\n  .ag-ltr textarea[class^=\"ag-\"] {\n    padding-left: var(--ag-grid-size);\n  }\n\n  .ag-rtl input[class^=\"ag-\"]:not([type]),\n  .ag-rtl input[class^=\"ag-\"][type=\"text\"],\n  .ag-rtl input[class^=\"ag-\"][type=\"number\"],\n  .ag-rtl input[class^=\"ag-\"][type=\"tel\"],\n  .ag-rtl input[class^=\"ag-\"][type=\"date\"],\n  .ag-rtl input[class^=\"ag-\"][type=\"datetime-local\"],\n  .ag-rtl textarea[class^=\"ag-\"] {\n    padding-right: var(--ag-grid-size);\n  }\n\n  .ag-picker-field-wrapper {\n    min-height: calc(var(--ag-grid-size) * 4);\n  }\n  .ag-tab {\n    padding: var(--ag-grid-size);\n    border-left: var(--ag-borders) transparent;\n    border-right: var(--ag-borders) transparent;\n    flex: 1 1 auto;\n  }\n  .ag-tab-selected {\n    background-color: var(--ag-background-color);\n  }\n  .ag-ltr .ag-tab-selected:not(:first-of-type) {\n    border-left-color: var(--ag-border-color);\n  }\n\n  .ag-rtl .ag-tab-selected:not(:first-of-type) {\n    border-right-color: var(--ag-border-color);\n  }\n\n  .ag-ltr .ag-tab-selected:not(:last-of-type) {\n    border-right-color: var(--ag-border-color);\n  }\n\n  .ag-rtl .ag-tab-selected:not(:last-of-type) {\n    border-left-color: var(--ag-border-color);\n  }\n\n  .ag-tab:not(.ag-tab-selected) {\n    opacity: 0.7;\n  }\n  .ag-tab:not(.ag-tab-selected):hover {\n    opacity: 1;\n  }\n  .ag-menu {\n    background-color: var(--ag-control-panel-background-color);\n    color: color-mix(in srgb, transparent, var(--ag-foreground-color) 95%);\n  }\n  .ag-menu.ag-tabs {\n    min-width: 290px;\n  }\n  .ag-menu-option .ag-icon {\n    opacity: 65%;\n  }\n  .ag-menu-header {\n    background-color: var(--ag-control-panel-background-color);\n  }\n  .ag-menu-option {\n    font-weight: 500;\n    cursor: pointer;\n  }\n  .ag-ltr .ag-menu-option-popup-pointer .ag-icon {\n    text-align: right;\n  }\n\n  .ag-rtl .ag-menu-option-popup-pointer .ag-icon {\n    text-align: left;\n  }\n\n  .ag-tabs-header {\n    border-bottom: var(--ag-borders) var(--ag-border-color);\n    display: flex;\n    background-color: color-mix(\n      in srgb,\n      transparent,\n      var(--ag-foreground-color) 5%\n    );\n  }\n  .ag-side-bar {\n    background-color: var(--ag-control-panel-background-color);\n    min-width: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n  }\n  .ag-side-buttons {\n    padding: 0;\n    align-self: stretch;\n    width: calc(var(--ag-icon-size) + var(--ag-grid-size) * 2);\n    background: var(--ag-control-panel-background-color);\n  }\n  .ag-side-button {\n    border-top: var(--ag-borders) transparent;\n    border-bottom: var(--ag-borders) transparent;\n  }\n  .ag-side-button.ag-selected {\n    border-bottom-color: var(--ag-border-color);\n    background-color: var(--ag-background-color);\n  }\n  .ag-side-button.ag-selected:not(:first-of-type) {\n    border-top-color: var(--ag-border-color);\n  }\n  .ag-column-panel-column-select {\n    border-top: none;\n    border-bottom: 1px solid var(--ag-secondary-border-color);\n  }\n  .ag-filter-toolpanel-search {\n    height: initial;\n    margin-top: var(--ag-widget-container-vertical-padding);\n  }\n  .ag-filter-toolpanel-search-input {\n    margin: 0;\n  }\n  .ag-filter-apply-panel {\n    border: none;\n    padding-top: var(--ag-widget-vertical-spacing);\n  }\n  .ag-chart-tabbed-menu-body {\n    position: relative;\n  }\n  .ag-chart-tabbed-menu-body::after {\n    content: \"\";\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 16px;\n    background: linear-gradient(\n      var(--ag-control-panel-background-color),\n      transparent\n    );\n  }\n  .ag-charts-settings-group-title-bar,\n  .ag-charts-data-group-title-bar,\n  .ag-charts-format-top-level-group-title-bar,\n  .ag-charts-settings-group-container {\n    border-top: none;\n    padding: 0 calc(var(--ag-grid-size) * 1.5);\n    font-weight: 500;\n  }\n  .ag-charts-format-top-level-group-item {\n    padding-bottom: 12px;\n  }\n  .ag-charts-settings-group-container {\n    margin-top: calc(var(--ag-grid-size));\n  }\n  .ag-ltr .ag-charts-settings-group-container {\n    padding-right: var(--ag-widget-container-horizontal-padding);\n  }\n\n  .ag-rtl .ag-charts-settings-group-container {\n    padding-left: var(--ag-widget-container-horizontal-padding);\n  }\n\n  .ag-ltr .ag-charts-format-sub-level-group-container {\n    padding-right: 0;\n  }\n\n  .ag-rtl .ag-charts-format-sub-level-group-container {\n    padding-left: 0;\n  }\n\n  .ag-charts-format-top-level-group-toolbar {\n    margin-top: var(--ag-grid-size);\n  }\n  .ag-ltr .ag-charts-format-top-level-group-toolbar {\n    padding-left: calc(var(--ag-grid-size) * 2);\n  }\n\n  .ag-rtl .ag-charts-format-top-level-group-toolbar {\n    padding-right: calc(var(--ag-grid-size) * 2);\n  }\n\n  .ag-charts-settings-group-title-bar,\n  .ag-charts-data-group-title-bar,\n  .ag-charts-format-top-level-group-title-bar {\n    margin-top: calc(var(--ag-grid-size) * 2);\n  }\n  .ag-charts-format-top-level-group-container {\n    padding: 0;\n  }\n  .ag-ltr .ag-charts-format-top-level-group-container {\n    padding-left: 0;\n    padding-right: var(--ag-widget-container-horizontal-padding);\n  }\n\n  .ag-rtl .ag-charts-format-top-level-group-container {\n    padding-right: 0;\n    padding-left: var(--ag-widget-container-horizontal-padding);\n  }\n\n  .ag-charts-format-top-level-group-item {\n    margin-top: calc(var(--ag-grid-size) * 2);\n    margin-bottom: 0;\n  }\n  .ag-chart-mini-thumbnail {\n    background-color: var(--ag-background-color);\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .ag-chart-settings-nav-bar {\n    border-top: var(--ag-borders-secondary) var(--ag-secondary-border-color);\n  }\n  .ag-ltr .ag-group-title-bar-icon {\n    margin-right: var(--ag-grid-size);\n  }\n\n  .ag-rtl .ag-group-title-bar-icon {\n    margin-left: var(--ag-grid-size);\n  }\n\n  .ag-color-picker .ag-picker-field-wrapper {\n    max-width: 55px;\n    min-width: 55px;\n  }\n  .ag-color-picker .ag-picker-field-display {\n    height: 18px;\n    width: 18px;\n    flex: auto 0 0;\n    margin: 6px;\n    border-radius: 2px;\n    border: solid 1px var(--ag-input-border-color);\n  }\n  .ag-ltr .ag-color-picker .ag-picker-field-icon {\n    margin-right: 4px;\n  }\n\n  .ag-rtl .ag-color-picker .ag-picker-field-icon {\n    margin-left: 4px;\n  }\n\n  .ag-charts-format-sub-level-group {\n    border-left: dashed 1px;\n    border-left-color: var(--ag-border-color);\n    padding-left: var(--ag-grid-size);\n    margin-bottom: calc(var(--ag-grid-size) * 2);\n  }\n  .ag-charts-format-sub-level-group-title-bar {\n    padding-top: 0;\n    padding-bottom: 0;\n    background: none;\n    font-weight: 500;\n  }\n  .ag-charts-format-sub-level-group-container {\n    padding-bottom: 0;\n  }\n  .ag-charts-format-sub-level-group-item:last-child {\n    margin-bottom: 0;\n  }\n  .ag-theme-kit.ag-dnd-ghost {\n    font-weight: 500;\n  }\n  .ag-standard-button {\n    font-family: inherit;\n    appearance: none;\n    -webkit-appearance: none;\n    border-radius: var(--ag-border-radius);\n    border: solid 1px var(--ag-input-border-color);\n    background-color: var(--ag-background-color);\n    padding: var(--ag-grid-size) calc(var(--ag-grid-size) * 2);\n    cursor: pointer;\n  }\n  .ag-standard-button:hover {\n    background-color: var(--ag-row-hover-color);\n  }\n  .ag-standard-button:active {\n    border-color: var(--ag-active-color);\n  }\n  .ag-standard-button:disabled {\n    color: var(--ag-disabled-foreground-color);\n    background-color: var(--ag-input-disabled-background-color);\n    border-color: var(--ag-input-disabled-border-color);\n  }\n  .ag-column-drop-cell {\n    border-radius: calc(var(--ag-grid-size) * 3);\n    height: calc(var(--ag-grid-size) * 3);\n    padding: 0 var(--ag-grid-size);\n  }\n  .ag-column-drop-cell-button {\n    min-width: 0;\n    margin: 0;\n  }\n  .ag-column-drop-cell-drag-handle {\n    margin-left: 0;\n  }\n  .ag-column-drop-vertical {\n    min-height: 75px;\n  }\n  .ag-column-drop-vertical-title-bar {\n    padding: var(--ag-widget-container-vertical-padding)\n      calc(var(--ag-grid-size) * 2) 0;\n  }\n  .ag-ltr .ag-column-drop-vertical-icon {\n    margin-left: 0;\n    margin-right: var(--ag-widget-horizontal-spacing);\n  }\n\n  .ag-rtl .ag-column-drop-vertical-icon {\n    margin-right: 0;\n    margin-left: var(--ag-widget-horizontal-spacing);\n  }\n\n  .ag-column-drop-vertical-empty-message {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: dashed 1px;\n    border-color: var(--ag-border-color);\n    margin: calc(var(--ag-grid-size) * 1.5) calc(var(--ag-grid-size) * 2);\n    padding: calc(var(--ag-grid-size) * 2);\n  }\n  .ag-column-drop-empty-message {\n    color: var(--ag-foreground-color);\n  }\n  .ag-status-bar {\n    font-weight: normal;\n  }\n  .ag-status-name-value {\n    padding: var(--ag-widget-container-vertical-padding) 0;\n  }\n  .ag-status-name-value-value,\n  .ag-paging-number,\n  .ag-paging-row-summary-panel-number {\n    font-weight: 500;\n  }\n  .ag-column-drop-cell-button {\n    opacity: 0.75;\n  }\n  .ag-column-drop-cell-button:hover {\n    opacity: 1;\n  }\n  .ag-header-cell-menu-button,\n  .ag-panel-title-bar-button,\n  .ag-header-expand-icon,\n  .ag-column-group-icons,\n  .ag-set-filter-group-icons,\n  .ag-group-expanded .ag-icon,\n  .ag-group-contracted .ag-icon,\n  .ag-chart-settings-prev,\n  .ag-chart-settings-next,\n  .ag-group-title-bar-icon,\n  .ag-column-select-header-icon,\n  .ag-floating-filter-button-button,\n  .ag-filter-toolpanel-expand,\n  .ag-panel-title-bar-button-icon,\n  .ag-chart-menu-icon,\n  .ag-chart-menu-close {\n    --ag-quartz-icon-hover-color: color-mix(\n      in srgb,\n      transparent,\n      var(--ag-foreground-color) 10%\n    );\n  }\n  .ag-header-cell-menu-button:hover,\n  .ag-panel-title-bar-button:hover,\n  .ag-header-expand-icon:hover,\n  .ag-column-group-icons:hover,\n  .ag-set-filter-group-icons:hover,\n  .ag-group-expanded .ag-icon:hover,\n  .ag-group-contracted .ag-icon:hover,\n  .ag-chart-settings-prev:hover,\n  .ag-chart-settings-next:hover,\n  .ag-group-title-bar-icon:hover,\n  .ag-column-select-header-icon:hover,\n  .ag-floating-filter-button-button:hover,\n  .ag-filter-toolpanel-expand:hover,\n  .ag-panel-title-bar-button-icon:hover,\n  .ag-chart-menu-icon:hover,\n  .ag-chart-menu-close:hover {\n    border-radius: 1px;\n    background-color: var(--ag-quartz-icon-hover-color);\n    box-shadow: 0 0 0 4px var(--ag-quartz-icon-hover-color);\n    cursor: pointer;\n  }\n  .ag-chart-menu-close {\n    --ag-quartz-icon-hover-color: color-mix(\n      in srgb,\n      var(--ag-background-color),\n      var(--ag-foreground-color) 10%\n    );\n  }\n  .ag-chart-menu {\n    --ag-icon-size: 20px;\n    background-color: color-mix(\n      in srgb,\n      transparent,\n      var(--ag-background-color) 30%\n    );\n    padding: 4px 2px;\n  }\n  .ag-chart-menu-icon {\n    opacity: 0.8;\n  }\n  .ag-drag-handle {\n    color: var(--ag-icon-font-color);\n  }\n  .ag-chart-menu-close {\n    background: var(--ag-background-color);\n  }\n  .ag-chart-menu-close .ag-icon {\n    border: 1px solid var(--ag-border-color);\n  }\n  .ag-ltr .ag-chart-menu-close .ag-icon {\n    border-right: none;\n  }\n\n  .ag-rtl .ag-chart-menu-close .ag-icon {\n    border-left: none;\n  }\n\n  .ag-chart-docked-container {\n    min-width: 260px;\n  }\n  .ag-menu-option-icon,\n  .ag-compact-menu-option-icon {\n    width: var(--ag-icon-size);\n    cursor: pointer;\n  }\n  .ag-ltr .ag-menu-option-icon,\n  .ag-ltr .ag-compact-menu-option-icon {\n    padding-left: calc(var(--ag-grid-size) * 1.5);\n  }\n\n  .ag-rtl .ag-menu-option-icon,\n  .ag-rtl .ag-compact-menu-option-icon {\n    padding-right: calc(var(--ag-grid-size) * 1.5);\n  }\n\n  .ag-chart-settings-card-item.ag-not-selected:hover {\n    opacity: 0.35;\n  }\n  .ag-ltr .ag-panel-title-bar-button {\n    margin-left: calc(var(--ag-grid-size) * 2);\n    margin-right: var(--ag-grid-size);\n  }\n\n  .ag-rtl .ag-panel-title-bar-button {\n    margin-right: calc(var(--ag-grid-size) * 2);\n    margin-left: var(--ag-grid-size);\n  }\n\n  .ag-multi-filter-group-title-bar {\n    padding: calc(var(--ag-grid-size) * 1.5) var(--ag-grid-size);\n  }\n  .ag-ltr .ag-filter-toolpanel-group-container {\n    padding-left: var(--ag-grid-size);\n  }\n\n  .ag-rtl .ag-filter-toolpanel-group-container {\n    padding-right: var(--ag-grid-size);\n  }\n\n  .ag-filter-toolpanel-instance-filter {\n    border: none;\n    background-color: var(--ag-control-panel-background-color);\n  }\n  .ag-ltr .ag-filter-toolpanel-instance-filter {\n    margin-left: calc(var(--ag-icon-size) * 0.5);\n  }\n\n  .ag-rtl .ag-filter-toolpanel-instance-filter {\n    margin-right: calc(var(--ag-icon-size) * 0.5);\n  }\n\n  .ag-filter-toolpanel-group-level-0 {\n    border-top: none;\n  }\n  .ag-filter-toolpanel-header {\n    height: initial;\n    padding-top: var(--ag-grid-size);\n    padding-bottom: var(--ag-grid-size);\n  }\n  .ag-filter-toolpanel-group-item {\n    margin: 0;\n  }\n  .ag-layout-auto-height .ag-center-cols-viewport,\n  .ag-layout-auto-height .ag-center-cols-container,\n  .ag-layout-print .ag-center-cols-viewport,\n  .ag-layout-print .ag-center-cols-container {\n    min-height: 150px;\n  }\n  .ag-overlay-no-rows-wrapper.ag-layout-auto-height {\n    padding-top: 60px;\n  }\n  .ag-date-time-list-page-entry-is-current {\n    background-color: var(--ag-active-color);\n  }\n  .ag-advanced-filter-builder-button {\n    padding: var(--ag-grid-size);\n    font-weight: 600;\n  }\n  .ag-advanced-filter-builder-item-button-disabled .ag-icon,\n  .ag-disabled .ag-icon,\n  .ag-column-select-column-group-readonly .ag-icon,\n  [disabled] .ag-icon {\n    opacity: 0.6;\n  }\n  .ag-icon-grip {\n    opacity: 0.7;\n  }\n  .ag-column-select-column-readonly.ag-icon-grip,\n  .ag-column-select-column-readonly .ag-icon-grip {\n    opacity: 0.35;\n  }\n  .ag-column-select-header-filter-wrapper .ag-input-wrapper::before,\n  .ag-filter-toolpanel-search .ag-input-wrapper::before,\n  .ag-mini-filter .ag-input-wrapper::before,\n  .ag-filter-filter .ag-input-wrapper::before {\n    position: absolute;\n    display: block;\n    width: 12px;\n    height: 12px;\n    background-image: url(\"data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==\");\n    background-position: 50% 50%;\n    background-size: contain;\n    opacity: 40%;\n    content: \"\";\n    filter: var(--ag-icon-filter);\n  }\n  .ag-theme-kit\n    .ag-ltr\n    .ag-column-select-header-filter-wrapper\n    .ag-input-wrapper::before,\n  .ag-ltr .ag-filter-toolpanel-search .ag-input-wrapper::before,\n  .ag-ltr .ag-mini-filter .ag-input-wrapper::before,\n  .ag-ltr .ag-filter-filter .ag-input-wrapper::before {\n    margin-left: var(--ag-grid-size);\n  }\n\n  .ag-theme-kit\n    .ag-rtl\n    .ag-column-select-header-filter-wrapper\n    .ag-input-wrapper::before,\n  .ag-rtl .ag-filter-toolpanel-search .ag-input-wrapper::before,\n  .ag-rtl .ag-mini-filter .ag-input-wrapper::before,\n  .ag-rtl .ag-filter-filter .ag-input-wrapper::before {\n    margin-right: var(--ag-grid-size);\n  }\n\n  .ag-theme-kit\n    .ag-ltr\n    .ag-column-select-header-filter-wrapper\n    input.ag-text-field-input,\n  .ag-theme-kit\n    .ag-ltr\n    .ag-column-select-header-filter-wrapper\n    input.ag-number-field-input,\n  .ag-ltr .ag-filter-toolpanel-search input.ag-text-field-input,\n  .ag-ltr .ag-filter-toolpanel-search input.ag-number-field-input,\n  .ag-ltr .ag-mini-filter input.ag-text-field-input,\n  .ag-ltr .ag-mini-filter input.ag-number-field-input,\n  .ag-ltr .ag-filter-filter input.ag-text-field-input,\n  .ag-ltr .ag-filter-filter input.ag-number-field-input {\n    padding-left: 26px;\n  }\n\n  .ag-theme-kit\n    .ag-rtl\n    .ag-column-select-header-filter-wrapper\n    input.ag-text-field-input,\n  .ag-theme-kit\n    .ag-rtl\n    .ag-column-select-header-filter-wrapper\n    input.ag-number-field-input,\n  .ag-rtl .ag-filter-toolpanel-search input.ag-text-field-input,\n  .ag-rtl .ag-filter-toolpanel-search input.ag-number-field-input,\n  .ag-rtl .ag-mini-filter input.ag-text-field-input,\n  .ag-rtl .ag-mini-filter input.ag-number-field-input,\n  .ag-rtl .ag-filter-filter input.ag-text-field-input,\n  .ag-rtl .ag-filter-filter input.ag-number-field-input {\n    padding-right: 26px;\n  }\n\n  .ag-ltr .ag-column-select-add-group-indent {\n    margin-left: calc(var(--ag-icon-size) + var(--ag-grid-size) * 1.5);\n  }\n\n  .ag-rtl .ag-column-select-add-group-indent {\n    margin-right: calc(var(--ag-icon-size) + var(--ag-grid-size) * 1.5);\n  }\n\n  .ag-text-field-input[disabled],\n  .ag-menu-option-disabled {\n    cursor: not-allowed;\n  }\n  .ag-checkbox-input-wrapper.ag-checked.ag-disabled {\n    --ag-checkbox-checked-color: var(--ag-checkbox-unchecked-color);\n  }\n  .ag-checkbox-input,\n  .ag-toggle-button-input,\n  .ag-radio-button-input,\n  input[class^=\"ag-\"][type=\"range\"] {\n    cursor: pointer;\n  }\n  .ag-details-row {\n    padding: calc(var(--ag-grid-size) * 3.75);\n  }\n}\n\n.ag-cell .btn {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n",".react-datetime-picker--overwrite {\n  width: 100%;\n\n  &.react-datetime-picker--disabled {\n    .react-datetime-picker__wrapper {\n      background-color: $input-disabled-bg;\n      border-color: $input-disabled-border-color;\n      color: $input-disabled-color;\n      input {\n        color: $input-disabled-color;\n      }\n    }\n  }\n\n  .react-datetime-picker__wrapper {\n    padding: $input-padding-y $input-padding-x;\n    background-color: $input-bg;\n    border: $input-border-width solid $input-border-color;\n    @include border-radius($input-border-radius, 0);\n    @include box-shadow($input-box-shadow);\n  }\n\n  .react-datetime-picker__inputGroup {\n    min-width: calc(4px + (4px * 3) + 0.54em * 6 + 0.217em * 2);\n    flex-grow: 1;\n    padding: 0 2px;\n  }\n\n  .react-datetime-picker__inputGroup__divider {\n    padding: 0;\n  }\n\n  .react-datetime-picker__button {\n    padding: 0;\n    margin-left: 8px;\n  }\n\n  .react-datetime-picker__button:enabled {\n    cursor: pointer;\n  }\n\n  .react-datetime-picker__button:enabled:hover\n    .react-datetime-picker__button__icon,\n  .react-datetime-picker__button:enabled:focus\n    .react-datetime-picker__button__icon {\n    stroke: $input-focus-color;\n  }\n\n  .react-datetime-picker__button:disabled .react-datetime-picker__button__icon {\n    stroke: $input-disabled-border-color;\n  }\n\n  .react-datetime-picker__calendar .react-calendar {\n    border: $input-border-width solid $input-border-color;\n    @include border-radius($input-border-radius, 0);\n  }\n\n  .react-datetime-picker__clock {\n    background-color: $input-bg;\n    border: $input-border-width solid $input-border-color;\n    @include border-radius($input-border-radius, 0);\n  }\n}\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.react-select--overwrite {\n  &.is-invalid {\n\n    .react-select__control,\n    .react-select__control:hover {\n      border-color: $danger;\n    }\n  }\n\n  .react-select {\n\n    &__control,\n    &__menu {\n      display: block;\n      width: 100%;\n      padding: $form-select-padding-y $form-select-padding-x;\n      font-family: $form-select-font-family;\n      @include font-size($form-select-font-size);\n      font-weight: $form-select-font-weight;\n      line-height: $form-select-line-height;\n      color: $form-select-color;\n      vertical-align: middle;\n      background-color: $form-select-bg;\n      border: $form-select-border-width solid $form-select-border-color;\n      @include border-radius($form-select-border-radius, 0);\n      @include box-shadow($form-select-box-shadow);\n      appearance: none;\n    }\n\n    &__control {\n      display: flex;\n      justify-content: space-between;\n      min-height: auto !important;\n\n      &:hover {\n        border-color: $form-select-border-color;\n      }\n\n      &--menu-is-open {\n        border-color: color(\"primary\");\n      }\n\n      &:focus,\n      &--is-focused {\n        border-color: $input-focus-border-color;\n        outline: 0;\n\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n        }\n\n        @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $form-select-focus-box-shadow;\n        }\n      }\n\n      &[multiple],\n      &[size]:not([size=\"1\"]) {\n        padding-right: $form-select-padding-x;\n        background-image: none;\n      }\n\n      &:disabled,\n      &--is-disabled {\n        color: $form-select-disabled-color;\n        background-color: $form-select-disabled-bg;\n        border-color: $form-select-disabled-border-color;\n      }\n    }\n\n    &__indicator,\n    &__value-container,\n    &__input-container,\n    &__placeholder,\n    &__single-value,\n    &__indicator-separator {\n      padding: 0;\n      margin: 0;\n    }\n\n    &__indicator {\n      width: 1.75rem;\n      height: 1rem;\n\n      svg {\n        display: none;\n      }\n\n      &.react-select__dropdown-indicator {\n        background-image: escape-svg($form-select-indicator);\n        background-repeat: no-repeat;\n        background-position: right center;\n        background-size: $form-select-bg-size;\n      }\n\n      &.react-select__clear-indicator {\n        margin-top: -.5rem;\n        width: 1rem;\n        height: 1rem;\n\n        svg {\n          display: inline;\n        }\n      }\n    }\n\n    &__menu {\n      padding: $form-select-padding-y 0;\n      box-shadow: none;\n      z-index: 10;\n    }\n\n    &__option {\n      padding: $form-select-padding-y $form-select-padding-x;\n\n      &--is-selected,\n      &--is-selected.react-select__option--is-focused {\n        background-color: color(\"primary\");\n      }\n\n      &--is-focused {\n        background-color: $input-focus-border-color;\n      }\n    }\n  }\n}\n",".draggable-element {\n    cursor: auto !important;\n\n    &--dragging {\n        opacity: 0.2;\n    }\n}\n","html, body, #root {\n  height: 100%;\n}\n#root {\n  --main-header-height: 4rem;\n\n  display: flex;\n  flex-direction: column;\n  padding-top: var(--main-header-height);\n}\n",".reaction-header {\n  margin-bottom: -24px;\n  z-index: 20;\n}\n\n.reaction-header__scheme {\n  &-accordion .accordion-body {\n    padding: 0;\n    overflow: hidden;\n  }\n  &-container {\n    position: relative;\n  }\n  &-image {\n    height: 280px;\n    margin: 0 auto;\n    &.reaction-header__scheme-image--enlarged {\n      height: auto;\n      width: 100%;\n    }\n  }\n  &-enlarge-button-container {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n  }\n}\n.reaction-navbar {\n  .reaction-name {\n    display: block;\n  }\n  .reaction-id {\n    display: block;\n    font-size: $font-size-base;\n  }\n}\n.scheme-drawer-button {\n  --bs-btn-padding-y: 0;\n  margin-top: -12px;\n  span {\n    padding: 0 0.25em;\n  }\n  &-container {\n    position: relative;\n    z-index: -1;\n  }\n}\n",".activity {\n  display: flex;\n  flex-direction: column;\n  > div:first-child {\n    margin-bottom: 0.75rem;\n  }\n  &.activity--below-drag-position {\n    flex-direction: column-reverse;\n    > div:first-child {\n      margin-bottom: 0;\n      margin-top: 0.75rem;\n    }\n  }\n  &.activity--locked {\n    > div:first-child {\n      margin: 0;\n    }\n  }\n}\n",".activity-creator {\n  margin-right: 0.75rem;\n}\n",".activity-info {\n  &__add {\n    display: flex;\n    align-items: flex-start;\n  }\n  &__text-block {\n    flex-grow: 1;\n  }\n  &__description {\n    padding-top: 4px;\n    border-top: 1px solid;\n    margin-top: 4px !important;\n    .procedure-card--condition & {\n      border-top-color: border-color('condition');\n    }\n    .procedure-card--action & {\n      border-top-color: border-color('action');\n    }\n  }\n}\n","@use \"sass:map\";\n\n$condition-card-indentation: 3rem;\n\n.procedure-card--condition {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-right: none;\n  margin-left: $condition-card-indentation;\n  .card-header {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n  }\n  .procedure-card__header-label {\n    max-width: $max-label-width - $condition-card-indentation;\n  }\n  .procedure-card__info {\n    border-bottom-right-radius: 0 !important;\n  }\n}\n",".condition-form--focus {\n  .condition-type-form-group__open-controls, > .form-buttons {\n    display: none !important;\n  }\n}\n",".insert-zone {\n  min-height: 0.75rem;\n  background-color: $gray-400;\n  margin-right: 0.75rem;\n\n  &.insert-zone--target {\n    height: 3rem;\n    border-color: color(\"step\");\n    border-style: dashed;\n    border-width: 3px;\n    background-color: tint-color(color(\"step\"), 90%);\n    display: flex;\n    align-items: center;\n  }\n\n  &.insert-zone--creator {\n    background-color: transparent;\n    margin-right: 0;\n  }\n\n  &__drop-target-label {\n    display: block;\n    margin: 0 auto;\n    color: color(\"step\");\n    font-weight: bold;\n    animation: blinker 0.5s linear 1;\n  }\n\n  &.insert-zone--inactive {\n    display: none;\n  }\n\n  &__reveal-creator-button {\n    --bs-btn-hover-bg: var(--bs-btn-bg);\n    --bs-btn-hover-color: var(--bs-btn-color);\n    --bs-btn-hover-border-color: var(--bs-btn-border-color);\n    display: none;\n    width: 100%;\n  }\n\n  &__visible-creator-button {\n    --bs-btn-hover-bg: var(--bs-btn-bg);\n    --bs-btn-hover-color: var(--bs-btn-color);\n    --bs-btn-hover-border-color: var(--bs-btn-border-color);\n    --bs-btn-color: var(--bs-body-color);\n    width: 100%;\n  }\n\n  &__reveal-creator-button {\n    --bs-btn-color: var(--bs-body-color);\n  }\n\n  &--default:hover .insert-zone__reveal-creator-button {\n    display: block;\n  }\n}\n\n@keyframes blinker {\n  50% {\n    opacity: 0;\n  }\n}\n",".filtration-step-form {\n    &__solvent-list {\n        border-color: $input-border-color;\n        border-width: 1px 1px 0;\n        border-style: solid;\n        border-radius: $input-border-radius $input-border-radius 0 0;\n        background-color: $input-bg;\n        .row {\n            border-color: $input-border-color;\n            border-top-width: 1px;\n            border-top-style: solid;\n            &:first-child {\n                border-top-width: 0;\n                background-color: $input-disabled-bg;\n            }\n        }\n    }\n    &__solvent-select .react-select__control {\n        border-radius: 0 0 $input-border-radius $input-border-radius;\n    }\n}",".timer__info {\n    @include separator-border('top');\n}","@use \"sass:map\";\n\n@mixin type-border-color($direction:'') {\n  @each $color, $value in $theme-colors {\n    &--#{$color} {\n      @if $direction != '' {\n        border-#{$direction}-color: border-color($color);\n      }\n      @else {\n        border-color: border-color($color);\n      }\n    }\n  }\n}\n\n@mixin separator-border($direction:'bottom') {\n  border-#{$direction}-width: 1px;\n  border-#{$direction}-style: solid;\n  @include type-border-color($direction)\n}\n",".global-notification {\n  --bs-offcanvas-padding-y: 4.5rem;\n  --bs-offcanvas-bg: transparent;\n  --bs-offcanvas-border-width: 0;\n  pointer-events: none;\n}\n",".main-header {\n  height: var(--main-header-height);\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1030;\n\n  .dropdown-item {\n    font-size: $h4-font-size;\n  }\n\n  .nav-link,\n  .navbar-text,\n  .btn {\n    font-size: $h4-font-size;\n  }\n\n  &__brand {\n    display: flex;\n    align-items: center;\n\n    &-name {\n      font-size: $h2-font-size;\n    }\n  }\n\n  &__nav {\n    &:before {\n      margin-top: -.2rem;\n      display: inline-block;\n      content: '|';\n      color: $navbar-dark-color;\n      font-size: $h1-font-size;\n      margin-left: $navbar-nav-link-padding-x;\n      margin-right: $navbar-brand-margin-end;\n    }\n  }\n}\n\n.user-drop-down {\n  &__toggle {\n    --bs-btn-padding-y: 0.4rem;\n    display: flex;\n    align-items: center;\n    background-color: border-color('secondary');\n    border: none;\n  }\n}\n\n.navbar-direct-link {\n  width: 300px;\n}\n",".ontologies-editor {\n  --ontology-toolbar-height: 5rem;\n\n  &__toolbar {\n    height: var(--ontology-toolbar-height);\n    position: sticky;\n    top: var(--main-header-height);\n    z-index: 1020;\n\n    .navbar {\n      flex-wrap: nowrap;\n      height: 100%;\n    }\n  }\n\n  &__table-header {\n    --bs-table-bg: #{tint-color(color(\"preparation\"), 30%)};\n\n    color: $black;\n    position: sticky;\n    top: calc(var(--main-header-height) + var(--ontology-toolbar-height));\n    z-index: 1010;\n  }\n\n  &__close-button.icon-button {\n    --bs-btn-color: #{$red};\n    --bs-btn-hover-bg: #{$red};\n    --bs-btn-hover-color: #{$white};\n\n    width: 2rem;\n    height: 2rem;\n    margin-right: 0.75rem;\n    border: 2px solid $red;\n    border-radius: 0;\n  }\n}\n\n.icon-button.ontology-list-item__edit-button {\n  --bs-btn-color: #{color(\"primary\")};\n  --bs-btn-hover-bg: #{color(\"primary\")};\n  --bs-btn-hover-color: #{$white};\n}\n\n.badge.ontology-list-item__status-badge {\n  color: $black;\n  padding: 0.4rem 0.6rem;\n}\n\n.ontology-form__add-role {\n  width: calc(15ch + 4rem);\n}\n\n.ontology-form__dependencies {\n  min-width: 0;\n  padding: $spacer;\n}\n\n.ontology-form__filtered-options {\n  flex: 0 0 clamp(24rem, 40vw, 42rem);\n\n  .react-select__indicator.react-select__clear-indicator {\n    display: flex;\n    align-self: center;\n    align-items: center;\n    justify-content: center;\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0;\n\n    svg {\n      display: inline-block !important;\n      width: 1.25rem;\n      height: 1.25rem;\n    }\n  }\n\n  .react-select__option {\n    white-space: nowrap;\n  }\n}\n",".sample-molecule-image {\n  width: 132px;\n  height: 76px;\n  object-fit: contain;\n  border-color: var(--bs-card-border-color);\n}\n",".amount-input {\n  margin-bottom: -0.5rem;\n  > * {\n    position: relative;\n  }\n  &--active.amount-input {\n    @include type-active-background-color(1px)\n  }\n  &--passive {\n    .col-form-label {\n      font-weight: normal;\n    }\n  }\n}\n","@use \"sass:map\";\n\n@mixin type-active-background-color($padding-bottom: 0) {\n  @each $color, $value in $theme-colors {\n    &--#{$color} {\n      &:before {\n        content: \"\";\n        background-color: highlight-color($color);\n        position: absolute;\n        top: 0;\n        right:-0.75rem;\n        bottom: $padding-bottom * -1;\n        left:-0.75rem;\n        z-index: 0;\n      }\n    }\n  }\n}\n",".card-header-label-button {\n  @include button-size(0.125rem, 0.625rem, 0.875rem, 0.875rem);\n}\n",".create-button {\n  display: flex;\n  align-items: center;\n  .svg-inline--fa {\n    margin: 0 0.5em 0 -0.2em;\n    background-color: $body-bg;\n    color: $body-color;\n    border-radius: 50%;\n    padding: 0.1em;\n    aspect-ratio: 1 / 1;\n    object-fit: contain;\n  }\n  span {\n    white-space: nowrap;\n  }\n}\n",".duration-selection {\n  &__form-label {\n    width: auto;\n    flex-grow: 1;\n  }\n  &__input-container {\n    width: 18%\n  }\n}\n",".form-buttons {\n  padding: 0.5rem 0;\n}\n","@use \"sass:map\";\n\n.form-section {\n  padding: 0.5rem 0;\n  margin-bottom: 0rem !important;\n  @include separator-border;\n  position: relative;\n  > * {\n    position: relative;\n  }\n  &--disabled {\n    &:before {\n      content: \"\";\n      background-color: transparentize($body-bg, 0.5);\n      position: absolute !important;\n      top: 0;\n      right:-0.75rem;\n      bottom: 0;\n      left:-0.75rem;\n      z-index: 1;\n    }\n  };\n  &--active {\n    &.form-section {\n      z-index: 2;\n      @include type-active-background-color(0)\n    }\n  }\n}\n\n@container step-column (min-width: 560px) {\n  .activity-form.action-form .form-section {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    column-gap: 1rem;\n    align-items: start;\n\n    > * {\n      min-width: 0;\n    }\n\n    > .form-buttons {\n      grid-column: 1 / -1;\n    }\n  }\n}\n",".icon-button {\n  border-radius: 50%;\n  border-style: none;\n  padding: 4px;\n  --bs-btn-color: white;\n  --bs-btn-hover-color: var(--bs-body-color);\n  --bs-btn-hover-bg: white;\n  font-size:  $font-size-lg;\n  line-height: 1em;\n  &.btn-lg {\n    font-size: $h3-font-size;\n    padding: 6px;\n  }\n  &.icon-button--positive {\n    --bs-btn-color: var(--bs-body-color);\n    --bs-btn-hover-color: white;\n    --bs-btn-hover-bg: var(--bs-body-color);\n  }\n  svg {\n    width: 1em;\n  }\n}\n",".circle-button {\n  font-size: 75%;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n",".label--disabled {\n  opacity: 0.5;\n}\n",".multi-input-form-group {\n  padding: 1rem 0 0.25rem;\n  margin: 1rem 0 0.75rem;\n  border-width: 1px 0;\n  border-style: solid;\n  @include type-border-color\n}\n",".metrics-input {\n  display: flex;\n  align-items: center;\n}\n","@use \"sass:map\";\n\n.procedure-card {\n  --bs-card-spacer-x: 0;\n  --bs-card-spacer-y: 0;\n  --bs-card-cap-padding-x: 0.75rem;\n  --bs-card-cap-padding-y: 0.35rem;\n  &--action {\n    margin-right: 0.75rem;\n  }\n  &__header-label {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: $max-label-width;\n  }\n  &__info,\n  &__form,\n  &__details,\n  &__type-panel {\n    padding: var(--bs-card-cap-padding-x);\n  }\n  &__type-panel {\n    padding-top: 0;\n  }\n  &__info {\n    padding-top: 0;\n    font-size: $font-size-sm;\n    &--editable {\n      cursor: pointer;\n    }\n    .sample-molecule-image {\n      margin-right: 1rem;\n    }\n    h6,\n    p {\n      margin-bottom: 0;\n    }\n    &-line {\n      display: block;\n      padding-top: 0.1875rem;\n    }\n    &:last-child {\n      border-bottom-left-radius: var(--bs-card-inner-border-radius);\n      border-bottom-right-radius: var(--bs-card-inner-border-radius);\n    }\n    &-section {\n      margin-top: 0.75rem;\n      padding-top: 0.375rem;\n      @include separator-border(\"top\");\n      & ~ .procedure-card__info-section {\n        margin-top: 0.375rem;\n      }\n    }\n  }\n  &__details {\n    @include separator-border(\"top\");\n    @include details-spacing;\n  }\n  .card-header {\n    border-bottom: none;\n  }\n  &--editable {\n    .card-header {\n      h3,\n      h4,\n      h5,\n      h6 {\n        cursor: pointer;\n      }\n    }\n    .procedure-card__info {\n      cursor: pointer;\n    }\n  }\n  @include type-border-color();\n  &--column {\n    width: 360px;\n  }\n  &.step-column-card {\n    width: 100%;\n    min-width: 280px;\n    max-width: 80vw;\n  }\n  &--step {\n    .step-column-card__condition-container {\n      border-color: border-color(\"condition\");\n      border-style: solid;\n      border-width: 0 6px 0 0;\n      @include details-spacing;\n    }\n  }\n}\n\n.step-column-card {\n  &__resize-container {\n    position: relative;\n    flex: 0 0 auto;\n    min-width: 280px;\n    max-width: 80vw;\n    container: step-column / inline-size;\n  }\n  &__resize-handle {\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    width: 10px;\n    cursor: ew-resize;\n    touch-action: none;\n    &--left {\n      left: -5px;\n    }\n    &--right {\n      right: -5px;\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .procedure-card--#{$color} {\n    .card-header,\n    .procedure-card__info {\n      background-color: #{$value};\n    }\n  }\n}\n","@mixin details-spacing {\n  > * {\n    margin-bottom: 12px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n",".sample-selection {\n  padding: 0.375rem;\n  border-color: $input-border-color;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: $input-border-radius;\n  background-color: $input-disabled-bg;\n}",".spinner-with-message {\n  --bs-modal-width: 100%;\n  --bs-modal-border-radius: 0;\n\n  .modal-content {\n    background-color: color(\"secondary\");\n    border: none;\n    padding: 20px;\n    margin-top: -100px;\n  }\n  &__content {\n    height: 160px;\n  }\n  .spinner__container {\n    width: 108px;\n    min-height: 108px;\n    margin: 16px;\n    background-color: $body-bg;\n    border-radius: 50%;\n    border-width: 8px;\n    border-style: solid;\n    border-color: color(\"dark\");\n    position: relative;\n  }\n  .spinner-transformer {\n    position: absolute;\n    &:first-child {\n      left: 6px;\n      top: 6px;\n      .spinner-border {\n        height: 80px;\n        width: 80px;\n      }\n    }\n    &:nth-child(2) {\n      left: 16px;\n      top: 16px;\n      transform: scaleX(-1);\n      .spinner-border {\n        height: 60px;\n        width: 60px;\n      }\n    }\n    &:last-child {\n      left: 26px;\n      top: 26px;\n      .spinner-border {\n        height: 40px;\n        width: 40px;\n      }\n    }\n  }\n}\n",".type-selection-panel {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -.375rem;\n\n  &__action {\n    margin-bottom: 1.375rem;\n  }\n\n  &__cluster {\n    padding: .75rem .375rem 0;\n\n    .btn {\n\n      margin-bottom: .5rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
